var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/AppAdminRoutes.tsx
import { Navigate as Navigate48 } from "react-router-dom";
import { ErrorContainer as ErrorContainer13 } from "shared-ui";
import { DebuggerConfig } from "app-core";

// src/public/SignIn/SignInLoader.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MynLogo } from "app-core";
import {
  useCustomEventListener,
  useClearNextLocation,
  useNextLocation
} from "shared-lib";
import { Button, Size } from "shared-ui";
import { jsx, jsxs } from "react/jsx-runtime";
var SignInLoader = () => {
  const navigate = useNavigate();
  const clearLocation = useClearNextLocation();
  const [nextLocation] = useNextLocation();
  const [nextPage, setNextPage] = useState(null);
  useEffect(() => {
    if (!nextPage) {
      return;
    }
    if (nextPage.startsWith("http")) {
      window.location.href = nextPage;
    } else {
      navigate(nextPage, { replace: true });
    }
  }, [navigate, nextPage]);
  useCustomEventListener(
    "user-signed-in",
    () => {
      if (nextLocation) {
        setNextPage(nextLocation);
        clearLocation();
      } else {
        setNextPage("../app");
      }
    },
    [nextLocation]
  );
  return /* @__PURE__ */ jsx("div", { className: "container mx-auto flex h-full h-screen justify-center", children: /* @__PURE__ */ jsx("div", { className: "flex h-full max-w-lg flex-grow items-center bg-white", children: /* @__PURE__ */ jsxs("div", { className: "flex h-fit flex-grow flex-col justify-center rounded border bg-white p-10 p-4 text-center", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx("div", { className: "flex w-full items-center space-x-4", children: /* @__PURE__ */ jsx("div", { className: "mx-auto flex items-center justify-center py-2", children: /* @__PURE__ */ jsx(MynLogo, { size: Size.lg }) }) }) }),
    /* @__PURE__ */ jsx("div", { className: "flex w-full flex-col gap-2", children: /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx("span", { className: "block", children: "Myn Administration" }) }),
      /* @__PURE__ */ jsx("div", { className: "pt-4", children: /* @__PURE__ */ jsx("div", { className: "text-md text-primary-500 font-medium", children: "Start changing your work life today" }) }),
      /* @__PURE__ */ jsx("div", { className: "mt-8 flex justify-center", children: /* @__PURE__ */ jsx("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx(
        Button,
        {
          color: "primary",
          onClick: () => navigate("../app"),
          size: Size.xl,
          children: /* @__PURE__ */ jsx("div", { className: "mx-1 flex items-center gap-1", children: /* @__PURE__ */ jsx("div", { className: "whitespace-nowrap text-sm", children: "Go to Portal" }) })
        }
      ) }) })
    ] }) })
  ] }) }) });
};

// src/public/HomePage.tsx
import { useNavigate as useNavigate2 } from "react-router-dom";
import { EdLink } from "shared-ui";
import { useOIDC } from "app-core";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var HomePage = () => {
  const navigate = useNavigate2();
  const { signIn } = useOIDC();
  async function onSignIn() {
    await signIn("app");
    navigate("app");
  }
  return /* @__PURE__ */ jsx2("div", { className: "container", children: /* @__PURE__ */ jsx2("div", { className: "bg-white", children: /* @__PURE__ */ jsxs2("div", { className: "mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 lg:px-8 lg:py-16", children: [
    /* @__PURE__ */ jsx2("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx2("span", { className: "block", children: "Myn Administration" }) }),
    /* @__PURE__ */ jsxs2("div", { className: "mt-8 flex justify-center", children: [
      /* @__PURE__ */ jsx2("div", { className: "inline-flex rounded-md shadow", children: /* @__PURE__ */ jsx2(
        "a",
        {
          onClick: onSignIn,
          className: "bg-info-600 hover:bg-info-700 rounded-md border border-transparent px-5 py-3 text-base font-medium text-white",
          children: "Sign In"
        }
      ) }),
      /* @__PURE__ */ jsx2("div", { className: "ml-3 inline-flex", children: /* @__PURE__ */ jsx2(EdLink, { href: "public/signup", name: "signup-link", children: /* @__PURE__ */ jsx2("div", { className: "bg-info-100 text-info-700 hover:bg-info-200 inline-flex items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium", children: "Sign Up" }) }) })
    ] })
  ] }) }) });
};

// src/secure/index.ts
var secure_exports = {};
__export(secure_exports, {
  Account: () => Account,
  AccountsHomeList: () => AccountsHomeList,
  AdminLayout: () => AdminLayout,
  AdminNotificationsLayout: () => AdminNotificationsLayout,
  AdminUserGroupsListRoute: () => AdminUserGroupsListRoute,
  AdminUsersListRoute: () => AdminUsersListRoute,
  AppAdminSecureLayout: () => AppAdminSecureLayout,
  AppAdminSecureRoutes: () => AppAdminSecureRoutes,
  CustomDataFieldMappingDetailPage: () => CustomDataFieldMappingDetailPage,
  CustomDataFieldMappingListPage: () => CustomDataFieldMappingListPage,
  CustomDataFieldMappingNewPage: () => CustomDataFieldMappingNewPage,
  CustomDataFieldMappingsLayoutPage: () => CustomDataFieldMappingsLayoutPage,
  CustomDataHome: () => CustomDataHome,
  EmployersLayout: () => EmployersLayout,
  EmployersListRoute: () => EmployersListRoute,
  IntegrationsConfigEmployerMappingDetailPage: () => IntegrationsConfigEmployerMappingDetailPage,
  IntegrationsConfigEmployerMappingListPage: () => IntegrationsConfigEmployerMappingListPage,
  IntegrationsConfigEmployerMappingNewPage: () => IntegrationsConfigEmployerMappingNewPage,
  IntegrationsConfigLayoutPage: () => IntegrationsConfigLayoutPage,
  SystemsLayout: () => SystemsLayout,
  WorkflowDesignerPage: () => WorkflowDesignerPage,
  WorkflowHomePage: () => WorkflowHomePage,
  WorkflowsLayout: () => WorkflowsLayout,
  createAdminRoutes: () => createAdminRoutes,
  createAppAdminAccountsRoutes: () => createAppAdminAccountsRoutes,
  createAppAdminRecruitRoutes: () => createAppAdminRecruitRoutes,
  createCustomDataRoutes: () => createCustomDataRoutes,
  createEmployersRoutes: () => createEmployersRoutes,
  createIntegrationsRoutes: () => createIntegrationsRoutes,
  createNotificationRoutes: () => createNotificationRoutes,
  createTalentPoolsRoutes: () => createTalentPoolsRoutes,
  loader: () => loader3,
  useAdminUserCreate: () => useAdminUserCreate,
  useAdminUserDisable: () => useAdminUserDisable,
  useAdminUserEnable: () => useAdminUserEnable,
  useAdminUserGroupCreate: () => useAdminUserGroupCreate,
  useAdminUserGroupUpdate: () => useAdminUserGroupUpdate,
  useAdminUserGroupUpdatePermissions: () => useAdminUserGroupUpdatePermissions,
  useAdminUserJoinGroup: () => useAdminUserJoinGroup,
  useAdminUserLeaveGroup: () => useAdminUserLeaveGroup,
  useAdminUserUpdate: () => useAdminUserUpdate
});

// src/secure/__generated__/AppAdminSecureLayoutQuery.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountsAdminUserViewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTestUser",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AppAdminSecureLayoutQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AppAdminSecureLayoutQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "05a7a8095b58d7c33204003520c26605",
      "id": null,
      "metadata": {},
      "name": "AppAdminSecureLayoutQuery",
      "operationKind": "query",
      "text": "query AppAdminSecureLayoutQuery {\n  account: accountsAdminUserViewer {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    isTestUser\n  }\n}\n"
    }
  };
}();
node.hash = "ae743f9aa5af9503c3466cc034d1cfc4";
var AppAdminSecureLayoutQuery_graphql_default = node;

// src/secure/AppAdminSecureLayout.tsx
import { useCallback as useCallback5 } from "react";
import {
  loadQuery as loadQuery3,
  usePreloadedQuery
} from "react-relay";
import {
  Navigate as Navigate3,
  Outlet as Outlet3,
  useLoaderData,
  useLocation as useLocation2
} from "react-router-dom";
import {
  ArrowRightOnRectangleIcon,
  CircleStackIcon,
  CubeIcon,
  PhotoIcon,
  Squares2X2Icon,
  DocumentTextIcon,
  BugAntIcon
} from "@heroicons/react/24/outline";
import {
  Button as Button7,
  CandidateShell,
  createLinkState as createLinkState2,
  Size as Size4
} from "shared-ui";
import { useAuth, OutletRoute as OutletRoute2 } from "app-core";
import { createDataManagementRoutes } from "feature-data-management";

// src/secure/testing/components/TestingLayout.tsx
import { Outlet } from "react-router-dom";
import { Tabs } from "shared-ui";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var TestingLayout = () => {
  return /* @__PURE__ */ jsxs3("div", { className: "container m-4 flex flex-col gap-5 p-4", children: [
    /* @__PURE__ */ jsx3("h1", { className: "text-2xl", children: "Email Application Testing" }),
    /* @__PURE__ */ jsx3("div", { className: "@container w-full", children: /* @__PURE__ */ jsx3(
      Tabs,
      {
        tabs: [
          {
            id: "single",
            name: "Single",
            to: "./single"
          },
          {
            id: "multiple",
            name: "Multiple",
            to: "./multiple"
          }
        ]
      }
    ) }),
    /* @__PURE__ */ jsx3(Outlet, {})
  ] });
};

// src/secure/testing/email/EmailTestingTool.tsx
import { Controller as Controller2, useForm as useForm3 } from "react-hook-form";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import { z as z2 } from "zod";
import {
  Button as Button6,
  CheckboxInput,
  DebouncedInput as DebouncedInput2,
  Error as Error3,
  FormInput as FormInput2,
  MynPageTitle as MynPageTitle5,
  Spinner as Spinner2,
  Suspense as Suspense7
} from "shared-ui";

// src/secure/testing/mutations/__generated__/useTestingJobBoardsEmailApplicationMutation.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useTestingJobBoardsEmailApplicationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "TestingJobBoardsEmailApplicationSendPayload",
          "kind": "LinkedField",
          "name": "testingJobBoardsEmailApplicationSend",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTestEmailApplication",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TestingJobBoardsTestEmailApplication",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useTestingJobBoardsEmailApplicationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "TestingJobBoardsEmailApplicationSendPayload",
          "kind": "LinkedField",
          "name": "testingJobBoardsEmailApplicationSend",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTestEmailApplication",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TestingJobBoardsTestEmailApplication",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c375def8233a1753ff3586b683c9bcf8",
      "id": null,
      "metadata": {},
      "name": "useTestingJobBoardsEmailApplicationMutation",
      "operationKind": "mutation",
      "text": "mutation useTestingJobBoardsEmailApplicationMutation(\n  $input: TestingJobBoardsEmailApplicationSendInput!\n) {\n  testingJobBoardsEmailApplicationSend(input: $input) {\n    payload {\n      node {\n        code\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "ac9007ced0a5e68f173d7de32cf9b68b";
var useTestingJobBoardsEmailApplicationMutation_graphql_default = node2;

// src/secure/testing/mutations/useTestingJobBoardsEmailApplication.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = useTestingJobBoardsEmailApplicationMutation_graphql_default;
function useTestingJobBoardsEmailApplication() {
  const [commit, isBusy] = useAsyncMutation(mutationDef);
  return [commit, isBusy];
}

// src/secure/testing/email/EmailTestingTool.tsx
import { createClientMutationId as createClientMutationId5 } from "shared-lib";
import { useState as useState7 } from "react";

// src/secure/testing/components/__generated__/TestResumeQuery.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 50
    },
    {
      "kind": "Literal",
      "name": "where",
      "value": {}
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "TestResumeQuery",
      "selections": [
        {
          "alias": "data",
          "args": v0,
          "concreteType": "TestingJobBoardsTestResumesConnection",
          "kind": "LinkedField",
          "name": "testingJobBoardsTestResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TestingJobBoardsTestResume",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v1,
                v2,
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": "testingJobBoardsTestResumes(first:50,where:{})"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "TestResumeQuery",
      "selections": [
        {
          "alias": "data",
          "args": v0,
          "concreteType": "TestingJobBoardsTestResumesConnection",
          "kind": "LinkedField",
          "name": "testingJobBoardsTestResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TestingJobBoardsTestResume",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v1,
                v2,
                v3,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "testingJobBoardsTestResumes(first:50,where:{})"
        }
      ]
    },
    "params": {
      "cacheID": "0996769e4a9bfae81de34ee82fceb6d4",
      "id": null,
      "metadata": {},
      "name": "TestResumeQuery",
      "operationKind": "query",
      "text": "query TestResumeQuery {\n  data: testingJobBoardsTestResumes(first: 50, where: {}) {\n    nodes {\n      entityId\n      name\n      fileName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "421cd6eed51fe217608efc3cbbc0c175";
var TestResumeQuery_graphql_default = node3;

// src/secure/testing/components/TestResume.tsx
import { useLazyLoadQuery } from "react-relay";
import { ScrollArea, StyledTable, classNames } from "shared-ui";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var queryDef = TestResumeQuery_graphql_default;
var {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} = StyledTable;
var TestResume = ({
  onSelect,
  selected
}) => {
  const data = useLazyLoadQuery(queryDef, {});
  return /* @__PURE__ */ jsxs4("div", { children: [
    /* @__PURE__ */ jsx4("h1", { children: "Test Resume" }),
    /* @__PURE__ */ jsx4(Table, { children: /* @__PURE__ */ jsxs4(ScrollArea, { className: "relative h-72 rounded-lg border", children: [
      /* @__PURE__ */ jsx4(TableHeader, { className: "sticky top-0 bg-white", children: /* @__PURE__ */ jsxs4(TableRow, { children: [
        /* @__PURE__ */ jsx4(TableHead, { className: "w-[200px]", children: "Name" }),
        /* @__PURE__ */ jsx4(TableHead, { className: "w-[200px]", children: "Filename" })
      ] }) }),
      /* @__PURE__ */ jsx4(TableBody, { children: data?.data?.nodes?.map((x, index) => /* @__PURE__ */ jsxs4(
        TableRow,
        {
          onClick: () => onSelect && onSelect(x),
          className: classNames(
            x.entityId === selected ? "bg-primary-100 hover:bg-primary-100" : ""
          ),
          children: [
            /* @__PURE__ */ jsx4(TableCell, { children: x.name }),
            /* @__PURE__ */ jsx4(TableCell, { children: x.fileName })
          ]
        },
        x + index.toString()
      )) })
    ] }) })
  ] });
};

// src/secure/testing/email/EmailTestingToolMultiple.tsx
import { Controller, useForm as useForm2 } from "react-hook-form";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
  Button as Button5,
  DebouncedInput,
  Error as Error2,
  FormInput,
  MynPageTitle as MynPageTitle4,
  Spinner,
  Suspense as Suspense6
} from "shared-ui";
import { createClientMutationId as createClientMutationId4 } from "shared-lib";

// src/secure/testing/mutations/__generated__/useTestingJobBoardsEmailApplicationSendAllMutation.graphql.ts
var node4 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "TestingJobBoardsEmailApplicationSendAllPayload",
      "kind": "LinkedField",
      "name": "testingJobBoardsEmailApplicationSendAll",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SendAllTestEmailsResult",
          "kind": "LinkedField",
          "name": "payload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "errorMessage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useTestingJobBoardsEmailApplicationSendAllMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useTestingJobBoardsEmailApplicationSendAllMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "95f11b6bc403a4af39246de9846f52f1",
      "id": null,
      "metadata": {},
      "name": "useTestingJobBoardsEmailApplicationSendAllMutation",
      "operationKind": "mutation",
      "text": "mutation useTestingJobBoardsEmailApplicationSendAllMutation(\n  $input: TestingJobBoardsEmailApplicationSendAllInput!\n) {\n  testingJobBoardsEmailApplicationSendAll(input: $input) {\n    payload {\n      count\n      errorMessage\n    }\n  }\n}\n"
    }
  };
}();
node4.hash = "4786d71c471be660b2fb41c4bd11610c";
var useTestingJobBoardsEmailApplicationSendAllMutation_graphql_default = node4;

// src/secure/testing/mutations/useTestingJobBoardsEmailApplicationSendAll.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef2 = useTestingJobBoardsEmailApplicationSendAllMutation_graphql_default;
function useTestingJobBoardsEmailApplicationSendAll() {
  const [commit, isBusy] = useAsyncMutation2(
    mutationDef2
  );
  return [commit, isBusy];
}

// src/secure/testing/email/EmailTestingToolMultiple.tsx
import { useState as useState6 } from "react";

// src/secure/recruit/job-boards/components/JobBoardListContainer.tsx
import { useState as useState2 } from "react";
import { Input } from "shared-ui";
import { useDebounce } from "shared-lib";
import { JobBoardList } from "feature-recruit";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var JobBoardsListContainer = () => {
  const [filter, setFilter] = useState2(null);
  const searchTerm = useDebounce(filter, 500);
  const where2 = {
    isDeleted: { eq: false }
  };
  if (searchTerm) {
    where2.or = [{ name: { startsWith: filter } }];
  }
  return /* @__PURE__ */ jsxs5("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx5("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs5("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx5("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx5("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx5(
        Input,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx5("div", { className: "flex-1", children: /* @__PURE__ */ jsx5(JobBoardList, { where: where2 }) })
  ] });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListQuery.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardAdList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reference",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v3,
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardAdList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "615808b91a37342b239c715d17c183bf",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListQuery(\n  $where: RecruitJobBoardAdFilter!\n) {\n  ...JobBoardAdList_list\n}\n\nfragment JobBoardAdList_list on Query {\n  list: recruitJobBoardAds(first: 25, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node5.hash = "ca8e21d1ac49f81f45d6247ffbff5b13";
var JobBoardAdListQuery_graphql_default = node5;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListPaginationQuery.graphql.ts
var node6 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardAdList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reference",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v5,
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardAdList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "3862e789d3f7529c5dbfe537487b8e66",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: RecruitJobBoardAdFilter\n) {\n  ...JobBoardAdList_list_2HEEH6\n}\n\nfragment JobBoardAdList_list_2HEEH6 on Query {\n  list: recruitJobBoardAds(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "b33c4bc9ea01189159cfb3f2116d1db1";
var JobBoardAdListPaginationQuery_graphql_default = node6;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdList_list.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardAdListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardAdList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "RecruitJobBoardAdsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardAdList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardAdsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoardAd",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardAdId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitJobBoard",
                    "kind": "LinkedField",
                    "name": "jobBoard",
                    "plural": false,
                    "selections": [
                      v1
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node7.hash = "b33c4bc9ea01189159cfb3f2116d1db1";
var JobBoardAdList_list_graphql_default = node7;

// src/secure/recruit/job-boards/components/JobBoardAdList.tsx
import { useCallback, useState as useState3 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2, usePaginationFragment } from "react-relay";
import { Suspense, classNames as classNames2 } from "shared-ui";
import { Button as Button2, EdSkeleton, Size as Size2 } from "shared-ui";
import {
  createClientMutationId,
  isNotNullOrUndefined,
  noop,
  timeAgo
} from "shared-lib";

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardAdCreateMutation.graphql.ts
var node8 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardAdId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reference",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "RecruitJobBoardAdCreatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseJobBoardAdCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "RecruitJobBoardAdCreatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoard",
                      "kind": "LinkedField",
                      "name": "jobBoard",
                      "plural": false,
                      "selections": [
                        v8,
                        v3
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v8,
                        v9,
                        v3
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2d76a95f6f4f3e89d324da5f3b8b438e",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdCreateMutation(\n  $input: RecruitJobBoardAdCreateInput!\n) {\n  data: recruitJobBoardAdCreate(input: $input) {\n    payload {\n      node {\n        id\n        jobBoardAdId\n        code\n        reference\n        createdAt\n        jobBoard {\n          name\n          id\n        }\n        vacancy {\n          name\n          employerName\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "d7b321fc3a4c75cd7ebca598d10983b9";
var UseJobBoardAdCreateMutation_graphql_default = node8;

// src/secure/recruit/job-boards/mutations/UseJobBoardAdCreate.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef3 = UseJobBoardAdCreateMutation_graphql_default;
function useJobBoardAdCreate() {
  const [commit, isBusy] = useAsyncMutation3(mutationDef3);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardAdRemoveMutation.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "succeeded",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardAdRemovePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfJobboardAd",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoardAd",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardAdRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardAdRemovePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfJobboardAd",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfJobboardAd",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitJobBoardAd",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "filters": null,
                          "handle": "deleteRecord",
                          "key": "",
                          "kind": "ScalarHandle",
                          "name": "id"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b02a9c6d47d68134f5c827c89f00549a",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdRemoveMutation(\n  $input: RecruitJobBoardAdRemoveInput!\n) {\n  data: recruitJobBoardAdRemove(input: $input) {\n    payload {\n      edge {\n        node {\n          id\n        }\n      }\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "9ee2f94186fd2805e2edce9fc236f8f0";
var UseJobBoardAdRemoveMutation_graphql_default = node9;

// src/secure/recruit/job-boards/mutations/UseJobBoardAdRemove.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef4 = UseJobBoardAdRemoveMutation_graphql_default;
function useJobBoardAdRemove() {
  const [commit, isBusy] = useAsyncMutation4(mutationDef4);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/mutations/__generated__/UseJobBoardUpdateMutation.graphql.ts
var node10 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobBoardEmailConfiguration",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitJobBoard",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobBoardId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVisible",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inboxEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmailLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmailRegex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceCustomHeader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReferenceRegex",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "34c0166da12868b3f69916ecaa2bfe04",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardUpdateMutation(\n  $input: RecruitJobBoardUpdateInput!\n) {\n  data: recruitJobBoardUpdate(input: $input) {\n    payload {\n      node {\n        id\n        jobBoardId\n        code\n        isDeleted\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "71ef140dda18f5a1a0297942b95fe964";
var UseJobBoardUpdateMutation_graphql_default = node10;

// src/secure/recruit/job-boards/mutations/UseJobBoardUpdate.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef5 = UseJobBoardUpdateMutation_graphql_default;
function useJobBoardUpdate() {
  const [commit, isBusy] = useAsyncMutation5(mutationDef5);
  return [commit, isBusy];
}

// src/secure/recruit/job-boards/components/JobBoardAdList.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var queryDef2 = JobBoardAdListQuery_graphql_default;
var fragmentDef = JobBoardAdList_list_graphql_default;
var List = ({
  fragmentRef,
  showDelete,
  onSelect,
  selected
}) => {
  const [deleteId, setDeleteId] = useState3(null);
  const [deleteAd, isDeletingAd] = useJobBoardAdRemove();
  const onDelete = useCallback(async () => {
    console.log(deleteId);
    if (!deleteId) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId(),
      jobBoardAdId: deleteId
    };
    const response = await deleteAd({ input });
    if (response.data.payload) {
      setDeleteId(null);
    }
  }, [deleteId, setDeleteId, deleteAd]);
  const { data, loadNext } = usePaginationFragment(fragmentDef, fragmentRef);
  const onLoadNext = useCallback(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const ads = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined);
  const rows = ads.map((jobBoardAd, idx) => {
    return /* @__PURE__ */ jsxs6(
      "tr",
      {
        className: classNames2(
          selected === jobBoardAd.jobBoardAdId ? "bg-primary-100 hover:bg-primary-100" : ""
        ),
        onClick: () => onSelect && onSelect(jobBoardAd.jobBoardAdId),
        children: [
          /* @__PURE__ */ jsx6("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: jobBoardAd.jobBoard.name }),
          /* @__PURE__ */ jsx6("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: jobBoardAd.reference }),
          /* @__PURE__ */ jsx6("td", { children: jobBoardAd.vacancy.name }),
          /* @__PURE__ */ jsx6("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: jobBoardAd.createdAt ? timeAgo(jobBoardAd.createdAt) : "unknown" }),
          /* @__PURE__ */ jsx6("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: showDelete && /* @__PURE__ */ jsx6(
            Button2,
            {
              color: "danger",
              clicked: () => setDeleteId(jobBoardAd.jobBoardAdId),
              children: "Delete"
            }
          ) })
        ]
      },
      jobBoardAd.code
    );
  });
  const jobBoardAdToDelete = deleteId ? ads.find((a) => a.jobBoardAdId === deleteId) : null;
  return /* @__PURE__ */ jsxs6(Suspense, { fallback: /* @__PURE__ */ jsx6(EdSkeleton, {}), children: [
    jobBoardAdToDelete && /* @__PURE__ */ jsxs6("div", { className: "m-8 flex flex-col gap-5 border bg-white p-4", children: [
      /* @__PURE__ */ jsx6("div", { className: "flex justify-center border-b pb-4", children: /* @__PURE__ */ jsxs6("div", { className: "text-danger-500 text-2xl", children: [
        "Delete Ad for ",
        jobBoardAdToDelete.jobBoard.name
      ] }) }),
      /* @__PURE__ */ jsx6("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6(Button2, { color: "danger", size: Size2.xl, clicked: onDelete, children: "Yes, Delete Now" }) }) })
    ] }),
    /* @__PURE__ */ jsx6("div", { className: "border bg-white", children: /* @__PURE__ */ jsxs6("table", { className: "min-w-full divide-y divide-gray-200", children: [
      /* @__PURE__ */ jsx6("thead", { className: "bg-gray-50", children: /* @__PURE__ */ jsxs6("tr", { children: [
        /* @__PURE__ */ jsx6(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Job Board"
          }
        ),
        /* @__PURE__ */ jsx6(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Reference"
          }
        ),
        /* @__PURE__ */ jsx6(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Vacancy Name"
          }
        ),
        /* @__PURE__ */ jsx6(
          "th",
          {
            scope: "col",
            className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
            children: "Created"
          }
        ),
        /* @__PURE__ */ jsx6("th", { scope: "col" })
      ] }) }),
      /* @__PURE__ */ jsx6("tbody", { children: rows })
    ] }) })
  ] });
};
var JobBoardAdsList = ({
  reference,
  jobBoardId,
  vacancyId,
  showDelete = true,
  onSelect = noop,
  selected
}) => {
  let where2 = {
    isDeleted: { eq: false }
  };
  if (reference) {
    where2 = {
      ...where2,
      reference: { eq: reference }
    };
  }
  if (jobBoardId) {
    where2 = {
      ...where2,
      jobboardId: { eq: jobBoardId }
    };
  }
  if (vacancyId) {
    where2 = {
      ...where2,
      vacancyId: { eq: vacancyId }
    };
  }
  const query = useLazyLoadQuery2(
    queryDef2,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx6(
    List,
    {
      fragmentRef: query,
      showDelete,
      onSelect,
      selected
    }
  );
};

// src/secure/recruit/job-boards/components/JobBoardAdReferenceEditor.tsx
import { useCallback as useCallback2, useState as useState4 } from "react";
import { Suspense as Suspense2 } from "shared-ui";
import { createClientMutationId as createClientMutationId2 } from "shared-lib";
import { Button as Button3, Input as Input2 } from "shared-ui";
import {
  JobBoardSearchBoxContainer
} from "feature-recruit";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var JobBoardAdReferenceEditor = ({
  connectionId,
  vacancyId,
  onDone,
  onCancel
}) => {
  const [reference, setReference] = useState4(null);
  const [jobBoard, setJobBoard] = useState4(null);
  const [createAd, isCreatingAd] = useJobBoardAdCreate();
  const onCreateAd = useCallback2(async () => {
    if (!reference || !jobBoard) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId2(),
      boardId: jobBoard.jobBoardId,
      reference,
      vacancyId
    };
    const response = await createAd({ connections: [connectionId], input });
    if (response.data.payload) {
      onDone();
    }
  }, [createAd]);
  return /* @__PURE__ */ jsx7(Suspense2, { fallback: "Loading...", children: /* @__PURE__ */ jsxs7("div", { className: "flex flex-col gap-3 border bg-white p-4 sm:w-1/2", children: [
    /* @__PURE__ */ jsxs7("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx7("div", { className: "w-32", children: "Job Board" }),
      /* @__PURE__ */ jsx7("div", { className: "flex-1", children: /* @__PURE__ */ jsx7(JobBoardSearchBoxContainer, { onSearchCompleted: setJobBoard }) })
    ] }),
    /* @__PURE__ */ jsxs7("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx7("div", { className: "w-32", children: "Reference" }),
      /* @__PURE__ */ jsx7("div", { className: "flex-1", children: /* @__PURE__ */ jsx7(Input2, { onValueChange: setReference, placeholder: "Enter Reference" }) })
    ] }),
    /* @__PURE__ */ jsxs7("div", { className: "flex items-center gap-2 border-t pt-4", children: [
      /* @__PURE__ */ jsx7("div", { children: /* @__PURE__ */ jsx7(Button3, { color: "primary", clicked: onCreateAd, children: "Add Reference" }) }),
      /* @__PURE__ */ jsx7("div", { children: /* @__PURE__ */ jsx7(Button3, { color: "gray", clicked: onCancel, children: "Cancel" }) })
    ] })
  ] }) });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardContainerRouteQuery.graphql.ts
var node11 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobBoardCode"
    }
  ], v1 = [
    {
      "alias": "jobBoard",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "jobBoardCode"
        }
      ],
      "concreteType": "RecruitJobBoard",
      "kind": "LinkedField",
      "name": "recruitJobBoardByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobBoardId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVisible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inboxEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateEmailLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateEmailRegex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceCustomHeader",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobReferenceRegex",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardContainerRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardContainerRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "9345fcff01217317eefad6d7e45a03fd",
      "id": null,
      "metadata": {},
      "name": "JobBoardContainerRouteQuery",
      "operationKind": "query",
      "text": "query JobBoardContainerRouteQuery(\n  $jobBoardCode: Int!\n) {\n  jobBoard: recruitJobBoardByCode(code: $jobBoardCode) {\n    id\n    jobBoardId\n    code\n    isVisible\n    name\n    inboxEmail\n    candidateEmailLocation\n    candidateEmailRegex\n    jobReferenceLocation\n    jobReferenceCustomHeader\n    jobReferenceRegex\n  }\n}\n"
    }
  };
}();
node11.hash = "93d252004a553883fd4dce821d8c5010";
var JobBoardContainerRouteQuery_graphql_default = node11;

// src/secure/recruit/job-boards/components/JobBoardContainer.tsx
import { Fragment as Fragment3, Suspense as Suspense5 } from "react";
import { Navigate, Outlet as Outlet2, useLocation } from "react-router-dom";
import { loadQuery as loadQuery2 } from "react-relay";
import { UserGroupIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useRouteData as useRouteData2, useToggle } from "shared-lib";
import {
  BooleanIcon,
  Button as Button4,
  createLinkState,
  DescriptionItem as DescriptionItem2,
  DescriptionList as DescriptionList2,
  EdSkeleton as EdSkeleton4,
  MynPageTitle as MynPageTitle2,
  Size as Size3,
  TabPills
} from "shared-ui";

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListContainerQuery.graphql.ts
var node12 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardAdListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardAdListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "ae5213915efb3dfe9cf09486413c8957",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdListContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardAdListContainerQuery(\n  $where: RecruitJobBoardAdFilter!\n) {\n  ...JobBoardAdListContainer_list\n}\n\nfragment JobBoardAdListContainer_list on Query {\n  list: recruitJobBoardAds(first: 25, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        createdAt\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "26f9d8be81cd54b9304c9f9e3a81fc70";
var JobBoardAdListContainerQuery_graphql_default = node12;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdsListContainerPaginationQuery.graphql.ts
var node13 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardAdListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitJobBoardAdsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoardAds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardAdsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoardAd",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardAdId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardAdListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoardAds"
        }
      ]
    },
    "params": {
      "cacheID": "58e11bcccdf84dd61641d5e01d350616",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardAdsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: RecruitJobBoardAdFilter\n) {\n  ...JobBoardAdListContainer_list_2HEEH6\n}\n\nfragment JobBoardAdListContainer_list_2HEEH6 on Query {\n  list: recruitJobBoardAds(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardAdId\n        code\n        createdAt\n        vacancy {\n          name\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node13.hash = "185aa17a792c425e8cdd3bef629b0f76";
var JobBoardAdsListContainerPaginationQuery_graphql_default = node13;

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdListContainer_list.graphql.ts
var node14 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardAdsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardAdListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitJobBoardAdsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardAdListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardAdsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoardAd",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardAdId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node14.hash = "185aa17a792c425e8cdd3bef629b0f76";
var JobBoardAdListContainer_list_graphql_default = node14;

// src/secure/recruit/job-boards/components/JobBoardAdListContainer.tsx
import { useCallback as useCallback3, useState as useState5 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3, usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { Suspense as Suspense3 } from "shared-ui";
import {
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  EdSkeleton as EdSkeleton2,
  Input as Input3,
  ListLayout
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined2, useDebounce as useDebounce2 } from "shared-lib";
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var queryDef3 = JobBoardAdListContainerQuery_graphql_default;
var fragmentDef2 = JobBoardAdListContainer_list_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List2 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment2(fragmentDef2, fragmentRef);
  const onLoadNext = useCallback3(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined2).map((jobBoardAd) => {
    const name = `${jobBoardAd.vacancy.name}`;
    return {
      key: jobBoardAd.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx8("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs8("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx8("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx8("div", { className: "text-md text-blue-700", children: jobBoardAd.code })
      ] }) }),
      description: /* @__PURE__ */ jsx8("div", { className: "flex items-center gap-2 pt-2 text-sm", children: jobBoardAd.createdAt && /* @__PURE__ */ jsxs8("div", { className: "text-info-700", children: [
        /* @__PURE__ */ jsx8("div", { children: "Created" }),
        /* @__PURE__ */ jsx8("div", { children: jobBoardAd.createdAt })
      ] }) }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: jobBoardAd.code
      },
      element: /* @__PURE__ */ jsx8(DefaultListLayoutSectionElement, { children: /* @__PURE__ */ jsx8("div", { className: "grid", children: /* @__PURE__ */ jsx8("div", { children: jobBoardAd.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx8(Suspense3, { fallback: /* @__PURE__ */ jsx8(EdSkeleton2, {}), children: /* @__PURE__ */ jsx8(
    ListLayout,
    {
      title: "Job Board Ads",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx8(
        DefaultListLayoutItemHeader,
        {
          title: "Ads",
          to: createLinkTo,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var JobBoardAdsListContainer = ({
  jobBoardId,
  vacancyId
}) => {
  const [filter, setFilter] = useState5(null);
  const searchTerm = useDebounce2(filter, 500);
  let where2 = {
    isDeleted: { eq: false }
  };
  if (jobBoardId) {
    where2 = {
      ...where2,
      jobboardId: { eq: jobBoardId }
    };
  }
  if (vacancyId) {
    where2 = {
      ...where2,
      vacancyId: { eq: vacancyId }
    };
  }
  if (searchTerm) {
    where2.or = [{ reference: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery3(
    queryDef3,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs8("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx8("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs8("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx8("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx8("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx8(
        Input3,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx8("div", { className: "flex-1", children: /* @__PURE__ */ jsx8(List2, { fragmentRef: query }) })
  ] });
};

// src/secure/recruit/job-boards/components/__generated__/JobBoardAdContainerRouteQuery.graphql.ts
var node15 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobBoardAdCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "jobBoardAdCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardAdId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reference",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobboardId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v11 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardAdContainerRouteQuery",
      "selections": [
        {
          "alias": "jobBoardAd",
          "args": v1,
          "concreteType": "RecruitJobBoardAd",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v10
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardAdContainerRouteQuery",
      "selections": [
        {
          "alias": "jobBoardAd",
          "args": v1,
          "concreteType": "RecruitJobBoardAd",
          "kind": "LinkedField",
          "name": "recruitJobBoardAdByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v10,
                v2
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "07aa8b3b09fdac3e71bb40d64d0c0825",
      "id": null,
      "metadata": {},
      "name": "JobBoardAdContainerRouteQuery",
      "operationKind": "query",
      "text": "query JobBoardAdContainerRouteQuery(\n  $jobBoardAdCode: Int!\n) {\n  jobBoardAd: recruitJobBoardAdByCode(code: $jobBoardAdCode) {\n    id\n    jobBoardAdId\n    code\n    isDeleted\n    createdAt\n    reference\n    jobboardId\n    vacancy {\n      name\n      employerName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node15.hash = "6518b3f54eeff27d48d230248e16c9f1";
var JobBoardAdContainerRouteQuery_graphql_default = node15;

// src/secure/recruit/job-boards/components/JobBoardAdContainer.tsx
import { Fragment, Suspense as Suspense4 } from "react";
import { loadQuery } from "react-relay";
import { useRouteData } from "shared-lib";
import { DescriptionItem, DescriptionList, EdSkeleton as EdSkeleton3, MynPageTitle } from "shared-ui";
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var queryDef4 = JobBoardAdContainerRouteQuery_graphql_default;
async function loader(environment, params) {
  const code = params.jobBoardAdCode;
  const jobBoardAdCode = parseInt(code);
  return loadQuery(environment, queryDef4, {
    jobBoardAdCode
  });
}
var JobBoardAdContainer = ({ routeId: routeId6 }) => {
  const data = useRouteData(queryDef4, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx9(Fragment2, { children: "Loading..." });
  }
  const { jobBoardAd } = data;
  if (!jobBoardAd) {
    return /* @__PURE__ */ jsx9(Fragment2, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs9(Suspense4, { fallback: /* @__PURE__ */ jsx9(EdSkeleton3, {}), children: [
    /* @__PURE__ */ jsx9(MynPageTitle, { title: "Job Board Ad Details" }),
    /* @__PURE__ */ jsx9("div", { className: "flex-1", children: /* @__PURE__ */ jsxs9("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs9("div", { className: "flex items-center justify-between gap-2 p-4", children: [
        /* @__PURE__ */ jsxs9("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx9("div", { className: "text-primary-700 px-1 text-xl font-bold", children: jobBoardAd.vacancy.employerName }),
          /* @__PURE__ */ jsx9("div", { className: "text-primary-700 px-1 text-xl font-bold", children: jobBoardAd.vacancy.name })
        ] }),
        /* @__PURE__ */ jsx9("div", { className: "flex items-center gap-2 pt-2 text-sm", children: /* @__PURE__ */ jsx9("div", { className: "text-primary-700 text-sm font-bold", children: jobBoardAd.code }) })
      ] }),
      /* @__PURE__ */ jsx9(
        DescriptionList,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx9("div", { className: "flex items-center", children: jobBoardAd.createdAt && /* @__PURE__ */ jsxs9("div", { className: "text-info-700", children: [
            /* @__PURE__ */ jsx9("div", { children: "Created" }),
            /* @__PURE__ */ jsx9("div", { children: jobBoardAd.createdAt })
          ] }) }),
          items: /* @__PURE__ */ jsx9(Fragment, { children: /* @__PURE__ */ jsx9(DescriptionItem, { label: "Reference", children: jobBoardAd.reference }) })
        }
      )
    ] }) })
  ] });
};
var createRoute = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  return {
    id: routeId6,
    path: ":jobBoardAdCode",
    element: /* @__PURE__ */ jsx9(JobBoardAdContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader(environment, params);
    }
  };
};

// src/secure/recruit/job-boards/components/JobBoardEditor.tsx
import { useCallback as useCallback4 } from "react";
import * as zod from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId3,
  useSetUserErrorCodes,
  useUserErrorCode
} from "shared-lib";
import {
  ActionContainer,
  ErrorField,
  FormErrorCode,
  FormErrorCodes,
  FormInputRow,
  InputField,
  SwitchInput
} from "shared-ui";
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var formSchema = zod.object({
  name: zod.string().min(1, { message: "Name is required" }),
  inboxEmail: zod.string().email().min(1, { message: "Inbox Email is required" }),
  jobReferenceCustomHeader: zod.string().min(1, { message: "uppSenderId is required" }).nullable(),
  jobReferenceLocation: zod.string().min(1, { message: "uppSenderId is required" }),
  jobReferenceRegex: zod.string().min(1, { message: "uppSenderId is required" }),
  candidateEmailAddressLocation: zod.string().min(1, { message: "Email Address Location is required" }),
  candidateEmailAddressRegex: zod.string().min(1, { message: "Email Address Regex is required" }),
  isVisible: zod.boolean()
});
var JobBoardEditor = ({
  jobBoardId,
  jobBoard,
  onDone,
  onCancel
}) => {
  const defaultValues = {
    name: jobBoard?.name,
    inboxEmail: jobBoard?.inboxEmail,
    candidateEmailAddressLocation: jobBoard?.candidateEmailLocation,
    candidateEmailAddressRegex: jobBoard?.candidateEmailRegex,
    jobReferenceLocation: jobBoard?.jobReferenceLocation,
    jobReferenceCustomHeader: jobBoard?.jobReferenceCustomHeader || null,
    jobReferenceRegex: jobBoard?.jobReferenceRegex,
    isVisible: jobBoard?.isVisible || false
  };
  const setErrorCode = useSetUserErrorCodes();
  const { register, handleSubmit, watch, formState, control } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode();
  const [updateJobBoard, isUpdatingJobBoard] = useJobBoardUpdate();
  const onSave = useCallback4(
    async (form) => {
      setErrorCode(null);
      if (!form.name || !form.inboxEmail || !form.candidateEmailAddressLocation || !form.candidateEmailAddressRegex || !form.jobReferenceLocation || !form.jobReferenceRegex) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId3(),
        id: jobBoardId,
        name: form.name,
        inboxEmail: form.inboxEmail,
        candidateEmailAddressLocation: form.candidateEmailAddressLocation,
        candidateEmailAddressRegex: form.candidateEmailAddressRegex,
        jobReferenceLocation: form.jobReferenceLocation,
        jobReferenceCustomHeader: form.jobReferenceCustomHeader,
        jobReferenceRegex: form.jobReferenceRegex,
        isVisible: form.isVisible
      };
      const response = await updateJobBoard({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [updateJobBoard]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx10(FormErrorCodes, {});
  if (userErrorCode) {
    errorDisplay = /* @__PURE__ */ jsx10(FormErrorCode, { message: userErrorCode });
  }
  return /* @__PURE__ */ jsxs10("div", { className: "m-4 flex w-full flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx10("form", { className: "w-full", onSubmit, children: /* @__PURE__ */ jsxs10(
      ActionContainer,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isUpdatingJobBoard,
        titleTop: `Update Job Board`,
        children: [
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "name", title: "Name *", children: [
            /* @__PURE__ */ jsx10(
              InputField,
              {
                register,
                name: "name",
                required: true,
                placeholder: "Name"
              }
            ),
            /* @__PURE__ */ jsx10(ErrorField, { field: errors.name })
          ] }),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "inboxEmail", title: "Inbox Email *", children: [
            /* @__PURE__ */ jsx10(
              InputField,
              {
                register,
                name: "inboxEmail",
                required: true,
                placeholder: "Inbox Email"
              }
            ),
            /* @__PURE__ */ jsx10(ErrorField, { field: errors.inboxEmail })
          ] }),
          /* @__PURE__ */ jsxs10(
            FormInputRow,
            {
              name: "jobReferenceLocation",
              title: "Reference Location *",
              children: [
                /* @__PURE__ */ jsx10(
                  InputField,
                  {
                    register,
                    name: "jobReferenceLocation",
                    required: true,
                    placeholder: "Reference Location"
                  }
                ),
                /* @__PURE__ */ jsx10(ErrorField, { field: errors.jobReferenceLocation })
              ]
            }
          ),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "jobReferenceRegex", title: "Reference Regex *", children: [
            /* @__PURE__ */ jsx10(
              InputField,
              {
                register,
                name: "jobReferenceRegex",
                required: true,
                placeholder: "Reference Regex"
              }
            ),
            /* @__PURE__ */ jsx10(ErrorField, { field: errors.jobReferenceRegex })
          ] }),
          /* @__PURE__ */ jsxs10(
            FormInputRow,
            {
              name: "jobReferenceCustomHeader",
              title: "Reference Custom Header *",
              children: [
                /* @__PURE__ */ jsx10(
                  InputField,
                  {
                    register,
                    name: "jobReferenceCustomHeader",
                    required: false,
                    placeholder: "Reference Custom Header"
                  }
                ),
                /* @__PURE__ */ jsx10(ErrorField, { field: errors.jobReferenceCustomHeader })
              ]
            }
          ),
          /* @__PURE__ */ jsxs10(
            FormInputRow,
            {
              name: "candidateEmailAddressLocation",
              title: "Email Location *",
              children: [
                /* @__PURE__ */ jsx10(
                  InputField,
                  {
                    register,
                    name: "candidateEmailAddressLocation",
                    required: true,
                    placeholder: "Inbox Email"
                  }
                ),
                /* @__PURE__ */ jsx10(ErrorField, { field: errors.candidateEmailAddressLocation })
              ]
            }
          ),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "candidateEmailAddressRegex", title: "Email Regex *", children: [
            /* @__PURE__ */ jsx10(
              InputField,
              {
                register,
                name: "candidateEmailAddressRegex",
                required: true,
                placeholder: "Email Regex"
              }
            ),
            /* @__PURE__ */ jsx10(ErrorField, { field: errors.candidateEmailAddressRegex })
          ] }),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "isVisible", title: "Visible *", children: [
            /* @__PURE__ */ jsx10(
              SwitchInput,
              {
                control,
                name: "isVisible",
                defaultChecked: false
              }
            ),
            /* @__PURE__ */ jsx10(ErrorField, { field: errors.isVisible })
          ] })
        ]
      }
    ) })
  ] });
};

// src/secure/recruit/job-boards/components/JobBoardContainer.tsx
import { Fragment as Fragment4, jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var queryDef5 = JobBoardContainerRouteQuery_graphql_default;
async function loader2(environment, params) {
  const code = params.jobBoardCode;
  const jobBoardCode = parseInt(code);
  return loadQuery2(environment, queryDef5, {
    jobBoardCode
  });
}
var JobBoardContainer = ({ routeId: routeId6 }) => {
  const [isEditing, toggleIsEditing] = useToggle();
  const data = useRouteData2(queryDef5, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx11(Fragment4, { children: "Loading..." });
  }
  const { jobBoard } = data;
  if (!jobBoard) {
    return /* @__PURE__ */ jsx11(Fragment4, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx11("div", { className: "flex py-4", children: /* @__PURE__ */ jsx11(
      JobBoardEditor,
      {
        jobBoardId: jobBoard.jobBoardId,
        jobBoard,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) });
  } else {
    content = /* @__PURE__ */ jsx11("div", { className: "flex py-4", children: /* @__PURE__ */ jsx11(
      DescriptionList2,
      {
        classes: "w-full border",
        heading: /* @__PURE__ */ jsx11("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx11("span", { className: "text-info-800", children: jobBoard.name }) }),
        items: /* @__PURE__ */ jsxs11(Fragment3, { children: [
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Inbox Email", children: jobBoard.inboxEmail }),
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Reference Custom Header", children: jobBoard.jobReferenceCustomHeader }),
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Reference Location", children: jobBoard.jobReferenceLocation }),
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Reference Regex", children: jobBoard.jobReferenceRegex }),
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Candidate Email Location", children: jobBoard.candidateEmailLocation }),
          /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Candidate Email Regex", children: jobBoard.candidateEmailRegex })
        ] })
      }
    ) });
  }
  return /* @__PURE__ */ jsxs11(Suspense5, { fallback: /* @__PURE__ */ jsx11(EdSkeleton4, {}), children: [
    /* @__PURE__ */ jsx11(MynPageTitle2, { title: "Job Board Details" }),
    /* @__PURE__ */ jsxs11("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs11("div", { className: "flex items-center justify-between gap-2 border-b", children: [
        /* @__PURE__ */ jsxs11("div", { className: "flex items-center justify-between gap-2 p-4", children: [
          /* @__PURE__ */ jsx11("div", { className: "text-primary-700 px-1 text-xl font-bold", children: jobBoard.name }),
          /* @__PURE__ */ jsxs11("div", { className: "flex items-center gap-2 text-sm", children: [
            /* @__PURE__ */ jsx11("div", { children: "Visible" }),
            /* @__PURE__ */ jsx11(BooleanIcon, { value: jobBoard.isVisible || false })
          ] })
        ] }),
        /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Button4, { size: Size3.lg, color: "primary", clicked: toggleIsEditing, children: "Edit Configuration" }) })
      ] }),
      content
    ] })
  ] });
};
var JobBoardAds = ({ routeId: routeId6 }) => {
  const data = useRouteData2(queryDef5, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx11(Fragment4, { children: "Loading..." });
  }
  const { jobBoard } = data;
  if (!jobBoard) {
    return /* @__PURE__ */ jsx11(Fragment4, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs11(Suspense5, { fallback: /* @__PURE__ */ jsx11(EdSkeleton4, {}), children: [
    /* @__PURE__ */ jsx11(MynPageTitle2, { title: "Job Board Ads" }),
    /* @__PURE__ */ jsx11(JobBoardAdsListContainer, { jobBoardId: jobBoard.jobBoardId })
  ] });
};
var Layout = () => {
  const location = useLocation();
  const tabs4 = [
    createLinkState(location, "Details", `details`, UsersIcon),
    createLinkState(location, "Ads", `ads`, UserGroupIcon)
  ];
  return /* @__PURE__ */ jsxs11("div", { className: "flex flex-1 flex-col gap-2", children: [
    /* @__PURE__ */ jsx11("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx11(TabPills, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx11("div", { className: "", children: /* @__PURE__ */ jsx11(Outlet2, {}) })
  ] });
};
var createRoute2 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  const listRouteId = `${routeId6}-ads-list`;
  return {
    id: routeId6,
    path: ":jobBoardCode",
    element: /* @__PURE__ */ jsx11(Layout, {}),
    loader: ({ params }) => {
      return loader2(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx11(JobBoardContainer, { routeId: routeId6, inList })
      },
      {
        id: listRouteId,
        path: "ads/*",
        element: /* @__PURE__ */ jsx11(JobBoardAds, { routeId: routeId6 }),
        children: [
          createRoute(listRouteId, environment, context, true)
        ]
      },
      createRoute(routeId6, environment, context, false),
      {
        path: "*",
        element: /* @__PURE__ */ jsx11(Navigate, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/job-boards/JobBoardsLayout.tsx
import { Navigate as Navigate2 } from "react-router-dom";
import { OutletRoute } from "app-core";
import { MynPageTitle as MynPageTitle3 } from "shared-ui";
import { jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var List3 = () => {
  return /* @__PURE__ */ jsxs12("div", { children: [
    /* @__PURE__ */ jsx12(MynPageTitle3, { title: "Job Boards" }),
    /* @__PURE__ */ jsx12(JobBoardsListContainer, {}),
    ";"
  ] });
};
var createJobBoardsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-job-boards`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx12(OutletRoute, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx12(List3, {}),
          children: [
            createRoute2(listRouteId, environment, context, true)
          ]
        },
        createRoute2(routeId6, environment, context, false),
        {
          path: "*",
          element: /* @__PURE__ */ jsx12(Navigate2, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/testing/email/EmailTestingToolMultiple.tsx
import { jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var formSchemaMultiple = z.object({
  applicantEmailAddressDomain: z.string().min(1, { message: "Domain is required" }),
  applicantEmailAddressPrefix: z.string().min(1, { message: "Prefix is required" }),
  jobBoardAdId: z.string().min(1, { message: "Advert is required" })
});
function EmailTestingToolMultiple() {
  const [vacancyQuery, setVacancyQuery] = useState6("");
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm2({
    resolver: zodResolver2(formSchemaMultiple),
    defaultValues: {
      applicantEmailAddressPrefix: "test+",
      applicantEmailAddressDomain: "http://myn.co.uk"
    }
  });
  const [commit, isPending] = useTestingJobBoardsEmailApplicationSendAll();
  const onSubmit = handleSubmit((data) => {
    commit({
      input: {
        ...data,
        clientMutationId: createClientMutationId4()
      }
    });
  });
  return /* @__PURE__ */ jsxs13("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsx13(MynPageTitle4, { title: "Multiple Email Application Testing" }),
    /* @__PURE__ */ jsxs13("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsxs13("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx13(
          FormInput,
          {
            label: "Email Address Domain",
            "aria-label": "Email Address Domain",
            name: "applicantEmailAddressDomain",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx13(Error2, { children: errors.applicantEmailAddressDomain?.message }),
        /* @__PURE__ */ jsx13(
          FormInput,
          {
            label: "Email Address Prefix",
            "aria-label": "Email Address Prefix",
            name: "applicantEmailAddressPrefix",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx13(Error2, { children: errors.applicantEmailAddressPrefix?.message })
      ] }),
      /* @__PURE__ */ jsxs13("div", { className: "flex flex-col gap-5 rounded-lg border p-2", children: [
        /* @__PURE__ */ jsx13("strong", { className: "text-lg", children: "Job Ads" }),
        /* @__PURE__ */ jsx13(
          DebouncedInput,
          {
            label: "Search for Reference",
            value: vacancyQuery,
            placeholder: "",
            onValueChanged: setVacancyQuery
          }
        ),
        /* @__PURE__ */ jsx13(Suspense6, { children: /* @__PURE__ */ jsx13(
          Controller,
          {
            name: "jobBoardAdId",
            control,
            render: ({ field }) => /* @__PURE__ */ jsx13(
              JobBoardAdsList,
              {
                reference: vacancyQuery,
                showDelete: false,
                selected: field.value,
                onSelect: (vacancy) => {
                  field.onChange(vacancy);
                }
              }
            )
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx13(Error2, { children: errors.jobBoardAdId?.message })
    ] }),
    /* @__PURE__ */ jsxs13("div", { className: "flex items-center gap-5", children: [
      /* @__PURE__ */ jsx13(
        Button5,
        {
          "aria-label": "Submit Form",
          onClick: onSubmit,
          color: "primary",
          disabled: isPending,
          children: "Submit"
        }
      ),
      isPending && /* @__PURE__ */ jsx13(Spinner, {})
    ] })
  ] });
}

// src/secure/testing/email/EmailTestingTool.tsx
import { jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
var formSchema2 = formSchemaMultiple.extend({
  applicantEmailAddressDomain: z2.string().min(1, { message: "Domain is required" }),
  applicantEmailAddressPrefix: z2.string().min(1, { message: "Prefix is required" }),
  applicantFirstName: z2.string().min(1, { message: "First name is required" }),
  applicantLastName: z2.string().min(1, { message: "Last name is required" }),
  testResumeId: z2.string().min(1, { message: "Resmue is required" }),
  failureOptions: z2.object({
    emptyMessage: z2.boolean(),
    garbledCvFile: z2.boolean(),
    garbledMessage: z2.boolean(),
    missingEmailAddress: z2.boolean(),
    missingSubject: z2.boolean(),
    wrongReference: z2.boolean()
  })
});
function EmailTestingTool() {
  const [vacancyQuery, setVacancyQuery] = useState7("");
  const [resumeQuery, setResumeQuery] = useState7("");
  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm3({
    resolver: zodResolver3(formSchema2),
    defaultValues: {
      applicantEmailAddressPrefix: "test+",
      applicantEmailAddressDomain: "http://myn.co.uk"
    }
  });
  const [commit, isPending] = useTestingJobBoardsEmailApplication();
  const onSubmit = handleSubmit((data) => {
    commit({
      input: {
        ...data,
        testResumeId: {
          value: data.testResumeId
        },
        clientMutationId: createClientMutationId5()
      }
    });
  });
  return /* @__PURE__ */ jsxs14("div", { children: [
    /* @__PURE__ */ jsx14(MynPageTitle5, { title: "Single Email Application Testing" }),
    /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx14(
          FormInput2,
          {
            "aria-label": "Email Address Domain",
            label: "Email Address Domain",
            name: "applicantEmailAddressDomain",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx14(Error3, { children: errors.applicantEmailAddressDomain?.message }),
        /* @__PURE__ */ jsx14(
          FormInput2,
          {
            "aria-label": "Email Address Prefix",
            label: "Email Address Prefix",
            name: "applicantEmailAddressPrefix",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx14(Error3, { children: errors.applicantEmailAddressPrefix?.message }),
        /* @__PURE__ */ jsx14(
          FormInput2,
          {
            "aria-label": "First Name",
            label: "First Name",
            name: "applicantFirstName",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx14(Error3, { children: errors.applicantFirstName?.message }),
        /* @__PURE__ */ jsx14(
          FormInput2,
          {
            "aria-label": "Last Name",
            label: "Last Name",
            name: "applicantLastName",
            register,
            required: false
          }
        ),
        /* @__PURE__ */ jsx14(Error3, { children: errors.applicantLastName?.message }),
        /* @__PURE__ */ jsx14(
          DebouncedInput2,
          {
            label: "Search for Resume",
            value: resumeQuery,
            placeholder: "",
            onValueChanged: setResumeQuery
          }
        ),
        /* @__PURE__ */ jsx14(
          Controller2,
          {
            name: "testResumeId",
            control,
            render: ({ field }) => /* @__PURE__ */ jsx14(
              TestResume,
              {
                selected: field.value,
                onSelect: (x) => field.onChange(x.entityId)
              },
              resumeQuery
            )
          }
        ),
        /* @__PURE__ */ jsx14(Error3, { children: errors.testResumeId?.message }),
        /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-5 rounded-lg border p-2", children: [
          /* @__PURE__ */ jsx14("strong", { className: "text-lg", children: "Job Ads" }),
          /* @__PURE__ */ jsx14(
            DebouncedInput2,
            {
              label: "Search for Reference",
              value: vacancyQuery,
              placeholder: "",
              onValueChanged: setVacancyQuery
            }
          ),
          /* @__PURE__ */ jsx14(Suspense7, { children: /* @__PURE__ */ jsx14(
            Controller2,
            {
              name: "jobBoardAdId",
              control,
              render: ({ field }) => /* @__PURE__ */ jsx14(
                JobBoardAdsList,
                {
                  reference: vacancyQuery,
                  showDelete: false,
                  selected: field.value,
                  onSelect: (vacancy) => {
                    field.onChange(vacancy);
                  }
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx14(Error3, { children: errors.jobBoardAdId?.message })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-2 rounded border border bg-white p-5", children: [
        /* @__PURE__ */ jsx14("strong", { className: "text-2xl", children: "Failure Options" }),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.emptyMessage",
            control,
            label: `Empty Message`
          }
        ),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.garbledCvFile",
            control,
            label: `Garbled CV File`
          }
        ),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.garbledMessage",
            control,
            label: `Garbled Message`
          }
        ),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.missingEmailAddress",
            control,
            label: `Missing Email Address`
          }
        ),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.missingSubject",
            control,
            label: `Missing Subject`
          }
        ),
        /* @__PURE__ */ jsx14(
          CheckboxInput,
          {
            name: "failureOptions.wrongReference",
            control,
            label: `Wrong Reference`
          }
        ),
        /* @__PURE__ */ jsxs14(Error3, { children: [
          errors.failureOptions?.emptyMessage?.message,
          errors.failureOptions?.garbledCvFile?.message,
          errors.failureOptions?.garbledMessage?.message,
          errors.failureOptions?.missingEmailAddress?.message,
          errors.failureOptions?.missingSubject?.message,
          errors.failureOptions?.wrongReference?.message
        ] })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-5", children: [
        /* @__PURE__ */ jsx14(
          Button6,
          {
            "aria-label": "Submit Form",
            onClick: onSubmit,
            color: "primary",
            disabled: isPending,
            children: "Submit"
          }
        ),
        isPending && /* @__PURE__ */ jsx14(Spinner2, {})
      ] })
    ] })
  ] });
}

// src/secure/AppAdminSecureLayout.tsx
import { jsx as jsx15, jsxs as jsxs15 } from "react/jsx-runtime";
var queryDef6 = AppAdminSecureLayoutQuery_graphql_default;
var AppAdminSecureRoutes = (environment, context) => {
  return [
    {
      path: "accounts/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createAppAdminAccountsRoutes(environment, context)
    },
    { path: "account/*", element: /* @__PURE__ */ jsx15(Account, {}) },
    {
      path: "custom-data/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createCustomDataRoutes(environment, context)
    },
    {
      path: "data-management/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createDataManagementRoutes(environment, context)
    },
    {
      path: "recruit/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createAppAdminRecruitRoutes(environment, context)
    },
    {
      path: "notifications/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createNotificationRoutes(environment, context)
    },
    {
      path: "integrations/*",
      element: /* @__PURE__ */ jsx15(OutletRoute2, {}),
      children: createIntegrationsRoutes(environment, context)
    },
    { path: "workflows/*", element: /* @__PURE__ */ jsx15(WorkflowsLayout, {}) },
    { path: "system/*", element: /* @__PURE__ */ jsx15(SystemsLayout, {}) },
    {
      path: "testing/*",
      element: /* @__PURE__ */ jsx15(TestingLayout, {}),
      children: [
        { path: "single", element: /* @__PURE__ */ jsx15(EmailTestingTool, {}) },
        { path: "multiple", element: /* @__PURE__ */ jsx15(EmailTestingToolMultiple, {}) },
        { path: "*", element: /* @__PURE__ */ jsx15(Navigate3, { to: "single", replace: true }) }
      ]
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx15("div", { className: "p-4", children: /* @__PURE__ */ jsx15("h3", { children: "Welcome" }) })
    }
  ];
};
var AppAdminSecureLayout = () => {
  const auth = useAuth();
  const preloadedQuery = useLoaderData();
  const data = usePreloadedQuery(queryDef6, preloadedQuery);
  const { account } = data;
  const location = useLocation2();
  const accountLink = createLinkState2(
    location,
    "Account",
    `account`,
    Squares2X2Icon
  );
  const sidebarNavigation = [
    accountLink,
    createLinkState2(location, "Accounts", `accounts`, PhotoIcon),
    createLinkState2(location, "Integrations", `integrations`, CubeIcon),
    createLinkState2(location, "Recruit", `recruit`, DocumentTextIcon),
    createLinkState2(
      location,
      "Notifications",
      `notifications`,
      CircleStackIcon
    ),
    createLinkState2(location, "Custom Data", `custom-data`, CircleStackIcon),
    createLinkState2(location, "Data", `data-management`, CircleStackIcon),
    createLinkState2(location, "Workflows", `workflows`, CubeIcon),
    createLinkState2(location, "System", `system`, CubeIcon),
    createLinkState2(location, "Testing", `testing`, BugAntIcon)
  ];
  const trayNavigation = [
    createLinkState2(location, "Accounts", `accounts`, PhotoIcon),
    createLinkState2(location, "Recruit", `recruit`, DocumentTextIcon),
    createLinkState2(location, "Integrations", `integrations`, CubeIcon),
    createLinkState2(
      location,
      "Notifications",
      `notifications`,
      CircleStackIcon
    )
  ];
  const onSignOut = useCallback5(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  const userNavigation = [
    accountLink,
    {
      name: "Sign out",
      to: ".",
      icon: ArrowRightOnRectangleIcon,
      onClick: onSignOut
    }
  ];
  if (!account) {
    return /* @__PURE__ */ jsxs15("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx15("div", { className: "p-4 font-bold", children: "Logged Out" }),
      /* @__PURE__ */ jsx15("div", { className: "p-4", children: /* @__PURE__ */ jsx15(Button7, { color: "primary", size: Size4.lg, clicked: onSignOut, children: "Sign In" }) })
    ] });
  }
  return /* @__PURE__ */ jsx15(
    CandidateShell,
    {
      accountLink: "/admin/app/account",
      sidebarNavigation,
      userNavigation,
      trayNavigation,
      accountInfo: {
        firstName: account.firstName,
        lastName: account.lastName
      },
      children: /* @__PURE__ */ jsx15(Outlet3, {})
    }
  );
};
async function loader3(environment) {
  return loadQuery3(environment, queryDef6, {});
}

// src/secure/account/Account.tsx
import { useCallback as useCallback6, useState as useState8 } from "react";
import { useCopyToClipboard, useTimeoutFn } from "react-use";
import { Transition } from "@headlessui/react";
import { Button as Button8 } from "shared-ui";
import { getAuthTokenKey, useAuth as useAuth2, useIdentityLink } from "app-core";
import { jsx as jsx16, jsxs as jsxs16 } from "react/jsx-runtime";
var Account = () => {
  const [authKey] = useState8(() => {
    return getAuthTokenKey();
  });
  const auth = useAuth2();
  const [state, copyToClipboard] = useCopyToClipboard();
  const [isShowing, setIsShowing] = useState8(false);
  const [isReady, cancel, reset] = useTimeoutFn(() => {
    setIsShowing(false);
  }, 2e3);
  const accountLink = useIdentityLink();
  const copyAuthToken = useCallback6(() => {
    cancel();
    if (!auth || !auth.userData) {
      alert("not logged in");
      setIsShowing(false);
      return;
    }
    copyToClipboard(
      `"Authorization": "Bearer ${auth?.userData?.access_token}"`
    );
    setIsShowing(true);
    reset();
  }, [auth]);
  if (auth && auth.userData) {
    return /* @__PURE__ */ jsxs16("div", { className: "p-8", children: [
      /* @__PURE__ */ jsxs16("div", { className: "border bg-white p-8 sm:w-1/2", children: [
        /* @__PURE__ */ jsxs16("p", { className: "p-2", children: [
          "Name: ",
          auth?.userData?.profile?.ElevateAccountName
        ] }),
        /* @__PURE__ */ jsxs16("p", { className: "p-2", children: [
          "Email: ",
          auth?.userData?.profile?.email
        ] }),
        /* @__PURE__ */ jsx16("div", { className: "p-2", children: /* @__PURE__ */ jsxs16("div", { className: "flex space-x-2 py-2", children: [
          /* @__PURE__ */ jsx16(
            "a",
            {
              className: "bg-primary-800 text-md rounded-lg border px-2.5 py-1 font-medium text-white",
              href: accountLink,
              target: "identity",
              children: "Go To Identity Account"
            }
          ),
          /* @__PURE__ */ jsx16(
            Button8,
            {
              "aria-label": "Log out",
              clicked: () => auth.signOutRedirect(),
              children: "Log out!"
            }
          ),
          /* @__PURE__ */ jsx16(
            Button8,
            {
              "aria-label": "Copy Auth Token",
              color: "primary",
              clicked: copyAuthToken,
              children: "Copy Auth Token"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsxs16(Transition, { show: isShowing, className: "flex p-2", children: [
          state.value ? /* @__PURE__ */ jsx16("div", { className: "text-success-500 w-48 rounded-md border p-2 font-medium", children: "Copied" }) : null,
          state.error ? /* @__PURE__ */ jsx16("div", { className: "text-danger-500 rounded-md border p-2", children: /* @__PURE__ */ jsxs16("p", { children: [
            "Unable to copy value: ",
            state.error.message
          ] }) }) : null
        ] })
      ] }),
      /* @__PURE__ */ jsx16("div", { className: "mt-4 flex", children: /* @__PURE__ */ jsxs16("div", { className: "flex gap-2 border bg-white p-2", children: [
        /* @__PURE__ */ jsx16("div", { className: "text-primary-700 font-bold", children: "Auth Key" }),
        /* @__PURE__ */ jsx16("div", { className: "font-bold text-gray-800", children: authKey })
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsx16("div", { children: "Not logged in! Try to refresh to be redirected to Google." });
};

// src/secure/custom_data/CustomDataLayout.tsx
import { Suspense as Suspense28 } from "react";
import { Navigate as Navigate12, Outlet as Outlet7, useLocation as useLocation5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import {
  InformationCircleIcon,
  DocumentIcon,
  BuildingStorefrontIcon,
  HomeIcon
} from "@heroicons/react/24/outline";
import { ErrorBoundaryFallback as ErrorBoundaryFallback4 } from "app-core";
import { createLinkState as createLinkState5, MynPageTitle as MynPageTitle23, TabUnderline as TabUnderline3 } from "shared-ui";
import { OutletRoute as OutletRoute8 } from "app-core";

// src/secure/custom_data/form-templates/FormTemplatesRoute.tsx
import { Suspense as Suspense16 } from "react";
import { Navigate as Navigate6 } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import {
  ErrorBoundaryFallback,
  FormTemplateListContainer,
  OutletRoute as OutletRoute4
} from "app-core";

// src/secure/custom_data/form-templates/FormTemplateRoute.tsx
import { Navigate as Navigate5 } from "react-router-dom";
import { ErrorContainer } from "shared-ui";

// src/secure/custom_data/form-templates/__generated__/FormTemplateLayoutQuery.graphql.ts
var node16 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "dbaea3ef06147a68b0b47f50f76bf0f9",
      "id": null,
      "metadata": {},
      "name": "FormTemplateLayoutQuery",
      "operationKind": "query",
      "text": "query FormTemplateLayoutQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n  }\n}\n"
    }
  };
}();
node16.hash = "365f1a9ae1ac686ab40b28164855fa78";
var FormTemplateLayoutQuery_graphql_default = node16;

// src/secure/custom_data/form-templates/FormTemplateLayout.tsx
import { useMemo } from "react";
import {
  Link,
  Outlet as Outlet4,
  useLocation as useLocation3,
  useLoaderData as useLoaderData2,
  useRouteLoaderData
} from "react-router-dom";
import {
  loadQuery as loadQuery4,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import { Suspense as Suspense8 } from "shared-ui";
import {
  createLinkState as createLinkState3,
  DynamicBreadcrumb,
  ExpandButton,
  TabUnderline
} from "shared-ui";
import { Fragment as Fragment5, jsx as jsx17, jsxs as jsxs17 } from "react/jsx-runtime";
var routeId = "form-template-home";
var formTemplateLayoutLayoutQueryDef = FormTemplateLayoutQuery_graphql_default;
var FormTemplateLayout = ({ showHeader }) => {
  const location = useLocation3();
  const tabs4 = useMemo(() => {
    return [
      createLinkState3(location, "Details", `../details`),
      createLinkState3(location, "Viewer", `../viewer`),
      createLinkState3(location, "Editor", `../editor`),
      createLinkState3(location, "Access", `../access`)
    ];
  }, [location]);
  const preloadedQuery = useLoaderData2();
  const data = usePreloadedQuery2(
    formTemplateLayoutLayoutQueryDef,
    preloadedQuery
  );
  const { formTemplate } = data;
  if (formTemplate === null || formTemplate === void 0) {
    return /* @__PURE__ */ jsx17("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx17(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsxs17("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsxs17(Fragment5, { children: [
      /* @__PURE__ */ jsxs17("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
        /* @__PURE__ */ jsx17("div", { className: "p-2", children: /* @__PURE__ */ jsx17(
          ExpandButton,
          {
            to: `../../../${formTemplate.code}`,
            label: "View Form Template"
          }
        ) }),
        /* @__PURE__ */ jsx17(DynamicBreadcrumb, {}),
        /* @__PURE__ */ jsx17("div", { className: "text-primary-700 px-2 font-medium uppercase sm:px-8", children: formTemplate.name })
      ] }),
      /* @__PURE__ */ jsx17("div", { className: "flex flex-wrap items-center gap-2 border-b p-4", children: /* @__PURE__ */ jsx17("div", { className: "text-primary-700 font-medium uppercase", children: formTemplate.description }) })
    ] }),
    /* @__PURE__ */ jsx17("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx17(TabUnderline, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx17(Outlet4, {})
  ] }) });
};
var FormTemplateLink = ({ routeId: routeId6, label }) => {
  const data = useFormTemplateRouteData(routeId6);
  if (!data.formTemplate) {
    return /* @__PURE__ */ jsx17(Fragment5, {});
  }
  const name = `${data.formTemplate.name}`;
  return /* @__PURE__ */ jsx17(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsx17(Link, { to: ".", children: label || name }) });
};
async function loader4(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery4(
    environment,
    formTemplateLayoutLayoutQueryDef,
    {
      formTemplateCode
    }
  );
}
function useFormTemplateRouteData(routeId6) {
  const queryRef = useRouteLoaderData(
    routeId6
  );
  const data = usePreloadedQuery2(
    formTemplateLayoutLayoutQueryDef,
    queryRef
  );
  return data;
}

// src/secure/custom_data/form-templates/__generated__/FormTemplateDetailsRouteQuery.graphql.ts
var node17 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ace209220d40c0276a39b2d53cc67b29",
      "id": null,
      "metadata": {},
      "name": "FormTemplateDetailsRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateDetailsRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n    updatedAt\n  }\n}\n"
    }
  };
}();
node17.hash = "2da8f9b77cb1001e0b9c6953e7d043e2";
var FormTemplateDetailsRouteQuery_graphql_default = node17;

// src/secure/custom_data/form-templates/FormTemplateDetails.tsx
import { Suspense as Suspense9 } from "react";
import { loadQuery as loadQuery5 } from "react-relay";
import { Link as Link2 } from "react-router-dom";
import { timeAgo as timeAgo2, useRouteData as useRouteData3 } from "shared-lib";
import { EdSkeleton as EdSkeleton5, MynPageTitle as MynPageTitle6 } from "shared-ui";
import { Fragment as Fragment6, jsx as jsx18, jsxs as jsxs18 } from "react/jsx-runtime";
var queryDef7 = FormTemplateDetailsRouteQuery_graphql_default;
async function loader5(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery5(environment, queryDef7, {
    formTemplateCode
  });
}
var FormTemplateDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData3(queryDef7, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx18(Fragment6, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx18(Fragment6, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs18(Suspense9, { fallback: /* @__PURE__ */ jsx18(EdSkeleton5, {}), children: [
    /* @__PURE__ */ jsx18(MynPageTitle6, { title: "Form Template Details" }),
    /* @__PURE__ */ jsx18("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: /* @__PURE__ */ jsxs18("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs18("div", { className: "flex items-center justify-between gap-2 border-b", children: [
        /* @__PURE__ */ jsx18("div", { className: "text-primary-700 p-4 text-lg font-medium", children: formTemplate.name }),
        /* @__PURE__ */ jsxs18("div", { className: "text-primary-700 p-4 text-sm", children: [
          "Updated ",
          timeAgo2(formTemplate.updatedAt)
        ] })
      ] }),
      /* @__PURE__ */ jsx18("div", { className: "text-md p-4 text-gray-900", children: formTemplate.description })
    ] }) })
  ] });
};
var createRoute3 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-root`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx18(FormTemplateDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx18(Link2, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader5(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateEditRouteQuery.graphql.ts
var node18 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateEditRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateEditor_formTemplate"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateEditRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "typeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowPreFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresSignature",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "htmlTemplate",
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0c8a9ad97a2b76ac402ee3e206e93f9b",
      "id": null,
      "metadata": {},
      "name": "FormTemplateEditRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateEditRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    ...FormTemplateEditor_formTemplate\n  }\n}\n\nfragment FormTemplateEditor_formTemplate on FormTemplate {\n  id\n  formTemplateId\n  version\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n  typeId\n  allowPreFilling\n  requiresSignature\n  uiSchema\n  dataSchema\n  documentTypeId\n  htmlTemplate\n}\n"
    }
  };
}();
node18.hash = "6173452a179b4685e1444659bf694748";
var FormTemplateEditRouteQuery_graphql_default = node18;

// src/secure/custom_data/form-templates/FormTemplateEdit.tsx
import { useCallback as useCallback7 } from "react";
import { loadQuery as loadQuery6 } from "react-relay";
import { Link as Link3, useNavigate as useNavigate3 } from "react-router-dom";
import { MynPageTitle as MynPageTitle7, Suspense as Suspense10 } from "shared-ui";
import { useRouteData as useRouteData4 } from "shared-lib";
import { EdSkeleton as EdSkeleton6 } from "shared-ui";
import { FormTemplateEditor } from "app-core";
import { Fragment as Fragment7, jsx as jsx19, jsxs as jsxs19 } from "react/jsx-runtime";
var queryDef8 = FormTemplateEditRouteQuery_graphql_default;
async function loader6(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery6(environment, queryDef8, {
    formTemplateCode
  });
}
var FormTemplateEdit = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate3();
  const data = useRouteData4(queryDef8, routeId6);
  const onNavigateToDetails = useCallback7(() => {
    navigate("../details");
  }, []);
  if (!data) {
    return /* @__PURE__ */ jsx19(Fragment7, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx19(Fragment7, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs19(Suspense10, { fallback: /* @__PURE__ */ jsx19(EdSkeleton6, {}), children: [
    /* @__PURE__ */ jsx19(MynPageTitle7, { title: "Form Template Editor" }),
    /* @__PURE__ */ jsx19(
      FormTemplateEditor,
      {
        fragmentRef: formTemplate,
        onSaved: onNavigateToDetails,
        onCancel: onNavigateToDetails
      }
    )
  ] });
};
var createRoute4 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-edit`;
  return {
    id: routeId6,
    path: "editor",
    element: /* @__PURE__ */ jsx19(FormTemplateEdit, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx19(Link3, { to: "editor", children: "Editor" })
    },
    loader: ({ params }) => {
      return loader6(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateViewerRouteQuery.graphql.ts
var node19 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "alias": "formTemplate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "formTemplateCode"
        }
      ],
      "concreteType": "FormTemplate",
      "kind": "LinkedField",
      "name": "customDataFormTemplateByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataSchema",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uiSchema",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateViewerRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateViewerRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "b82374716bd6ae6cc28da8a862961f97",
      "id": null,
      "metadata": {},
      "name": "FormTemplateViewerRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateViewerRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    code\n    key\n    name\n    description\n    updatedAt\n    dataSchema\n    uiSchema\n  }\n}\n"
    }
  };
}();
node19.hash = "37e096beb392f87b233d610b5fcaa43c";
var FormTemplateViewerRouteQuery_graphql_default = node19;

// src/secure/custom_data/form-templates/FormTemplateViewer.tsx
import { useCallback as useCallback8, useState as useState9 } from "react";
import { loadQuery as loadQuery7 } from "react-relay";
import { Link as Link4 } from "react-router-dom";
import { JsonForms } from "@jsonforms/react";
import { JsonFormsStyleContext } from "@jsonforms/vanilla-renderers";
import { MynPageTitle as MynPageTitle8, Suspense as Suspense11 } from "shared-ui";
import { useRouteData as useRouteData5, useToggle as useToggle2 } from "shared-lib";
import {
  Button as Button9,
  ButtonList,
  EdSkeleton as EdSkeleton7,
  elevateJsonFormsCells,
  elevateJsonFormsRenderers,
  elevateJsonFormsStyleContext
} from "shared-ui";
import { Fragment as Fragment8, jsx as jsx20, jsxs as jsxs20 } from "react/jsx-runtime";
var queryDef9 = FormTemplateViewerRouteQuery_graphql_default;
async function loader7(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery7(environment, queryDef9, {
    formTemplateCode
  });
}
var FormTemplateViewer = ({ routeId: routeId6, inList }) => {
  const data = useRouteData5(queryDef9, routeId6);
  const [hasErrors, setHasErrors] = useState9(false);
  const [formData, setFormData] = useState9({});
  const [renderJson, toggleRenderJson] = useToggle2();
  const onChange = useCallback8(
    (form) => {
      setFormData(form);
    },
    [formData]
  );
  const onSave = useCallback8(() => {
    toggleRenderJson();
  }, [toggleRenderJson]);
  const onCancel = useCallback8(() => {
    toggleRenderJson();
  }, [toggleRenderJson]);
  const onFormChanged = useCallback8(
    ({ data: data2, errors }) => {
      onChange(data2);
      if (errors) {
        const hasError = errors.filter((e) => e.data).length > 0;
        setHasErrors(hasError);
      } else {
        setHasErrors(false);
      }
    },
    [onChange, setHasErrors]
  );
  if (!data) {
    return /* @__PURE__ */ jsx20(Fragment8, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx20(Fragment8, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs20(Suspense11, { fallback: /* @__PURE__ */ jsx20(EdSkeleton7, {}), children: [
    /* @__PURE__ */ jsx20(MynPageTitle8, { title: "Form Template Viewer" }),
    formTemplate.dataSchema && formTemplate.uiSchema && /* @__PURE__ */ jsxs20("div", { className: "m-8 border bg-white px-8 py-2", children: [
      /* @__PURE__ */ jsx20(JsonFormsStyleContext.Provider, { value: elevateJsonFormsStyleContext, children: /* @__PURE__ */ jsx20(
        JsonForms,
        {
          data: formData,
          schema: JSON.parse(formTemplate.dataSchema),
          uischema: JSON.parse(formTemplate.uiSchema),
          renderers: elevateJsonFormsRenderers,
          cells: elevateJsonFormsCells,
          onChange: onFormChanged
        }
      ) }),
      renderJson && /* @__PURE__ */ jsx20("div", { className: "border bg-white p-4", children: JSON.stringify(formData) }),
      /* @__PURE__ */ jsx20("div", { className: "mt-4 border-t py-4", children: /* @__PURE__ */ jsxs20(ButtonList, { children: [
        /* @__PURE__ */ jsx20("div", { children: /* @__PURE__ */ jsx20(
          Button9,
          {
            "aria-label": "Save",
            color: "primary",
            disabled: hasErrors,
            clicked: onSave,
            children: "Save"
          }
        ) }),
        /* @__PURE__ */ jsx20("div", { children: /* @__PURE__ */ jsx20(
          Button9,
          {
            "aria-label": "Cancel",
            color: "gray",
            clicked: () => {
              onCancel();
            },
            children: "Cancel"
          }
        ) })
      ] }) })
    ] })
  ] });
};
var createRoute5 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-viewer`;
  return {
    id: routeId6,
    path: "viewer",
    element: /* @__PURE__ */ jsx20(FormTemplateViewer, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx20(Link4, { to: "viewer", children: "Viewer" })
    },
    loader: ({ params }) => {
      return loader7(environment, params);
    }
  };
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessRouteQuery.graphql.ts
var node20 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateTypeId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4,
                v2
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b238631b4ba9cd73ea0edb83d4199f51",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    formTemplateType {\n      formTemplateTypeId\n      id\n    }\n  }\n}\n"
    }
  };
}();
node20.hash = "5eef71c170166f44a456fa9a0799fc69";
var FormTemplateAccessRouteQuery_graphql_default = node20;

// src/secure/custom_data/form-templates/FormTemplateAccessRoute.tsx
import { Suspense as Suspense14 } from "react";
import { loadQuery as loadQuery10 } from "react-relay";
import { Navigate as Navigate4 } from "react-router-dom";
import { useRouteData as useRouteData8 } from "shared-lib";
import { EdSkeleton as EdSkeleton10, EdTextLink, MynPageTitle as MynPageTitle11 } from "shared-ui";
import {
  OutletRoute as OutletRoute3,
  FormTemplateAccessListContainer
} from "app-core";

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessAddRouteQuery.graphql.ts
var node21 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateTypeId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessAddRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateTypeAddAccess_formTemplate"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessAddRouteQuery",
      "selections": [
        {
          "alias": "formTemplate",
          "args": v1,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "customDataFormTemplateByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "FormTemplateType",
              "kind": "LinkedField",
              "name": "formTemplateType",
              "plural": false,
              "selections": [
                v4,
                v2
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "typeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowPreFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresSignature",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "htmlTemplate",
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e5e85b4c687fee404e2166e4e7d7aec2",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessAddRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessAddRouteQuery(\n  $formTemplateCode: Int!\n) {\n  formTemplate: customDataFormTemplateByCode(code: $formTemplateCode) {\n    id\n    formTemplateId\n    formTemplateType {\n      formTemplateTypeId\n      id\n    }\n    ...FormTemplateTypeAddAccess_formTemplate\n  }\n}\n\nfragment FormTemplateTypeAddAccess_formTemplate on FormTemplate {\n  id\n  formTemplateId\n  formTemplateType {\n    id\n    formTemplateTypeId\n  }\n  version\n  code\n  createdAt\n  updatedAt\n  key\n  name\n  description\n  typeId\n  allowPreFilling\n  requiresSignature\n  uiSchema\n  dataSchema\n  documentTypeId\n  htmlTemplate\n}\n"
    }
  };
}();
node21.hash = "c46274a98b90d9913b019da742a0eab5";
var FormTemplateAccessAddRouteQuery_graphql_default = node21;

// src/secure/custom_data/form-templates/FormTemplateAccessAddRoute.tsx
import { useCallback as useCallback9 } from "react";
import { loadQuery as loadQuery8 } from "react-relay";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { MynPageTitle as MynPageTitle9, Suspense as Suspense12 } from "shared-ui";
import { useRouteData as useRouteData6 } from "shared-lib";
import { EdSkeleton as EdSkeleton8 } from "shared-ui";
import { FormTemplateTypeAddAccess } from "app-core";
import { Fragment as Fragment9, jsx as jsx21, jsxs as jsxs21 } from "react/jsx-runtime";
var queryDef10 = FormTemplateAccessAddRouteQuery_graphql_default;
async function loader8(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery8(environment, queryDef10, {
    formTemplateCode
  });
}
var FormTemplateAccessAddRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate4();
  const data = useRouteData6(queryDef10, routeId6);
  const onNavigateToList = useCallback9(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx21(Fragment9, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx21(Fragment9, { children: "Add Loading..." });
  }
  return /* @__PURE__ */ jsx21(Suspense12, { fallback: /* @__PURE__ */ jsx21(EdSkeleton8, {}), children: /* @__PURE__ */ jsxs21("div", { className: "md:m-4 lg:m-8", children: [
    /* @__PURE__ */ jsx21(MynPageTitle9, { title: "Add Form Template Access" }),
    /* @__PURE__ */ jsx21(
      FormTemplateTypeAddAccess,
      {
        fragmentRef: formTemplate,
        onSaved: onNavigateToList,
        onCancel: onNavigateToList
      }
    )
  ] }) });
};

// src/secure/custom_data/form-templates/__generated__/FormTemplateAccessViewRouteQuery.graphql.ts
var node22 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "formTemplateAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formTemplateAccessId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FormTemplateAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "FormTemplateAccess",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FormTemplateAccessContainer_access"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FormTemplateAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "FormTemplateAccess",
          "kind": "LinkedField",
          "name": "customDataFormTemplateAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalOrganisationName",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "285775f8a04ef056eed3fa2ef2f83e3e",
      "id": null,
      "metadata": {},
      "name": "FormTemplateAccessViewRouteQuery",
      "operationKind": "query",
      "text": "query FormTemplateAccessViewRouteQuery(\n  $formTemplateAccessCode: Int!\n) {\n  access: customDataFormTemplateAccessByCode(code: $formTemplateAccessCode) {\n    id\n    formTemplateAccessId\n    code\n    ...FormTemplateAccessContainer_access\n  }\n}\n\nfragment FormTemplateAccessContainer_access on FormTemplateAccess {\n  id\n  formTemplateAccessId\n  code\n  createdAt\n  updatedAt\n  status\n  version\n  organisation {\n    externalOrganisationName\n    id\n  }\n}\n"
    }
  };
}();
node22.hash = "555c61625f1a2b39352bc7c84966434f";
var FormTemplateAccessViewRouteQuery_graphql_default = node22;

// src/secure/custom_data/form-templates/FormTemplateAccessViewRoute.tsx
import { useCallback as useCallback10 } from "react";
import { loadQuery as loadQuery9 } from "react-relay";
import { useNavigate as useNavigate5 } from "react-router-dom";
import { MynPageTitle as MynPageTitle10, Suspense as Suspense13 } from "shared-ui";
import { useRouteData as useRouteData7 } from "shared-lib";
import { EdSkeleton as EdSkeleton9 } from "shared-ui";
import { FormTemplateAccessContainer } from "app-core";
import { Fragment as Fragment10, jsx as jsx22, jsxs as jsxs22 } from "react/jsx-runtime";
var queryDef11 = FormTemplateAccessViewRouteQuery_graphql_default;
async function loader9(environment, params) {
  const code = params.formTemplateAccessCode;
  const formTemplateAccessCode = parseInt(code);
  return loadQuery9(environment, queryDef11, {
    formTemplateAccessCode
  });
}
var FormTemplateAccessViewRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate5();
  const data = useRouteData7(
    queryDef11,
    routeId6
  );
  const onNavigateToList = useCallback10(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx22(Fragment10, { children: "Loading..." });
  }
  const { access } = data;
  if (!access) {
    return /* @__PURE__ */ jsx22(Fragment10, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx22(Suspense13, { fallback: /* @__PURE__ */ jsx22(EdSkeleton9, {}), children: /* @__PURE__ */ jsxs22("div", { className: "flex-1 md:m-4 lg:m-8", children: [
    /* @__PURE__ */ jsx22(MynPageTitle10, { title: "Form Template Access View" }),
    /* @__PURE__ */ jsx22(
      FormTemplateAccessContainer,
      {
        fragmentRef: access,
        onRemoved: onNavigateToList
      }
    )
  ] }) });
};

// src/secure/custom_data/form-templates/FormTemplateAccessRoute.tsx
import { Fragment as Fragment11, jsx as jsx23, jsxs as jsxs23 } from "react/jsx-runtime";
var queryDef12 = FormTemplateAccessRouteQuery_graphql_default;
async function loader10(environment, params) {
  const code = params.formTemplateCode;
  const formTemplateCode = parseInt(code);
  return loadQuery10(environment, queryDef12, {
    formTemplateCode
  });
}
var ListHeader = () => {
  return /* @__PURE__ */ jsx23("div", { className: "flex justify-end border-b p-2", children: /* @__PURE__ */ jsx23(EdTextLink, { id: "add-link", to: "../add", label: "Add" }) });
};
var List4 = ({ routeId: routeId6, inList }) => {
  const data = useRouteData8(queryDef12, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx23(Fragment11, { children: "Loading..." });
  }
  const { formTemplate } = data;
  if (!formTemplate) {
    return /* @__PURE__ */ jsx23(Fragment11, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs23(Suspense14, { fallback: /* @__PURE__ */ jsx23(EdSkeleton10, {}), children: [
    /* @__PURE__ */ jsx23(MynPageTitle11, { title: "Form Template Access" }),
    /* @__PURE__ */ jsx23(
      FormTemplateAccessListContainer,
      {
        formTemplateTypeId: formTemplate?.formTemplateType.formTemplateTypeId,
        listHeader: /* @__PURE__ */ jsx23(ListHeader, {})
      }
    )
  ] });
};
var createRoute6 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-access`;
  const listRouteId = `${routeId6}-list`;
  const editRouteId = `${routeId6}-edit`;
  const editListRouteId = `${listRouteId}-edit`;
  const addRouteId = `${routeId6}-add`;
  return {
    id: routeId6,
    path: "access",
    element: /* @__PURE__ */ jsx23(OutletRoute3, {}),
    loader: ({ params }) => {
      return loader10(environment, params);
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx23(List4, { routeId: routeId6, inList }),
        children: [
          {
            id: editListRouteId,
            path: ":formTemplateAccessCode",
            element: /* @__PURE__ */ jsx23(
              FormTemplateAccessViewRoute,
              {
                routeId: editListRouteId,
                inList
              }
            ),
            loader: ({ params }) => {
              return loader9(environment, params);
            }
          }
        ]
      },
      {
        id: editRouteId,
        path: ":formTemplateAccessCode",
        element: /* @__PURE__ */ jsx23(FormTemplateAccessViewRoute, { routeId: routeId6, inList }),
        loader: ({ params }) => {
          return loader9(environment, params);
        }
      },
      {
        id: addRouteId,
        path: "add",
        element: /* @__PURE__ */ jsx23(FormTemplateAccessAddRoute, { routeId: addRouteId, inList }),
        loader: ({ params }) => {
          return loader8(environment, params);
        }
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx23(Navigate4, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/custom_data/form-templates/FormTemplateRoute.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var createFormTemplateRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx24(FormTemplateLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx24(ErrorContainer, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx24(FormTemplateLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader4(environment, params);
      },
      children: [
        createRoute3(routePrefix, environment, context, inList),
        createRoute5(routePrefix, environment, context, inList),
        createRoute4(routePrefix, environment, context, inList),
        createRoute6(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx24(Navigate5, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/form-templates/FormTemplateCreate.tsx
import { useCallback as useCallback11 } from "react";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { MynPageTitle as MynPageTitle12, Suspense as Suspense15 } from "shared-ui";
import { EdSkeleton as EdSkeleton11 } from "shared-ui";
import { FormTemplateCreate } from "app-core";
import { jsx as jsx25, jsxs as jsxs24 } from "react/jsx-runtime";
var FormTemplateCreateContainer = () => {
  const navigate = useNavigate6();
  const onCreated = useCallback11((template) => {
    navigate(`../${template.code}`);
  }, []);
  const onCancel = useCallback11(() => {
    navigate("../list");
  }, []);
  return /* @__PURE__ */ jsxs24(Suspense15, { fallback: /* @__PURE__ */ jsx25(EdSkeleton11, {}), children: [
    /* @__PURE__ */ jsx25(MynPageTitle12, { title: "Create Form Template" }),
    /* @__PURE__ */ jsx25(FormTemplateCreate, { onCreated, onCancel })
  ] });
};

// src/secure/custom_data/form-templates/FormTemplatesRoute.tsx
import { MynPageTitle as MynPageTitle13 } from "shared-ui";
import { jsx as jsx26, jsxs as jsxs25 } from "react/jsx-runtime";
var Layout2 = () => {
  return /* @__PURE__ */ jsx26(Suspense16, { fallback: "Loading Form Templates...", children: /* @__PURE__ */ jsxs25(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: [
    /* @__PURE__ */ jsx26(MynPageTitle13, { title: "Form Templates" }),
    /* @__PURE__ */ jsx26(FormTemplateListContainer, {})
  ] }) });
};
var createFormTemplatesRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-list`;
  return [
    {
      id: routeId6,
      path: "list/*",
      element: /* @__PURE__ */ jsx26(Layout2, {}),
      children: [
        {
          id: `${routeId6}-template`,
          path: ":formTemplateCode/*",
          element: /* @__PURE__ */ jsx26(OutletRoute4, {}),
          children: createFormTemplateRoutes(
            `${routeId6}-template`,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: `${routePrefix}-template`,
      path: ":formTemplateCode/*",
      element: /* @__PURE__ */ jsx26(OutletRoute4, {}),
      children: createFormTemplateRoutes(
        `${routePrefix}-template`,
        environment,
        context,
        false,
        false
      )
    },
    {
      id: `${routePrefix}-create`,
      path: "create",
      element: /* @__PURE__ */ jsx26(FormTemplateCreateContainer, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx26(Navigate6, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/organisations/OrganisationsRoute.tsx
import { Suspense as Suspense20 } from "react";
import { Navigate as Navigate8 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback2,
  OrganisationListContainer,
  OutletRoute as OutletRoute5
} from "app-core";

// src/secure/custom_data/organisations/OrganisationRoute.tsx
import { Navigate as Navigate7 } from "react-router-dom";
import { ErrorContainer as ErrorContainer2 } from "shared-ui";

// src/secure/custom_data/organisations/__generated__/OrganisationLayoutQuery.graphql.ts
var node23 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationCode"
    }
  ], v1 = [
    {
      "alias": "organisation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "organisationCode"
        }
      ],
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "customDataOrganisationByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "69397cd329429bd2fd99d50eaac958eb",
      "id": null,
      "metadata": {},
      "name": "OrganisationLayoutQuery",
      "operationKind": "query",
      "text": "query OrganisationLayoutQuery(\n  $organisationCode: Int!\n) {\n  organisation: customDataOrganisationByCode(code: $organisationCode) {\n    id\n    organisationId\n    createdAt\n    updatedAt\n    code\n    externalOrganisationName\n    externalOrganisationId\n    status\n  }\n}\n"
    }
  };
}();
node23.hash = "56b5cba04649edb5f28db6eeae564ed5";
var OrganisationLayoutQuery_graphql_default = node23;

// src/secure/custom_data/organisations/OrganisationLayout.tsx
import { Suspense as Suspense17 } from "react";
import {
  Link as Link5,
  Outlet as Outlet5,
  useLoaderData as useLoaderData3,
  useRouteLoaderData as useRouteLoaderData2
} from "react-router-dom";
import {
  loadQuery as loadQuery11,
  usePreloadedQuery as usePreloadedQuery3
} from "react-relay";
import { DynamicBreadcrumb as DynamicBreadcrumb2, EdTextLink as EdTextLink2 } from "shared-ui";
import { Fragment as Fragment12, jsx as jsx27, jsxs as jsxs26 } from "react/jsx-runtime";
var routeId2 = "form-template-home";
var organisationLayoutLayoutQueryDef = OrganisationLayoutQuery_graphql_default;
var OrganisationLayout = ({ showHeader }) => {
  const preloadedQuery = useLoaderData3();
  const data = usePreloadedQuery3(
    organisationLayoutLayoutQueryDef,
    preloadedQuery
  );
  const { organisation } = data;
  if (organisation === null || organisation === void 0) {
    return /* @__PURE__ */ jsx27("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx27(Suspense17, { fallback: "Loading...", children: /* @__PURE__ */ jsxs26("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsxs26("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx27(DynamicBreadcrumb2, {}),
      /* @__PURE__ */ jsx27("div", { className: "text-primary-700 px-2 font-medium uppercase sm:px-8", children: organisation.externalOrganisationName })
    ] }) }),
    /* @__PURE__ */ jsxs26("div", { className: "flex flex-wrap items-center gap-2 border-b bg-gray-50 px-4", children: [
      /* @__PURE__ */ jsx27(
        EdTextLink2,
        {
          id: "form-template-root-link-details",
          to: "details",
          label: "Details"
        }
      ),
      /* @__PURE__ */ jsx27(EdTextLink2, { id: "form-template-root-link-viewer", to: "viewer", label: "Viewer" })
    ] }),
    /* @__PURE__ */ jsx27(Outlet5, {})
  ] }) });
};
var OrganisationLink = ({ routeId: routeId6, label }) => {
  const data = useOrganisationRouteData(routeId6);
  if (!data.organisation) {
    return /* @__PURE__ */ jsx27(Fragment12, {});
  }
  const name = `${data.organisation.externalOrganisationName}`;
  return /* @__PURE__ */ jsx27(Suspense17, { fallback: "Loading...", children: /* @__PURE__ */ jsx27(Link5, { to: ".", children: label || name }) });
};
async function loader11(environment, params) {
  const code = params.organisationCode;
  const organisationCode = parseInt(code);
  return loadQuery11(
    environment,
    organisationLayoutLayoutQueryDef,
    {
      organisationCode
    }
  );
}
function useOrganisationRouteData(routeId6) {
  const queryRef = useRouteLoaderData2(
    routeId6
  );
  const data = usePreloadedQuery3(
    organisationLayoutLayoutQueryDef,
    queryRef
  );
  return data;
}

// src/secure/custom_data/organisations/__generated__/OrganisationDetailsRouteQuery.graphql.ts
var node24 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationCode"
    }
  ], v1 = [
    {
      "alias": "organisation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "organisationCode"
        }
      ],
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "customDataOrganisationByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalOrganisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OrganisationDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OrganisationDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "6f85a95576aa1500c52f0c1cfcc21ea3",
      "id": null,
      "metadata": {},
      "name": "OrganisationDetailsRouteQuery",
      "operationKind": "query",
      "text": "query OrganisationDetailsRouteQuery(\n  $organisationCode: Int!\n) {\n  organisation: customDataOrganisationByCode(code: $organisationCode) {\n    id\n    organisationId\n    createdAt\n    updatedAt\n    code\n    externalOrganisationName\n    externalOrganisationId\n    status\n  }\n}\n"
    }
  };
}();
node24.hash = "01aa91c932c2252af67e75e7cc969012";
var OrganisationDetailsRouteQuery_graphql_default = node24;

// src/secure/custom_data/organisations/OrganisationDetails.tsx
import { Suspense as Suspense18 } from "react";
import { loadQuery as loadQuery12 } from "react-relay";
import { Link as Link6 } from "react-router-dom";
import { timeAgo as timeAgo3, useRouteData as useRouteData9 } from "shared-lib";
import { EdSkeleton as EdSkeleton12, MynPageTitle as MynPageTitle14 } from "shared-ui";
import { Fragment as Fragment13, jsx as jsx28, jsxs as jsxs27 } from "react/jsx-runtime";
var queryDef13 = OrganisationDetailsRouteQuery_graphql_default;
async function loader12(environment, params) {
  const code = params.organisationCode;
  const organisationCode = parseInt(code);
  try {
    return loadQuery12(environment, queryDef13, {
      organisationCode
    });
  } catch (e) {
    console.error("OrganisationDetails Loader Failed.");
    console.error(e);
    throw e;
  }
}
var OrganisationDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData9(queryDef13, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx28(Fragment13, { children: "Loading..." });
  }
  const { organisation } = data;
  if (!organisation) {
    return /* @__PURE__ */ jsx28(Fragment13, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs27(Suspense18, { fallback: /* @__PURE__ */ jsx28(EdSkeleton12, {}), children: [
    /* @__PURE__ */ jsx28(MynPageTitle14, { title: "Organisation Details" }),
    /* @__PURE__ */ jsxs27("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: [
      /* @__PURE__ */ jsxs27("div", { className: "my-4 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx28("div", { className: "text-primary-700 px-4 text-lg font-medium", children: organisation.externalOrganisationName }),
        /* @__PURE__ */ jsxs27("div", { className: "text-primary-700 text-md px-4", children: [
          "Updated ",
          timeAgo3(organisation.updatedAt)
        ] })
      ] }),
      inList && /* @__PURE__ */ jsx28("div", { children: /* @__PURE__ */ jsx28(Link6, { to: `../../../${organisation.code}`, children: "View" }) })
    ] })
  ] });
};
var createRoute7 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-form-template-root`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx28(OrganisationDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx28(Link6, { to: "details", children: "Organisation" })
    },
    loader: ({ params }) => {
      return loader12(environment, params);
    }
  };
};

// src/secure/custom_data/organisations/OrganisationRoute.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var createOrganisationRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId2}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx29(OrganisationLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx29(ErrorContainer2, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx29(OrganisationLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader11(environment, params);
      },
      children: [
        createRoute7(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx29(Navigate7, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/organisations/OrganisationCreate.tsx
import { useCallback as useCallback13 } from "react";
import { useNavigate as useNavigate7 } from "react-router-dom";
import { MynPageTitle as MynPageTitle15, Suspense as Suspense19 } from "shared-ui";
import { EdSkeleton as EdSkeleton13 } from "shared-ui";

// src/secure/custom_data/organisations/OrganisationCreateContainer.tsx
import { useCallback as useCallback12, useState as useState10 } from "react";
import { createClientMutationId as createClientMutationId6 } from "shared-lib";
import { Button as Button10, Size as Size5 } from "shared-ui";
import {
  EmployerSearchContainer
} from "feature-employer-accounts";
import {
  useCustomDataOrganisationCreate
} from "app-core";
import { jsx as jsx30, jsxs as jsxs28 } from "react/jsx-runtime";
var OrganisationCreateContainer = ({
  onDone,
  onCancel
}) => {
  const [create, isCreating] = useCustomDataOrganisationCreate();
  const [employer, setEmployer] = useState10(null);
  const onEmployerChange = useCallback12(
    (e) => {
      setEmployer(e);
    },
    [setEmployer]
  );
  const onCreate = useCallback12(async () => {
    if (!employer) {
      return;
    }
    const input = {
      externalOrganisationId: employer.employerId,
      externalOrganisationName: employer.name,
      clientMutationId: createClientMutationId6()
    };
    const response = await create({ input });
    if (response.data.organisation?.node) {
      onDone(response.data.organisation?.node);
    }
  }, [employer, create, onDone]);
  return /* @__PURE__ */ jsxs28("div", { className: "mx-auto my-8 flex flex-col gap-2 border bg-white p-8 md:w-1/2", children: [
    /* @__PURE__ */ jsxs28("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx30("div", { className: "text-primary-700 text-lg", children: /* @__PURE__ */ jsx30("label", { children: "Select Employer" }) }),
      /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsx30(EmployerSearchContainer, { onSearchCompleted: onEmployerChange }) })
    ] }),
    /* @__PURE__ */ jsx30("div", { className: "mt-8 flex items-center justify-end gap-2", children: /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsx30(
      Button10,
      {
        "aria-label": "Create Organization",
        disabled: isCreating,
        size: Size5.xl,
        color: "primary",
        clicked: onCreate,
        children: "Create"
      }
    ) }) })
  ] });
};

// src/secure/custom_data/organisations/OrganisationCreate.tsx
import { jsx as jsx31, jsxs as jsxs29 } from "react/jsx-runtime";
var OrganisationCreate = () => {
  const navigate = useNavigate7();
  const onCancel = useCallback13(() => {
    navigate(`../list`);
  }, [navigate]);
  const onDone = useCallback13(
    (data) => {
      navigate(`../${data.code}`);
    },
    [navigate]
  );
  return /* @__PURE__ */ jsxs29(Suspense19, { fallback: /* @__PURE__ */ jsx31(EdSkeleton13, {}), children: [
    /* @__PURE__ */ jsx31(MynPageTitle15, { title: "Create Organisation" }),
    /* @__PURE__ */ jsx31(OrganisationCreateContainer, { onDone, onCancel })
  ] });
};

// src/secure/custom_data/organisations/OrganisationsRoute.tsx
import { MynPageTitle as MynPageTitle16 } from "shared-ui";
import { jsx as jsx32, jsxs as jsxs30 } from "react/jsx-runtime";
var Layout3 = () => {
  return /* @__PURE__ */ jsx32(Suspense20, { fallback: "Loading Organisations...", children: /* @__PURE__ */ jsxs30(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: [
    /* @__PURE__ */ jsx32(MynPageTitle16, { title: "Organisations" }),
    /* @__PURE__ */ jsx32(OrganisationListContainer, {})
  ] }) });
};
var createOrganisationsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-list`;
  const createRouteId = `${routePrefix}-create`;
  return [
    {
      id: routeId6,
      path: "list/*",
      element: /* @__PURE__ */ jsx32(Layout3, {}),
      children: [
        {
          id: `${routeId6}-template`,
          path: ":organisationCode/*",
          element: /* @__PURE__ */ jsx32(OutletRoute5, {}),
          children: createOrganisationRoutes(
            `${routeId6}-template`,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: createRouteId,
      path: "create",
      element: /* @__PURE__ */ jsx32(OrganisationCreate, {})
    },
    {
      id: `${routePrefix}-template`,
      path: ":organisationCode/*",
      element: /* @__PURE__ */ jsx32(OutletRoute5, {}),
      children: createOrganisationRoutes(
        `${routePrefix}-template`,
        environment,
        context,
        false,
        false
      )
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx32(Navigate8, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/document-types/DocumentTypesRoute.tsx
import { Suspense as Suspense27 } from "react";
import { Navigate as Navigate11 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback3,
  DocumentTypeListContainer,
  OutletRoute as OutletRoute7
} from "app-core";

// src/secure/custom_data/document-types/__generated__/DocumentTypeRouteQuery.graphql.ts
var node25 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v3 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "updatedBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sampleUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "htmlTemplate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canGeneratePdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatesDocument",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "90bffd0b1b6ae780a9a3c564bb25cc83",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n    createdAt\n    createdBy {\n      id\n      accountType\n    }\n    updatedAt\n    updatedBy {\n      id\n      accountType\n    }\n    name\n    description\n    sampleUrl\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    htmlTemplate\n    canGeneratePdf\n    generatesDocument\n  }\n}\n"
    }
  };
}();
node25.hash = "2bacd4a5207eb5a8584faa7b989f6269";
var DocumentTypeRouteQuery_graphql_default = node25;

// src/secure/custom_data/document-types/DocumentTypeRoute.tsx
import { useMemo as useMemo2 } from "react";
import {
  Navigate as Navigate10,
  Outlet as Outlet6,
  useLocation as useLocation4,
  useLoaderData as useLoaderData4
} from "react-router-dom";
import {
  loadQuery as loadQuery17,
  usePreloadedQuery as usePreloadedQuery4
} from "react-relay";
import { Suspense as Suspense25 } from "shared-ui";
import {
  createLinkState as createLinkState4,
  DynamicBreadcrumb as DynamicBreadcrumb3,
  ErrorContainer as ErrorContainer3,
  ExpandButton as ExpandButton2,
  TabUnderline as TabUnderline2
} from "shared-ui";

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessRouteQuery.graphql.ts
var node26 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "91dae105a0d93b5906b2f6b4cd3ba06c",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n  }\n}\n"
    }
  };
}();
node26.hash = "7ca4d5605dcf72883dc0ef2ede8e61fc";
var DocumentTypeAccessRouteQuery_graphql_default = node26;

// src/secure/custom_data/document-types/DocumentTypeAccessRoute.tsx
import { Suspense as Suspense23 } from "react";
import { loadQuery as loadQuery15 } from "react-relay";
import { Navigate as Navigate9 } from "react-router-dom";
import { useRouteData as useRouteData12 } from "shared-lib";
import { EdSkeleton as EdSkeleton16, EdTextLink as EdTextLink3, MynPageTitle as MynPageTitle19 } from "shared-ui";
import {
  OutletRoute as OutletRoute6,
  DocumentTypeAccessListContainer
} from "app-core";

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessAddRouteQuery.graphql.ts
var node27 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "documentTypeCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessAddRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentType",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DocumentTypeAddAccess_document"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessAddRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentType",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1224d2e7a1b4aa09443b05499985fe5e",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessAddRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessAddRouteQuery(\n  $documentTypeCode: Int!\n) {\n  access: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    ...DocumentTypeAddAccess_document\n  }\n}\n\nfragment DocumentTypeAddAccess_document on DocumentType {\n  id\n  documentTypeId\n  version\n  code\n  createdAt\n  updatedAt\n  name\n  description\n}\n"
    }
  };
}();
node27.hash = "35c0979f5b90d3e896b1fd267f261d23";
var DocumentTypeAccessAddRouteQuery_graphql_default = node27;

// src/secure/custom_data/document-types/DocumentTypeAccessAddRoute.tsx
import { useCallback as useCallback14 } from "react";
import { loadQuery as loadQuery13 } from "react-relay";
import { useNavigate as useNavigate8 } from "react-router-dom";
import { MynPageTitle as MynPageTitle17, Suspense as Suspense21 } from "shared-ui";
import { useRouteData as useRouteData10 } from "shared-lib";
import { EdSkeleton as EdSkeleton14 } from "shared-ui";
import { DocumentTypeAddAccess } from "app-core";
import { Fragment as Fragment14, jsx as jsx33, jsxs as jsxs31 } from "react/jsx-runtime";
var queryDef14 = DocumentTypeAccessAddRouteQuery_graphql_default;
async function loader13(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery13(environment, queryDef14, {
    documentTypeCode
  });
}
var DocumentTypeAccessAddRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate8();
  const data = useRouteData10(queryDef14, routeId6);
  const onNavigateToList = useCallback14(() => {
    navigate("../");
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx33(Fragment14, { children: "Loading..." });
  }
  const { access } = data;
  if (!access) {
    return /* @__PURE__ */ jsx33(Fragment14, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx33(Suspense21, { fallback: /* @__PURE__ */ jsx33(EdSkeleton14, {}), children: /* @__PURE__ */ jsxs31("div", { className: "flex-1 md:m-4 lg:m-8", children: [
    /* @__PURE__ */ jsx33(MynPageTitle17, { title: "Add Document Type Access" }),
    /* @__PURE__ */ jsx33(
      DocumentTypeAddAccess,
      {
        fragmentRef: access,
        onSaved: onNavigateToList,
        onCancel: onNavigateToList
      }
    )
  ] }) });
};

// src/secure/custom_data/document-types/__generated__/DocumentTypeAccessViewRouteQuery.graphql.ts
var node28 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "documentTypeAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeAccessId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalOrganisationName",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentTypeAccess",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                v9
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeAccessViewRouteQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "DocumentTypeAccess",
          "kind": "LinkedField",
          "name": "customDataDocumentTypeAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "Organisation",
              "kind": "LinkedField",
              "name": "organisation",
              "plural": false,
              "selections": [
                v9,
                v2
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6717d84c87cfaa9f018f54cc56b6736b",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeAccessViewRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeAccessViewRouteQuery(\n  $documentTypeAccessCode: Int!\n) {\n  access: customDataDocumentTypeAccessByCode(code: $documentTypeAccessCode) {\n    id\n    documentTypeAccessId\n    code\n    createdAt\n    updatedAt\n    status\n    version\n    organisation {\n      externalOrganisationName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "829cfb5d331193537e604b1b42542c09";
var DocumentTypeAccessViewRouteQuery_graphql_default = node28;

// src/secure/custom_data/document-types/DocumentTypeAccessViewRoute.tsx
import { useCallback as useCallback15 } from "react";
import { ConnectionHandler, loadQuery as loadQuery14 } from "react-relay";
import { useNavigate as useNavigate9 } from "react-router-dom";
import { createClientMutationId as createClientMutationId7, timeAgo as timeAgo4, useRouteData as useRouteData11 } from "shared-lib";
import {
  Button as Button11,
  ButtonList as ButtonList2,
  DescriptionItem as DescriptionItem3,
  DescriptionList as DescriptionList3,
  EdSkeleton as EdSkeleton15,
  MynPageTitle as MynPageTitle18,
  Suspense as Suspense22,
  Size as Size6
} from "shared-ui";
import {
  useDocumentTypeRemoveAccess
} from "app-core";
import { Fragment as Fragment15, jsx as jsx34, jsxs as jsxs32 } from "react/jsx-runtime";
var queryDef15 = DocumentTypeAccessViewRouteQuery_graphql_default;
async function loader14(environment, params) {
  const code = params.documentTypeAccessCode;
  const documentTypeAccessCode = parseInt(code);
  return loadQuery14(environment, queryDef15, {
    documentTypeAccessCode
  });
}
var DocumentTypeAccessViewRoute = ({ routeId: routeId6, inList }) => {
  const navigate = useNavigate9();
  const data = useRouteData11(
    queryDef15,
    routeId6
  );
  const { access } = data;
  const [removeAccess, isRemoving] = useDocumentTypeRemoveAccess();
  const connectionId = ConnectionHandler.getConnectionID(
    "root",
    "DocumentTypeAccessList_list"
  );
  const onNavigateToList = useCallback15(() => {
    navigate("../");
  }, [navigate]);
  const onRemoveOrganisationAccess = useCallback15(async () => {
    if (!access) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId7(),
      documentTypeAccessId: access.documentTypeAccessId
    };
    const response = await removeAccess({
      connections: [connectionId],
      input
    });
    if (response.data.result) {
      onNavigateToList();
    }
  }, [access, removeAccess, onNavigateToList, connectionId]);
  if (!data) {
    return /* @__PURE__ */ jsx34(Fragment15, { children: "Loading..." });
  }
  if (!access) {
    return /* @__PURE__ */ jsx34(Fragment15, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs32(Suspense22, { fallback: /* @__PURE__ */ jsx34(EdSkeleton15, {}), children: [
    /* @__PURE__ */ jsx34(MynPageTitle18, { title: "Document Type Access View" }),
    /* @__PURE__ */ jsx34("div", { className: "flex-1 md:m-4 lg:m-8", children: /* @__PURE__ */ jsxs32("div", { className: "rounded-lg border bg-gray-100", children: [
      /* @__PURE__ */ jsx34(
        DescriptionList3,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx34("div", { className: "p-2", children: /* @__PURE__ */ jsx34("div", { className: "text-primary-700", children: access.organisation.externalOrganisationName }) }),
          items: /* @__PURE__ */ jsxs32(Fragment15, { children: [
            /* @__PURE__ */ jsx34(DescriptionItem3, { label: "Status", children: /* @__PURE__ */ jsx34("div", { children: access.status }) }),
            /* @__PURE__ */ jsx34(DescriptionItem3, { label: "Version", children: /* @__PURE__ */ jsx34("div", { children: access.version }) }),
            /* @__PURE__ */ jsx34(DescriptionItem3, { label: "Created", children: timeAgo4(access.createdAt) }),
            /* @__PURE__ */ jsx34(DescriptionItem3, { label: "Updated", children: timeAgo4(access.updatedAt) })
          ] })
        }
      ),
      /* @__PURE__ */ jsx34("div", { className: "p-4", children: /* @__PURE__ */ jsx34(ButtonList2, { children: /* @__PURE__ */ jsx34(
        Button11,
        {
          size: Size6.lg,
          color: "danger",
          disabled: isRemoving,
          clicked: onRemoveOrganisationAccess,
          children: "Remove"
        }
      ) }) })
    ] }) })
  ] });
};

// src/secure/custom_data/document-types/DocumentTypeAccessRoute.tsx
import { Fragment as Fragment16, jsx as jsx35, jsxs as jsxs33 } from "react/jsx-runtime";
var queryDef16 = DocumentTypeAccessRouteQuery_graphql_default;
async function loader15(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery15(environment, queryDef16, {
    documentTypeCode
  });
}
var ListHeader2 = () => {
  return /* @__PURE__ */ jsx35("div", { className: "flex justify-end border-b p-2", children: /* @__PURE__ */ jsx35(EdTextLink3, { id: "add-link", to: "../add", label: "Add" }) });
};
var List5 = ({ routeId: routeId6, inList }) => {
  const data = useRouteData12(queryDef16, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx35(Fragment16, { children: "Loading..." });
  }
  const { documentType } = data;
  if (!documentType) {
    return /* @__PURE__ */ jsx35(Fragment16, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs33(Suspense23, { fallback: /* @__PURE__ */ jsx35(EdSkeleton16, {}), children: [
    /* @__PURE__ */ jsx35(MynPageTitle19, { title: "Document Type Access" }),
    /* @__PURE__ */ jsx35(
      DocumentTypeAccessListContainer,
      {
        documentTypeId: documentType.documentTypeId,
        listHeader: /* @__PURE__ */ jsx35(ListHeader2, {})
      }
    )
  ] });
};
var createRoute8 = (documentTypeRouteId, environment, context, inList = true) => {
  const routeId6 = `${documentTypeRouteId}-access`;
  const listRouteId = `${routeId6}-list`;
  const editRouteId = `${routeId6}-edit`;
  const editListRouteId = `${listRouteId}-edit`;
  const addRouteId = `${routeId6}-add`;
  return {
    id: routeId6,
    path: "access",
    element: /* @__PURE__ */ jsx35(OutletRoute6, {}),
    loader: ({ params }) => {
      return loader15(environment, params);
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx35(List5, { routeId: routeId6, inList }),
        children: [
          {
            id: editListRouteId,
            path: ":documentTypeAccessCode",
            element: /* @__PURE__ */ jsx35(
              DocumentTypeAccessViewRoute,
              {
                routeId: editListRouteId,
                inList
              }
            ),
            loader: ({ params }) => {
              return loader14(environment, params);
            }
          }
        ]
      },
      {
        id: editRouteId,
        path: ":documentTypeAccessCode",
        element: /* @__PURE__ */ jsx35(DocumentTypeAccessViewRoute, { routeId: routeId6, inList }),
        loader: ({ params }) => {
          return loader14(environment, params);
        }
      },
      {
        id: addRouteId,
        path: "add",
        element: /* @__PURE__ */ jsx35(DocumentTypeAccessAddRoute, { routeId: addRouteId, inList }),
        loader: ({ params }) => {
          return loader13(environment, params);
        }
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx35(Navigate9, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/custom_data/document-types/__generated__/DocumentTypeDetailsRouteQuery.graphql.ts
var node29 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentTypeCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v3 = [
    {
      "alias": "documentType",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "documentTypeCode"
        }
      ],
      "concreteType": "DocumentType",
      "kind": "LinkedField",
      "name": "customDataDocumentTypeByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "updatedBy",
          "plural": false,
          "selections": v2,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sampleUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "htmlTemplate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canGeneratePdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatesDocument",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentTypeDetailsRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentTypeDetailsRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "4864416de922b028964be69d73611444",
      "id": null,
      "metadata": {},
      "name": "DocumentTypeDetailsRouteQuery",
      "operationKind": "query",
      "text": "query DocumentTypeDetailsRouteQuery(\n  $documentTypeCode: Int!\n) {\n  documentType: customDataDocumentTypeByCode(code: $documentTypeCode) {\n    id\n    documentTypeId\n    code\n    version\n    createdAt\n    createdBy {\n      id\n      accountType\n    }\n    updatedAt\n    updatedBy {\n      id\n      accountType\n    }\n    name\n    description\n    sampleUrl\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    htmlTemplate\n    canGeneratePdf\n    generatesDocument\n  }\n}\n"
    }
  };
}();
node29.hash = "4e0f4f9b4e5309d7015f1cb893838374";
var DocumentTypeDetailsRouteQuery_graphql_default = node29;

// src/secure/custom_data/document-types/DocumentTypeDetailsRoute.tsx
import { Suspense as Suspense24 } from "react";
import { loadQuery as loadQuery16 } from "react-relay";
import { Link as Link7 } from "react-router-dom";
import { timeAgo as timeAgo5, useRouteData as useRouteData13 } from "shared-lib";
import { EdSkeleton as EdSkeleton17, MynPageTitle as MynPageTitle20 } from "shared-ui";
import { Fragment as Fragment17, jsx as jsx36, jsxs as jsxs34 } from "react/jsx-runtime";
var queryDef17 = DocumentTypeDetailsRouteQuery_graphql_default;
async function loader16(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery16(environment, queryDef17, {
    documentTypeCode
  });
}
var Container = ({ routeId: routeId6, inList }) => {
  const data = useRouteData13(queryDef17, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx36(Fragment17, { children: "Loading..." });
  }
  const { documentType } = data;
  if (!documentType) {
    return /* @__PURE__ */ jsx36(Fragment17, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs34(Suspense24, { fallback: /* @__PURE__ */ jsx36(EdSkeleton17, {}), children: [
    /* @__PURE__ */ jsx36(MynPageTitle20, { title: "Document Type Details" }),
    /* @__PURE__ */ jsx36("div", { className: "grid gap-2 border-b bg-white p-4 sm:grid-cols-3", children: /* @__PURE__ */ jsxs34("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs34("div", { className: "flex items-center justify-between gap-2 border-b", children: [
        /* @__PURE__ */ jsx36("div", { className: "text-primary-700 p-4 text-lg font-medium", children: documentType.name }),
        /* @__PURE__ */ jsxs34("div", { className: "text-primary-700 p-4 text-sm", children: [
          "Updated ",
          timeAgo5(documentType.updatedAt)
        ] })
      ] }),
      /* @__PURE__ */ jsx36("div", { className: "text-md p-4 text-gray-900", children: documentType.description })
    ] }) })
  ] });
};
var createRoute9 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx36(Container, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx36(Link7, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader16(environment, params);
    }
  };
};

// src/secure/custom_data/document-types/DocumentTypeRoute.tsx
import { jsx as jsx37, jsxs as jsxs35 } from "react/jsx-runtime";
var documentTypeRouteQueryDef = DocumentTypeRouteQuery_graphql_default;
async function loader17(environment, params) {
  const code = params.documentTypeCode;
  const documentTypeCode = parseInt(code);
  return loadQuery17(
    environment,
    documentTypeRouteQueryDef,
    {
      documentTypeCode
    }
  );
}
var Layout4 = () => {
  const location = useLocation4();
  const tabs4 = useMemo2(() => {
    return [
      createLinkState4(location, "Details", `../details`),
      createLinkState4(location, "Access", `../access`)
    ];
  }, [location]);
  const preloadedQuery = useLoaderData4();
  const data = usePreloadedQuery4(documentTypeRouteQueryDef, preloadedQuery);
  const { documentType } = data;
  if (documentType === null || documentType === void 0) {
    return /* @__PURE__ */ jsx37("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx37(Suspense25, { fallback: "Loading...", children: /* @__PURE__ */ jsxs35("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs35("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx37("div", { className: "p-2", children: /* @__PURE__ */ jsx37(ExpandButton2, { to: `../../../${documentType.code}`, label: "View" }) }),
      /* @__PURE__ */ jsx37(DynamicBreadcrumb3, {}),
      /* @__PURE__ */ jsx37("div", { className: "text-primary-700 px-2 font-medium uppercase sm:px-8", children: documentType.name })
    ] }),
    /* @__PURE__ */ jsx37("div", { className: "flex flex-wrap items-center gap-2 border-b p-4", children: /* @__PURE__ */ jsx37("div", { className: "text-primary-700 font-medium uppercase", children: documentType.description }) }),
    /* @__PURE__ */ jsx37("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx37(TabUnderline2, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx37(Outlet6, {})
  ] }) });
};
var createDocumentTypeRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-document-type`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx37(Layout4, {}),
      errorElement: /* @__PURE__ */ jsx37(ErrorContainer3, {}),
      loader: ({ params }) => {
        return loader17(environment, params);
      },
      children: [
        createRoute9(routePrefix, environment, context, inList),
        createRoute8(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx37(Navigate10, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/custom_data/document-types/DocumentTypeCreate.tsx
import { useCallback as useCallback16 } from "react";
import { useNavigate as useNavigate10 } from "react-router-dom";
import { MynPageTitle as MynPageTitle21, Suspense as Suspense26 } from "shared-ui";
import { DocumentTypeCreate } from "app-core";
import { EdSkeleton as EdSkeleton18 } from "shared-ui";
import { jsx as jsx38, jsxs as jsxs36 } from "react/jsx-runtime";
var DocumentTypesCreateContainer = () => {
  const navigate = useNavigate10();
  const onCreated = useCallback16((documentType) => {
    navigate(`../list`);
  }, []);
  const onCancel = useCallback16(() => {
    navigate("../list");
  }, []);
  return /* @__PURE__ */ jsxs36(Suspense26, { fallback: /* @__PURE__ */ jsx38(EdSkeleton18, {}), children: [
    /* @__PURE__ */ jsx38(MynPageTitle21, { title: "Create Document Types" }),
    /* @__PURE__ */ jsx38(DocumentTypeCreate, { onCreated, onCancel })
  ] });
};

// src/secure/custom_data/document-types/DocumentTypesRoute.tsx
import { MynPageTitle as MynPageTitle22 } from "shared-ui";
import { jsx as jsx39, jsxs as jsxs37 } from "react/jsx-runtime";
var Layout5 = () => {
  return /* @__PURE__ */ jsx39(Suspense27, { fallback: "Loading Document Types...", children: /* @__PURE__ */ jsxs37(ErrorBoundary3, { FallbackComponent: ErrorBoundaryFallback3, children: [
    /* @__PURE__ */ jsx39(MynPageTitle22, { title: "Document Types" }),
    /* @__PURE__ */ jsx39(DocumentTypeListContainer, { listHeader: /* @__PURE__ */ jsx39("div", {}) })
  ] }) });
};
var createDocumentTypesRoutes = (routePrefix, environment, context) => {
  const listRouteId = `${routePrefix}-list`;
  const listDocumentRouteId = `${listRouteId}-list-document`;
  const documentRouteId = `${listRouteId}-document`;
  return [
    {
      id: listRouteId,
      path: "list/*",
      element: /* @__PURE__ */ jsx39(Layout5, {}),
      children: [
        {
          id: listDocumentRouteId,
          path: ":documentTypeCode/*",
          element: /* @__PURE__ */ jsx39(OutletRoute7, {}),
          children: createDocumentTypeRoutes(
            listDocumentRouteId,
            environment,
            context,
            true,
            true
          )
        }
      ]
    },
    {
      id: documentRouteId,
      path: ":documentTypeCode/*",
      element: /* @__PURE__ */ jsx39(OutletRoute7, {}),
      children: createDocumentTypeRoutes(
        documentRouteId,
        environment,
        context,
        false,
        false
      )
    },
    {
      id: `${routePrefix}-create`,
      path: "create",
      element: /* @__PURE__ */ jsx39(DocumentTypesCreateContainer, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx39(Navigate11, { to: "list", replace: true })
    }
  ];
};

// src/secure/custom_data/CustomDataLayout.tsx
import { jsx as jsx40, jsxs as jsxs38 } from "react/jsx-runtime";
var Layout6 = () => {
  const location = useLocation5();
  const tabs4 = [
    createLinkState5(location, "Home", `home`, HomeIcon),
    createLinkState5(
      location,
      "Organisations",
      `organisations`,
      BuildingStorefrontIcon
    ),
    createLinkState5(
      location,
      "Form Templates",
      `form-templates`,
      InformationCircleIcon
    ),
    createLinkState5(location, "Document Types", `document-types`, DocumentIcon)
  ];
  return /* @__PURE__ */ jsxs38(Suspense28, { fallback: "Loading Custom Data Management...", children: [
    /* @__PURE__ */ jsx40(MynPageTitle23, { title: "Custom Data" }),
    /* @__PURE__ */ jsx40(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback4, children: /* @__PURE__ */ jsxs38("div", { className: "bg-white", children: [
      /* @__PURE__ */ jsxs38("div", { className: "flex-col gap-2 border-b", children: [
        /* @__PURE__ */ jsx40("div", { className: "border-b", children: /* @__PURE__ */ jsx40("div", { className: "text-primary-700 p-4 font-medium", children: "Custom Data Management" }) }),
        /* @__PURE__ */ jsx40("div", { className: "p-2", children: /* @__PURE__ */ jsx40(TabUnderline3, { tabs: tabs4 }) })
      ] }),
      /* @__PURE__ */ jsx40("div", { className: "", children: /* @__PURE__ */ jsx40(Outlet7, {}) })
    ] }) })
  ] });
};
var CustomDataHome = () => {
  return /* @__PURE__ */ jsx40(Suspense28, { fallback: "Loading Form Templates...", children: /* @__PURE__ */ jsx40("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx40("h1", { children: "Custom Data" }) }) });
};
var createCustomDataRoutes = (environment, context) => {
  return [
    {
      path: "",
      element: /* @__PURE__ */ jsx40(Layout6, {}),
      children: [
        {
          path: "home",
          element: /* @__PURE__ */ jsx40(CustomDataHome, {})
        },
        {
          path: "organisations/*",
          element: /* @__PURE__ */ jsx40(OutletRoute8, {}),
          children: createOrganisationsRoutes(
            "custom-data-organisations",
            environment,
            context
          )
        },
        {
          path: "form-templates/*",
          element: /* @__PURE__ */ jsx40(OutletRoute8, {}),
          children: createFormTemplatesRoutes(
            "custom-data-form-templates",
            environment,
            context
          )
        },
        {
          path: "document-types/*",
          element: /* @__PURE__ */ jsx40(OutletRoute8, {}),
          children: createDocumentTypesRoutes(
            "custom-data-document-types",
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx40(Navigate12, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/index.ts
var accounts_exports = {};
__export(accounts_exports, {
  AccountsHomeList: () => AccountsHomeList,
  AdminLayout: () => AdminLayout,
  AdminUserGroupsListRoute: () => AdminUserGroupsListRoute,
  AdminUsersListRoute: () => AdminUsersListRoute,
  EmployersLayout: () => EmployersLayout,
  EmployersListRoute: () => EmployersListRoute,
  createAdminRoutes: () => createAdminRoutes,
  createAppAdminAccountsRoutes: () => createAppAdminAccountsRoutes,
  createEmployersRoutes: () => createEmployersRoutes,
  useAdminUserCreate: () => useAdminUserCreate,
  useAdminUserDisable: () => useAdminUserDisable,
  useAdminUserEnable: () => useAdminUserEnable,
  useAdminUserGroupCreate: () => useAdminUserGroupCreate,
  useAdminUserGroupUpdate: () => useAdminUserGroupUpdate,
  useAdminUserGroupUpdatePermissions: () => useAdminUserGroupUpdatePermissions,
  useAdminUserJoinGroup: () => useAdminUserJoinGroup,
  useAdminUserLeaveGroup: () => useAdminUserLeaveGroup,
  useAdminUserUpdate: () => useAdminUserUpdate
});

// src/secure/accounts/administrators/components/AdminRoute.tsx
import { Suspense as Suspense44 } from "react";
import { Navigate as Navigate15, Outlet as Outlet10, useLocation as useLocation6 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { UsersIcon as UsersIcon2, UserGroupIcon as UserGroupIcon2 } from "@heroicons/react/24/outline";
import {
  Button as Button15,
  createLinkState as createLinkState6,
  EdLink as EdLink2,
  MynPageTitle as MynPageTitle30,
  PageHeading,
  TabPills as TabPills2
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback5, OutletRoute as OutletRoute10 } from "app-core";

// src/secure/accounts/administrators/components/AdminUserRoute.tsx
import { Navigate as Navigate13 } from "react-router-dom";
import { ErrorContainer as ErrorContainer4 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserLayoutQuery.graphql.ts
var node30 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = [
    {
      "alias": "adminUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserCode"
        }
      ],
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountAdminUserByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "7cd6e8fe845c6cf82c3f746708f7c45a",
      "id": null,
      "metadata": {},
      "name": "AdminUserLayoutQuery",
      "operationKind": "query",
      "text": "query AdminUserLayoutQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n  }\n}\n"
    }
  };
}();
node30.hash = "a0a8aefa6d296c0ef71a518a5f876af4";
var AdminUserLayoutQuery_graphql_default = node30;

// src/secure/accounts/administrators/components/AdminUserLayout.tsx
import { Suspense as Suspense29 } from "react";
import {
  Link as Link8,
  Outlet as Outlet8,
  useLoaderData as useLoaderData5,
  useRouteLoaderData as useRouteLoaderData3
} from "react-router-dom";
import {
  loadQuery as loadQuery18,
  usePreloadedQuery as usePreloadedQuery5
} from "react-relay";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
import {
  DynamicBreadcrumb as DynamicBreadcrumb4,
  EdButtonLink,
  EdTextLink as EdTextLink4,
  IconJustify
} from "shared-ui";
import { Fragment as Fragment18, jsx as jsx41, jsxs as jsxs39 } from "react/jsx-runtime";
var routeId3 = "admin-user-home";
var queryDef18 = AdminUserLayoutQuery_graphql_default;
var AdminUserLayout = ({ showHeader, inList }) => {
  const preloadedQuery = useLoaderData5();
  const data = usePreloadedQuery5(queryDef18, preloadedQuery);
  const { adminUser } = data;
  if (adminUser === null || adminUser === void 0) {
    return /* @__PURE__ */ jsx41("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx41(Suspense29, { fallback: "Loading...", children: /* @__PURE__ */ jsxs39("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx41("div", { children: /* @__PURE__ */ jsxs39("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx41(DynamicBreadcrumb4, {}),
      /* @__PURE__ */ jsxs39("div", { className: "text-primary-700 flex items-center gap-2 font-medium uppercase", children: [
        /* @__PURE__ */ jsx41("div", { children: adminUser.firstName }),
        /* @__PURE__ */ jsx41("div", { children: adminUser.lastName })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs39("div", { className: "flex flex-wrap items-center justify-between border-b p-2", children: [
      /* @__PURE__ */ jsx41("div", { className: "flex flex-wrap items-center gap-2 border-b bg-gray-50 px-4", children: /* @__PURE__ */ jsx41(
        EdTextLink4,
        {
          id: "identity-user-root-link",
          to: "details",
          label: "Details"
        }
      ) }),
      inList && /* @__PURE__ */ jsx41("div", { children: /* @__PURE__ */ jsx41(
        EdButtonLink,
        {
          to: `../../../../${adminUser.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon,
          iconJustify: IconJustify.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx41(Outlet8, {})
  ] }) });
};
var AdminUserGroupLink = ({ routeId: routeId6, label }) => {
  const data = useAdminUserRouteData(routeId6);
  if (!data.adminUser) {
    return /* @__PURE__ */ jsx41(Fragment18, {});
  }
  const name = `${data.adminUser.firstName} ${data.adminUser.lastName}`;
  return /* @__PURE__ */ jsx41(Suspense29, { fallback: "Loading...", children: /* @__PURE__ */ jsx41(Link8, { to: ".", children: label || name }) });
};
async function loader18(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery18(environment, queryDef18, {
    adminUserCode
  });
}
function useAdminUserRouteData(routeId6) {
  const queryRef = useRouteLoaderData3(
    routeId6
  );
  const data = usePreloadedQuery5(queryDef18, queryRef);
  return data;
}

// src/secure/accounts/administrators/components/__generated__/AdminUserDetailsRouteQuery.graphql.ts
var node31 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "adminUserCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountsAdminUserGroup",
    "kind": "LinkedField",
    "name": "userGroups",
    "plural": true,
    "selections": [
      v2,
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminUserGroupId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserDetailsRouteQuery",
      "selections": [
        {
          "alias": "adminUser",
          "args": v1,
          "concreteType": "AccountsAdminUser",
          "kind": "LinkedField",
          "name": "accountAdminUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v6,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AdminUserDetailsInfo_fragment"
            },
            v7
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserDetailsRouteQuery",
      "selections": [
        {
          "alias": "adminUser",
          "args": v1,
          "concreteType": "AccountsAdminUser",
          "kind": "LinkedField",
          "name": "accountAdminUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v6,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailAddress",
              "storageKey": null
            },
            v7
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f7d8a4ce18dc50250160f0448c0a433e",
      "id": null,
      "metadata": {},
      "name": "AdminUserDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserDetailsRouteQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    accountId\n    userGroups {\n      id\n      code\n      name\n      isDeleted\n      adminUserGroupId\n    }\n    ...AdminUserDetailsInfo_fragment\n  }\n}\n\nfragment AdminUserDetailsInfo_fragment on AccountsAdminUser {\n  id\n  code\n  isDeleted\n  accountId\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  emailAddress\n}\n"
    }
  };
}();
node31.hash = "edbfa91ecb749428b901c681bc2c785a";
var AdminUserDetailsRouteQuery_graphql_default = node31;

// src/secure/accounts/administrators/components/AdminUserDetails.tsx
import { useCallback as useCallback20, useState as useState14 } from "react";
import { loadQuery as loadQuery19 } from "react-relay";
import { Link as Link9 } from "react-router-dom";
import { ConnectionHandler as ConnectionHandler2 } from "relay-runtime";
import { createClientMutationId as createClientMutationId9, useRouteData as useRouteData14, useToggle as useToggle3 } from "shared-lib";
import {
  AlertMessage as AlertMessage2,
  Button as Button13,
  ButtonList as ButtonList3,
  Card,
  EdSkeleton as EdSkeleton20,
  Size as Size8,
  Suspense as Suspense31,
  MynPageTitle as MynPageTitle24
} from "shared-ui";

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserCreateMutation.graphql.ts
var node32 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1a3f7a030a514cf5731f581af44236f5",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserCreateMutation(\n  $input: AccountsAdminUserCreateInput!\n) {\n  data: accountsAdminUserCreate(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node32.hash = "5f2a1e1719e214e40dc8f07783a794eb";
var UseAdminUserCreateMutation_graphql_default = node32;

// src/secure/accounts/administrators/mutations/UseAdminUserCreate.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef6 = UseAdminUserCreateMutation_graphql_default;
function useAdminUserCreate() {
  const [commit, isBusy] = useAsyncMutation6(mutationDef6);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupCreateMutation.graphql.ts
var node33 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminUserGroupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e346f54ed792c1a35ebb6e100952bc60",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupCreateMutation(\n  $input: AccountsAdminUserGroupCreateInput!\n) {\n  data: accountsAdminUserGroupCreate(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        adminUserGroupId\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node33.hash = "ace95ff0655e9f91170e744eb4805f04";
var UseAdminUserGroupCreateMutation_graphql_default = node33;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupCreate.ts
import { useAsyncMutation as useAsyncMutation7 } from "shared-lib";
var mutationDef7 = UseAdminUserGroupCreateMutation_graphql_default;
function useAdminUserGroupCreate() {
  const [commit, isBusy] = useAsyncMutation7(mutationDef7);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupUpdateMutation.graphql.ts
var node34 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fc57d545b102e9bc2198151e74b9398",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupUpdateMutation(\n  $input: AccountsAdminUserGroupUpdateInput!\n) {\n  data: accountsAdminUserGroupUpdate(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "0da80a3bd6d061ebabd27e688482701e";
var UseAdminUserGroupUpdateMutation_graphql_default = node34;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupUpdate.ts
import { useAsyncMutation as useAsyncMutation8 } from "shared-lib";
var mutationDef8 = UseAdminUserGroupUpdateMutation_graphql_default;
function useAdminUserGroupUpdate() {
  const [commit, isBusy] = useAsyncMutation8(mutationDef8);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserGroupUpdatePermissionsMutation.graphql.ts
var node35 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUserGroup",
    "kind": "LinkedField",
    "name": "adminUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupPermissionsPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupPermissions",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserGroupPermissionsPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserGroupPermissions",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2726dc734ff1cde5329d110e2a4faa39",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserGroupUpdatePermissionsMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserGroupUpdatePermissionsMutation(\n  $input: AccountsAdminUserGroupPermissionsInput!\n) {\n  data: accountsAdminUserGroupPermissions(input: $input) {\n    adminUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "6fb4463311f76327f41d9f83e01fa21a";
var UseAdminUserGroupUpdatePermissionsMutation_graphql_default = node35;

// src/secure/accounts/administrators/mutations/UseAdminUserGroupUpdatePermissions.ts
import { useAsyncMutation as useAsyncMutation9 } from "shared-lib";
var mutationDef9 = UseAdminUserGroupUpdatePermissionsMutation_graphql_default;
function useAdminUserGroupUpdatePermissions() {
  const [commit, isBusy] = useAsyncMutation9(mutationDef9);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserJoinGroupMutation.graphql.ts
var node36 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsAdminUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v2,
              v3,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "adminUserGroupId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserJoinGroup",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserJoinGroup",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8973507c2c880c08e28b0884ae81edc3",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserJoinGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserJoinGroupMutation(\n  $input: AccountsAdminUserJoinGroupInput!\n) {\n  data: accountsAdminUserJoinGroup(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        userGroups {\n          id\n          code\n          name\n          isDeleted\n          adminUserGroupId\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node36.hash = "c9e4ef2e4fb8e3fb13f99dcb38167796";
var UseAdminUserJoinGroupMutation_graphql_default = node36;

// src/secure/accounts/administrators/mutations/UseAdminUserJoinGroup.ts
import { useAsyncMutation as useAsyncMutation10 } from "shared-lib";
var mutationDef10 = UseAdminUserJoinGroupMutation_graphql_default;
function useAdminUserJoinGroup() {
  const [commit, isBusy] = useAsyncMutation10(mutationDef10);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserLeaveGroupMutation.graphql.ts
var node37 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountsAdminUserGroup",
    "kind": "LinkedField",
    "name": "userGroups",
    "plural": true,
    "selections": [
      v2,
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminUserGroupId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v11 = {
    "kind": "InlineFragment",
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfAdminUser",
              "kind": "LinkedField",
              "name": "adminUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfAdminUser",
              "kind": "LinkedField",
              "name": "adminUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteEdge",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id",
                      "handleArgs": [
                        {
                          "kind": "Variable",
                          "name": "connections",
                          "variableName": "connections"
                        }
                      ]
                    },
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "23003b6a916702f635fe5d713f6fb7bd",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserLeaveGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserLeaveGroupMutation(\n  $input: AccountsAdminUserLeaveGroupInput!\n) {\n  data: accountsAdminUserLeaveGroup(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        userGroups {\n          id\n          code\n          name\n          isDeleted\n          adminUserGroupId\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node37.hash = "faf69d9c7c240c295a78f911c61d7fde";
var UseAdminUserLeaveGroupMutation_graphql_default = node37;

// src/secure/accounts/administrators/mutations/UseAdminUserLeaveGroup.ts
import { useAsyncMutation as useAsyncMutation11 } from "shared-lib";
var mutationDef11 = UseAdminUserLeaveGroupMutation_graphql_default;
function useAdminUserLeaveGroup() {
  const [commit, isBusy] = useAsyncMutation11(mutationDef11);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserUpdateMutation.graphql.ts
var node38 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8d9d389d9ef8073cd1d90c2aec5aa595",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserUpdateMutation(\n  $input: AccountsAdminUserUpdateInput!\n) {\n  data: accountsAdminUserUpdate(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node38.hash = "4e43bcd431666f831934df4a01210adc";
var UseAdminUserUpdateMutation_graphql_default = node38;

// src/secure/accounts/administrators/mutations/UseAdminUserUpdate.ts
import { useAsyncMutation as useAsyncMutation12 } from "shared-lib";
var mutationDef12 = UseAdminUserUpdateMutation_graphql_default;
function useAdminUserUpdate() {
  const [commit, isBusy] = useAsyncMutation12(mutationDef12);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserEnableMutation.graphql.ts
var node39 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserEnable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserEnable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b4ece84697e7a5231d8842c1d79f10aa",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserEnableMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserEnableMutation(\n  $input: AccountsAdminUserEnableInput!\n) {\n  data: accountsAdminUserEnable(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node39.hash = "70913c6f9d15a4aa38f89fbf28f08695";
var UseAdminUserEnableMutation_graphql_default = node39;

// src/secure/accounts/administrators/mutations/UseAdminUserEnable.ts
import { useAsyncMutation as useAsyncMutation13 } from "shared-lib";
var mutationDef13 = UseAdminUserEnableMutation_graphql_default;
function useAdminUserEnable() {
  const [commit, isBusy] = useAsyncMutation13(mutationDef13);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/mutations/__generated__/UseAdminUserDisableMutation.graphql.ts
var node40 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAdminUser",
    "kind": "LinkedField",
    "name": "adminUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAdminUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserDisable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAdminUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsAdminUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsAdminUserDisable",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "21b053f355e057f04ae41b78bc8eef84",
      "id": null,
      "metadata": {},
      "name": "UseAdminUserDisableMutation",
      "operationKind": "mutation",
      "text": "mutation UseAdminUserDisableMutation(\n  $input: AccountsAdminUserDisableInput!\n) {\n  data: accountsAdminUserDisable(input: $input) {\n    adminUser {\n      node {\n        id\n        code\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node40.hash = "bbb2df7c8f11f541a63dbf88468227a2";
var UseAdminUserDisableMutation_graphql_default = node40;

// src/secure/accounts/administrators/mutations/UseAdminUserDisable.ts
import { useAsyncMutation as useAsyncMutation14 } from "shared-lib";
var mutationDef14 = UseAdminUserDisableMutation_graphql_default;
function useAdminUserDisable() {
  const [commit, isBusy] = useAsyncMutation14(mutationDef14);
  return [commit, isBusy];
}

// src/secure/accounts/administrators/components/__generated__/accountAdminUserByCode.graphql.ts
var node41 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "accountAdminUserByCode",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AdminUserDetailsInfo_fragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "accountAdminUserByCode",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDeleted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "type": "AccountsAdminUser",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8177621cde0a9eb05134d07e600742c2",
      "id": null,
      "metadata": {},
      "name": "accountAdminUserByCode",
      "operationKind": "query",
      "text": "query accountAdminUserByCode(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AdminUserDetailsInfo_fragment\n    id\n  }\n}\n\nfragment AdminUserDetailsInfo_fragment on AccountsAdminUser {\n  id\n  code\n  isDeleted\n  accountId\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  emailAddress\n}\n"
    }
  };
}();
node41.hash = "2eedb39d2b747f98998e864388e58482";
var accountAdminUserByCode_graphql_default = node41;

// src/secure/accounts/administrators/components/__generated__/AdminUserDetailsInfo_fragment.graphql.ts
var node42 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": accountAdminUserByCode_graphql_default,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "AdminUserDetailsInfo_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "AccountsAdminUser",
  "abstractKey": null
};
node42.hash = "2eedb39d2b747f98998e864388e58482";
var AdminUserDetailsInfo_fragment_graphql_default = node42;

// src/secure/accounts/administrators/components/AdminUserDetailsInfo.tsx
import { Suspense as Suspense30, useCallback as useCallback17, useState as useState11 } from "react";
import { useRefetchableFragment } from "react-relay";
import { Button as Button12, EdSkeleton as EdSkeleton19, Size as Size7, AlertMessage } from "shared-ui";
import { createClientMutationId as createClientMutationId8, timeAgo as timeAgo6, createUUID } from "shared-lib";
import { Fragment as Fragment19, jsx as jsx42, jsxs as jsxs40 } from "react/jsx-runtime";
var queryDef19 = AdminUserDetailsInfo_fragment_graphql_default;
var AdminUserDetailsInfo = ({ queryRef, userId, groupUserId }) => {
  const [data, refetch] = useRefetchableFragment(queryDef19, queryRef);
  const handleRefetch = useCallback17(() => {
    refetch({ userId }, { fetchPolicy: "store-and-network" });
  }, [refetch, userId]);
  const [enable, isEnabling] = useAdminUserEnable();
  const [disable, isDisabling] = useAdminUserDisable();
  const [errorMessage, setErrorMessage] = useState11(
    null
  );
  const onEnable = useCallback17(async () => {
    const input = {
      clientMutationId: createClientMutationId8(),
      groupId: groupUserId || createUUID(),
      userId: data?.accountId || ""
    };
    const response = await enable({ input });
    if (response?.data) {
      response?.data?.userErrors && setErrorMessage(response?.data?.userErrors[0]?.message);
      handleRefetch();
    }
  }, [data?.accountId, enable, groupUserId, handleRefetch]);
  const onDisable = useCallback17(async () => {
    const input = {
      clientMutationId: createClientMutationId8(),
      groupId: groupUserId || createUUID(),
      userId: data?.accountId || ""
    };
    const response = await disable({ input });
    if (response?.data) {
      response?.data?.userErrors && setErrorMessage(response?.data?.userErrors[0]?.message);
      handleRefetch();
    }
  }, [data?.accountId, disable, groupUserId, handleRefetch]);
  if (!data) {
    return /* @__PURE__ */ jsx42(Fragment19, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx42(Suspense30, { fallback: /* @__PURE__ */ jsx42(EdSkeleton19, {}), children: /* @__PURE__ */ jsxs40(Fragment19, { children: [
    errorMessage ? /* @__PURE__ */ jsx42(AlertMessage, { isError: true, message: errorMessage }) : null,
    /* @__PURE__ */ jsxs40("div", { className: "my-4 flex justify-between gap-2", children: [
      /* @__PURE__ */ jsxs40("div", { className: "my-4 flex flex-col gap-2", children: [
        data?.isDeleted && /* @__PURE__ */ jsx42("div", { className: "mb-4 max-w-sm border bg-gray-100 px-8 py-4", children: /* @__PURE__ */ jsx42("div", { className: "text-danger-500 text-xl font-bold", children: "Disabled" }) }),
        /* @__PURE__ */ jsxs40("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx42("div", { children: data?.firstName }),
          /* @__PURE__ */ jsx42("div", { children: data?.lastName })
        ] }),
        /* @__PURE__ */ jsx42("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx42("div", { children: data?.emailAddress }) }),
        /* @__PURE__ */ jsxs40("div", { className: "flex items-center gap-2", children: [
          "Updated: ",
          timeAgo6(data?.updatedAt)
        ] })
      ] }),
      /* @__PURE__ */ jsx42("div", { className: "p-4", children: data?.isDeleted ? /* @__PURE__ */ jsx42("div", { children: /* @__PURE__ */ jsx42(
        Button12,
        {
          "aria-label": "Enable",
          color: "danger",
          size: Size7.xl,
          disabled: isEnabling,
          confirmMessage: "Are you sure ?",
          onClick: onEnable,
          children: "Enable"
        }
      ) }) : /* @__PURE__ */ jsx42("div", { children: /* @__PURE__ */ jsx42(
        Button12,
        {
          "aria-label": "Disable",
          color: "danger",
          size: Size7.xl,
          disabled: isDisabling,
          confirmMessage: "Are you sure ?",
          onClick: onDisable,
          children: "Disable"
        }
      ) }) })
    ] })
  ] }) });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupSearchContainerQuery.graphql.ts
var node43 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupSearchContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupSearchContainerQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v2,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v2,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "5bc71d00dc10331896df56b180a2857b",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupSearchContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupSearchContainerQuery(\n  $where: AccountsAdminUserGroupFilter\n) {\n  ...AdminUserGroupSearchBox_groups_3FC4Qo\n}\n\nfragment AdminUserGroupSearchBox_groups_3FC4Qo on Query {\n  groups: accountAdminUserGroups(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        adminUserGroupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node43.hash = "cf70e109a906ecf3c40b6bdd44bfb684";
var AdminUserGroupSearchContainerQuery_graphql_default = node43;

// src/secure/accounts/administrators/components/AdminUserGroupSearchContainer.tsx
import { useCallback as useCallback19, useState as useState13 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupSearchBoxPaginationQuery.graphql.ts
var node44 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v4,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "9530ef5e94f8685d68d9718ffc99f224",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: AccountsAdminUserGroupFilter\n) {\n  ...AdminUserGroupSearchBox_groups_3sueo6\n}\n\nfragment AdminUserGroupSearchBox_groups_3sueo6 on Query {\n  groups: accountAdminUserGroups(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        adminUserGroupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node44.hash = "ace40eaf06666803a3c3fbff01a90f8c";
var AdminUserGroupSearchBoxPaginationQuery_graphql_default = node44;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupSearchBox_groups.graphql.ts
var node45 = /* @__PURE__ */ function() {
  var v0 = [
    "groups"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUserGroupSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserGroupSearchBox_groups",
    "selections": [
      {
        "alias": "groups",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountAdminUserGroupsConnection",
        "kind": "LinkedField",
        "name": "__AdminUserGroupSearchBox_groups_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUserGroupsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminUserGroupId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdminGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node45.hash = "ace40eaf06666803a3c3fbff01a90f8c";
var AdminUserGroupSearchBox_groups_graphql_default = node45;

// src/secure/accounts/administrators/components/AdminUserGroupSearchBox.tsx
import {
  startTransition,
  useCallback as useCallback18,
  useState as useState12
} from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";

// ../../node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// ../../node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// ../../node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string4) {
  var index = string4.length;
  while (index-- && reWhitespace.test(string4.charAt(index))) {
  }
  return index;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string4) {
  return string4 ? string4.slice(0, trimmedEndIndex_default(string4) + 1).replace(reTrimStart, "") : string4;
}
var baseTrim_default = baseTrim;

// ../../node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject;

// ../../node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/lodash-es/now.js
var now = function() {
  return root_default.Date.now();
};
var now_default = now;

// ../../node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_default();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time = now_default(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce;

// src/secure/accounts/administrators/components/AdminUserGroupSearchBox.tsx
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Combobox } from "@headlessui/react";
import { classNames as classNames3 } from "shared-ui";
import { Fragment as Fragment20, jsx as jsx43, jsxs as jsxs41 } from "react/jsx-runtime";
var fragment = AdminUserGroupSearchBox_groups_graphql_default;
var AdminUserGroupSearchBox = ({
  onSelected,
  fragmentRef,
  defaultValue,
  disabled,
  showLabel
}) => {
  const [selected, setSelected] = useState12(
    defaultValue ?? null
  );
  const onSetSelected = useCallback18(
    (r) => {
      setSelected(r);
      onSelected(r);
    },
    [selected]
  );
  const { data, refetch } = usePaginationFragment3(fragment, fragmentRef);
  const onSearch = useCallback18(
    debounce_default((q) => {
      startTransition(() => {
        refetch({
          where: {
            name: { startsWith: q }
          }
        });
      });
    }, 500),
    [refetch]
  );
  const { groups } = data;
  const rows = (groups?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsxs41(
    Combobox,
    {
      as: "div",
      value: selected,
      onChange: onSetSelected,
      disabled,
      children: [
        showLabel && /* @__PURE__ */ jsx43(Combobox.Label, { className: "text-primary-700 mb-2 block px-1 text-sm font-medium", children: "User Groups" }),
        /* @__PURE__ */ jsxs41("div", { className: "relative", children: [
          /* @__PURE__ */ jsx43(
            Combobox.Input,
            {
              className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
              onChange: (event) => onSearch(event.target.value),
              displayValue: (result) => {
                if (result) {
                  return result.name;
                }
                return "";
              },
              autoComplete: "off",
              "aria-label": "User group search box"
            }
          ),
          /* @__PURE__ */ jsx43(
            Combobox.Button,
            {
              className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
              "aria-label": "User group search box select",
              children: /* @__PURE__ */ jsx43(
                ChevronUpDownIcon,
                {
                  className: "h-5 w-5 text-gray-600",
                  "aria-hidden": "true"
                }
              )
            }
          ),
          rows.length > 0 && /* @__PURE__ */ jsx43(Combobox.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx43(
            Combobox.Option,
            {
              value: result,
              className: ({ active }) => classNames3(
                "relative cursor-default select-none py-2 pl-3 pr-9",
                active ? "bg-info-600 text-white" : "text-gray-900"
              ),
              children: ({ active, selected: selected2 }) => /* @__PURE__ */ jsxs41(Fragment20, { children: [
                /* @__PURE__ */ jsx43("div", { className: "flex", children: /* @__PURE__ */ jsx43(
                  "span",
                  {
                    className: classNames3(
                      "truncate",
                      selected2 ? "font-semibold" : ""
                    ),
                    children: result.name
                  }
                ) }),
                selected2 && /* @__PURE__ */ jsx43(
                  "span",
                  {
                    className: classNames3(
                      "absolute inset-y-0 right-0 flex items-center pr-4",
                      active ? "bg-info-600 text-white" : "text-info-600"
                    ),
                    children: /* @__PURE__ */ jsx43(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                )
              ] })
            },
            result.id
          )) })
        ] })
      ]
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserGroupSearchContainer.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var graphqlQuery = AdminUserGroupSearchContainerQuery_graphql_default;
var AdminUserGroupSearchContainer = ({
  disabled,
  onSearchCompleted,
  showLabel,
  defaultValue
}) => {
  const [selectedResult, setSelectedResult] = useState13(defaultValue);
  const onSetSelected = useCallback19(
    (r) => {
      setSelectedResult(r);
      onSearchCompleted(r);
    },
    [onSearchCompleted, selectedResult]
  );
  const query = useLazyLoadQuery4(
    graphqlQuery,
    {
      where: {
        name: { startsWith: "" }
      }
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx44(
    AdminUserGroupSearchBox,
    {
      onSelected: onSetSelected,
      fragmentRef: query,
      showLabel,
      defaultValue: selectedResult
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserDetails.tsx
import { Fragment as Fragment21, jsx as jsx45, jsxs as jsxs42 } from "react/jsx-runtime";
var queryDef20 = AdminUserDetailsRouteQuery_graphql_default;
async function loader19(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery19(environment, queryDef20, {
    adminUserCode
  });
}
var AdminUserDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData14(queryDef20, routeId6);
  const { adminUser } = data;
  const [group, setGroup] = useState14(null);
  const [isJoiningGroup, toggleIsJoiningGroup] = useToggle3();
  const [errorMessage, setErrorMessage] = useState14(
    null
  );
  const [join, isJoining] = useAdminUserJoinGroup();
  const [leave, isLeaving] = useAdminUserLeaveGroup();
  if (data === null) {
    return /* @__PURE__ */ jsx45(EdSkeleton20, {});
  }
  if (!data) {
    return /* @__PURE__ */ jsx45(Fragment21, { children: "Loading..." });
  }
  if (!adminUser) {
    return /* @__PURE__ */ jsx45(Fragment21, { children: "Loading..." });
  }
  const onJoin = useCallback20(
    async (group2) => {
      try {
        const input = {
          userId: adminUser.accountId,
          groupId: group2.adminUserGroupId,
          clientMutationId: createClientMutationId9()
        };
        const response = await join({ input });
        if (response.data.adminUser) {
          setGroup(null);
          toggleIsJoiningGroup();
        } else if (response.data.userErrors) {
          setErrorMessage(response?.data?.userErrors?.[0]?.message);
        }
      } catch (error) {
        console.error(error);
        setErrorMessage("An error occurred while joining the group.");
      }
    },
    [join, group]
  );
  const onLeave = useCallback20(
    async (group2) => {
      try {
        const input = {
          userId: adminUser.accountId,
          groupId: group2.adminUserGroupId,
          clientMutationId: createClientMutationId9()
        };
        const connectionId = ConnectionHandler2.getConnectionID(
          "root",
          "AdminUsersList_list"
        );
        const response = await leave({ connections: [connectionId], input });
        if (response.data.userErrors) {
          setErrorMessage(response?.data?.userErrors?.[0]?.message);
        }
      } catch (error) {
        console.error(error);
        setErrorMessage("An error occurred while leaving the group.");
      }
    },
    [leave, group]
  );
  const groupsList = adminUser.userGroups?.length > 0 ? adminUser.userGroups.map((g) => {
    return /* @__PURE__ */ jsxs42("div", { className: "flex items-center gap-5", children: [
      /* @__PURE__ */ jsx45("div", { className: "bg-primary-500 w-1/3 cursor-pointer rounded-lg border p-2 text-white", children: /* @__PURE__ */ jsx45("div", { children: g.name }) }),
      /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
        Button13,
        {
          "aria-label": "Remove",
          confirmMessage: "Remove, are you sure?",
          color: "warning",
          size: Size8.sm,
          disabled: isLeaving,
          clicked: () => onLeave(g),
          children: "Remove"
        }
      ) })
    ] }, g.code);
  }) : /* @__PURE__ */ jsx45("div", { className: "text-primary-700", children: "No groups found" });
  return /* @__PURE__ */ jsxs42(Suspense31, { fallback: /* @__PURE__ */ jsx45(EdSkeleton20, {}), children: [
    /* @__PURE__ */ jsx45(MynPageTitle24, { title: "Admin User Details" }),
    /* @__PURE__ */ jsxs42(Card, { className: "m-4 flex flex-col gap-2 bg-white p-4", children: [
      data?.adminUser && /* @__PURE__ */ jsx45(
        AdminUserDetailsInfo,
        {
          queryRef: data?.adminUser,
          groupUserId: data?.adminUser?.userGroups?.[0]?.adminUserGroupId || "",
          userId: routeId6
        }
      ),
      errorMessage && /* @__PURE__ */ jsx45(AlertMessage2, { isError: true, message: errorMessage }),
      isJoiningGroup ? /* @__PURE__ */ jsx45("div", { className: "flex", children: /* @__PURE__ */ jsxs42("div", { className: "flex w-1/2 flex-col gap-4 border bg-white p-4", children: [
        /* @__PURE__ */ jsx45("div", { className: "flex", children: /* @__PURE__ */ jsx45("div", { className: "text-primary-500 font-medium", children: "Select a User Group below" }) }),
        /* @__PURE__ */ jsx45("div", { className: "", children: /* @__PURE__ */ jsx45(
          AdminUserGroupSearchContainer,
          {
            disabled: isJoining || isLeaving,
            onSearchCompleted: setGroup,
            showLabel: true
          }
        ) }),
        /* @__PURE__ */ jsxs42(ButtonList3, { children: [
          /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
            Button13,
            {
              "aria-label": "Save",
              color: "primary",
              size: Size8.lg,
              disabled: isJoining,
              onClick: () => group && onJoin(group),
              children: "Save"
            }
          ) }),
          /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
            Button13,
            {
              "aria-label": "Cancel",
              color: "gray",
              size: Size8.lg,
              disabled: isJoining,
              onClick: toggleIsJoiningGroup,
              children: "Cancel"
            }
          ) })
        ] })
      ] }) }) : /* @__PURE__ */ jsxs42("div", { className: "my-4 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx45("div", { className: "text-primary-700 flex items-center gap-2 font-medium uppercase", children: "Groups" }),
        /* @__PURE__ */ jsx45("div", { className: "flex flex-col gap-2 py-4", children: groupsList }),
        /* @__PURE__ */ jsx45("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
          Button13,
          {
            "aria-label": "Add to Group",
            color: "primary",
            size: Size8.lg,
            onClick: toggleIsJoiningGroup,
            children: "Add to Group"
          }
        ) }) })
      ] })
    ] })
  ] });
};
var createRoute10 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx45(AdminUserDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx45(Link9, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader19(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/AdminUserRoute.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var createAdminUserRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId3}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx46(AdminUserLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx46(ErrorContainer4, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx46(AdminUserGroupLink, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader18(environment, params);
      },
      children: [
        createRoute10(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx46(Navigate13, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/administrators/components/AdminUserCreate.tsx
import { useCallback as useCallback22 } from "react";
import { useNavigate as useNavigate11 } from "react-router-dom";
import { MynPageTitle as MynPageTitle25, Suspense as Suspense32 } from "shared-ui";
import { EdSkeleton as EdSkeleton21 } from "shared-ui";

// src/secure/accounts/administrators/components/AdminUserCreateContainer.tsx
import { useCallback as useCallback21 } from "react";
import * as zod2 from "zod";
import { useForm as useForm4 } from "react-hook-form";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId10,
  useSetUserErrorCodes as useSetUserErrorCodes2,
  useUserErrorCode as useUserErrorCode2
} from "shared-lib";
import {
  ActionContainer as ActionContainer2,
  ErrorField as ErrorField2,
  FormErrorCode as FormErrorCode2,
  FormErrorCodes as FormErrorCodes2,
  FormInputRow as FormInputRow2,
  InputField as InputField2,
  SwitchInput as SwitchInput2
} from "shared-ui";

// src/secure/accounts/administrators/lib/error-codes.ts
var AdminUserAccountsErrorCodes = class {
};
AdminUserAccountsErrorCodes.USER_EMAIL_IS_IN_USE = "ACCOUNTS_ADMIN_USER_EMAIL_IS_IN_USE";

// src/secure/accounts/administrators/components/AdminUserCreateContainer.tsx
import { jsx as jsx47, jsxs as jsxs43 } from "react/jsx-runtime";
var formSchema3 = zod2.object({
  firstName: zod2.string().min(1, { message: "Firstname is required" }),
  lastName: zod2.string().min(1, { message: "Lastname is required" }),
  email: zod2.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  isTestUser: zod2.boolean()
});
var AdminUserCreateContainer = ({ onCreate, onCancel }) => {
  const defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    isTestUser: true
  };
  const setErrorCode = useSetUserErrorCodes2();
  const { register, handleSubmit, watch, formState, control } = useForm4({
    resolver: zodResolver4(formSchema3),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode2();
  const [createAdminUser, isCreatingAdminUser] = useAdminUserCreate();
  const onSave = useCallback21(
    async (form) => {
      setErrorCode(null);
      if (!form.firstName || !form.lastName || !form.email) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId10(),
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        isTestUser: form.isTestUser
      };
      const response = await createAdminUser({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.adminUser?.node) {
        onCreate();
      }
    },
    [createAdminUser]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx47(FormErrorCodes2, {});
  if (userErrorCode && userErrorCode === AdminUserAccountsErrorCodes.USER_EMAIL_IS_IN_USE) {
    errorDisplay = /* @__PURE__ */ jsx47(FormErrorCode2, { message: "Email is already in use" });
  }
  return /* @__PURE__ */ jsxs43("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx47("form", { onSubmit, children: /* @__PURE__ */ jsxs43(
      ActionContainer2,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isCreatingAdminUser,
        titleTop: `Create AdminUser`,
        children: [
          /* @__PURE__ */ jsxs43(FormInputRow2, { name: "firstName", title: "First Name *", children: [
            /* @__PURE__ */ jsx47(
              InputField2,
              {
                register,
                name: "firstName",
                required: true,
                placeholder: "Admin User First Name"
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.firstName })
          ] }),
          /* @__PURE__ */ jsxs43(FormInputRow2, { name: "lastName", title: "Last Name *", children: [
            /* @__PURE__ */ jsx47(
              InputField2,
              {
                register,
                name: "lastName",
                required: true,
                placeholder: "Admin User Last Name"
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.lastName })
          ] }),
          /* @__PURE__ */ jsxs43(FormInputRow2, { name: "email", title: "Email *", children: [
            /* @__PURE__ */ jsx47(
              InputField2,
              {
                register,
                name: "email",
                required: true,
                placeholder: "Admin User Email"
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.email })
          ] }),
          /* @__PURE__ */ jsxs43(FormInputRow2, { name: "isTestUser", title: "Test Account *", children: [
            /* @__PURE__ */ jsx47(
              SwitchInput2,
              {
                control,
                name: "isTestUser",
                defaultChecked: false,
                label: "Is Test Account"
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.isTestUser })
          ] })
        ]
      }
    ) })
  ] });
};

// src/secure/accounts/administrators/components/AdminUserCreate.tsx
import { jsx as jsx48, jsxs as jsxs44 } from "react/jsx-runtime";
var AdminUserCreate = () => {
  const navigate = useNavigate11();
  const onCompleteAction = useCallback22(() => {
    navigate(`../`);
  }, [navigate]);
  return /* @__PURE__ */ jsxs44(Suspense32, { fallback: /* @__PURE__ */ jsx48(EdSkeleton21, {}), children: [
    /* @__PURE__ */ jsx48(MynPageTitle25, { title: "Create Admin User" }),
    /* @__PURE__ */ jsx48(
      AdminUserCreateContainer,
      {
        onCreate: onCompleteAction,
        onCancel: onCompleteAction
      }
    )
  ] });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserListContainerQuery.graphql.ts
var node46 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AdminUserList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountAdminUsersConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsers"
        }
      ]
    },
    "params": {
      "cacheID": "30a0e500852286b8de2fe8f98642fcb6",
      "id": null,
      "metadata": {},
      "name": "AdminUserListContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserListContainerQuery(\n  $where: AccountsAdminUserFilter!\n) {\n  ...AdminUserList_list\n}\n\nfragment AdminUserList_list on Query {\n  list: accountAdminUsers(first: 25, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node46.hash = "4532429833ab1dca588f32cfd0a727ae";
var AdminUserListContainerQuery_graphql_default = node46;

// src/secure/accounts/administrators/components/AdminUserListContainer.tsx
import { useState as useState15 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { Suspense as Suspense33 } from "shared-ui";
import { Input as Input4, Loading } from "shared-ui";
import { useDebounce as useDebounce3 } from "shared-lib";

// src/secure/accounts/administrators/components/__generated__/AdminUsersListPaginationQuery.graphql.ts
var node47 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUsersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "AccountAdminUsersConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsers"
        }
      ]
    },
    "params": {
      "cacheID": "bea8a7504e8a5d6452e308adfe0c26d3",
      "id": null,
      "metadata": {},
      "name": "AdminUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUsersListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: AccountsAdminUserFilter\n) {\n  ...AdminUserList_list_2HEEH6\n}\n\nfragment AdminUserList_list_2HEEH6 on Query {\n  list: accountAdminUsers(first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node47.hash = "6b6f156bcab007aa3e9528d799c1ca48";
var AdminUsersListPaginationQuery_graphql_default = node47;

// src/secure/accounts/administrators/components/__generated__/AdminUserList_list.graphql.ts
var node48 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUsersListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "firstName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountAdminUsersConnection",
        "kind": "LinkedField",
        "name": "__AdminUsersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node48.hash = "6b6f156bcab007aa3e9528d799c1ca48";
var AdminUserList_list_graphql_default = node48;

// src/secure/accounts/administrators/components/AdminUserList.tsx
import { useCallback as useCallback23 } from "react";
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader2,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement2,
  ListLayout as ListLayout2
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined3 } from "shared-lib";
import { jsx as jsx49, jsxs as jsxs45 } from "react/jsx-runtime";
var fragmentDef3 = AdminUserList_list_graphql_default;
function createLinkTo2(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment4(
    fragmentDef3,
    fragmentRef
  );
  const onLoadNext = useCallback23(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined3).map((e) => e.node).map((ft) => {
    const name = `${ft.firstName} ${ft.lastName}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx49("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs45("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx49("div", { className: "text-md font-medium uppercase", children: ft.firstName }),
          /* @__PURE__ */ jsx49("div", { className: "text-md font-medium uppercase", children: ft.lastName })
        ] }),
        /* @__PURE__ */ jsx49("div", { className: "text-md text-blue-700", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs45("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow(parseISO(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx49(DefaultListLayoutSectionElement2, { children: /* @__PURE__ */ jsx49("div", { className: "grid", children: /* @__PURE__ */ jsx49("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx49(
    ListLayout2,
    {
      title: "Admin Users",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx49(
        DefaultListLayoutItemHeader2,
        {
          title: "Admin Users",
          to: createLinkTo2,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserListContainer.tsx
import { jsx as jsx50, jsxs as jsxs46 } from "react/jsx-runtime";
var queryDef21 = AdminUserListContainerQuery_graphql_default;
var AdminUserListContainer = () => {
  const [filter, setFilter] = useState15(null);
  const searchTerm = useDebounce3(filter, 500);
  let where2 = {};
  if (searchTerm) {
    const parts = searchTerm?.split(/\s+/);
    const firstPart = parts?.[0];
    const secondPart = parts?.slice(1)?.join(" ");
    where2 = {
      ...where2,
      or: [
        {
          firstName: { startsWith: firstPart },
          and: [{ lastName: { startsWith: secondPart } }]
        },
        {
          lastName: { startsWith: firstPart },
          and: [{ firstName: { startsWith: secondPart } }]
        },
        {
          firstName: { startsWith: searchTerm }
        },
        {
          lastName: { startsWith: searchTerm }
        },
        { emailAddress: { startsWith: searchTerm } }
      ]
    };
  }
  const query = useLazyLoadQuery5(
    queryDef21,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs46("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx50("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs46("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx50("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx50("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx50(
        Input4,
        {
          "aria-label": "Enter Name",
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2.trim())
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx50("div", { className: "flex-1", children: /* @__PURE__ */ jsx50(Suspense33, { fallback: /* @__PURE__ */ jsx50(Loading, {}), children: /* @__PURE__ */ jsx50(AdminUserList, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListContainerQuery.graphql.ts
var node49 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AdminUserGroupListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupListContainer_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "5cbf674ad9419ec7dab035d0fcb7e467",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupListContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupListContainerQuery(\n  $where: AccountsAdminUserGroupFilter!\n) {\n  ...AdminUserGroupListContainer_list\n}\n\nfragment AdminUserGroupListContainer_list on Query {\n  list: accountAdminUserGroups(first: 25, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        adminUserGroupId\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node49.hash = "f266eb231a8111e5cee69bbabc485bdd";
var AdminUserGroupListContainerQuery_graphql_default = node49;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListPaginationQuery.graphql.ts
var node50 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "AccountAdminUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountAdminUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adminUserGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "AdminUserGroupListContainer_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "d14e699636d5a237237dc83b0e9a65e3",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: AccountsAdminUserGroupFilter\n) {\n  ...AdminUserGroupListContainer_list_2HEEH6\n}\n\nfragment AdminUserGroupListContainer_list_2HEEH6 on Query {\n  list: accountAdminUserGroups(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        adminUserGroupId\n        updatedAt\n        createdAt\n        name\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node50.hash = "776885304bbb4a9fb8c3575ca77c37fd";
var AdminUserGroupListPaginationQuery_graphql_default = node50;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupListContainer_list.graphql.ts
var node51 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUserGroupListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserGroupListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountAdminUserGroupsConnection",
        "kind": "LinkedField",
        "name": "__AdminUserGroupListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUserGroupsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminUserGroupId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionSet",
                    "kind": "LinkedField",
                    "name": "permissionSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResourcePermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actions",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "resource",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node51.hash = "776885304bbb4a9fb8c3575ca77c37fd";
var AdminUserGroupListContainer_list_graphql_default = node51;

// src/secure/accounts/administrators/components/AdminUserGroupListContainer.tsx
import { useCallback as useCallback24, useState as useState16 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6, usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO2 } from "date-fns";
import { Suspense as Suspense34 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined4, useDebounce as useDebounce4 } from "shared-lib";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader3,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement3,
  EdSkeleton as EdSkeleton22,
  Input as Input5,
  ListLayout as ListLayout3
} from "shared-ui";
import { jsx as jsx51, jsxs as jsxs47 } from "react/jsx-runtime";
var queryDef22 = AdminUserGroupListContainerQuery_graphql_default;
var fragmentDef4 = AdminUserGroupListContainer_list_graphql_default;
function createLinkTo3(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserList2 = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment5(fragmentDef4, fragmentRef);
  const onLoadNext = useCallback24(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined4).map((e) => e.node).map((ft) => {
    const name = `${ft.name}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx51("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs47("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx51("div", { className: "text-md font-medium uppercase", children: ft.name }),
        /* @__PURE__ */ jsx51("div", { className: "text-md text-blue-700", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs47("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow2(parseISO2(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx51(Suspense34, { fallback: /* @__PURE__ */ jsx51(EdSkeleton22, {}), children: /* @__PURE__ */ jsx51(DefaultListLayoutSectionElement3, { children: /* @__PURE__ */ jsx51("div", { className: "grid", children: /* @__PURE__ */ jsx51("div", { children: ft.code }) }) }) })
    };
  });
  return /* @__PURE__ */ jsx51(
    ListLayout3,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx51(
        DefaultListLayoutItemHeader3,
        {
          title: "Admin Users",
          to: createLinkTo3,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  );
};
var AdminUserGroupListContainer = () => {
  const [filter, setFilter] = useState16(null);
  const searchTerm = useDebounce4(filter, 500);
  let where2 = {};
  if (searchTerm) {
    where2 = { name: { startsWith: filter } };
  }
  const query = useLazyLoadQuery6(
    queryDef22,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs47("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx51("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs47("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx51("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx51("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx51(
        Input5,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2.trim())
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx51("div", { className: "flex-1", children: /* @__PURE__ */ jsx51(Suspense34, { fallback: /* @__PURE__ */ jsx51(EdSkeleton22, {}), children: /* @__PURE__ */ jsx51(AdminUserList2, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/AdminUserGroupRoute.tsx
import { Navigate as Navigate14 } from "react-router-dom";
import { ErrorContainer as ErrorContainer5 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupLayoutQuery.graphql.ts
var node52 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PermissionSet",
          "kind": "LinkedField",
          "name": "permissionSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResourcePermissions",
              "kind": "LinkedField",
              "name": "permissions",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "actions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resource",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "1c674deed3e3c510bd08c626bb6abb1c",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupLayoutQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupLayoutQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    permissionSet {\n      permissions {\n        actions\n        resource\n      }\n    }\n  }\n}\n"
    }
  };
}();
node52.hash = "446cf9ef26c9d05bcc4f378b002d909d";
var AdminUserGroupLayoutQuery_graphql_default = node52;

// src/secure/accounts/administrators/components/AdminUserGroupLayout.tsx
import { Suspense as Suspense35 } from "react";
import {
  Link as Link10,
  Outlet as Outlet9,
  useLoaderData as useLoaderData6,
  useRouteLoaderData as useRouteLoaderData4
} from "react-router-dom";
import {
  loadQuery as loadQuery20,
  usePreloadedQuery as usePreloadedQuery6
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon2 } from "@heroicons/react/24/outline";
import {
  DynamicBreadcrumb as DynamicBreadcrumb5,
  EdButtonLink as EdButtonLink2,
  EdTextLink as EdTextLink5,
  IconJustify as IconJustify2
} from "shared-ui";
import { Fragment as Fragment22, jsx as jsx52, jsxs as jsxs48 } from "react/jsx-runtime";
var routeId4 = "admin-user-group-home";
var queryDef23 = AdminUserGroupLayoutQuery_graphql_default;
var AdminUserGroupLayout = ({ inList, showHeader }) => {
  const preloadedQuery = useLoaderData6();
  const data = usePreloadedQuery6(queryDef23, preloadedQuery);
  const { adminUserGroup } = data;
  if (adminUserGroup === null || adminUserGroup === void 0) {
    return /* @__PURE__ */ jsx52("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx52(Suspense35, { fallback: "Loading...", children: /* @__PURE__ */ jsxs48("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx52("div", { children: /* @__PURE__ */ jsxs48("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx52(DynamicBreadcrumb5, {}),
      /* @__PURE__ */ jsx52("div", { className: "text-primary-700 px-2 font-medium uppercase sm:px-8", children: adminUserGroup.name })
    ] }) }),
    /* @__PURE__ */ jsxs48("div", { className: "flex flex-wrap items-center justify-between border-b bg-white p-2", children: [
      /* @__PURE__ */ jsxs48("div", { className: "flex flex-wrap items-center gap-2 px-4", children: [
        /* @__PURE__ */ jsx52(
          EdTextLink5,
          {
            id: "form-template-root-link",
            to: "details",
            label: "Details"
          }
        ),
        /* @__PURE__ */ jsx52(
          EdTextLink5,
          {
            id: "form-template-permissions-link",
            to: "permissions",
            label: "Permissions"
          }
        ),
        /* @__PURE__ */ jsx52(
          EdTextLink5,
          {
            id: "form-template-users-link",
            to: "users",
            label: "Users"
          }
        )
      ] }),
      inList && /* @__PURE__ */ jsx52("div", { children: /* @__PURE__ */ jsx52(
        EdButtonLink2,
        {
          to: `../../../../group/${adminUserGroup.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon2,
          iconJustify: IconJustify2.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx52(Outlet9, {})
  ] }) });
};
var AdminUserGroupLink2 = ({ routeId: routeId6, label }) => {
  const data = useAdminUserGroupRouteData(routeId6);
  if (!data.adminUserGroup) {
    return /* @__PURE__ */ jsx52(Fragment22, {});
  }
  const name = `${data.adminUserGroup.name}`;
  return /* @__PURE__ */ jsx52(Suspense35, { fallback: "Loading...", children: /* @__PURE__ */ jsx52(Link10, { to: ".", children: label || name }) });
};
async function loader20(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery20(environment, queryDef23, {
    adminUserGroupCode
  });
}
function useAdminUserGroupRouteData(routeId6) {
  const queryRef = useRouteLoaderData4(
    routeId6
  );
  const data = usePreloadedQuery6(queryDef23, queryRef);
  return data;
}

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupDetailsRouteQuery.graphql.ts
var node53 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupDetailsRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupDetailsRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "fa737f446ce898ce96363860280bbcc1",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupDetailsRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    description\n  }\n}\n"
    }
  };
}();
node53.hash = "68269ee548deca9ab99b61f2c4b22b1c";
var AdminUserGroupDetailsRouteQuery_graphql_default = node53;

// src/secure/accounts/administrators/components/AdminUserGroupDetails.tsx
import { Suspense as Suspense36 } from "react";
import { loadQuery as loadQuery21 } from "react-relay";
import { Link as Link11 } from "react-router-dom";
import { timeAgo as timeAgo7, useRouteData as useRouteData15 } from "shared-lib";
import { EdSkeleton as EdSkeleton23, MynPageTitle as MynPageTitle26 } from "shared-ui";
import { Fragment as Fragment23, jsx as jsx53, jsxs as jsxs49 } from "react/jsx-runtime";
var queryDef24 = AdminUserGroupDetailsRouteQuery_graphql_default;
async function loader21(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery21(environment, queryDef24, {
    adminUserGroupCode
  });
}
var AdminUserGroupDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData15(queryDef24, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx53(Fragment23, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx53(Fragment23, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs49(Suspense36, { fallback: /* @__PURE__ */ jsx53(EdSkeleton23, {}), children: [
    /* @__PURE__ */ jsx53(MynPageTitle26, { title: "Admin Group Details" }),
    /* @__PURE__ */ jsxs49("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx53("div", { className: "mt-4 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsxs49("div", { className: "flex items-center gap-2 border-b pb-2", children: [
        /* @__PURE__ */ jsx53("div", { className: "text-primary-700 text-xl font-medium uppercase", children: adminUserGroup.name }),
        /* @__PURE__ */ jsxs49("div", { className: "text-sm text-gray-700", children: [
          "Updated ",
          timeAgo7(adminUserGroup.updatedAt)
        ] })
      ] }) }),
      /* @__PURE__ */ jsx53("div", { className: "mt-4 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx53("div", { className: "font-medium text-gray-900", children: /* @__PURE__ */ jsx53("div", { children: adminUserGroup.description }) }) })
    ] })
  ] });
};
var createRoute11 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx53(AdminUserGroupDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx53(Link11, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader21(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupPermissionsRouteQuery.graphql.ts
var node54 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "adminUserGroupCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "adminUserGroupId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v8 = [
    v6,
    v7
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupPermissionsRouteQuery",
      "selections": [
        {
          "alias": "adminUserGroup",
          "args": v1,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "accountAdminUserGroupByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AdminUserGroupPermissionsEditorContainer_group"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupPermissionsRouteQuery",
      "selections": [
        {
          "alias": "adminUserGroup",
          "args": v1,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "accountAdminUserGroupByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v6,
            v7,
            {
              "alias": "groupId",
              "args": null,
              "kind": "ScalarField",
              "name": "adminUserGroupId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAdminGroup",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDefault",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PermissionSet",
              "kind": "LinkedField",
              "name": "permissionSet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ResourcePermissions",
                  "kind": "LinkedField",
                  "name": "permissions",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actions",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resource",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Authorizable",
              "kind": "LinkedField",
              "name": "authorizableSets",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableResource",
                  "kind": "LinkedField",
                  "name": "resource",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableCategory",
                  "kind": "LinkedField",
                  "name": "category",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "label",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorizableAction",
                  "kind": "LinkedField",
                  "name": "actions",
                  "plural": true,
                  "selections": v8,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "019da22a6302f7f9e283c61189515e1e",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupPermissionsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupPermissionsRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    ...AdminUserGroupPermissionsEditorContainer_group\n  }\n}\n\nfragment AdminUserGroupPermissionsEditorContainer_group on AccountsAdminUserGroup {\n  id\n  name\n  description\n  groupId: adminUserGroupId\n  isAdminGroup\n  isDefault\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n  authorizableSets {\n    resource {\n      name\n      description\n    }\n    category {\n      name\n      label\n      description\n    }\n    actions {\n      name\n      description\n    }\n  }\n}\n"
    }
  };
}();
node54.hash = "912f3ca9e3f89390e61c97e288fe8471";
var AdminUserGroupPermissionsRouteQuery_graphql_default = node54;

// src/secure/accounts/administrators/components/AdminUserGroupPermissions.tsx
import { Suspense as Suspense39 } from "react";
import { loadQuery as loadQuery22 } from "react-relay";
import { Link as Link12 } from "react-router-dom";
import { useRouteData as useRouteData16 } from "shared-lib";
import { EdSkeleton as EdSkeleton26, MynPageTitle as MynPageTitle27 } from "shared-ui";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupPermissionsEditorContainer_group.graphql.ts
var node55 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v2 = [
    v0,
    v1
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUserGroupPermissionsEditorContainer_group",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      v0,
      v1,
      {
        "alias": "groupId",
        "args": null,
        "kind": "ScalarField",
        "name": "adminUserGroupId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAdminGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PermissionSet",
        "kind": "LinkedField",
        "name": "permissionSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourcePermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "actions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resource",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Authorizable",
        "kind": "LinkedField",
        "name": "authorizableSets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableResource",
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": v2,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              v1
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorizableAction",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": v2,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsAdminUserGroup",
    "abstractKey": null
  };
}();
node55.hash = "a5089cf9f3a964c7d611968ddcdb53e0";
var AdminUserGroupPermissionsEditorContainer_group_graphql_default = node55;

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditorContainer.tsx
import { useCallback as useCallback26, useMemo as useMemo3, useState as useState17 } from "react";
import { useFragment } from "react-relay";
import { Suspense as Suspense38 } from "shared-ui";
import {
  createAuthorizableGroups,
  createAuthorizables,
  createPermissionKeyableSet
} from "app-core";
import { classNames as classNames4, EdSkeleton as EdSkeleton25 } from "shared-ui";

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditor.tsx
import { useCallback as useCallback25 } from "react";
import { Suspense as Suspense37 } from "shared-ui";
import { createClientMutationId as createClientMutationId11 } from "shared-lib";
import { EdSkeleton as EdSkeleton24 } from "shared-ui";
import { AuthorizableGroupEditor } from "app-core";
import { jsx as jsx54 } from "react/jsx-runtime";
var AdminUserGroupPermissionsEditor = ({
  groups,
  selectedCategoryLabel
}) => {
  const [updateGroup, isUpdatingGroup] = useAdminUserGroupUpdatePermissions();
  const onUpdateGroup = useCallback25(
    async (group) => {
      if (!group) {
        return;
      }
      const allPermissions = groups.filter((g) => g.id !== group.id).flatMap((g) => g.permissions).map((p) => ({
        resource: p.resource,
        actions: p.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const groupPermissions = group.permissions.map((p) => ({
        resource: p.resource,
        actions: p.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const input = {
        clientMutationId: createClientMutationId11(),
        permissions: [...allPermissions, ...groupPermissions],
        groupId: group.groupId
      };
      await updateGroup({ input });
    },
    [updateGroup]
  );
  let activeGroups = [];
  if (selectedCategoryLabel && groups) {
    activeGroups = groups.filter((g) => g.category === selectedCategoryLabel);
  }
  const groupList = activeGroups.map((g) => {
    return /* @__PURE__ */ jsx54(
      AuthorizableGroupEditor,
      {
        group: g,
        isBusy: isUpdatingGroup,
        onUpdate: onUpdateGroup
      },
      g.id
    );
  });
  return /* @__PURE__ */ jsx54(Suspense37, { fallback: /* @__PURE__ */ jsx54(EdSkeleton24, {}), children: groupList });
};

// src/secure/accounts/administrators/components/AdminUserGroupPermissionsEditorContainer.tsx
import { jsx as jsx55, jsxs as jsxs50 } from "react/jsx-runtime";
var fragmentDef5 = AdminUserGroupPermissionsEditorContainer_group_graphql_default;
var AdminUserGroupPermissionsEditorContainer = ({
  fragmentRef
}) => {
  const adminUserGroup = useFragment(fragmentDef5, fragmentRef);
  const [selectedCategoryLabel, setSelectedCategoryLabel] = useState17();
  const onSelect = useCallback26(
    (groupCategory) => {
      setSelectedCategoryLabel(groupCategory);
    },
    [setSelectedCategoryLabel]
  );
  const authorizableSets = useMemo3(() => {
    if (adminUserGroup === null) {
      return [];
    }
    return createAuthorizables(adminUserGroup?.authorizableSets || []);
  }, [adminUserGroup]);
  const groups = useMemo3(() => {
    if (adminUserGroup === null) {
      return [];
    }
    const permissionsList = adminUserGroup.permissionSet.permissions.filter(
      (p) => p.actions.length > 0
    );
    const permissions = createPermissionKeyableSet(permissionsList);
    const groups2 = createAuthorizableGroups(
      adminUserGroup,
      permissions,
      authorizableSets
    );
    return groups2;
  }, [adminUserGroup]);
  const categoryLabels = groups.map((g) => {
    const isSelected = selectedCategoryLabel && g.category === selectedCategoryLabel;
    return /* @__PURE__ */ jsx55(
      "div",
      {
        className: classNames4(
          "cursor-pointer border-b p-3 hover:bg-gray-100",
          isSelected ? "font-bold" : ""
        ),
        onClick: () => onSelect(g.category),
        children: g.category
      },
      g.id
    );
  });
  return /* @__PURE__ */ jsx55(Suspense38, { fallback: /* @__PURE__ */ jsx55(EdSkeleton25, {}), children: /* @__PURE__ */ jsxs50("div", { className: "mx-4 flex items-start gap-2 border bg-white px-4", children: [
    /* @__PURE__ */ jsxs50("div", { className: "sticky top-0 flex w-1/5 flex-col", children: [
      /* @__PURE__ */ jsx55("div", { className: "text-primary-800 p-3 font-medium", children: "Categories" }),
      categoryLabels
    ] }),
    /* @__PURE__ */ jsxs50("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsx55("div", { className: "text-primary-800 p-3 font-medium", children: "Groups" }),
      selectedCategoryLabel && /* @__PURE__ */ jsx55(
        AdminUserGroupPermissionsEditor,
        {
          groups,
          selectedCategoryLabel
        }
      )
    ] })
  ] }) });
};

// src/secure/accounts/administrators/components/AdminUserGroupPermissions.tsx
import { Fragment as Fragment24, jsx as jsx56, jsxs as jsxs51 } from "react/jsx-runtime";
var queryDef25 = AdminUserGroupPermissionsRouteQuery_graphql_default;
async function loader22(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery22(environment, queryDef25, {
    adminUserGroupCode
  });
}
var AdminUserGroupPermissions = ({ routeId: routeId6, inList }) => {
  const data = useRouteData16(
    queryDef25,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx56(Fragment24, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx56(Fragment24, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs51(Suspense39, { fallback: /* @__PURE__ */ jsx56(EdSkeleton26, {}), children: [
    /* @__PURE__ */ jsx56(MynPageTitle27, { title: "Admin Group Permissions" }),
    /* @__PURE__ */ jsx56("div", { className: "my-2 flex flex-col gap-2", children: /* @__PURE__ */ jsx56(
      AdminUserGroupPermissionsEditorContainer,
      {
        fragmentRef: adminUserGroup
      }
    ) })
  ] });
};
var createRoute12 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-permissions`;
  return {
    id: routeId6,
    path: "permissions",
    element: /* @__PURE__ */ jsx56(AdminUserGroupPermissions, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx56(Link12, { to: "permissions", children: "Permissions" })
    },
    loader: ({ params }) => {
      return loader22(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersRouteQuery.graphql.ts
var node56 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserGroupCode"
    }
  ], v1 = [
    {
      "alias": "adminUserGroup",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserGroupCode"
        }
      ],
      "concreteType": "AccountsAdminUserGroup",
      "kind": "LinkedField",
      "name": "accountAdminUserGroupByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": "groupId",
          "args": null,
          "kind": "ScalarField",
          "name": "adminUserGroupId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdminGroup",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ad30710486b70d6abb2abd0b87e8975d",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersRouteQuery(\n  $adminUserGroupCode: Long!\n) {\n  adminUserGroup: accountAdminUserGroupByCode(code: $adminUserGroupCode) {\n    id\n    code\n    adminUserGroupId\n    groupId: adminUserGroupId\n    createdAt\n    updatedAt\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node56.hash = "e363024d3a9d11367025ed4c1ca3a669";
var AdminUserGroupUsersRouteQuery_graphql_default = node56;

// src/secure/accounts/administrators/components/AdminUserGroupUsers.tsx
import { Suspense as Suspense43 } from "react";
import { loadQuery as loadQuery24 } from "react-relay";
import { Link as Link14 } from "react-router-dom";
import { useRouteData as useRouteData18 } from "shared-lib";
import { EdSkeleton as EdSkeleton28, MynPageTitle as MynPageTitle29 } from "shared-ui";
import { OutletRoute as OutletRoute9 } from "app-core";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersContainerQuery.graphql.ts
var node57 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    v1,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupUsersList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "AccountAdminUsersByUserGroupConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsersByUserGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersByUserGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsersByUserGroup"
        }
      ]
    },
    "params": {
      "cacheID": "b1d23ecef747f4433d3c05fdeb9e2372",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersContainerQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersContainerQuery(\n  $userGroupId: UUID!\n  $where: AccountsAdminUserFilter!\n) {\n  ...AdminUserGroupUsersList_list_2BWF27\n}\n\nfragment AdminUserGroupUsersList_list_2BWF27 on Query {\n  list: accountAdminUsersByUserGroup(userGroupId: $userGroupId, first: 25, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node57.hash = "a7ffde28d8e8e8dfc8c4f3ebba6d51dd";
var AdminUserGroupUsersContainerQuery_graphql_default = node57;

// src/secure/accounts/administrators/components/AdminUserGroupUsersContainer.tsx
import { useState as useState18 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { Suspense as Suspense41 } from "shared-ui";
import { Input as Input6 } from "shared-ui";
import { useDebounce as useDebounce5 } from "shared-lib";

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersListPaginationQuery.graphql.ts
var node58 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    v3,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "AdminUserGroupUsersList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUsersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "AccountAdminUsersByUserGroupConnection",
          "kind": "LinkedField",
          "name": "accountAdminUsersByUserGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountAdminUsersByUserGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsAdminUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "AdminUsersList_list",
          "kind": "LinkedHandle",
          "name": "accountAdminUsersByUserGroup"
        }
      ]
    },
    "params": {
      "cacheID": "043e36931c5d141fc6a69c93546102c5",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUsersListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $userGroupId: UUID!\n  $where: AccountsAdminUserFilter\n) {\n  ...AdminUserGroupUsersList_list_2Lqwyl\n}\n\nfragment AdminUserGroupUsersList_list_2Lqwyl on Query {\n  list: accountAdminUsersByUserGroup(userGroupId: $userGroupId, first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        updatedAt\n        createdAt\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node58.hash = "ff473675ccacac53d074ee90361362e9";
var AdminUserGroupUsersListPaginationQuery_graphql_default = node58;

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUsersList_list.graphql.ts
var node59 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userGroupId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AdminUserGroupUsersListPaginationQuery_graphql_default
      }
    },
    "name": "AdminUserGroupUsersList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "AccountAdminUsersByUserGroupConnection",
        "kind": "LinkedField",
        "name": "__AdminUsersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountAdminUsersByUserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsAdminUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node59.hash = "ff473675ccacac53d074ee90361362e9";
var AdminUserGroupUsersList_list_graphql_default = node59;

// src/secure/accounts/administrators/components/AdminUserGroupUsersList.tsx
import { useCallback as useCallback27 } from "react";
import { usePaginationFragment as usePaginationFragment6 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO3 } from "date-fns";
import { Suspense as Suspense40 } from "shared-ui";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader4,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement4,
  ListLayout as ListLayout4
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined5 } from "shared-lib";
import { jsx as jsx57, jsxs as jsxs52 } from "react/jsx-runtime";
var fragmentDef6 = AdminUserGroupUsersList_list_graphql_default;
function createLinkTo4(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var AdminUserGroupUsersList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment6(fragmentDef6, fragmentRef);
  const onLoadNext = useCallback27(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined5).map((e) => e.node).map((ft) => {
    const name = `${ft.firstName} ${ft.lastName}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx57("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs52("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs52("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx57("div", { className: "text-md font-medium uppercase", children: ft.firstName }),
          /* @__PURE__ */ jsx57("div", { className: "text-md font-medium uppercase", children: ft.lastName })
        ] }),
        /* @__PURE__ */ jsx57("div", { className: "text-md text-blue-700", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs52("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow3(parseISO3(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx57(Suspense40, { fallback: "Loading...", children: /* @__PURE__ */ jsx57(DefaultListLayoutSectionElement4, { children: /* @__PURE__ */ jsx57("div", { className: "grid", children: /* @__PURE__ */ jsx57("div", { children: ft.code }) }) }) })
    };
  });
  return /* @__PURE__ */ jsx57(
    ListLayout4,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx57(
        DefaultListLayoutItemHeader4,
        {
          title: "Admin Users",
          to: createLinkTo4,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  );
};

// src/secure/accounts/administrators/components/AdminUserGroupUsersContainer.tsx
import { jsx as jsx58, jsxs as jsxs53 } from "react/jsx-runtime";
var queryDef26 = AdminUserGroupUsersContainerQuery_graphql_default;
var AdminUserGroupUsersContainer = ({ userGroupId }) => {
  const [filter, setFilter] = useState18(null);
  const searchTerm = useDebounce5(filter, 500);
  let where2 = {};
  if (searchTerm) {
    where2 = {
      or: [
        { firstName: { startsWith: filter } },
        { lastName: { startsWith: filter } },
        { emailAddress: { startsWith: filter } }
      ]
    };
  }
  const query = useLazyLoadQuery7(
    queryDef26,
    { userGroupId, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs53("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx58("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs53("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx58("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx58("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx58(
        Input6,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx58("div", { className: "flex-1", children: /* @__PURE__ */ jsx58(Suspense41, { fallback: "Loading...", children: /* @__PURE__ */ jsx58(AdminUserGroupUsersList, { fragmentRef: query }) }) })
  ] });
};

// src/secure/accounts/administrators/components/__generated__/AdminUserGroupUserDetailsRouteQuery.graphql.ts
var node60 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "adminUserCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = [
    {
      "alias": "adminUser",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "adminUserCode"
        }
      ],
      "concreteType": "AccountsAdminUser",
      "kind": "LinkedField",
      "name": "accountAdminUserByCode",
      "plural": false,
      "selections": [
        v1,
        v2,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountsAdminUserGroup",
          "kind": "LinkedField",
          "name": "userGroups",
          "plural": true,
          "selections": [
            v1,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "7d8d3c8d9a07fa515249e088820de7d8",
      "id": null,
      "metadata": {},
      "name": "AdminUserGroupUserDetailsRouteQuery",
      "operationKind": "query",
      "text": "query AdminUserGroupUserDetailsRouteQuery(\n  $adminUserCode: Long!\n) {\n  adminUser: accountAdminUserByCode(code: $adminUserCode) {\n    id\n    code\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    userGroups {\n      id\n      code\n      name\n    }\n  }\n}\n"
    }
  };
}();
node60.hash = "432c0a8049fe68247bcabe6a78471888";
var AdminUserGroupUserDetailsRouteQuery_graphql_default = node60;

// src/secure/accounts/administrators/components/AdminUserGroupUserDetails.tsx
import { useCallback as useCallback28 } from "react";
import { ConnectionHandler as ConnectionHandler3, loadQuery as loadQuery23 } from "react-relay";
import { Link as Link13, useNavigate as useNavigate12 } from "react-router-dom";
import { MynPageTitle as MynPageTitle28, Suspense as Suspense42 } from "shared-ui";
import { createClientMutationId as createClientMutationId12, timeAgo as timeAgo8, useRouteData as useRouteData17 } from "shared-lib";
import { Button as Button14, EdSkeleton as EdSkeleton27 } from "shared-ui";
import { Fragment as Fragment25, jsx as jsx59, jsxs as jsxs54 } from "react/jsx-runtime";
var queryDef27 = AdminUserGroupUserDetailsRouteQuery_graphql_default;
async function loader23(environment, params) {
  const code = params.adminUserCode;
  const adminUserCode = parseInt(code);
  return loadQuery23(environment, queryDef27, {
    adminUserCode
  });
}
var AdminUserGroupUserDetails = ({
  routeId: routeId6,
  groupRouteId
}) => {
  const navigate = useNavigate12();
  const groupData = useAdminUserGroupUsersRouteData(groupRouteId);
  const userData = useRouteData17(
    queryDef27,
    routeId6
  );
  const connectionId = ConnectionHandler3.getConnectionID(
    "root",
    "AdminUsersList_list"
  );
  const onRemoved = useCallback28(() => {
    navigate("../../");
  }, [navigate]);
  const [remove, isRemoving] = useAdminUserLeaveGroup();
  const onRemoveUser = useCallback28(async () => {
    if (!groupData.adminUserGroup || !userData.adminUser) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId12(),
      groupId: groupData.adminUserGroup?.adminUserGroupId,
      userId: userData.adminUser.accountId
    };
    const result = await remove({ connections: [connectionId], input });
    if (result.data.adminUser) {
      onRemoved();
    }
  }, [remove]);
  if (!userData) {
    return /* @__PURE__ */ jsx59(Fragment25, { children: "Loading..." });
  }
  const { adminUser } = userData;
  if (!adminUser) {
    return /* @__PURE__ */ jsx59(Fragment25, { children: "Loading..." });
  }
  const groupsList = adminUser.userGroups.map((g) => {
    return /* @__PURE__ */ jsx59("div", { className: "flex", children: /* @__PURE__ */ jsx59("div", { className: "bg-primary-500 w-1/3 cursor-pointer rounded-lg border p-2 text-white", children: /* @__PURE__ */ jsx59("div", { children: g.name }) }) }, g.code);
  });
  return /* @__PURE__ */ jsxs54(Suspense42, { fallback: /* @__PURE__ */ jsx59(EdSkeleton27, {}), children: [
    /* @__PURE__ */ jsx59(MynPageTitle28, { title: "Admin Group User Details" }),
    /* @__PURE__ */ jsxs54("div", { className: "flex flex-1 flex-col gap-2 border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs54("div", { className: "my-4 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsxs54("div", { className: "text-primary-700 flex items-center gap-2 border-b pb-2 font-medium uppercase", children: [
          /* @__PURE__ */ jsx59("div", { children: adminUser.firstName }),
          /* @__PURE__ */ jsx59("div", { children: adminUser.lastName })
        ] }),
        /* @__PURE__ */ jsx59("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsxs54("div", { className: "text-sm text-gray-500", children: [
          "Updated ",
          timeAgo8(adminUser.updatedAt)
        ] }) })
      ] }),
      /* @__PURE__ */ jsx59("div", { className: "my-4 flex flex-col gap-2 border-b border-t py-4", children: /* @__PURE__ */ jsx59("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx59("div", { children: /* @__PURE__ */ jsx59(
        Button14,
        {
          color: "primary",
          clicked: onRemoveUser,
          confirmMessage: "Remove, are you sure ? ",
          children: "Remove"
        }
      ) }) }) }),
      /* @__PURE__ */ jsxs54("div", { className: "my-4 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx59("div", { className: "text-primary-700 flex items-center gap-2 font-medium uppercase", children: "Groups" }),
        /* @__PURE__ */ jsx59("div", { className: "flex flex-col gap-2 py-4", children: groupsList })
      ] })
    ] })
  ] });
};
var createRoute13 = (routePrefix, environment, context, groupRouteId) => {
  const routeId6 = `${routePrefix}-admin-user-details`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx59(
      AdminUserGroupUserDetails,
      {
        routeId: routeId6,
        groupRouteId
      }
    ),
    handle: {
      crumb: () => /* @__PURE__ */ jsx59(Link13, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader23(environment, params);
    }
  };
};

// src/secure/accounts/administrators/components/AdminUserGroupUsers.tsx
import { Fragment as Fragment26, jsx as jsx60, jsxs as jsxs55 } from "react/jsx-runtime";
var queryDef28 = AdminUserGroupUsersRouteQuery_graphql_default;
async function loader24(environment, params) {
  const code = params.adminUserGroupCode;
  const adminUserGroupCode = parseInt(code);
  return loadQuery24(environment, queryDef28, {
    adminUserGroupCode
  });
}
var useAdminUserGroupUsersRouteData = (routeId6) => {
  const data = useRouteData18(queryDef28, routeId6);
  return data;
};
var AdminUserGroupUsers = ({ routeId: routeId6, inList }) => {
  const data = useAdminUserGroupUsersRouteData(routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx60(Fragment26, { children: "Loading..." });
  }
  const { adminUserGroup } = data;
  if (!adminUserGroup) {
    return /* @__PURE__ */ jsx60(Fragment26, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs55(Suspense43, { fallback: /* @__PURE__ */ jsx60(EdSkeleton28, {}), children: [
    /* @__PURE__ */ jsx60(MynPageTitle29, { title: "Admin Group Users" }),
    /* @__PURE__ */ jsx60(
      AdminUserGroupUsersContainer,
      {
        userGroupId: adminUserGroup.adminUserGroupId
      }
    )
  ] });
};
var createRoute14 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-admin-user-group-users`;
  return {
    id: routeId6,
    path: "users",
    element: /* @__PURE__ */ jsx60(AdminUserGroupUsers, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx60(Link14, { to: "users", children: "Users" })
    },
    loader: ({ params }) => {
      return loader24(environment, params);
    },
    children: [
      {
        id: `${routeId6}-admin-user`,
        path: ":adminUserCode/*",
        element: /* @__PURE__ */ jsx60(OutletRoute9, {}),
        children: [
          createRoute13(`${routeId6}-admin-user`, environment, context, routeId6)
        ]
      }
    ]
  };
};

// src/secure/accounts/administrators/components/AdminUserGroupRoute.tsx
import { jsx as jsx61 } from "react/jsx-runtime";
var createAdminUserGroupRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId6 = `${routePrefix}-${routeId4}`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx61(AdminUserGroupLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx61(ErrorContainer5, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx61(AdminUserGroupLink2, { routeId: routeId6 })
      },
      loader: ({ params }) => {
        return loader20(environment, params);
      },
      children: [
        createRoute11(routePrefix, environment, context, inList),
        createRoute12(routePrefix, environment, context, inList),
        createRoute14(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx61(Navigate14, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/administrators/components/AdminRoute.tsx
import { jsx as jsx62, jsxs as jsxs56 } from "react/jsx-runtime";
var AdminLayout = () => {
  const location = useLocation6();
  const tabs4 = [
    createLinkState6(location, "Users", `users`, UsersIcon2),
    createLinkState6(location, "Groups", `groups`, UserGroupIcon2)
  ];
  return /* @__PURE__ */ jsx62(Suspense44, { fallback: "Loading Admin...", children: /* @__PURE__ */ jsx62(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsxs56("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs56("div", { className: "flex items-center justify-between border-b bg-white px-4", children: [
      /* @__PURE__ */ jsxs56("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx62(EdLink2, { href: "../../", name: "List Admin Users", children: /* @__PURE__ */ jsx62(Button15, { "aria-label": "Back", color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx62(TabPills2, { tabs: tabs4 })
      ] }),
      /* @__PURE__ */ jsxs56("div", { className: "flex items-center gap-2 p-4", children: [
        /* @__PURE__ */ jsx62(PageHeading, { children: "Myn User Admin" }),
        /* @__PURE__ */ jsx62(EdLink2, { href: "create", name: "Create Admin Users", children: /* @__PURE__ */ jsx62(Button15, { "aria-label": "Create Admin User", color: "primary", children: "Create Admin User" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx62("div", { children: /* @__PURE__ */ jsx62(Outlet10, {}) })
  ] }) }) });
};
var AdminUsersListRoute = () => {
  return /* @__PURE__ */ jsx62(Suspense44, { fallback: "Loading Admin Users...", children: /* @__PURE__ */ jsxs56(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: [
    /* @__PURE__ */ jsx62(MynPageTitle30, { title: "Admin Users" }),
    /* @__PURE__ */ jsx62(AdminUserListContainer, {})
  ] }) });
};
var AdminUserGroupsListRoute = () => {
  return /* @__PURE__ */ jsx62(Suspense44, { fallback: "Loading Admin User Groups...", children: /* @__PURE__ */ jsxs56(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: [
    /* @__PURE__ */ jsx62(MynPageTitle30, { title: "Admin Groups" }),
    /* @__PURE__ */ jsx62(AdminUserGroupListContainer, {})
  ] }) });
};
var createAdminRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-admin-users`;
  const listRouteId = `${routeId6}-list`;
  const groupListRouteId = `${routeId6}-groups-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx62(AdminLayout, {}),
      children: [
        {
          id: listRouteId,
          path: "users/*",
          element: /* @__PURE__ */ jsx62(AdminUsersListRoute, {}),
          children: [
            {
              id: `${listRouteId}-admin-users`,
              path: ":adminUserCode/*",
              element: /* @__PURE__ */ jsx62(OutletRoute10, {}),
              children: createAdminUserRoutes(
                `${listRouteId}-admin-user`,
                environment,
                context,
                true,
                true
              )
            }
          ]
        },
        {
          id: groupListRouteId,
          path: "groups/*",
          element: /* @__PURE__ */ jsx62(AdminUserGroupsListRoute, {}),
          children: [
            {
              id: `${groupListRouteId}-admin-user-groups`,
              path: ":adminUserGroupCode/*",
              element: /* @__PURE__ */ jsx62(OutletRoute10, {}),
              children: createAdminUserGroupRoutes(
                `${groupListRouteId}-list-admin-user-group`,
                environment,
                context,
                true,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-admin-user-group`,
          path: "group/:adminUserGroupCode/*",
          element: /* @__PURE__ */ jsx62(OutletRoute10, {}),
          children: createAdminUserGroupRoutes(
            `${groupListRouteId}-admin-user-group`,
            environment,
            context,
            true,
            false
          )
        },
        {
          id: `${routeId6}-admin-user`,
          path: ":adminUserCode/*",
          element: /* @__PURE__ */ jsx62(OutletRoute10, {}),
          children: createAdminUserRoutes(
            `${routePrefix}-admin-user`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routeId6}-create`,
          path: "create/*",
          element: /* @__PURE__ */ jsx62(AdminUserCreate, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx62(Navigate15, { to: "users", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployersRoute.tsx
import { Suspense as Suspense54 } from "react";
import { Navigate as Navigate19, Outlet as Outlet13 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { PlusIcon } from "@heroicons/react/24/solid";
import { Button as Button21, EdLink as EdLink3, PageHeading as PageHeading2, MynPageTitle as MynPageTitle36 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback6, OutletRoute as OutletRoute13 } from "app-core";
import { EmployersListContainer } from "feature-employer-accounts";

// src/secure/accounts/employers/components/EmployerRoute.tsx
import { Navigate as Navigate18 } from "react-router-dom";
import { ErrorContainer as ErrorContainer8 } from "shared-ui";
import { OutletRoute as OutletRoute12 } from "app-core";
import { createEmployerUserGroupsRoutes } from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerLayoutQuery.graphql.ts
var node61 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalCompanyName",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0c2b8c722a4200c113b6a1d87d5747a2",
      "id": null,
      "metadata": {},
      "name": "EmployerLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n  }\n}\n"
    }
  };
}();
node61.hash = "a349afbfc78a01130df5b5f42a519814";
var EmployerLayoutQuery_graphql_default = node61;

// src/secure/accounts/employers/components/EmployerLayout.tsx
import { useMemo as useMemo4 } from "react";
import {
  Link as Link15,
  Outlet as Outlet11,
  useLoaderData as useLoaderData7,
  useLocation as useLocation7,
  useRouteLoaderData as useRouteLoaderData5
} from "react-router-dom";
import {
  loadQuery as loadQuery25,
  usePreloadedQuery as usePreloadedQuery7
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon3 } from "@heroicons/react/24/outline";
import { Suspense as Suspense45 } from "shared-ui";
import {
  createLinkState as createLinkState7,
  EdButtonLink as EdButtonLink3,
  IconJustify as IconJustify3,
  TabUnderline as TabUnderline4
} from "shared-ui";
import { Fragment as Fragment27, jsx as jsx63, jsxs as jsxs57 } from "react/jsx-runtime";
var routeId5 = "employer-layout";
var queryDef29 = EmployerLayoutQuery_graphql_default;
var EmployerLayout = ({ showHeader, inList }) => {
  const location = useLocation7();
  const preloadedQuery = useLoaderData7();
  const data = usePreloadedQuery7(queryDef29, preloadedQuery);
  const tabs4 = useMemo4(() => {
    return [
      createLinkState7(location, "Details", `details`),
      createLinkState7(location, "Users", `users`),
      createLinkState7(location, "User Groups", `user-groups/list`),
      createLinkState7(location, "Email", `email-config`),
      createLinkState7(location, "Job Publishing", `job-publishing`)
    ];
  }, [location]);
  const { employer } = data;
  if (employer === null || employer === void 0) {
    return /* @__PURE__ */ jsx63("div", { children: "Not Found" });
  }
  return /* @__PURE__ */ jsx63(Suspense45, { fallback: "Loading...", children: /* @__PURE__ */ jsxs57("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx63("div", { children: /* @__PURE__ */ jsx63("div", { className: "flex flex-wrap items-center justify-between border-b py-4", children: /* @__PURE__ */ jsx63("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: employer.name }) }) }),
    /* @__PURE__ */ jsxs57("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
      /* @__PURE__ */ jsx63("div", { className: "px-4", children: /* @__PURE__ */ jsx63(TabUnderline4, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx63("div", { children: /* @__PURE__ */ jsx63(
        EdButtonLink3,
        {
          to: `../../../../${employer.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon3,
          iconJustify: IconJustify3.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx63(Outlet11, {})
  ] }) });
};
var EmployerLink = ({ routeId: routeId6, label }) => {
  const data = useEmployerLayoutRouteData(routeId6);
  if (!data.employer) {
    return /* @__PURE__ */ jsx63(Fragment27, {});
  }
  const name = `${data.employer.name}`;
  return /* @__PURE__ */ jsx63(Suspense45, { fallback: "Loading...", children: /* @__PURE__ */ jsx63(Link15, { to: ".", children: label || name }) });
};
async function loader25(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery25(environment, queryDef29, {
    employerCode
  });
}
function useEmployerLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData5(
    routeId6
  );
  const data = usePreloadedQuery7(queryDef29, queryRef);
  return data;
}

// src/secure/accounts/employers/components/__generated__/EmployerDetailsRouteQuery.graphql.ts
var node62 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "employerCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canonicalCompanyName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerEditor_employer"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerDetailsRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canViewTelephoneNumbers",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canonicalCompanyId",
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f2fd248921880711fd2ee0f030c1a680",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsRouteQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsRouteQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n    ...EmployerEditor_employer\n  }\n}\n\nfragment EmployerEditor_employer on Employer {\n  id\n  code\n  employerId\n  updatedAt\n  isApproved\n  isActive\n  isDeleted\n  canViewTelephoneNumbers\n  isTest\n  canonicalCompanyId\n  canonicalCompanyName\n}\n"
    }
  };
}();
node62.hash = "e938481d84625dc2151df62d72d99f2b";
var EmployerDetailsRouteQuery_graphql_default = node62;

// src/secure/accounts/employers/components/EmployerDetails.tsx
import { Suspense as Suspense47 } from "react";
import { loadQuery as loadQuery26 } from "react-relay";
import { Link as Link16 } from "react-router-dom";
import { useForm as useForm5 } from "react-hook-form";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import * as z3 from "zod";
import {
  createClientMutationId as createClientMutationId14,
  timeAgo as timeAgo9,
  useRouteData as useRouteData19,
  useToggle as useToggle4
} from "shared-lib";
import {
  Button as Button17,
  EdSkeleton as EdSkeleton30,
  Error as Error4,
  InputField as InputField3,
  MynPageTitle as MynPageTitle31,
  Spinner as Spinner3
} from "shared-ui";
import {
  useEmployerNameUpdateMutation
} from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerEditor_employer.graphql.ts
var node63 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerEditor_employer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewTelephoneNumbers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalCompanyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalCompanyName",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node63.hash = "6eba937130c08556ef323fde993a0f6d";
var EmployerEditor_employer_graphql_default = node63;

// src/secure/accounts/employers/components/EmployerEditor.tsx
import { useCallback as useCallback29 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { Suspense as Suspense46 } from "shared-ui";
import { createClientMutationId as createClientMutationId13 } from "shared-lib";
import { BooleanActionItem as BooleanActionItem2, Button as Button16, EdSkeleton as EdSkeleton29, Size as Size9 } from "shared-ui";
import {
  useEmployerActivate,
  useEmployerApprove,
  useEmployerChangeCanonicalCompany,
  useEmployerDeactivate,
  useEmployerSetIsTestAccount,
  useEmployerSetPhoneNumberVisibility
} from "feature-employer-accounts";
import {
  CompaniesSearchContainer
} from "feature-data-management";
import { jsx as jsx64, jsxs as jsxs58 } from "react/jsx-runtime";
var fragmentDef7 = EmployerEditor_employer_graphql_default;
var EmployerEditor = ({ fragmentRef }) => {
  const data = useFragment2(
    fragmentDef7,
    fragmentRef
  );
  const [activate, isActivating] = useEmployerActivate();
  const [deactivate, isDeactivating] = useEmployerDeactivate();
  const [approve, isApproving] = useEmployerApprove();
  const [setIsTestAccount, isSettingIsTestAccount] = useEmployerSetIsTestAccount();
  const [setPhoneNumberVisibility, isSettingPhoneNumberVisibility] = useEmployerSetPhoneNumberVisibility();
  const [setCanonicalCompany, isSettingCanonicalCompany] = useEmployerChangeCanonicalCompany();
  const onActivate = useCallback29(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId13()
    };
    await activate({ input });
  }, [activate]);
  const onDeactivate = useCallback29(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId13()
    };
    await deactivate({ input });
  }, [deactivate]);
  const onApprove = useCallback29(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId13()
    };
    await approve({ input });
  }, [approve]);
  const onSetIsTestAccount = useCallback29(async () => {
    const input = {
      isTestAccount: !data.isTest,
      employerId: data.employerId,
      clientMutationId: createClientMutationId13()
    };
    await setIsTestAccount({ input });
  }, [setIsTestAccount]);
  const onTogglePhoneNumberVisibility = useCallback29(async () => {
    const input = {
      employerId: data.employerId,
      clientMutationId: createClientMutationId13()
    };
    await setPhoneNumberVisibility({ input });
  }, [setPhoneNumberVisibility]);
  const onSetCompany = useCallback29(
    async (company2) => {
      const input = {
        canonicalId: company2.id,
        canonicalName: company2.name,
        clientMutationId: createClientMutationId13(),
        employerId: data.employerId
      };
      await setCanonicalCompany({ input });
    },
    [setCanonicalCompany]
  );
  if (data === null) {
    return /* @__PURE__ */ jsx64(EdSkeleton29, {});
  }
  let company = null;
  if (data.canonicalCompanyId && data.canonicalCompanyName) {
    company = {
      id: data.canonicalCompanyId,
      name: data.canonicalCompanyName,
      isVerified: true,
      //assumed/irrelevant
      industry: null
    };
  }
  return /* @__PURE__ */ jsx64(Suspense46, { fallback: /* @__PURE__ */ jsx64(EdSkeleton29, {}), children: /* @__PURE__ */ jsx64("div", { className: "flex", children: /* @__PURE__ */ jsxs58("div", { className: "flex flex-col gap-4 border p-4 sm:w-1/2", children: [
    /* @__PURE__ */ jsx64(
      BooleanActionItem2,
      {
        label: "Active",
        value: data.isActive,
        action: /* @__PURE__ */ jsx64("div", { children: data.isActive ? /* @__PURE__ */ jsx64(
          Button16,
          {
            "aria-label": "Deactivate",
            color: "warning",
            size: Size9.lg,
            clicked: onDeactivate,
            disabled: isDeactivating,
            children: "Deactivate"
          }
        ) : /* @__PURE__ */ jsx64(
          Button16,
          {
            "aria-label": "Activate",
            color: "primary",
            size: Size9.lg,
            clicked: onActivate,
            disabled: isActivating,
            children: "Activate"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx64(
      BooleanActionItem2,
      {
        label: "Approved",
        value: data.isApproved,
        action: /* @__PURE__ */ jsx64("div", { children: data.isApproved ? /* @__PURE__ */ jsx64("div", { children: "No Action" }) : /* @__PURE__ */ jsx64(
          Button16,
          {
            "aria-label": "Approve",
            color: "primary",
            size: Size9.lg,
            clicked: onApprove,
            disabled: isApproving,
            children: "Approve"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx64(
      BooleanActionItem2,
      {
        label: "Test Account",
        value: data.isTest,
        action: /* @__PURE__ */ jsx64("div", { children: data.isTest ? /* @__PURE__ */ jsx64("div", { children: "No Action" }) : /* @__PURE__ */ jsx64(
          Button16,
          {
            "aria-label": "Set Test Account",
            color: "warning",
            size: Size9.lg,
            clicked: onSetIsTestAccount,
            disabled: isSettingIsTestAccount,
            children: "Set Test Account"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx64(
      BooleanActionItem2,
      {
        label: "View Telephone Numbers",
        value: data.canViewTelephoneNumbers,
        action: /* @__PURE__ */ jsx64("div", { children: /* @__PURE__ */ jsx64(
          Button16,
          {
            "aria-label": "Toggle Phone Number Visibility",
            color: "primary",
            size: Size9.lg,
            clicked: onTogglePhoneNumberVisibility,
            disabled: isSettingPhoneNumberVisibility,
            children: "Toggle"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx64(
      BooleanActionItem2,
      {
        label: "Canonical Company",
        value: !!data.canonicalCompanyName,
        action: /* @__PURE__ */ jsx64(
          CompaniesSearchContainer,
          {
            name: `companies-search`,
            onSearchCompleted: onSetCompany,
            value: company,
            disabled: isSettingCanonicalCompany
          }
        )
      }
    )
  ] }) }) });
};

// src/secure/accounts/employers/components/EmployerDetails.tsx
import { Fragment as Fragment28, jsx as jsx65, jsxs as jsxs59 } from "react/jsx-runtime";
var queryDef30 = EmployerDetailsRouteQuery_graphql_default;
async function loader26(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  try {
    return loadQuery26(environment, queryDef30, {
      employerCode
    });
  } catch (e) {
    console.error("EmployerDetails Loader Failed.");
    console.error(e);
    throw e;
  }
}
var formSchema4 = z3.object({
  name: z3.string().min(3, "Name is required"),
  employerId: z3.string().min(1, "employerId is required")
});
var EmployerDetails = ({ routeId: routeId6, inList }) => {
  const data = useRouteData19(queryDef30, routeId6);
  const [updateName, isUpdatingName] = useEmployerNameUpdateMutation();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm5({
    resolver: zodResolver5(formSchema4),
    defaultValues: {
      name: data?.employer?.name || "",
      employerId: data?.employer?.employerId || ""
    }
  });
  const onSave = handleSubmit(async (form) => {
    const updateNameInput = {
      name: form.name,
      clientMutationId: createClientMutationId14(),
      employerId: form.employerId
    };
    await updateName({
      input: updateNameInput
    });
    toggleEditing();
  });
  const [isEditing, toggleEditing] = useToggle4();
  if (!data) {
    return /* @__PURE__ */ jsx65(Fragment28, { children: "Loading..." });
  }
  const { employer } = data;
  if (!employer) {
    return /* @__PURE__ */ jsx65(Fragment28, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs59(Suspense47, { fallback: /* @__PURE__ */ jsx65(EdSkeleton30, {}), children: [
    /* @__PURE__ */ jsx65(MynPageTitle31, { title: "Employer Details" }),
    /* @__PURE__ */ jsxs59("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs59("div", { className: "my-4 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsxs59("div", { className: "flex items-baseline gap-2 px-4", children: [
          /* @__PURE__ */ jsx65("div", { children: isEditing ? /* @__PURE__ */ jsxs59("div", { children: [
            /* @__PURE__ */ jsx65(
              InputField3,
              {
                "aria-label": "name",
                defaultValue: employer.name,
                name: "name",
                register,
                required: false
              }
            ),
            /* @__PURE__ */ jsx65(Error4, { children: errors.name?.message })
          ] }) : /* @__PURE__ */ jsx65("div", { className: "text-primary-700 text-lg font-medium", children: employer.name }) }),
          /* @__PURE__ */ jsx65(
            Button17,
            {
              "aria-label": `${isEditing ? "Cancel" : "Edit"} form`,
              onClick: toggleEditing,
              color: "primary",
              children: isEditing ? "Cancel" : "Edit"
            }
          ),
          isEditing && /* @__PURE__ */ jsx65(Button17, { "aria-label": "Save ", onClick: onSave, color: "green", children: "Save" }),
          isUpdatingName && /* @__PURE__ */ jsx65(Spinner3, {})
        ] }),
        /* @__PURE__ */ jsxs59("div", { className: "text-primary-700 text-md px-4", children: [
          "Updated ",
          timeAgo9(employer.updatedAt)
        ] })
      ] }),
      /* @__PURE__ */ jsx65(EmployerEditor, { fragmentRef: employer })
    ] })
  ] });
};
var createRoute15 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-employer-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx65(EmployerDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx65(Link16, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader26(environment, params);
    }
  };
};

// src/secure/accounts/employers/components/EmployerUsers.tsx
import { Navigate as Navigate17 } from "react-router-dom";
import { ErrorContainer as ErrorContainer7 } from "shared-ui";
import { OutletRoute as OutletRoute11 } from "app-core";
import {
  EmployerUsersHome,
  EmployerUserCreate,
  EmployerUsersListLoader,
  employerUsersLoader
} from "feature-employer-accounts";

// src/secure/accounts/employers/components/__generated__/EmployerUserQuery.graphql.ts
var node64 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserDetailsEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupsViewer_user"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUserGroup",
              "kind": "LinkedField",
              "name": "userGroups",
              "plural": true,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAdminGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4206e18b8b0507a08d61e00c75492fc1",
      "id": null,
      "metadata": {},
      "name": "EmployerUserQuery",
      "operationKind": "query",
      "text": "query EmployerUserQuery(\n  $code: Long!\n) {\n  user: accountEmployerUserByCode(code: $code) {\n    id\n    code\n    accountId\n    firstName\n    lastName\n    emailAddress\n    updatedAt\n    isDeleted\n    ...EmployerUserDetailsEditor_user\n    ...EmployerUserGroupsViewer_user\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n\nfragment EmployerUserGroupsViewer_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  updatedAt\n  userGroups {\n    id\n    groupId\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node64.hash = "111e1871db9000cb2a9310a086839f6e";
var EmployerUserQuery_graphql_default = node64;

// src/secure/accounts/employers/components/EmployerUser.tsx
import { useMemo as useMemo5 } from "react";
import {
  loadQuery as loadQuery27,
  usePreloadedQuery as usePreloadedQuery8
} from "react-relay";
import {
  Navigate as Navigate16,
  Outlet as Outlet12,
  useLocation as useLocation8,
  useRouteLoaderData as useRouteLoaderData6
} from "react-router-dom";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon4 } from "@heroicons/react/24/outline";
import { Suspense as Suspense50 } from "shared-ui";
import {
  createLinkState as createLinkState8,
  EdButtonLink as EdButtonLink4,
  EdSkeleton as EdSkeleton33,
  ErrorContainer as ErrorContainer6,
  IconJustify as IconJustify4,
  TabUnderline as TabUnderline5
} from "shared-ui";
import { createImpersonateRoute } from "feature-employer-accounts";

// src/secure/accounts/employers/components/EmployerUserDetails.tsx
import { Suspense as Suspense48 } from "react";
import { useToggle as useToggle5 } from "shared-lib";
import { EdSkeleton as EdSkeleton31 } from "shared-ui";
import {
  EmployerUserDetailsView,
  EmployerUserGroupsViewer,
  EmployerUserDetailsEditor
} from "feature-employer-accounts";
import { jsx as jsx66, jsxs as jsxs60 } from "react/jsx-runtime";
var EmployerUserDetails = ({ routeId: routeId6 }) => {
  const { user } = useEmployerUserRouteData(routeId6);
  const [isEditing, toggleIsEditing] = useToggle5();
  if (user === null || user === void 0) {
    return /* @__PURE__ */ jsx66(EdSkeleton31, {});
  }
  let details = /* @__PURE__ */ jsx66("div", {});
  if (user) {
    details = isEditing ? /* @__PURE__ */ jsx66(
      EmployerUserDetailsEditor,
      {
        fragmentRef: user,
        onCancel: toggleIsEditing,
        onEnabled: toggleIsEditing,
        onDisabled: toggleIsEditing,
        onDone: toggleIsEditing
      }
    ) : /* @__PURE__ */ jsx66(EmployerUserDetailsView, { user, onEdit: toggleIsEditing });
  }
  return /* @__PURE__ */ jsxs60(Suspense48, { fallback: /* @__PURE__ */ jsx66(EdSkeleton31, {}), children: [
    /* @__PURE__ */ jsx66("div", { className: "m-2 sm:m-4", children: details }),
    /* @__PURE__ */ jsx66("div", { className: "m-2 sm:m-4", children: user && /* @__PURE__ */ jsx66(EmployerUserGroupsViewer, { fragmentRef: user }) })
  ] });
};

// src/secure/accounts/employers/components/__generated__/EmployerUserIdentityQuery.graphql.ts
var node65 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountUserId"
    }
  ], v1 = [
    {
      "alias": "identity",
      "args": [
        {
          "kind": "Variable",
          "name": "accountUserId",
          "variableName": "accountUserId"
        }
      ],
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "identityUserByAccountUserId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountTypes",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserIdentityQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserIdentityQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0b0273e45934b2021cfcc45d7af7e1ef",
      "id": null,
      "metadata": {},
      "name": "EmployerUserIdentityQuery",
      "operationKind": "query",
      "text": "query EmployerUserIdentityQuery(\n  $accountUserId: UUID!\n) {\n  identity: identityUserByAccountUserId(accountUserId: $accountUserId) {\n    id\n    code\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    email\n    accountTypes\n  }\n}\n"
    }
  };
}();
node65.hash = "ad4ba1bf7536bcce77be199bea88dfbd";
var EmployerUserIdentityQuery_graphql_default = node65;

// src/secure/accounts/employers/components/EmployerUserIdentity.tsx
import { useCallback as useCallback30, useState as useState19 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay";
import { useNavigate as useNavigate13 } from "react-router-dom";
import { MynPageTitle as MynPageTitle32, Suspense as Suspense49 } from "shared-ui";
import { createClientMutationId as createClientMutationId15, timeAgo as timeAgo10, useToggle as useToggle6 } from "shared-lib";
import { Button as Button18, ButtonList as ButtonList4, EdSkeleton as EdSkeleton32 } from "shared-ui";
import {
  IdentityUserSearchBoxContainer
} from "app-core";

// src/secure/accounts/employers/mutations/__generated__/UseEmployerUserChangeAccountMappingMutation.graphql.ts
var node66 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeIdentityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeIdentity",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeIdentityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeIdentity",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a9c709cad558a2fd4a2e3cab4dd476c0",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserChangeAccountMappingMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserChangeAccountMappingMutation(\n  $input: AccountsEmployerUserChangeIdentityInput!\n) {\n  data: accountsEmployerUserChangeIdentity(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        emailAddress\n        employerId\n        isTest\n        isDeleted\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node66.hash = "f20e5141e926bc82fdc99af8a5bbc637";
var UseEmployerUserChangeAccountMappingMutation_graphql_default = node66;

// src/secure/accounts/employers/mutations/UseEmployerUserChangeAccountMapping.ts
import { useAsyncMutation as useAsyncMutation15 } from "shared-lib";
var mutationDef15 = UseEmployerUserChangeAccountMappingMutation_graphql_default;
function useEmployerUserChangeAccountMapping() {
  const [commit, isBusy] = useAsyncMutation15(mutationDef15);
  return [commit, isBusy];
}

// src/secure/accounts/employers/components/EmployerUserIdentity.tsx
import { jsx as jsx67, jsxs as jsxs61 } from "react/jsx-runtime";
var queryDef31 = EmployerUserIdentityQuery_graphql_default;
var EmployerUserIdentity = ({ routeId: routeId6 }) => {
  const navigate = useNavigate13();
  const { user } = useEmployerUserRouteData(routeId6);
  const [changeIdentity, isChangingIdentity] = useEmployerUserChangeAccountMapping();
  const [selectedIdentity, setSelectedIdentity] = useState19();
  const onSearchCompleted = useCallback30(
    (result) => {
      setSelectedIdentity(result);
    },
    [setSelectedIdentity]
  );
  const query = useLazyLoadQuery8(
    queryDef31,
    { accountUserId: user.accountId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { identity } = query;
  const [isEditing, toggleIsEditing] = useToggle6(false);
  const onChange = useCallback30(async () => {
    if (!user || !selectedIdentity) {
      return;
    }
    const input = {
      userId: user.accountId,
      email: selectedIdentity.email,
      newIdentityId: selectedIdentity.identityUserId,
      clientMutationId: createClientMutationId15()
    };
    const response = await changeIdentity({ input });
    if (response.data.employerUser) {
      toggleIsEditing();
      navigate(0);
    }
  }, [changeIdentity]);
  if (user === null || user === void 0 || identity == null || identity == void 0) {
    return /* @__PURE__ */ jsx67(EdSkeleton32, {});
  }
  let content = /* @__PURE__ */ jsx67("div", {});
  if (isEditing) {
    content = /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx67("div", { className: "text-primary-700 font-medium", children: identity.email }),
        /* @__PURE__ */ jsx67("div", { className: "text-sm text-gray-500", children: /* @__PURE__ */ jsxs61("div", { children: [
          "Updated: ",
          timeAgo10(user.updatedAt)
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx67("div", { className: "text-gray-500", children: "Search for Identity" }),
        /* @__PURE__ */ jsx67(
          IdentityUserSearchBoxContainer,
          {
            onSearchCompleted
          }
        ),
        selectedIdentity && /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 px-2 py-4", children: [
          /* @__PURE__ */ jsx67("div", { className: "text-primary-500 font-medium", children: selectedIdentity.email }),
          /* @__PURE__ */ jsx67("div", { className: "my-2 border-t p-4", children: /* @__PURE__ */ jsx67(ButtonList4, { children: /* @__PURE__ */ jsx67(
            Button18,
            {
              "aria-label": "Use Identity",
              color: "primary",
              clicked: onChange,
              disabled: isChangingIdentity,
              children: "Use Identity"
            }
          ) }) })
        ] })
      ] })
    ] });
  } else {
    content = /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs61("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
        /* @__PURE__ */ jsx67("div", { className: "text-primary-700 font-medium", children: identity.email }),
        /* @__PURE__ */ jsx67("div", { className: "", children: /* @__PURE__ */ jsx67(
          Button18,
          {
            "aria-label": "Edit",
            color: "primary",
            clicked: toggleIsEditing,
            children: "Edit"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-2 p-4", children: [
        /* @__PURE__ */ jsx67("div", { className: "text-gray-500", children: "Account Types" }),
        /* @__PURE__ */ jsx67("div", { className: "flex items-center gap-2", children: identity.accountTypes.map((a) => {
          return /* @__PURE__ */ jsx67(
            "span",
            {
              className: "bg-primary-700 rounded-xl p-2 font-bold text-white",
              children: a
            },
            a
          );
        }) })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx67(Suspense49, { fallback: /* @__PURE__ */ jsx67(EdSkeleton32, {}), children: /* @__PURE__ */ jsxs61("div", { className: "md:w-1/2", children: [
    /* @__PURE__ */ jsx67(MynPageTitle32, { title: "Employer User Identity" }),
    /* @__PURE__ */ jsx67("div", { className: "m-2 sm:m-4", children: content })
  ] }) });
};

// src/secure/accounts/employers/components/EmployerUser.tsx
import { jsx as jsx68, jsxs as jsxs62 } from "react/jsx-runtime";
var queryDef32 = EmployerUserQuery_graphql_default;
async function loader27(environment, params) {
  const employerUserCode = params.employerUserCode;
  const code = Number(employerUserCode);
  const queryRef = loadQuery27(environment, queryDef32, {
    code
  });
  return {
    queryRef
  };
}
function useEmployerUserRouteData(routeId6) {
  const { queryRef } = useRouteLoaderData6(routeId6);
  return usePreloadedQuery8(queryDef32, queryRef);
}
var Layout7 = ({
  routeId: routeId6,
  inList
}) => {
  const data = useEmployerUserRouteData(routeId6);
  const location = useLocation8();
  const tabs4 = useMemo5(() => {
    return [
      createLinkState8(location, "Details", `details`),
      createLinkState8(location, "Impersonate", `impersonate`),
      createLinkState8(location, "Identity", `identity`)
    ];
  }, [location]);
  const { user } = data;
  if (!user) {
    return /* @__PURE__ */ jsx68(EdSkeleton33, {});
  }
  return /* @__PURE__ */ jsx68(Suspense50, { fallback: /* @__PURE__ */ jsx68(EdSkeleton33, {}), children: /* @__PURE__ */ jsxs62("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs62("div", { className: "flex flex-wrap items-center justify-between border-b bg-white p-2", children: [
      /* @__PURE__ */ jsx68("div", { className: "px-4", children: /* @__PURE__ */ jsx68(TabUnderline5, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx68("div", { children: /* @__PURE__ */ jsx68(
        EdButtonLink4,
        {
          to: `../../../../user/${user.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon4,
          iconJustify: IconJustify4.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx68("div", { className: "flex-1", children: /* @__PURE__ */ jsx68(Outlet12, {}) })
  ] }) });
};
var createEmployersUserRoutes = (routePrefix, environment, context, inList) => {
  const routeId6 = `${routePrefix}-employer-user`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx68(Layout7, { routeId: routeId6, inList }),
      errorElement: /* @__PURE__ */ jsx68(ErrorContainer6, {}),
      loader: ({ params }) => {
        return loader27(environment, params);
      },
      children: [
        {
          path: "details",
          id: `${routeId6}-details`,
          element: /* @__PURE__ */ jsx68(EmployerUserDetails, { routeId: routeId6 }),
          errorElement: /* @__PURE__ */ jsx68(ErrorContainer6, {})
        },
        {
          path: "identity",
          id: `${routeId6}-identity`,
          element: /* @__PURE__ */ jsx68(EmployerUserIdentity, { routeId: routeId6 }),
          errorElement: /* @__PURE__ */ jsx68(ErrorContainer6, {})
        },
        createImpersonateRoute(routeId6, environment),
        {
          path: "*",
          element: /* @__PURE__ */ jsx68(Navigate16, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployerUsers.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
var createEmployersUsersRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-employer-users`;
  return [
    {
      path: "list/*",
      id: routeId6,
      element: /* @__PURE__ */ jsx69(EmployerUsersListLoader, { routeId: routeId6 }),
      errorElement: /* @__PURE__ */ jsx69(ErrorContainer7, {}),
      loader: ({ params }) => {
        return employerUsersLoader(environment, params, context);
      },
      children: [
        {
          path: "*",
          element: /* @__PURE__ */ jsx69(EmployerUsersHome, {})
        },
        {
          path: "create/*",
          element: /* @__PURE__ */ jsx69(EmployerUserCreate, { canSearchIdentities: true, listRouteId: routeId6 })
        },
        {
          path: ":employerUserCode/*",
          element: /* @__PURE__ */ jsx69(OutletRoute11, {}),
          children: createEmployersUserRoutes(
            routeId6,
            environment,
            context,
            true
          )
        }
      ]
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx69(Navigate17, { to: "list", replace: true })
    }
  ];
};

// src/secure/accounts/employers/components/__generated__/EmployerEmailConfigurationRouteQuery.graphql.ts
var node67 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "employerId",
          "variableName": "employerId"
        }
      ],
      "concreteType": "EmployerSendingConfig",
      "kind": "LinkedField",
      "name": "notificationsEmployerEmailSendingConfigById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailProviderConfig",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerEmailConfigurationRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerEmailConfigurationRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "647776295dc05bece2580de2b7bfe6d4",
      "id": null,
      "metadata": {},
      "name": "EmployerEmailConfigurationRouteQuery",
      "operationKind": "query",
      "text": "query EmployerEmailConfigurationRouteQuery(\n  $employerId: UUID!\n) {\n  config: notificationsEmployerEmailSendingConfigById(employerId: $employerId) {\n    id\n    employerId\n    updatedAt\n    email\n    emailProvider\n    isVerified\n    emailProviderConfig\n  }\n}\n"
    }
  };
}();
node67.hash = "eea8a9701a638d26f2a7986a3cdbe78d";
var EmployerEmailConfigurationRouteQuery_graphql_default = node67;

// src/secure/accounts/employers/components/EmployerEmailConfiguration.tsx
import { Suspense as Suspense51 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery9 } from "react-relay";
import { Link as Link17 } from "react-router-dom";
import { useToggle as useToggle7 } from "shared-lib";
import { Button as Button19, EdSkeleton as EdSkeleton34, MynPageTitle as MynPageTitle33 } from "shared-ui";
import { EmployerEmailConfigurationForm } from "feature-employer-accounts";
import { Fragment as Fragment29, jsx as jsx70, jsxs as jsxs63 } from "react/jsx-runtime";
var queryDef33 = EmployerEmailConfigurationRouteQuery_graphql_default;
var EmployerEmailConfiguration = ({ layoutRouteId }) => {
  const [isEditing, toggleIsEditing] = useToggle7();
  const data = useEmployerLayoutRouteData(layoutRouteId);
  const { employer } = data;
  const query = useLazyLoadQuery9(
    queryDef33,
    { employerId: employer.employerId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data || !query) {
    return /* @__PURE__ */ jsx70(Fragment29, { children: "Loading..." });
  }
  const { config } = query;
  if (!employer) {
    return /* @__PURE__ */ jsx70(Fragment29, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx70("div", { className: "flex", children: /* @__PURE__ */ jsx70(
      EmployerEmailConfigurationForm,
      {
        employerId: employer.employerId,
        onDone: toggleIsEditing
      }
    ) });
  } else if (config) {
    content = /* @__PURE__ */ jsx70("div", { className: "flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx70("div", { children: config.email }) });
  } else {
    content = /* @__PURE__ */ jsx70("div", { className: "text-warning-700 flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx70("div", { children: "No custom sending email configured" }) });
  }
  return /* @__PURE__ */ jsxs63(Suspense51, { fallback: /* @__PURE__ */ jsx70(EdSkeleton34, {}), children: [
    /* @__PURE__ */ jsx70(MynPageTitle33, { title: "Employer Email Configuration" }),
    /* @__PURE__ */ jsxs63("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs63("div", { className: "flex items-center justify-between gap-2 border-b", children: [
        /* @__PURE__ */ jsx70("div", { className: "my-4 flex flex-col gap-2", children: /* @__PURE__ */ jsx70("div", { className: "text-primary-700 px-4 text-lg font-medium", children: "Custom Email From Address" }) }),
        /* @__PURE__ */ jsx70("div", { children: /* @__PURE__ */ jsx70(
          Button19,
          {
            "aria-label": "Edit",
            color: "primary",
            clicked: toggleIsEditing,
            children: "Edit"
          }
        ) })
      ] }),
      content
    ] })
  ] });
};
var createRoute16 = (layoutRouteId) => {
  const routeId6 = `${layoutRouteId}-employer-email`;
  return {
    id: routeId6,
    path: "email-config",
    element: /* @__PURE__ */ jsx70(EmployerEmailConfiguration, { layoutRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx70(Link17, { to: "email", children: "Email" })
    }
  };
};

// src/secure/accounts/employers/components/__generated__/EmployerJobPublishingRouteQuery.graphql.ts
var node68 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "employerCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canonicalCompanyName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = [
    {
      "kind": "Variable",
      "name": "employerCode",
      "variableName": "employerCode"
    }
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "idibuConfigId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerJobPublishingRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerEditor_employer"
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "config",
          "args": v10,
          "concreteType": "RecruitIdibuConfig",
          "kind": "LinkedField",
          "name": "recruitIdibuConfigByEmployerCode",
          "plural": false,
          "selections": [
            v2,
            v11,
            v4,
            v5,
            v6,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IdibuConfigContainer_config"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerJobPublishingRouteQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canViewTelephoneNumbers",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canonicalCompanyId",
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "config",
          "args": v10,
          "concreteType": "RecruitIdibuConfig",
          "kind": "LinkedField",
          "name": "recruitIdibuConfigByEmployerCode",
          "plural": false,
          "selections": [
            v2,
            v11,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedByAccountType",
              "storageKey": null
            },
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uppHash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uppSenderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAdminOnly",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Employer",
              "kind": "LinkedField",
              "name": "employer",
              "plural": false,
              "selections": [
                v7,
                v2
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "36acd5cb09b25b4c3e598fa37f6e42da",
      "id": null,
      "metadata": {},
      "name": "EmployerJobPublishingRouteQuery",
      "operationKind": "query",
      "text": "query EmployerJobPublishingRouteQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    createdAt\n    updatedAt\n    code\n    name\n    canonicalCompanyName\n    ...EmployerEditor_employer\n  }\n  config: recruitIdibuConfigByEmployerCode(employerCode: $employerCode) {\n    id\n    idibuConfigId\n    createdAt\n    updatedAt\n    code\n    ...IdibuConfigContainer_config\n  }\n}\n\nfragment EmployerEditor_employer on Employer {\n  id\n  code\n  employerId\n  updatedAt\n  isApproved\n  isActive\n  isDeleted\n  canViewTelephoneNumbers\n  isTest\n  canonicalCompanyId\n  canonicalCompanyName\n}\n\nfragment IdibuConfigContainer_config on RecruitIdibuConfig {\n  id\n  idibuConfigId\n  version\n  code\n  createdAt\n  createdById\n  createdByAccountType\n  updatedAt\n  updatedById\n  updatedByAccountType\n  employerId\n  uppHash\n  uppSenderId\n  isEnabled\n  isAdminOnly\n  employer {\n    name\n    id\n  }\n}\n"
    }
  };
}();
node68.hash = "58118f20ba23977923212a65dcf0688c";
var EmployerJobPublishingRouteQuery_graphql_default = node68;

// src/secure/accounts/employers/components/EmployerJobPublishing.tsx
import { Suspense as Suspense52 } from "react";
import { loadQuery as loadQuery28 } from "react-relay";
import { Link as Link18 } from "react-router-dom";
import { useRouteData as useRouteData20, useToggle as useToggle8 } from "shared-lib";
import { Button as Button20, EdSkeleton as EdSkeleton35, MynPageTitle as MynPageTitle34, Size as Size10 } from "shared-ui";
import { IdibuConfigContainer, IdibuConfigEditor } from "feature-recruit";
import { Fragment as Fragment30, jsx as jsx71, jsxs as jsxs64 } from "react/jsx-runtime";
var queryDef34 = EmployerJobPublishingRouteQuery_graphql_default;
async function loader28(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery28(environment, queryDef34, {
    employerCode
  });
}
var EmployerJobPublishing = ({ routeId: routeId6, inList }) => {
  const [isEditing, toggleIsEditing] = useToggle8();
  const data = useRouteData20(queryDef34, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx71(Fragment30, { children: "Loading..." });
  }
  const { employer, config } = data;
  if (!employer) {
    return /* @__PURE__ */ jsx71(Fragment30, { children: "Loading..." });
  }
  let content = null;
  if (isEditing) {
    content = /* @__PURE__ */ jsx71("div", { className: "flex py-4", children: /* @__PURE__ */ jsx71(
      IdibuConfigEditor,
      {
        employerId: employer.employerId,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) });
  } else if (config) {
    content = /* @__PURE__ */ jsx71("div", { className: "flex py-4", children: /* @__PURE__ */ jsx71(IdibuConfigContainer, { fragmentRef: config }) });
  } else {
    content = /* @__PURE__ */ jsx71("div", { className: "flex border p-4", children: /* @__PURE__ */ jsx71("div", { className: "text-warning-500 font-bold", children: "No Config Set" }) });
  }
  return /* @__PURE__ */ jsx71(Suspense52, { fallback: /* @__PURE__ */ jsx71(EdSkeleton35, {}), children: /* @__PURE__ */ jsxs64("div", { className: "flex flex-col gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsx71(MynPageTitle34, { title: "Employer Job Publishing" }),
    /* @__PURE__ */ jsxs64("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsx71("div", { className: "my-4 flex flex-col gap-2", children: /* @__PURE__ */ jsx71("div", { className: "text-primary-700 px-4 text-lg font-medium", children: "Idibu Config" }) }),
      /* @__PURE__ */ jsx71("div", { children: /* @__PURE__ */ jsx71(
        Button20,
        {
          "aria-label": "Edit Configuration",
          size: Size10.lg,
          color: "primary",
          clicked: toggleIsEditing,
          children: "Edit Configuration"
        }
      ) })
    ] }),
    content
  ] }) });
};
var createRoute17 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-publishing`;
  return {
    id: routeId6,
    path: "job-publishing",
    element: /* @__PURE__ */ jsx71(EmployerJobPublishing, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx71(Link18, { to: "job-publishing", children: "Job Publishing" })
    },
    loader: ({ params }) => {
      return loader28(environment, params);
    }
  };
};

// src/secure/accounts/employers/components/EmployerRoute.tsx
import { jsx as jsx72 } from "react/jsx-runtime";
var createEmployerRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const layoutRouteId = `${routePrefix}-${routeId5}`;
  return [
    {
      path: "*",
      id: layoutRouteId,
      element: /* @__PURE__ */ jsx72(EmployerLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx72(ErrorContainer8, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx72(EmployerLink, { routeId: layoutRouteId })
      },
      loader: ({ params }) => {
        return loader25(environment, params);
      },
      children: [
        createRoute15(routePrefix, environment, context, inList),
        createRoute17(routePrefix, environment, context, inList),
        createRoute16(layoutRouteId),
        {
          path: "users/*",
          element: /* @__PURE__ */ jsx72(OutletRoute12, {}),
          children: createEmployersUsersRoutes(
            `${layoutRouteId}-users`,
            environment,
            context
          )
        },
        {
          path: "user/:employerUserCode/*",
          element: /* @__PURE__ */ jsx72(OutletRoute12, {}),
          children: createEmployersUserRoutes(
            `${layoutRouteId}-users-user`,
            environment,
            context,
            false
          )
        },
        {
          path: "user-groups/*",
          element: /* @__PURE__ */ jsx72(OutletRoute12, {}),
          children: createEmployerUserGroupsRoutes(
            `${layoutRouteId}-user-groups`,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx72(Navigate18, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/employers/components/EmployerCreate.tsx
import { useCallback as useCallback31 } from "react";
import { useNavigate as useNavigate14 } from "react-router-dom";
import { MynPageTitle as MynPageTitle35, Suspense as Suspense53 } from "shared-ui";
import { EdSkeleton as EdSkeleton36 } from "shared-ui";
import {
  EmployerCreateContainer
} from "feature-employer-accounts";
import { jsx as jsx73, jsxs as jsxs65 } from "react/jsx-runtime";
var EmployerCreate = () => {
  const navigate = useNavigate14();
  const onCreated = useCallback31(
    (employer) => {
      navigate(`../${employer.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback31(() => {
    navigate(`../`);
  }, [navigate]);
  return /* @__PURE__ */ jsxs65(Suspense53, { fallback: /* @__PURE__ */ jsx73(EdSkeleton36, {}), children: [
    /* @__PURE__ */ jsx73(MynPageTitle35, { title: "Create Employer" }),
    /* @__PURE__ */ jsx73(EmployerCreateContainer, { onCreate: onCreated, onCancel })
  ] });
};

// src/secure/accounts/employers/components/EmployersRoute.tsx
import { jsx as jsx74, jsxs as jsxs66 } from "react/jsx-runtime";
var EmployersLayout = () => {
  return /* @__PURE__ */ jsx74(Suspense54, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx74(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsxs66("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs66("div", { className: "flex items-center justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs66("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx74(EdLink3, { href: "../../", name: "List Employers", children: /* @__PURE__ */ jsx74(Button21, { color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx74(MynPageTitle36, { title: "Employers" }),
        /* @__PURE__ */ jsx74(PageHeading2, { children: "Employers" })
      ] }),
      /* @__PURE__ */ jsx74("div", { children: /* @__PURE__ */ jsx74(EdLink3, { href: "../create", name: "Create Employer", children: /* @__PURE__ */ jsxs66(Button21, { "aria-label": "Create Employer", color: "primary", children: [
        "Create Employer \xA0",
        /* @__PURE__ */ jsx74(PlusIcon, { className: "h-5 w-5" })
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx74("div", { children: /* @__PURE__ */ jsx74(Outlet13, {}) })
  ] }) }) });
};
var EmployersListRoute = () => {
  return /* @__PURE__ */ jsx74(Suspense54, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx74(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsx74(EmployersListContainer, {}) }) });
};
var createEmployersRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-employers`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx74(EmployersLayout, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx74(EmployersListRoute, {}),
          children: [
            {
              id: `${listRouteId}-employer`,
              path: ":employerCode/*",
              element: /* @__PURE__ */ jsx74(OutletRoute13, {}),
              children: createEmployerRoutes(
                `${routeId6}-employer`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routeId6}-create`,
          path: "create/*",
          element: /* @__PURE__ */ jsx74(EmployerCreate, {})
        },
        {
          id: `${routeId6}-employer`,
          path: ":employerCode/*",
          element: /* @__PURE__ */ jsx74(OutletRoute13, {}),
          children: createEmployerRoutes(
            `${routePrefix}-employer`,
            environment,
            context,
            true,
            false
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx74(Navigate19, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/index.ts
__reExport(accounts_exports, identity_star);
import * as identity_star from "app-core/src/accounts/identity";

// src/secure/accounts/AccountsLayout.tsx
import { Suspense as Suspense71 } from "react";
import { Navigate as Navigate25 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary9 } from "react-error-boundary";
import { EdLink as EdLink6, MynPageTitle as MynPageTitle44 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback9, OutletRoute as OutletRoute17 } from "app-core";
import { createIdentityRoutes } from "app-core";

// src/secure/accounts/candidates/components/CandidatesRoute.tsx
import { Suspense as Suspense68 } from "react";
import { Navigate as Navigate23, Outlet as Outlet15 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary7 } from "react-error-boundary";
import { Button as Button29, EdLink as EdLink4, PageHeading as PageHeading3, MynPageTitle as MynPageTitle42 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback7, OutletRoute as OutletRoute16 } from "app-core";
import { CandidateAccountsListContainer } from "feature-candidate-accounts";

// src/secure/accounts/candidates/components/CandidateRoute.tsx
import { Navigate as Navigate22 } from "react-router-dom";
import { ErrorContainer as ErrorContainer9 } from "shared-ui";
import { createCandidateImpersonateRoute } from "feature-candidate-accounts";

// src/secure/accounts/candidates/components/__generated__/CandidateLayoutQuery.graphql.ts
var node69 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "91875c5e10df40de446994beb8f5f9ef",
      "id": null,
      "metadata": {},
      "name": "CandidateLayoutQuery",
      "operationKind": "query",
      "text": "query CandidateLayoutQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    updatedAt\n    firstName\n    lastName\n    email\n  }\n}\n"
    }
  };
}();
node69.hash = "b9ecdb0d7a9735cb72f4fdddd22ee5dc";
var CandidateLayoutQuery_graphql_default = node69;

// src/secure/accounts/candidates/components/CandidateLayout.tsx
import { useMemo as useMemo6 } from "react";
import {
  Link as Link19,
  Outlet as Outlet14,
  useLoaderData as useLoaderData8,
  useLocation as useLocation9,
  useRouteLoaderData as useRouteLoaderData7
} from "react-router-dom";
import {
  loadQuery as loadQuery29,
  usePreloadedQuery as usePreloadedQuery9
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon5 } from "@heroicons/react/24/outline";
import { Suspense as Suspense55 } from "shared-ui";
import {
  createLinkState as createLinkState9,
  EdButtonLink as EdButtonLink5,
  IconJustify as IconJustify5,
  TabUnderline as TabUnderline6
} from "shared-ui";
import { Fragment as Fragment31, jsx as jsx75, jsxs as jsxs67 } from "react/jsx-runtime";
var layoutQueryDef = CandidateLayoutQuery_graphql_default;
function useCandidateLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData7(
    routeId6
  );
  const data = usePreloadedQuery9(
    layoutQueryDef,
    queryRef
  );
  return data;
}
var CandidateLayout = ({ showHeader, inList }) => {
  const location = useLocation9();
  const preloadedQuery = useLoaderData8();
  const data = usePreloadedQuery9(layoutQueryDef, preloadedQuery);
  const tabs4 = useMemo6(() => {
    return [
      createLinkState9(location, "Details", `details`),
      createLinkState9(location, "Profile", `profile`),
      createLinkState9(location, "Impersonate", `impersonate`),
      createLinkState9(location, "Notifications", `notifications`),
      createLinkState9(location, "Support", `support`),
      createLinkState9(location, "Close", `close`)
    ];
  }, [location]);
  const { candidate } = data;
  if (candidate === null || candidate === void 0) {
    return /* @__PURE__ */ jsx75("div", { children: "Not Found" });
  }
  const name = `${candidate.firstName} ${candidate.lastName}`;
  return /* @__PURE__ */ jsx75(Suspense55, { fallback: "Loading...", children: /* @__PURE__ */ jsxs67("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsx75("div", { className: "flex flex-wrap items-center justify-between border-b py-4", children: /* @__PURE__ */ jsx75("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: name }) }),
    /* @__PURE__ */ jsxs67("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
      /* @__PURE__ */ jsx75("div", { className: "px-4", children: /* @__PURE__ */ jsx75(TabUnderline6, { tabs: tabs4 }) }),
      inList && /* @__PURE__ */ jsx75("div", { children: /* @__PURE__ */ jsx75(
        EdButtonLink5,
        {
          to: `../../../../${candidate.code}`,
          name: "View",
          icon: ArrowsPointingOutIcon5,
          iconJustify: IconJustify5.Right
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx75(Outlet14, {})
  ] }) });
};
var CandidateLink = ({ routeId: routeId6, label }) => {
  const data = useCandidateLayoutRouteData(routeId6);
  const { candidate } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx75(Fragment31, {});
  }
  const name = `${candidate.firstName} ${candidate.lastName}`;
  return /* @__PURE__ */ jsx75(Suspense55, { fallback: "Loading...", children: /* @__PURE__ */ jsx75(Link19, { to: ".", children: label || name }) });
};
async function loader29(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery29(environment, layoutQueryDef, {
    candidateCode
  });
}

// src/secure/accounts/candidates/components/__generated__/CandidateDetailsRouteQuery.graphql.ts
var node70 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "code",
    "variableName": "candidateCode"
  }, v2 = [
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v12 = {
    "alias": "approvalLogs",
    "args": [
      v1,
      {
        "kind": "Literal",
        "name": "order",
        "value": {
          "createdAt": "DESC"
        }
      }
    ],
    "concreteType": "RecruitCandidateApprovalLogsByCandidateCodeConnection",
    "kind": "LinkedField",
    "name": "recruitCandidateApprovalLogsByCandidateCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitCandidateApprovalLogsByCandidateCodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitCandidateApprovalLog",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v3,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateApprovalLogId",
                "storageKey": null
              },
              v5,
              v11,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reasons",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateDetailsRouteQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v2,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountEditor_candidate"
            },
            v10
          ],
          "storageKey": null
        },
        v12
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateDetailsRouteQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v2,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v11,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileThumbNailImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageS3Path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTestUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSuspended",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAnonymised",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approvedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anonymisedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEmailVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountActivated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSignUpComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAgreedToTerms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGdprConsented",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidatePhoneVerification",
              "kind": "LinkedField",
              "name": "phone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryPrefix",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneVerificationStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        },
        v12
      ]
    },
    "params": {
      "cacheID": "eb3d06b62c3c7506d728cb1d9b21a453",
      "id": null,
      "metadata": {},
      "name": "CandidateDetailsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateDetailsRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    email\n    updatedAt\n    ...CandidateAccountEditor_candidate\n  }\n  approvalLogs: recruitCandidateApprovalLogsByCandidateCode(code: $candidateCode, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n    }\n    totalCount\n    edges {\n      node {\n        id\n        candidateApprovalLogId\n        code\n        createdAt\n        version\n        candidateId\n        status\n        reasons\n      }\n    }\n  }\n}\n\nfragment CandidateAccountEditor_candidate on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  email\n  profileImageUrl\n  profileThumbNailImageUrl\n  profileImageS3Path\n  isTestUser\n  isSuspended\n  isAnonymised\n  approvedOn\n  anonymisedOn\n  isEmailVerified\n  isAccountApproved\n  isAccountActivated\n  isSignUpComplete\n  hasAgreedToTerms\n  isGdprConsented\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n  ...CandidateAccountNameEditor_account\n  ...CandidateAccountEmailEditor_account\n  ...CandidatePhoneContainer_account\n}\n\nfragment CandidateAccountEmailEditor_account on AccountsCandidateAccount {\n  id\n  email\n  isEmailVerified\n  createdAt\n  updatedAt\n}\n\nfragment CandidateAccountNameEditor_account on AccountsCandidateAccount {\n  id\n  firstName\n  lastName\n  createdAt\n  updatedAt\n}\n\nfragment CandidatePhoneContainer_account on AccountsCandidateAccount {\n  id\n  accountId\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n  ...CandidatePhoneEditor_account\n}\n\nfragment CandidatePhoneEditor_account on AccountsCandidateAccount {\n  id\n  accountId\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n}\n"
    }
  };
}();
node70.hash = "1be99f032ddf3f13b07a18c440c95f91";
var CandidateDetailsRouteQuery_graphql_default = node70;

// src/secure/accounts/candidates/components/__generated__/CandidateDetails_IdentityUserQuery.graphql.ts
var node71 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountUserId"
    }
  ], v1 = [
    {
      "alias": "identityUser",
      "args": [
        {
          "kind": "Variable",
          "name": "accountUserId",
          "variableName": "accountUserId"
        }
      ],
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "identityUserByAccountUserId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastLoggedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityUserId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateDetails_IdentityUserQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateDetails_IdentityUserQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "3fe026253ddaf83212ef5a3f9a87f998",
      "id": null,
      "metadata": {},
      "name": "CandidateDetails_IdentityUserQuery",
      "operationKind": "query",
      "text": "query CandidateDetails_IdentityUserQuery(\n  $accountUserId: UUID!\n) {\n  identityUser: identityUserByAccountUserId(accountUserId: $accountUserId) {\n    id\n    code\n    lastLoggedIn\n    identityUserId\n  }\n}\n"
    }
  };
}();
node71.hash = "757de097e4bc3d95d53b807f00994995";
var CandidateDetails_IdentityUserQuery_graphql_default = node71;

// src/secure/accounts/candidates/components/CandidateDetails.tsx
import { Suspense as Suspense57 } from "react";
import { loadQuery as loadQuery30, useLazyLoadQuery as useLazyLoadQuery10 } from "react-relay";
import { Link as Link20 } from "react-router-dom";
import { timeAgo as timeAgo12, useRouteData as useRouteData21 } from "shared-lib";
import { EdSkeleton as EdSkeleton38, MynPageTitle as MynPageTitle37 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountEditor_candidate.graphql.ts
var node72 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountEditor_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileThumbNailImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageS3Path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuspended",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anonymisedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSignUpComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountNameEditor_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailEditor_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidatePhoneContainer_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node72.hash = "83fa25da56b0e0caf57e26deb1f6311c";
var CandidateAccountEditor_candidate_graphql_default = node72;

// src/secure/accounts/candidates/components/CandidateAccountEditor.tsx
import { useCallback as useCallback32 } from "react";
import { useFragment as useFragment3 } from "react-relay";
import {
  CalendarDaysIcon,
  EnvelopeIcon,
  PhoneIcon,
  UserIcon,
  PencilIcon
} from "@heroicons/react/24/outline";
import {
  createClientMutationId as createClientMutationId16,
  formatDate,
  timeAgo as timeAgo11,
  useToggle as useToggle9
} from "shared-lib";
import {
  BooleanActionItem as BooleanActionItem3,
  Button as Button22,
  classNames as classNames5,
  EdSkeleton as EdSkeleton37,
  Size as Size11,
  Spinner as Spinner4,
  Suspense as Suspense56
} from "shared-ui";

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountApproveMutation.graphql.ts
var node73 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e17dfc0d5eb27f87ef1c2bd8350498ba",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountApproveMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountApproveMutation(\n  $input: AccountsCandidateAccountApproveInput!\n) {\n  data: accountsCandidateAccountApprove(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node73.hash = "15e929f26f5c91070d99bde9bd630030";
var UseCandidateAccountApproveMutation_graphql_default = node73;

// src/secure/accounts/candidates/mutations/UseCandidateAccountApprove.ts
import { useAsyncMutation as useAsyncMutation16 } from "shared-lib";
var mutationDef16 = UseCandidateAccountApproveMutation_graphql_default;
function useCandidateAccountApprove() {
  const [commit, isBusy] = useAsyncMutation16(mutationDef16);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountCloseScheduleMutation.graphql.ts
var node74 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccountCloseQueueItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccountCloseRequest",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountCloseRequestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ipAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userAgent",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountCloseScheduleMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseSchedulePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseSchedule",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountCloseScheduleMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseSchedulePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseSchedule",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "12c7392b5883f490577f8dac2e3a1ed2",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountCloseScheduleMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountCloseScheduleMutation(\n  $input: AccountsCandidateAccountCloseScheduleInput!\n) {\n  data: accountsCandidateAccountCloseSchedule(input: $input) {\n    payload {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node74.hash = "1ebbeb386e5d463036d6c256d7dad6ac";
var UseCandidateAccountCloseScheduleMutation_graphql_default = node74;

// src/secure/accounts/candidates/mutations/UseCandidateAccountCloseSchedule.ts
import { useAsyncMutation as useAsyncMutation17 } from "shared-lib";
var mutationDef17 = UseCandidateAccountCloseScheduleMutation_graphql_default;
function useCandidateAccountCloseSchedule() {
  const [commit, isBusy] = useAsyncMutation17(mutationDef17);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountCloseCancelMutation.graphql.ts
var node75 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccountCloseQueueItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccountCloseRequest",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountCloseRequestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ipAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userAgent",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountCloseCancelMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseCancelPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseCancel",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountCloseCancelMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountCloseCancelPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCloseCancel",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5d0450589be05ff42492491e33926bf3",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountCloseCancelMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountCloseCancelMutation(\n  $input: AccountsCandidateAccountCloseCancelInput!\n) {\n  data: accountsCandidateAccountCloseCancel(input: $input) {\n    payload {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node75.hash = "2c502abe11b8e376068eebe11d28090b";
var UseCandidateAccountCloseCancelMutation_graphql_default = node75;

// src/secure/accounts/candidates/mutations/UseCandidateAccountCloseCancel.ts
import { useAsyncMutation as useAsyncMutation18 } from "shared-lib";
var mutationDef18 = UseCandidateAccountCloseCancelMutation_graphql_default;
function useCandidateAccountCloseCancel() {
  const [commit, isBusy] = useAsyncMutation18(mutationDef18);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountSetSignUpCompleteMutation.graphql.ts
var node76 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetSignupCompletePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetSignupComplete",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSetSignupCompletePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSetSignupComplete",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4f407b3cf84dbf6c4a55a19aaa3f54e8",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountSetSignUpCompleteMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountSetSignUpCompleteMutation(\n  $input: AccountsCandidateAccountSetSignupCompleteInput!\n) {\n  data: accountsCandidateAccountSetSignupComplete(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node76.hash = "b11bccfb43c243d6bb565b6e45aef2d2";
var UseCandidateAccountSetSignUpCompleteMutation_graphql_default = node76;

// src/secure/accounts/candidates/mutations/UseCandidateAccountSetSignUpComplete.ts
import { useAsyncMutation as useAsyncMutation19 } from "shared-lib";
var mutationDef19 = UseCandidateAccountSetSignUpCompleteMutation_graphql_default;
function useCandidateAccountSetSignUpComplete() {
  const [commit, isBusy] = useAsyncMutation19(mutationDef19);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountSuspendMutation.graphql.ts
var node77 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountSuspendMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSuspendPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSuspend",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountSuspendMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountSuspendPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountSuspend",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a691ce58ebe407673751281dcc176532",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountSuspendMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountSuspendMutation(\n  $input: AccountsCandidateAccountSuspendInput!\n) {\n  data: accountsCandidateAccountSuspend(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node77.hash = "9b5ca48c1c86e919d351452f1d13322d";
var UseCandidateAccountSuspendMutation_graphql_default = node77;

// src/secure/accounts/candidates/mutations/UseCandidateAccountSuspend.ts
import { useAsyncMutation as useAsyncMutation20 } from "shared-lib";
var mutationDef20 = UseCandidateAccountSuspendMutation_graphql_default;
function useCandidateAccountSuspend() {
  const [commit, isBusy] = useAsyncMutation20(mutationDef20);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateAccountToggleTestUserMutation.graphql.ts
var node78 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileThumbNailImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileImageS3Path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "anonymisedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountActivated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateAccountToggleTestUserMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountToggleIsTestUserPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountToggleIsTestUser",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateAccountToggleTestUserMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountToggleIsTestUserPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountToggleIsTestUser",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "01fdf4f0b44ad8309ad5fe6b6babe560",
      "id": null,
      "metadata": {},
      "name": "UseCandidateAccountToggleTestUserMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateAccountToggleTestUserMutation(\n  $input: AccountsCandidateAccountToggleIsTestUserInput!\n) {\n  data: accountsCandidateAccountToggleIsTestUser(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        code\n        createdAt\n        updatedAt\n        firstName\n        lastName\n        email\n        profileImageUrl\n        profileThumbNailImageUrl\n        profileImageS3Path\n        isTestUser\n        isSuspended\n        isAnonymised\n        anonymisedOn\n        isEmailVerified\n        isAccountApproved\n        isAccountActivated\n        hasAgreedToTerms\n        isGdprConsented\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n          phoneVerificationStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node78.hash = "2531b7dbb0a993810d2ca4215daaa91a";
var UseCandidateAccountToggleTestUserMutation_graphql_default = node78;

// src/secure/accounts/candidates/mutations/UseCandidateAccountToggleTestUser.ts
import { useAsyncMutation as useAsyncMutation21 } from "shared-lib";
var mutationDef21 = UseCandidateAccountToggleTestUserMutation_graphql_default;
function useCandidateAccountToggleTestUser() {
  const [commit, isBusy] = useAsyncMutation21(mutationDef21);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateSupportConversationAddMessageMutation.graphql.ts
var node79 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateSupportConversation",
    "kind": "LinkedField",
    "name": "candidateSupportConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateSupportConversation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateUnreadCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateSupportConversationMessage",
            "kind": "LinkedField",
            "name": "messages",
            "plural": true,
            "selections": [
              v2,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateSupportConversationMessageId",
                "storageKey": null
              },
              v3,
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conversationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "administratorStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsUser",
                "kind": "LinkedField",
                "name": "createdByUser",
                "plural": false,
                "selections": [
                  v2,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomerServicesCandidateSupportConversationCreateMessagePayload",
          "kind": "LinkedField",
          "name": "customerServicesCandidateSupportConversationCreateMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CustomerServicesCandidateSupportConversationCreateMessagePayload",
          "kind": "LinkedField",
          "name": "customerServicesCandidateSupportConversationCreateMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1917b6c92cb1f209aaae74fe429f711a",
      "id": null,
      "metadata": {},
      "name": "UseCandidateSupportConversationAddMessageMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateSupportConversationAddMessageMutation(\n  $input: CustomerServicesCandidateSupportConversationCreateMessageInput!\n) {\n  data: customerServicesCandidateSupportConversationCreateMessage(input: $input) {\n    candidateSupportConversation {\n      node {\n        id\n        version\n        updatedAt\n        candidateUnreadCount\n        status\n        messages {\n          id\n          candidateSupportConversationMessageId\n          version\n          code\n          createdAt\n          updatedAt\n          conversationId\n          content\n          candidateStatus\n          administratorStatus\n          createdByUser {\n            id\n            firstName\n            lastName\n            accountType\n            emailAddress\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node79.hash = "87b4c9617ae045c41261232e49f86225";
var UseCandidateSupportConversationAddMessageMutation_graphql_default = node79;

// src/secure/accounts/candidates/mutations/UseCandidateSupportConversationAddMessage.ts
import { useAsyncMutation as useAsyncMutation22 } from "shared-lib";
var mutationDef22 = UseCandidateSupportConversationAddMessageMutation_graphql_default;
function useCandidateSupportConversationAddMessage() {
  const [commit, isBusy] = useAsyncMutation22(
    mutationDef22
  );
  return [commit, isBusy];
}

// src/secure/accounts/candidates/mutations/__generated__/UseCandidateSendReminderMutation.graphql.ts
var node80 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateSendReminderMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountEmailSendSignUpReminderPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountEmailSendSignUpReminder",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateSendReminderMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsCandidateAccountEmailSendSignUpReminderPayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountEmailSendSignUpReminder",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2f3d341cf8c5f1d0776648d7ae8285f2",
      "id": null,
      "metadata": {},
      "name": "UseCandidateSendReminderMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateSendReminderMutation(\n  $input: AccountsCandidateAccountEmailSendSignUpReminderInput!\n) {\n  data: accountsCandidateAccountEmailSendSignUpReminder(input: $input) {\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node80.hash = "02161e03eb13491fc449e4790217c3e5";
var UseCandidateSendReminderMutation_graphql_default = node80;

// src/secure/accounts/candidates/mutations/UseCandidateSendReminder.ts
import { useAsyncMutation as useAsyncMutation23 } from "shared-lib";
var mutationDef23 = UseCandidateSendReminderMutation_graphql_default;
function useCandidateSendReminder() {
  const [commit, isBusy] = useAsyncMutation23(mutationDef23);
  return [commit, isBusy];
}

// src/secure/accounts/candidates/components/CandidateAccountEditor.tsx
import {
  CandidateAccountEmailEditor,
  CandidateAccountNameEditor,
  CandidatePhoneContainer
} from "feature-candidate-accounts";
import { jsx as jsx76, jsxs as jsxs68 } from "react/jsx-runtime";
var fragmentDef8 = CandidateAccountEditor_candidate_graphql_default;
var CandidateAccountEditor = ({
  fragmentRef,
  lastLoggedIn
}) => {
  const [updateNameVisible, toggleUpdateName] = useToggle9();
  const [updateEmailVisible, toggleUpdateEmail] = useToggle9();
  const [updatePhoneVisible, toggleUpdatePhone] = useToggle9();
  const data = useFragment3(
    fragmentDef8,
    fragmentRef
  );
  const [approve, isApproving] = useCandidateAccountApprove();
  const [remindCandidate, isRemindingCandidate] = useCandidateSendReminder();
  const [setSignUpComplete, isSettingSignUpComplete] = useCandidateAccountSetSignUpComplete();
  const [suspend, isSuspending] = useCandidateAccountSuspend();
  const [toggleTestAccount, isTogglingTestAccount] = useCandidateAccountToggleTestUser();
  const onSuspend = useCallback32(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId16(),
      remindInMonths: 6
    };
    await suspend({ input });
  }, [data.accountId, suspend]);
  const onSendReminder = useCallback32(async () => {
    remindCandidate({
      input: {
        candidateId: data.accountId,
        clientMutationId: createClientMutationId16()
      }
    });
  }, [data.accountId, remindCandidate]);
  const onSetSignUpComplete = useCallback32(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId16()
    };
    await setSignUpComplete({ input });
  }, [data.accountId, setSignUpComplete]);
  const onApprove = useCallback32(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId16()
    };
    await approve({ input });
  }, [approve, data.accountId]);
  const onToggleTestAccount = useCallback32(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId16()
    };
    await toggleTestAccount({ input });
  }, [data.accountId, toggleTestAccount]);
  if (data === null) {
    return /* @__PURE__ */ jsx76(EdSkeleton37, {});
  }
  const DetailItems = ({
    label,
    value,
    icon,
    onEdit
  }) => {
    return /* @__PURE__ */ jsxs68("div", { className: "mb-2 flex items-center justify-between gap-10 border-b pb-4", children: [
      /* @__PURE__ */ jsxs68("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ jsx76("div", { className: "w-16 border-r pr-3", children: icon }),
        /* @__PURE__ */ jsx76("div", { className: "text-primary-700 text-lg font-bold", children: label })
      ] }),
      /* @__PURE__ */ jsxs68("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ jsx76("div", { className: classNames5(label !== "Email" && "capitalize"), children: value }),
        onEdit && /* @__PURE__ */ jsx76(
          "div",
          {
            className: "text-primary-400 flex cursor-pointer pb-5 pl-5",
            onClick: onEdit,
            children: /* @__PURE__ */ jsx76(PencilIcon, { className: "h-6 w-6" })
          }
        )
      ] })
    ] });
  };
  const approvedOnDate = data?.approvedOn ? timeAgo11(data?.approvedOn) : "";
  return /* @__PURE__ */ jsx76(Suspense56, { fallback: /* @__PURE__ */ jsx76(EdSkeleton37, {}), children: /* @__PURE__ */ jsx76("div", { className: "xl:flex", children: /* @__PURE__ */ jsxs68("div", { className: "flex w-full flex-col gap-4 border bg-white p-8", children: [
    !updateNameVisible ? /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: "Name",
        value: `${data?.firstName} ${data?.lastName}`,
        onEdit: toggleUpdateName,
        icon: /* @__PURE__ */ jsx76(
          UserIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ) : /* @__PURE__ */ jsx76("div", { children: /* @__PURE__ */ jsx76(
      CandidateAccountNameEditor,
      {
        candidateId: data.accountId,
        fragmentRef: data,
        onSaved: toggleUpdateName,
        onCancel: toggleUpdateName
      }
    ) }),
    !updateEmailVisible ? /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: "Email",
        value: data?.email,
        onEdit: toggleUpdateEmail,
        icon: /* @__PURE__ */ jsx76(
          EnvelopeIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ) : /* @__PURE__ */ jsx76("div", { children: /* @__PURE__ */ jsx76(
      CandidateAccountEmailEditor,
      {
        candidateId: data.accountId,
        fragmentRef: data,
        onSaved: toggleUpdateEmail,
        onCancel: toggleUpdateEmail
      }
    ) }),
    !updatePhoneVisible ? /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: "Phone",
        value: data?.phone?.phoneNumber || "Not Provided",
        onEdit: toggleUpdatePhone,
        icon: /* @__PURE__ */ jsx76(
          PhoneIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ) : /* @__PURE__ */ jsx76("div", { children: /* @__PURE__ */ jsx76(
      CandidatePhoneContainer,
      {
        fragmentRef: data,
        onCancel: toggleUpdatePhone
      }
    ) }),
    /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: " Last Logged in Date",
        value: lastLoggedIn,
        icon: /* @__PURE__ */ jsx76(
          CalendarDaysIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: "Account Created On Date",
        value: formatDate(data?.createdAt),
        icon: /* @__PURE__ */ jsx76(
          CalendarDaysIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Accepted Terms & Conditions",
        value: data.hasAgreedToTerms || false
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Accepted GDPR",
        value: data.isGdprConsented || false
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Email Verified",
        value: data.isEmailVerified
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Approved",
        value: data.isAccountApproved,
        action: /* @__PURE__ */ jsx76("div", { children: !data.isAccountApproved && /* @__PURE__ */ jsx76(
          Button22,
          {
            "aria-label": "Approve",
            color: "primary",
            size: Size11.lg,
            clicked: onApprove,
            disabled: isApproving,
            children: "Approve"
          }
        ) })
      }
    ),
    data.isAccountApproved && /* @__PURE__ */ jsx76(
      DetailItems,
      {
        label: "Approved on Date",
        value: approvedOnDate,
        icon: /* @__PURE__ */ jsx76(
          CalendarDaysIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Suspended",
        value: data.isSuspended,
        action: /* @__PURE__ */ jsx76("div", { children: !data.isSuspended && /* @__PURE__ */ jsx76(
          Button22,
          {
            "aria-label": "Suspend",
            color: "warning",
            size: Size11.lg,
            clicked: onSuspend,
            disabled: isSuspending,
            children: "Suspend"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Sign Up Complete",
        value: data.isSignUpComplete,
        action: /* @__PURE__ */ jsxs68("div", { className: "flex gap-1", children: [
          !data.isSignUpComplete && /* @__PURE__ */ jsx76(
            Button22,
            {
              "aria-label": "Send reminder",
              color: "primary",
              size: Size11.lg,
              clicked: onSendReminder,
              disabled: isSettingSignUpComplete,
              children: /* @__PURE__ */ jsxs68("div", { className: "flex items-center justify-between gap-1", children: [
                /* @__PURE__ */ jsx76("span", { children: "Send reminder" }),
                isRemindingCandidate && /* @__PURE__ */ jsx76(Spinner4, {})
              ] })
            }
          ),
          !data.isSignUpComplete && /* @__PURE__ */ jsx76(
            Button22,
            {
              "aria-label": "Set Sign Up Complete",
              color: "primary",
              size: Size11.lg,
              clicked: onSetSignUpComplete,
              disabled: isSettingSignUpComplete,
              children: "Set Sign Up Complete"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx76(
      BooleanActionItem3,
      {
        label: "Test Account",
        value: data.isTestUser,
        action: /* @__PURE__ */ jsx76("div", { children: data.isTestUser ? /* @__PURE__ */ jsx76(
          Button22,
          {
            "aria-label": "Set Normal Account",
            color: "warning",
            size: Size11.lg,
            disabled: isTogglingTestAccount,
            clicked: onToggleTestAccount,
            children: "Set Normal Account"
          }
        ) : /* @__PURE__ */ jsx76(
          Button22,
          {
            "aria-label": "Set Test Account",
            color: "warning",
            size: Size11.lg,
            disabled: isTogglingTestAccount,
            clicked: onToggleTestAccount,
            children: "Set Test Account"
          }
        ) })
      }
    )
  ] }) }) });
};

// src/secure/accounts/candidates/components/CandidateDetails.tsx
import { Fragment as Fragment32, jsx as jsx77, jsxs as jsxs69 } from "react/jsx-runtime";
var queryDef35 = CandidateDetailsRouteQuery_graphql_default;
var identityUserDef = CandidateDetails_IdentityUserQuery_graphql_default;
async function loader30(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery30(environment, queryDef35, {
    candidateCode
  });
}
var CandidateDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData21(queryDef35, routeId6);
  const accountId = data?.candidate?.accountId || "";
  const identityUserData = useLazyLoadQuery10(
    identityUserDef,
    { accountUserId: accountId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data) {
    return /* @__PURE__ */ jsx77(Fragment32, { children: "Loading..." });
  }
  const { candidate, approvalLogs } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx77(Fragment32, { children: "Loading..." });
  }
  const approvalLogsList = (approvalLogs?.edges || []).map((e) => e.node).map((l) => {
    const reasonList = l.reasons.map((reason) => {
      return /* @__PURE__ */ jsx77("li", { children: reason }, reason);
    });
    return /* @__PURE__ */ jsxs69("tr", { children: [
      /* @__PURE__ */ jsx77("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx77("div", { className: "text-primary-700 font-medium", children: timeAgo12(l.createdAt) }) }),
      /* @__PURE__ */ jsx77("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx77("div", { className: "text-sm text-gray-500", children: l.status }) }),
      /* @__PURE__ */ jsx77("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx77("ul", { children: reasonList }) })
    ] }, l.id);
  });
  const lastLoggedInAt = identityUserData?.identityUser?.lastLoggedIn && timeAgo12(identityUserData?.identityUser?.lastLoggedIn) || "";
  return /* @__PURE__ */ jsx77(Suspense57, { fallback: /* @__PURE__ */ jsx77(EdSkeleton38, {}), children: /* @__PURE__ */ jsxs69("div", { className: "p-4", children: [
    /* @__PURE__ */ jsx77(MynPageTitle37, { title: "Candidate Details" }),
    /* @__PURE__ */ jsx77("div", { className: "text-primary-700 mb-4 mt-4 px-2 text-xl font-medium", children: "Candidate Details" }),
    /* @__PURE__ */ jsx77(
      CandidateAccountEditor,
      {
        fragmentRef: candidate,
        lastLoggedIn: lastLoggedInAt
      }
    ),
    approvalLogs && /* @__PURE__ */ jsxs69("div", { className: "", children: [
      /* @__PURE__ */ jsx77("div", { className: "text-primary-700 mt-4 px-2 text-xl font-medium", children: "Approval Logs" }),
      /* @__PURE__ */ jsx77("div", { className: "py-4", children: /* @__PURE__ */ jsxs69("table", { className: "min-w-full divide-y divide-gray-300 border", children: [
        /* @__PURE__ */ jsx77("thead", { children: /* @__PURE__ */ jsxs69("tr", { children: [
          /* @__PURE__ */ jsx77(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Occurred On"
            }
          ),
          /* @__PURE__ */ jsx77(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Status"
            }
          ),
          /* @__PURE__ */ jsx77(
            "th",
            {
              scope: "col",
              className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
              children: "Reasons"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx77("tbody", { className: "divide-y divide-gray-200 bg-white", children: approvalLogsList })
      ] }) })
    ] })
  ] }) });
};
var createRoute18 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-details`;
  return {
    id: routeId6,
    path: "details",
    element: /* @__PURE__ */ jsx77(CandidateDetails, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx77(Link20, { to: "details", children: "Details" })
    },
    loader: ({ params }) => {
      return loader30(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/__generated__/CandidateProfileRouteQuery.graphql.ts
var node81 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateProfileRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateProfileRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "e2e17c616ee74bc3592bde9ed644a5ef",
      "id": null,
      "metadata": {},
      "name": "CandidateProfileRouteQuery",
      "operationKind": "query",
      "text": "query CandidateProfileRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    updatedAt\n    firstName\n    lastName\n    email\n  }\n}\n"
    }
  };
}();
node81.hash = "e593689b9d8d3cad5697956dd83ad38b";
var CandidateProfileRouteQuery_graphql_default = node81;

// src/secure/accounts/candidates/components/__generated__/CandidateProfileApplicationQuery.graphql.ts
var node82 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationWhere"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recommendationWhere"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "applicationWhere"
  }, v4 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "recommendationWhere"
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    },
    v3
  ], v10 = {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v13 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 8
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdOn": "DESC"
      }
    },
    v4
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateProfileApplicationQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateProfile_profile"
        },
        {
          "args": [
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CandidateApplications_applications"
        },
        {
          "args": [
            v4
          ],
          "kind": "FragmentSpread",
          "name": "CandidateRecommendations_recommendations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v2,
        v0,
        v1
      ],
      "kind": "Operation",
      "name": "CandidateProfileApplicationQuery",
      "selections": [
        {
          "alias": "profile",
          "args": [
            {
              "kind": "Variable",
              "name": "email",
              "variableName": "email"
            }
          ],
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileByEmail",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailAddress",
              "storageKey": null
            },
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recruitProfileId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPools",
              "plural": true,
              "selections": [
                v7,
                v6,
                v5
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v9,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    v12
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v9,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplications_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        },
        {
          "alias": "recommendations",
          "args": v13,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v7,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    v12
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v13,
          "filters": [],
          "handle": "connection",
          "key": "CandidateRecommendations_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        }
      ]
    },
    "params": {
      "cacheID": "0bc5bd4e350012399d8ba82c6eaa0192",
      "id": null,
      "metadata": {},
      "name": "CandidateProfileApplicationQuery",
      "operationKind": "query",
      "text": "query CandidateProfileApplicationQuery(\n  $recommendationWhere: RecruitRecommendationFilter!\n  $applicationWhere: ApplicationFilter!\n  $email: String!\n) {\n  ...CandidateProfile_profile\n  ...CandidateApplications_applications_1LJLPR\n  ...CandidateRecommendations_recommendations_2eTgco\n}\n\nfragment CandidateApplications_applications_1LJLPR on Query {\n  applications(first: 10, where: $applicationWhere, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        vacancyName\n        applicationStateName\n        __typename\n      }\n    }\n  }\n}\n\nfragment CandidateProfile_profile on Query {\n  profile: recruitProfileByEmail(email: $email) {\n    id\n    firstName\n    lastName\n    emailAddress\n    code\n    updatedAt\n    recruitProfileId\n    talentPools {\n      name\n      code\n      id\n    }\n  }\n}\n\nfragment CandidateRecommendations_recommendations_2eTgco on Query {\n  recommendations: recruitRecommendations(first: 8, where: $recommendationWhere, order: {createdOn: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node82.hash = "36c815c6d26da3dc8fe66152bd29c50d";
var CandidateProfileApplicationQuery_graphql_default = node82;

// src/secure/accounts/candidates/components/__generated__/CandidateProfile_profile.graphql.ts
var node83 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "kind": "RootArgument",
        "name": "email"
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateProfile_profile",
    "selections": [
      {
        "alias": "profile",
        "args": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          }
        ],
        "concreteType": "RecruitProfile",
        "kind": "LinkedField",
        "name": "recruitProfileByEmail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPool",
            "kind": "LinkedField",
            "name": "talentPools",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              v0
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node83.hash = "4603e342340f4e2b6c14ed967c4553d4";
var CandidateProfile_profile_graphql_default = node83;

// src/secure/accounts/candidates/components/CandidateProfile.tsx
import { Suspense as Suspense58 } from "react";
import { loadQuery as loadQuery31, useFragment as useFragment5, useLazyLoadQuery as useLazyLoadQuery12 } from "react-relay";
import { Link as Link21 } from "react-router-dom";
import { useRouteData as useRouteData22 } from "shared-lib";
import { EdSkeleton as EdSkeleton39, MynPageTitle as MynPageTitle38 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateProfileApplicationListPaginationQuery.graphql.ts
var node84 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateProfileApplicationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CandidateApplications_applications"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateProfileApplicationListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v4,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplications_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        }
      ]
    },
    "params": {
      "cacheID": "1a5c56dc3a7ccdbb628ad2e434d57fe1",
      "id": null,
      "metadata": {},
      "name": "CandidateProfileApplicationListPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateProfileApplicationListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $sort: [ApplicationSort!] = {createdAt: DESC}\n  $where: ApplicationFilter\n) {\n  ...CandidateApplications_applications_5yRcm\n}\n\nfragment CandidateApplications_applications_5yRcm on Query {\n  applications(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        vacancyName\n        applicationStateName\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node84.hash = "aeaf724854f8bb35a9b2e5d1911bd8c2";
var CandidateProfileApplicationListPaginationQuery_graphql_default = node84;

// src/secure/accounts/candidates/components/__generated__/CandidateApplications_applications.graphql.ts
var node85 = /* @__PURE__ */ function() {
  var v0 = [
    "applications"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateProfileApplicationListPaginationQuery_graphql_default
      }
    },
    "name": "CandidateApplications_applications",
    "selections": [
      {
        "alias": "applications",
        "args": null,
        "concreteType": "ApplicationsConnection",
        "kind": "LinkedField",
        "name": "__CandidateApplications_applications_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Application",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationStateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node85.hash = "aeaf724854f8bb35a9b2e5d1911bd8c2";
var CandidateApplications_applications_graphql_default = node85;

// src/secure/accounts/candidates/components/CandidateApplications.tsx
import { startTransition as startTransition2, useCallback as useCallback33 } from "react";
import { usePaginationFragment as usePaginationFragment7 } from "react-relay";
import { isNotNullOrUndefined as isNotNullOrUndefined6 } from "shared-lib";
import {
  Button as Button23,
  classNames as classNames6,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement5,
  FlatList
} from "shared-ui";
import { EmptyList } from "feature-recruit";
import { jsx as jsx78, jsxs as jsxs70 } from "react/jsx-runtime";
var applicationFragmentDef = CandidateApplications_applications_graphql_default;
var CandidateApplicationList = ({ fragmentRef }) => {
  const { data, loadNext, isLoadingNext } = usePaginationFragment7(applicationFragmentDef, fragmentRef);
  const { applications } = data;
  const onLoadNext = useCallback33(() => {
    startTransition2(() => {
      loadNext(10);
    });
  }, [loadNext]);
  const hasApplications = applications?.edges && applications?.edges?.length > 0;
  const section = (applications?.edges || []).filter(isNotNullOrUndefined6).map((e) => e.node).map((ft) => {
    const name = `${ft.vacancyName}`;
    return {
      key: ft.applicationId,
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx78("div", { className: "b flex flex-col gap-2  border-b-2 px-3 py-3 last:border-b-0", children: /* @__PURE__ */ jsxs70("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx78("div", { className: "text-base capitalize text-purple-900", children: name }),
        /* @__PURE__ */ jsx78(Button23, { color: "green", children: ft.applicationStateName })
      ] }) }),
      element: /* @__PURE__ */ jsx78(DefaultListLayoutSectionElement5, { children: /* @__PURE__ */ jsx78("div", { className: "grid", children: /* @__PURE__ */ jsx78("div", { children: ft.applicationStateName }) }) })
    };
  });
  return /* @__PURE__ */ jsxs70("div", { className: "w-full bg-white p-5", children: [
    /* @__PURE__ */ jsx78("div", { className: "text-xl text-purple-900", children: "Vacancies List" }),
    hasApplications ? /* @__PURE__ */ jsx78(
      FlatList,
      {
        data: section,
        onEndReached: onLoadNext,
        className: classNames6("md:block md:h-[320px] md:overflow-y-auto"),
        isLoading: isLoadingNext,
        style: {},
        renderItem: (item) => {
          return item.listTitle;
        }
      }
    ) : /* @__PURE__ */ jsx78(EmptyList, { title: "No Applications Yet \u{1F632}", subTitle: "" })
  ] });
};

// src/secure/accounts/candidates/components/__generated__/CandidateProfileRecommendationPaginationQuery.graphql.ts
var node86 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 8,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdOn": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v3
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateProfileRecommendationPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CandidateRecommendations_recommendations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateProfileRecommendationPaginationQuery",
      "selections": [
        {
          "alias": "recommendations",
          "args": v4,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "CandidateRecommendations_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        }
      ]
    },
    "params": {
      "cacheID": "8fdd069faa0383b298eecac57b7257d8",
      "id": null,
      "metadata": {},
      "name": "CandidateProfileRecommendationPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateProfileRecommendationPaginationQuery(\n  $after: String\n  $first: Int = 8\n  $sort: [RecruitRecommendationSort!] = {createdOn: DESC}\n  $where: RecruitRecommendationFilter\n) {\n  ...CandidateRecommendations_recommendations_5yRcm\n}\n\nfragment CandidateRecommendations_recommendations_5yRcm on Query {\n  recommendations: recruitRecommendations(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node86.hash = "85e49952305de67cf4120ded1b2d5d57";
var CandidateProfileRecommendationPaginationQuery_graphql_default = node86;

// src/secure/accounts/candidates/components/__generated__/CandidateRecommendations_recommendations.graphql.ts
var node87 = /* @__PURE__ */ function() {
  var v0 = [
    "recommendations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 8,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdOn": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateProfileRecommendationPaginationQuery_graphql_default
      }
    },
    "name": "CandidateRecommendations_recommendations",
    "selections": [
      {
        "alias": "recommendations",
        "args": null,
        "concreteType": "RecruitRecommendationsConnection",
        "kind": "LinkedField",
        "name": "__CandidateRecommendations_recommendations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitRecommendation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitRecommendationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node87.hash = "85e49952305de67cf4120ded1b2d5d57";
var CandidateRecommendations_recommendations_graphql_default = node87;

// src/secure/accounts/candidates/components/CandidateRecommendations.tsx
import { EmptyList as EmptyList2 } from "feature-recruit";
import { usePaginationFragment as usePaginationFragment8 } from "react-relay";
import {
  Button as Button24,
  classNames as classNames7,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement6,
  FlatList as FlatList2
} from "shared-ui";
import { startTransition as startTransition3, useCallback as useCallback34 } from "react";
import { isNotNullOrUndefined as isNotNullOrUndefined7 } from "shared-lib";
import { jsx as jsx79, jsxs as jsxs71 } from "react/jsx-runtime";
var recommendationFragmentDef = CandidateRecommendations_recommendations_graphql_default;
var CandidateRecommendationsList = ({ fragmentRef }) => {
  const { data, loadNext, isLoadingNext } = usePaginationFragment8(recommendationFragmentDef, fragmentRef);
  const { recommendations } = data;
  const onLoadNext = useCallback34(() => {
    startTransition3(() => {
      loadNext(10);
    });
  }, [loadNext]);
  const hasRecommendations = recommendations?.edges && recommendations?.edges?.length > 0;
  const sections = (recommendations?.edges || []).filter(isNotNullOrUndefined7).map((e) => e.node).map((ft) => {
    const name = `${ft.vacancy.name} at ${ft.vacancy.employerName}`;
    return {
      key: ft.recruitRecommendationId,
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx79("div", { className: "b flex flex-col gap-2  border-b-2 px-3 py-3 last:border-b-0", children: /* @__PURE__ */ jsxs71("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx79("div", { className: "text-base capitalize text-purple-900", children: name }),
        /* @__PURE__ */ jsx79(Button24, { color: "green", children: ft.currentStatus })
      ] }) }),
      element: /* @__PURE__ */ jsx79(DefaultListLayoutSectionElement6, { children: /* @__PURE__ */ jsx79("div", { className: "grid", children: /* @__PURE__ */ jsx79("div", { children: ft.currentStatus }) }) })
    };
  });
  return /* @__PURE__ */ jsxs71("div", { className: "w-full bg-white p-5", children: [
    /* @__PURE__ */ jsx79("div", { className: "text-xl text-purple-900", children: "Recommendations List" }),
    hasRecommendations ? /* @__PURE__ */ jsx79(
      FlatList2,
      {
        data: sections,
        onEndReached: onLoadNext,
        className: classNames7("md:block md:h-[320px] md:overflow-y-auto"),
        isLoading: isLoadingNext,
        style: {},
        renderItem: (item) => {
          return item.listTitle;
        }
      }
    ) : /* @__PURE__ */ jsx79(EmptyList2, { title: "No Recommendations Yet \u{1F632}", subTitle: "" })
  ] });
};

// src/secure/accounts/candidates/components/__generated__/CandidateResumeQuery.graphql.ts
var node88 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    },
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateResumeQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "CandidateResume_resumes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateResumeQuery",
      "selections": [
        {
          "alias": "resumes",
          "args": v2,
          "concreteType": "RecruitResumesConnection",
          "kind": "LinkedField",
          "name": "recruitResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "addedToProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResumeData",
                      "kind": "LinkedField",
                      "name": "resumeData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillModel",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v3,
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "monthsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResumePosition",
                          "kind": "LinkedField",
                          "name": "employmentHistory",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "index",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isInProfile",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canClarify",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canImport",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyIsVerified",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "inProfileOn",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidCompany",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidFromDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidToDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumePositionType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industry",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "description",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "from",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "to",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobTitles",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillTag",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v3,
                                v4
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isExcluded",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "resumes",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "CandidateResume_resumes",
          "kind": "LinkedHandle",
          "name": "recruitResumes"
        }
      ]
    },
    "params": {
      "cacheID": "1fe2edef3acb5412c61c6888137f0f89",
      "id": null,
      "metadata": {},
      "name": "CandidateResumeQuery",
      "operationKind": "query",
      "text": "query CandidateResumeQuery(\n  $where: RecruitResumeFilter!\n) {\n  ...CandidateResume_resumes_3FC4Qo\n}\n\nfragment CandidateResume_resumes_3FC4Qo on Query {\n  resumes: recruitResumes(first: 25, order: {createdAt: DESC}, where: $where) {\n    edges {\n      cursor\n      node {\n        id\n        resumeId\n        profileId\n        createdAt\n        updatedAt\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        ...ResumeView_resume\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeSkills_resume on RecruitResume {\n  id\n  resumeData {\n    skills {\n      skillId\n      skillName\n      lastUsed\n      monthsUsed\n    }\n  }\n}\n\nfragment ResumeView_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  ...ResumeHeader_resume\n  ...ResumeSkills_resume\n  ...ResumeWorkflow_resume\n  ...ResumePositions_resume\n  ...ResumeClarifyPositions_resume\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node88.hash = "17695f19eafb3f4a95634720825c472a";
var CandidateResumeQuery_graphql_default = node88;

// src/secure/accounts/candidates/components/__generated__/CandidateProfileResumeListPaginationQuery.graphql.ts
var node89 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillId",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateProfileResumeListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "CandidateResume_resumes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateProfileResumeListPaginationQuery",
      "selections": [
        {
          "alias": "resumes",
          "args": v1,
          "concreteType": "RecruitResumesConnection",
          "kind": "LinkedField",
          "name": "recruitResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "addedToProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResumeData",
                      "kind": "LinkedField",
                      "name": "resumeData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillModel",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v2,
                            v3,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "monthsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResumePosition",
                          "kind": "LinkedField",
                          "name": "employmentHistory",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "index",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isInProfile",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canClarify",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canImport",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyIsVerified",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "inProfileOn",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidCompany",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidFromDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidToDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumePositionType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industry",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "description",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "from",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "to",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobTitles",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillTag",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v2,
                                v3
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isExcluded",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "resumes",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "CandidateResume_resumes",
          "kind": "LinkedHandle",
          "name": "recruitResumes"
        }
      ]
    },
    "params": {
      "cacheID": "37c2e3bef57c4420cbfe5a949638a781",
      "id": null,
      "metadata": {},
      "name": "CandidateProfileResumeListPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateProfileResumeListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $order: [RecruitResumeSort!] = {createdAt: DESC}\n  $where: RecruitResumeFilter\n) {\n  ...CandidateResume_resumes_cnSAE\n}\n\nfragment CandidateResume_resumes_cnSAE on Query {\n  resumes: recruitResumes(first: $first, after: $after, order: $order, where: $where) {\n    edges {\n      cursor\n      node {\n        id\n        resumeId\n        profileId\n        createdAt\n        updatedAt\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        ...ResumeView_resume\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeSkills_resume on RecruitResume {\n  id\n  resumeData {\n    skills {\n      skillId\n      skillName\n      lastUsed\n      monthsUsed\n    }\n  }\n}\n\nfragment ResumeView_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  ...ResumeHeader_resume\n  ...ResumeSkills_resume\n  ...ResumeWorkflow_resume\n  ...ResumePositions_resume\n  ...ResumeClarifyPositions_resume\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node89.hash = "f4292aa65ddd29dae3c430c24ab9c7a8";
var CandidateProfileResumeListPaginationQuery_graphql_default = node89;

// src/secure/accounts/candidates/components/__generated__/CandidateResume_resumes.graphql.ts
var node90 = /* @__PURE__ */ function() {
  var v0 = [
    "resumes"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateProfileResumeListPaginationQuery_graphql_default
      }
    },
    "name": "CandidateResume_resumes",
    "selections": [
      {
        "alias": "resumes",
        "args": null,
        "concreteType": "RecruitResumesConnection",
        "kind": "LinkedField",
        "name": "__CandidateResume_resumes_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitResumesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitResume",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resumeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperienceToClarify",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRecentExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRecentExperienceToClarify",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperienceToImport",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasValidExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasInValidExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addedToProfile",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ResumeView_resume"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node90.hash = "f4292aa65ddd29dae3c430c24ab9c7a8";
var CandidateResume_resumes_graphql_default = node90;

// src/secure/accounts/candidates/components/CandidateResume.tsx
import { ResumeView } from "feature-recruit";
import { useState as useState20 } from "react";
import { useFragment as useFragment4, useLazyLoadQuery as useLazyLoadQuery11 } from "react-relay";
import { Button as Button25, classNames as classNames8, Modal } from "shared-ui";
import { jsx as jsx80, jsxs as jsxs72 } from "react/jsx-runtime";
var queryDef36 = CandidateResumeQuery_graphql_default;
var resumeFragmentDef = CandidateResume_resumes_graphql_default;
var CandidateResumeList = ({ profileData }) => {
  const { profile } = profileData;
  const query = useLazyLoadQuery11(
    queryDef36,
    {
      where: {
        profileId: { eq: profile?.recruitProfileId }
      }
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [selectedResume, setSelectedResume] = useState20("");
  const resumeData = useFragment4(
    resumeFragmentDef,
    query
  );
  const { resumes } = resumeData;
  const toggleResumeModal = (resumeId) => {
    setSelectedResume(selectedResume === resumeId ? "" : resumeId);
  };
  const hasResumes = resumes?.edges && resumes?.edges?.length > 0;
  return /* @__PURE__ */ jsxs72("div", { className: "bg-white p-5", children: [
    /* @__PURE__ */ jsx80("div", { className: "text-xl text-purple-900", children: "Resume List" }),
    hasResumes ? resumes?.edges?.map((resume) => /* @__PURE__ */ jsxs72("div", { children: [
      /* @__PURE__ */ jsxs72(
        "div",
        {
          className: classNames8(
            "flex justify-between p-4",
            (resumes?.edges?.length || 0) > 1 && "last:border-t"
          ),
          children: [
            /* @__PURE__ */ jsx80("div", { className: "text-primary-700 text-lg", children: resume.node.fileName }),
            /* @__PURE__ */ jsx80(
              Button25,
              {
                color: "primary",
                onClick: () => toggleResumeModal(resume.node.id),
                children: "View Resume"
              }
            )
          ]
        },
        resume.node.id
      ),
      selectedResume === resume.node.id && /* @__PURE__ */ jsx80(Modal, { onClose: () => toggleResumeModal(resume.node.id), children: /* @__PURE__ */ jsx80("div", { className: "md:w-[1000px]", children: /* @__PURE__ */ jsx80(ResumeView, { fragmentRef: resume.node }) }) })
    ] })) : /* @__PURE__ */ jsx80("div", { children: "No Resumes Found" })
  ] });
};
var CandidateResume_default = CandidateResumeList;

// src/secure/accounts/candidates/components/CandidateTalentPool.tsx
import { useNavigate as useNavigate15 } from "react-router-dom";
import { Button as Button26, classNames as classNames9 } from "shared-ui";
import { jsx as jsx81, jsxs as jsxs73 } from "react/jsx-runtime";
var CandidateTalentPoolList = ({ profileData }) => {
  const navigate = useNavigate15();
  const { profile } = profileData;
  const hasJoinedTalentPools = profile?.talentPools && profile?.talentPools?.length > 0;
  return /* @__PURE__ */ jsxs73("div", { className: "bg-white p-5", children: [
    /* @__PURE__ */ jsx81("div", { className: "text-xl text-purple-900", children: "Talent Pools List" }),
    hasJoinedTalentPools ? profile?.talentPools?.map((tp) => {
      return /* @__PURE__ */ jsxs73(
        "div",
        {
          className: classNames9(
            "flex justify-between p-4",
            profile?.talentPools?.length > 1 && "border-b last:border-b-0"
          ),
          children: [
            /* @__PURE__ */ jsx81("div", { className: "text-primary-700 text-lg", children: tp.name }),
            /* @__PURE__ */ jsx81(
              Button26,
              {
                "aria-label": "Go to talent pool",
                color: "primary",
                onClick: () => navigate(
                  `../../../../../../../recruit/talent-pools/${tp.code}/details`
                ),
                children: "Go to talent pool"
              }
            )
          ]
        },
        tp.name
      );
    }) : /* @__PURE__ */ jsx81("div", { children: "No Talent Pools Joined" })
  ] });
};

// src/secure/accounts/candidates/components/CandidateProfile.tsx
import { jsx as jsx82, jsxs as jsxs74 } from "react/jsx-runtime";
var queryDef37 = CandidateProfileRouteQuery_graphql_default;
var candidateProfileQueryDef = CandidateProfileApplicationQuery_graphql_default;
var profileFragmentDef = CandidateProfile_profile_graphql_default;
async function loader31(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery31(environment, queryDef37, {
    candidateCode
  });
}
var CandidateProfile = ({ routeId: routeId6 }) => {
  const data = useRouteData22(queryDef37, routeId6);
  if (!data.candidate) {
    return /* @__PURE__ */ jsx82(EdSkeleton39, {});
  }
  const query = useLazyLoadQuery12(
    candidateProfileQueryDef,
    {
      applicationWhere: {
        candidateId: { eq: data.candidate?.accountId }
      },
      recommendationWhere: {
        candidateId: { eq: data.candidate?.accountId }
      },
      email: data.candidate?.email
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const profileData = useFragment5(
    profileFragmentDef,
    query
  );
  if (!profileData) {
    return /* @__PURE__ */ jsx82(EdSkeleton39, {});
  }
  return /* @__PURE__ */ jsx82(Suspense58, { fallback: /* @__PURE__ */ jsx82(EdSkeleton39, {}), children: /* @__PURE__ */ jsxs74("div", { className: "p-4", children: [
    /* @__PURE__ */ jsx82(MynPageTitle38, { title: "Candidate Profile" }),
    /* @__PURE__ */ jsx82("div", { className: "text-primary-700 mb-4 mt-4 px-2 text-xl font-medium", children: "Candidate Profile" }),
    /* @__PURE__ */ jsxs74("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs74("div", { className: "flex w-full gap-2", children: [
        /* @__PURE__ */ jsx82(CandidateRecommendationsList, { fragmentRef: query }),
        /* @__PURE__ */ jsx82(CandidateApplicationList, { fragmentRef: query })
      ] }),
      /* @__PURE__ */ jsx82(CandidateTalentPoolList, { profileData }),
      /* @__PURE__ */ jsx82(CandidateResume_default, { profileData })
    ] })
  ] }) });
};
var createRoute19 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-profile`;
  return {
    id: routeId6,
    path: "profile",
    element: /* @__PURE__ */ jsx82(CandidateProfile, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx82(Link21, { to: "profile", children: "Profile" })
    },
    loader: ({ params }) => {
      return loader31(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/__generated__/CandidateCloseRouteQuery.graphql.ts
var node91 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    }
  ], v1 = [
    {
      "alias": "candidate",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "candidateCode"
        }
      ],
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "accountCandidateAccountByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateCloseRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateCloseRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "44a1cfb2e1abe259bb817056adc85dc7",
      "id": null,
      "metadata": {},
      "name": "CandidateCloseRouteQuery",
      "operationKind": "query",
      "text": "query CandidateCloseRouteQuery(\n  $candidateCode: Long!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n  }\n}\n"
    }
  };
}();
node91.hash = "76b9be624438508dc6fd72852488bedb";
var CandidateCloseRouteQuery_graphql_default = node91;

// src/secure/accounts/candidates/components/CandidateClose.tsx
import { Suspense as Suspense61 } from "react";
import { loadQuery as loadQuery32 } from "react-relay";
import { Link as Link22 } from "react-router-dom";
import { useRouteData as useRouteData23 } from "shared-lib";
import { EdSkeleton as EdSkeleton42, MynPageTitle as MynPageTitle39 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountCloseContainerQuery.graphql.ts
var node92 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "candidateCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v11 = [
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v12 = {
    "alias": "queue",
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": {
          "createdAt": "DESC"
        }
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "AccountCandidateAccountCloseRequestsConnection",
    "kind": "LinkedField",
    "name": "accountCandidateAccountCloseRequests",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountCandidateAccountCloseRequestsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccountCloseRequest",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v2,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountCloseRequestId",
                "storageKey": null
              },
              v10,
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountId",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": v11,
                "storageKey": null
              },
              v8,
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountId",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": v11,
                "storageKey": null
              },
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ipAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userAgent",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      v9
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateAccountCloseContainerQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountClose_candidate"
            },
            v9
          ],
          "storageKey": null
        },
        v12
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateAccountCloseContainerQuery",
      "selections": [
        {
          "alias": "candidate",
          "args": v1,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v10,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileThumbNailImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileImageS3Path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTestUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSuspended",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAnonymised",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anonymisedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEmailVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountApproved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountActivated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSignUpComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAgreedToTerms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGdprConsented",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidatePhoneVerification",
              "kind": "LinkedField",
              "name": "phone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryPrefix",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneVerificationStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        v12
      ]
    },
    "params": {
      "cacheID": "f8e4d1b268e05b8e46a96a5d6e8bdb8c",
      "id": null,
      "metadata": {},
      "name": "CandidateAccountCloseContainerQuery",
      "operationKind": "query",
      "text": "query CandidateAccountCloseContainerQuery(\n  $candidateCode: Long!\n  $where: AccountsCandidateAccountCloseRequestFilter!\n) {\n  candidate: accountCandidateAccountByCode(code: $candidateCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    email\n    updatedAt\n    ...CandidateAccountClose_candidate\n  }\n  queue: accountCandidateAccountCloseRequests(where: $where, order: {createdAt: DESC}) {\n    edges {\n      node {\n        id\n        accountCloseRequestId\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        code\n        status\n        ipAddress\n        userAgent\n      }\n    }\n  }\n}\n\nfragment CandidateAccountClose_candidate on AccountsCandidateAccount {\n  id\n  accountId\n  code\n  createdAt\n  updatedAt\n  firstName\n  lastName\n  email\n  profileImageUrl\n  profileThumbNailImageUrl\n  profileImageS3Path\n  isTestUser\n  isSuspended\n  isAnonymised\n  anonymisedOn\n  isEmailVerified\n  isAccountApproved\n  isAccountActivated\n  isSignUpComplete\n  hasAgreedToTerms\n  isGdprConsented\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n}\n"
    }
  };
}();
node92.hash = "4b222ff67ed4dfec63243de60fbafeca";
var CandidateAccountCloseContainerQuery_graphql_default = node92;

// src/secure/accounts/candidates/components/CandidateAccountCloseContainer.tsx
import { useMemo as useMemo7 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery13 } from "react-relay";
import { Suspense as Suspense60 } from "shared-ui";
import { EdSkeleton as EdSkeleton41 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateAccountClose_candidate.graphql.ts
var node93 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAccountClose_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileThumbNailImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageS3Path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuspended",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anonymisedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSignUpComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node93.hash = "fe16f0a95df0a643b1ce8bce07c4d647";
var CandidateAccountClose_candidate_graphql_default = node93;

// src/secure/accounts/candidates/components/CandidateAccountClose.tsx
import { useCallback as useCallback35 } from "react";
import { useFragment as useFragment6 } from "react-relay";
import { useNavigate as useNavigate16 } from "react-router-dom";
import { Suspense as Suspense59 } from "shared-ui";
import { createClientMutationId as createClientMutationId17, timeAgo as timeAgo13 } from "shared-lib";
import { Button as Button27, EdSkeleton as EdSkeleton40, Size as Size12 } from "shared-ui";
import { Fragment as Fragment33, jsx as jsx83, jsxs as jsxs75 } from "react/jsx-runtime";
var fragmentDef9 = CandidateAccountClose_candidate_graphql_default;
var CandidateAccountClose = ({
  fragmentRef,
  pendingRequests,
  onCancelled
}) => {
  let pendingRequest = null;
  if (pendingRequests.length > 0) {
    pendingRequest = pendingRequests[0];
  }
  const navigate = useNavigate16();
  const data = useFragment6(
    fragmentDef9,
    fragmentRef
  );
  const [close, isClosing] = useCandidateAccountCloseSchedule();
  const [cancel, isCancelling] = useCandidateAccountCloseCancel();
  const onClose = useCallback35(async () => {
    const input = {
      candidateId: data.accountId,
      clientMutationId: createClientMutationId17(),
      reason: ""
    };
    const response = await close({ input });
    if (response.data.payload) {
      navigate(0);
    }
  }, [close]);
  const onCancel = useCallback35(async () => {
    if (!pendingRequest) {
      return;
    }
    const input = {
      id: pendingRequest.accountCloseRequestId,
      clientMutationId: createClientMutationId17()
    };
    const response = await cancel({ input });
    if (response.data.payload) {
      navigate(0);
    }
  }, [cancel]);
  if (data === null) {
    return /* @__PURE__ */ jsx83(EdSkeleton40, {});
  }
  if (data.isAnonymised && data.anonymisedOn) {
    return /* @__PURE__ */ jsx83("div", { className: "flex", children: /* @__PURE__ */ jsx83("div", { className: "border bg-white", children: /* @__PURE__ */ jsxs75("div", { className: "m-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx83("div", { className: "text-primary-500 border-b p-4 text-2xl font-bold", children: "Account Anonymized" }),
      /* @__PURE__ */ jsxs75("div", { className: "text-md p-4 font-medium text-gray-500", children: [
        "Anonymized ",
        timeAgo13(data.anonymisedOn)
      ] })
    ] }) }) });
  }
  let actionContainer = /* @__PURE__ */ jsx83("div", {});
  if (pendingRequest) {
    actionContainer = /* @__PURE__ */ jsxs75(Fragment33, { children: [
      /* @__PURE__ */ jsx83("div", { className: "my-4 flex items-center gap-2 border-b px-2 py-4 text-xl", children: "Request is already Pending" }),
      /* @__PURE__ */ jsx83("div", { className: "flex", children: /* @__PURE__ */ jsx83(
        Button27,
        {
          color: "danger",
          size: Size12.lg,
          clicked: onCancel,
          disabled: isCancelling,
          children: "Cancel Request"
        }
      ) })
    ] });
  } else {
    actionContainer = /* @__PURE__ */ jsxs75(Fragment33, { children: [
      /* @__PURE__ */ jsx83("div", { className: "my-4 flex items-center gap-2 border-b px-2 py-4 text-xl", children: "Request Account Closure, this will take up to 24 hours" }),
      /* @__PURE__ */ jsx83("div", { className: "flex", children: /* @__PURE__ */ jsx83(
        Button27,
        {
          "aria-label": "Request Closure",
          color: "primary",
          size: Size12.lg,
          clicked: onClose,
          disabled: isClosing,
          children: "Request Closure"
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsx83(Suspense59, { fallback: /* @__PURE__ */ jsx83(EdSkeleton40, {}), children: /* @__PURE__ */ jsx83("div", { className: "flex border bg-white p-8 sm:w-1/2", children: /* @__PURE__ */ jsxs75("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs75("div", { className: "text-primary-700 flex items-center gap-2 border-b p-2 font-medium", children: [
      /* @__PURE__ */ jsx83("div", { children: data.firstName }),
      /* @__PURE__ */ jsx83("div", { children: data.lastName })
    ] }),
    actionContainer
  ] }) }) });
};

// src/secure/accounts/candidates/components/CandidateAccountCloseContainer.tsx
import { Fragment as Fragment34, jsx as jsx84 } from "react/jsx-runtime";
var queryDef38 = CandidateAccountCloseContainerQuery_graphql_default;
var CandidateAccountCloseContainer = ({
  candidateId,
  candidateCode
}) => {
  const where2 = {
    accountId: { eq: candidateId },
    status: { eq: "PENDING" }
  };
  const query = useLazyLoadQuery13(
    queryDef38,
    { where: where2, candidateCode },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { candidate, queue } = query;
  const pendingRequests = useMemo7(() => {
    return (queue && queue.edges || []).map((e) => {
      return e.node;
    });
  }, [queue]);
  if (!candidate) {
    return /* @__PURE__ */ jsx84(Fragment34, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx84(Suspense60, { fallback: /* @__PURE__ */ jsx84(EdSkeleton41, {}), children: /* @__PURE__ */ jsx84("div", { children: /* @__PURE__ */ jsx84(
    CandidateAccountClose,
    {
      pendingRequests,
      fragmentRef: candidate
    }
  ) }) });
};

// src/secure/accounts/candidates/components/CandidateClose.tsx
import { Fragment as Fragment35, jsx as jsx85, jsxs as jsxs76 } from "react/jsx-runtime";
var queryDef39 = CandidateCloseRouteQuery_graphql_default;
async function loader32(environment, params) {
  const code = params.candidateCode;
  const candidateCode = parseInt(code);
  return loadQuery32(environment, queryDef39, {
    candidateCode
  });
}
var CandidateClose = ({ routeId: routeId6 }) => {
  const data = useRouteData23(queryDef39, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx85(Fragment35, { children: "Loading..." });
  }
  const { candidate } = data;
  if (!candidate) {
    return /* @__PURE__ */ jsx85(Fragment35, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx85(Suspense61, { fallback: /* @__PURE__ */ jsx85(EdSkeleton42, {}), children: /* @__PURE__ */ jsxs76("div", { className: "p-4", children: [
    /* @__PURE__ */ jsx85(MynPageTitle39, { title: "Close Candidate Account" }),
    /* @__PURE__ */ jsx85(
      CandidateAccountCloseContainer,
      {
        candidateId: candidate.accountId,
        candidateCode: candidate.code
      }
    )
  ] }) });
};
var createRoute20 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-close`;
  return {
    id: routeId6,
    path: "close",
    element: /* @__PURE__ */ jsx85(CandidateClose, { routeId: routeId6, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx85(Link22, { to: "close", children: "Close" })
    },
    loader: ({ params }) => {
      return loader32(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/CandidateSupport.tsx
import { Suspense as Suspense64 } from "react";
import { Link as Link23, Navigate as Navigate20 } from "react-router-dom";
import { EdSkeleton as EdSkeleton45, MynPageTitle as MynPageTitle40 } from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainerQuery.graphql.ts
var node94 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationsListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateSupportConversationsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationsListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
          "kind": "LinkedField",
          "name": "customerServiceCandidateSupportConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateSupportConversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    v4,
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateUnreadCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationEnded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateSupportConversationMessage",
                      "kind": "LinkedField",
                      "name": "messages",
                      "plural": true,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateSupportConversationMessageId",
                          "storageKey": null
                        },
                        v3,
                        v4,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "conversationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "administratorStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateSupportConversationsList_list",
          "kind": "LinkedHandle",
          "name": "customerServiceCandidateSupportConversations"
        }
      ]
    },
    "params": {
      "cacheID": "a4b11a08c1b1562b6b7e830358fa125e",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationsListContainerQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationsListContainerQuery(\n  $where: CandidateSupportConversationFilter!\n) {\n  ...CandidateSupportConversationsListContainer_list\n}\n\nfragment CandidateSupportConversationsListContainer_list on Query {\n  list: customerServiceCandidateSupportConversations(first: 25, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        status\n        candidateUnreadCount\n        conversationEnded\n        messages {\n          id\n          ...ConversationMessageRow_account\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationMessageRow_account on CandidateSupportConversationMessage {\n  id\n  candidateSupportConversationMessageId\n  code\n  updatedAt\n  createdAt\n  conversationId\n  administratorStatus\n  candidateStatus\n}\n"
    }
  };
}();
node94.hash = "89ff67d36a20d337b836ea4986d4a164";
var CandidateSupportConversationsListContainerQuery_graphql_default = node94;

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainerPaginationQuery.graphql.ts
var node95 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "CandidateSupportConversationsListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
          "kind": "LinkedField",
          "name": "customerServiceCandidateSupportConversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateSupportConversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateUnreadCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationEnded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateSupportConversationMessage",
                      "kind": "LinkedField",
                      "name": "messages",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateSupportConversationMessageId",
                          "storageKey": null
                        },
                        v5,
                        v6,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "conversationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "administratorStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CandidateSupportConversationsList_list",
          "kind": "LinkedHandle",
          "name": "customerServiceCandidateSupportConversations"
        }
      ]
    },
    "params": {
      "cacheID": "855c1fba644eef4137439cfdd97a48cf",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: CandidateSupportConversationFilter\n) {\n  ...CandidateSupportConversationsListContainer_list_2HEEH6\n}\n\nfragment CandidateSupportConversationsListContainer_list_2HEEH6 on Query {\n  list: customerServiceCandidateSupportConversations(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        status\n        candidateUnreadCount\n        conversationEnded\n        messages {\n          id\n          ...ConversationMessageRow_account\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationMessageRow_account on CandidateSupportConversationMessage {\n  id\n  candidateSupportConversationMessageId\n  code\n  updatedAt\n  createdAt\n  conversationId\n  administratorStatus\n  candidateStatus\n}\n"
    }
  };
}();
node95.hash = "a327d7744de29e9460b2e490bc30c45b";
var CandidateSupportConversationsListContainerPaginationQuery_graphql_default = node95;

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationsListContainer_list.graphql.ts
var node96 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateSupportConversationsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "CandidateSupportConversationsListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CustomerServiceCandidateSupportConversationsConnection",
        "kind": "LinkedField",
        "name": "__CandidateSupportConversationsList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerServiceCandidateSupportConversationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CandidateSupportConversation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateUnreadCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conversationEnded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateSupportConversationMessage",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ConversationMessageRow_account"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node96.hash = "a327d7744de29e9460b2e490bc30c45b";
var CandidateSupportConversationsListContainer_list_graphql_default = node96;

// src/secure/accounts/candidates/components/CandidateSupportConversationsListContainer.tsx
import { useCallback as useCallback36, useState as useState21 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery14, usePaginationFragment as usePaginationFragment9 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow4, parseISO as parseISO4 } from "date-fns";
import { Suspense as Suspense62 } from "shared-ui";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader5,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement7,
  EdSkeleton as EdSkeleton43,
  Input as Input7,
  ListLayout as ListLayout5
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined8, useDebounce as useDebounce6 } from "shared-lib";
import { jsx as jsx86, jsxs as jsxs77 } from "react/jsx-runtime";
var queryDef40 = CandidateSupportConversationsListContainerQuery_graphql_default;
var fragmentDef10 = CandidateSupportConversationsListContainer_list_graphql_default;
function createLinkTo5(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List6 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment9(fragmentDef10, fragmentRef);
  const onLoadNext = useCallback36(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined8).map((e) => e.node).map((ft) => {
    const name = `${ft.name}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx86("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs77("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx86("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx86("div", { className: "text-md text-blue-700", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs77("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow4(parseISO4(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx86(DefaultListLayoutSectionElement7, { children: /* @__PURE__ */ jsx86("div", { className: "grid", children: /* @__PURE__ */ jsx86("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx86(Suspense62, { fallback: /* @__PURE__ */ jsx86(EdSkeleton43, {}), children: /* @__PURE__ */ jsx86(
    ListLayout5,
    {
      title: "Conversations",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx86(
        DefaultListLayoutItemHeader5,
        {
          title: "Conversations",
          to: createLinkTo5,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var CandidateSupportConversationsListContainer = ({
  candidateId
}) => {
  const [filter, setFilter] = useState21(null);
  const searchTerm = useDebounce6(filter, 500);
  const where2 = {
    candidateAccountId: { eq: candidateId }
  };
  if (searchTerm) {
    where2.or = [{ name: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery14(
    queryDef40,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs77("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx86("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs77("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx86("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx86("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx86(
        Input7,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx86("div", { className: "flex-1", children: /* @__PURE__ */ jsx86(List6, { fragmentRef: query }) })
  ] });
};

// src/secure/accounts/candidates/components/__generated__/CandidateSupportConversationContainerRouteQuery.graphql.ts
var node97 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "conversationCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v4 = [
    {
      "alias": "conversation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "conversationCode"
        }
      ],
      "concreteType": "CandidateSupportConversation",
      "kind": "LinkedField",
      "name": "customerServiceCandidateSupportConversationByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateSupportConversationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        v2,
        v3,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateUnreadCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conversationEnded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CandidateSupportConversationMessage",
          "kind": "LinkedField",
          "name": "messages",
          "plural": true,
          "selections": [
            v1,
            v3,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "administratorStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsUser",
              "kind": "LinkedField",
              "name": "createdByUser",
              "plural": false,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSupportConversationContainerRouteQuery",
      "selections": v4,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSupportConversationContainerRouteQuery",
      "selections": v4
    },
    "params": {
      "cacheID": "f5d5a574ea8c3817be473377c71e449c",
      "id": null,
      "metadata": {},
      "name": "CandidateSupportConversationContainerRouteQuery",
      "operationKind": "query",
      "text": "query CandidateSupportConversationContainerRouteQuery(\n  $conversationCode: Long!\n) {\n  conversation: customerServiceCandidateSupportConversationByCode(code: $conversationCode) {\n    id\n    candidateSupportConversationId\n    code\n    updatedAt\n    createdAt\n    name\n    description\n    status\n    candidateUnreadCount\n    conversationEnded\n    messages {\n      id\n      createdAt\n      updatedAt\n      candidateStatus\n      administratorStatus\n      content\n      createdByUser {\n        id\n        firstName\n        lastName\n        emailAddress\n        accountType\n      }\n    }\n  }\n}\n"
    }
  };
}();
node97.hash = "7970f8c9a9fee285b48ca694c708e8f8";
var CandidateSupportConversationContainerRouteQuery_graphql_default = node97;

// src/secure/accounts/candidates/components/CandidateSupportConversationContainer.tsx
import { Suspense as Suspense63 } from "react";
import { loadQuery as loadQuery33 } from "react-relay";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { timeAgo as timeAgo14, useRouteData as useRouteData24 } from "shared-lib";
import { classNames as classNames10, EdSkeleton as EdSkeleton44 } from "shared-ui";

// src/secure/accounts/candidates/components/CandidateSupportConversationForm.tsx
import { useCallback as useCallback37 } from "react";
import { useForm as useForm6 } from "react-hook-form";
import { z as z4 } from "zod";
import { zodResolver as zodResolver6 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId18 } from "shared-lib";
import {
  ActionContainer as ActionContainer3,
  ErrorField as ErrorField3,
  FormInputRow as FormInputRow3,
  FormTextAreaInput
} from "shared-ui";
import { jsx as jsx87, jsxs as jsxs78 } from "react/jsx-runtime";
var formSchema5 = z4.object({
  message: z4.string().min(1, { message: "Message is required" })
});
var CandidateSupportConversationForm = ({
  conversationId,
  onDone
}) => {
  const [createMessage, isCreatingMessage] = useCandidateSupportConversationAddMessage();
  const { register, handleSubmit, formState } = useForm6({
    mode: "onChange",
    resolver: zodResolver6(formSchema5)
  });
  const { errors, isDirty, isValid } = formState;
  const onSubmit = handleSubmit((data) => onCreateMessage(isValid, data));
  const onCreateMessage = useCallback37(
    async (isValid2, form) => {
      if (!form.message) {
        return;
      }
      const input = {
        conversationId,
        content: form.message,
        clientMutationId: createClientMutationId18()
      };
      const response = await createMessage({ input });
      if (response.data.candidateSupportConversation) {
        onDone();
        return;
      }
    },
    [createMessage, onDone]
  );
  return /* @__PURE__ */ jsx87("form", { onSubmit, children: /* @__PURE__ */ jsx87(
    ActionContainer3,
    {
      isDirty,
      showSubmit: true,
      submitText: "Send Message",
      isSaving: isCreatingMessage,
      isDisabled: !isValid,
      children: /* @__PURE__ */ jsxs78(FormInputRow3, { name: "message", title: "Reply", children: [
        /* @__PURE__ */ jsx87(
          FormTextAreaInput,
          {
            rows: 5,
            register,
            name: "message",
            required: true,
            placeholder: "Add a message"
          }
        ),
        /* @__PURE__ */ jsx87(ErrorField3, { field: errors.message })
      ] })
    }
  ) });
};

// src/secure/accounts/candidates/components/CandidateSupportConversationContainer.tsx
import { Fragment as Fragment36, jsx as jsx88, jsxs as jsxs79 } from "react/jsx-runtime";
var queryDef41 = CandidateSupportConversationContainerRouteQuery_graphql_default;
async function loader33(environment, params) {
  const code = params.conversationCode;
  const conversationCode = parseInt(code);
  try {
    return loadQuery33(
      environment,
      queryDef41,
      {
        conversationCode
      }
    );
  } catch (e) {
    console.error("CandidateSupportConversationContainer Loader Failed.");
    console.error(e);
    throw e;
  }
}
var CandidateSupportConversationContainer = ({ routeId: routeId6, inList }) => {
  const data = useRouteData24(
    queryDef41,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx88(Fragment36, { children: "Loading..." });
  }
  const { conversation } = data;
  if (!conversation) {
    return /* @__PURE__ */ jsx88(Fragment36, { children: "Loading..." });
  }
  const name = `${conversation.name}`;
  const messageRows = conversation.messages.map((message, messageIdx) => {
    const userName = `${message.createdByUser.firstName} ${message.createdByUser.lastName}`;
    return /* @__PURE__ */ jsxs79("li", { className: "relative flex gap-x-4", children: [
      /* @__PURE__ */ jsx88(
        "div",
        {
          className: classNames10(
            messageIdx === conversation.messages.length - 1 ? "h-6" : "-bottom-6",
            "absolute left-0 top-0 flex w-6 justify-center"
          ),
          children: /* @__PURE__ */ jsx88("div", { className: "w-px bg-gray-200" })
        }
      ),
      /* @__PURE__ */ jsx88("div", { className: "relative flex h-6 w-6 flex-none items-center justify-center bg-white", children: message.administratorStatus === "READ" ? /* @__PURE__ */ jsx88(
        CheckCircleIcon,
        {
          className: "h-6 w-6 text-indigo-600",
          "aria-hidden": "true"
        }
      ) : /* @__PURE__ */ jsx88("div", { className: "h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" }) }),
      /* @__PURE__ */ jsxs79("div", { className: "flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200", children: [
        /* @__PURE__ */ jsxs79("div", { className: "flex justify-between gap-x-4", children: [
          /* @__PURE__ */ jsx88("div", { className: "py-0.5 text-xs leading-5 text-gray-500", children: /* @__PURE__ */ jsx88("span", { className: "font-medium text-gray-900", children: userName }) }),
          /* @__PURE__ */ jsx88(
            "time",
            {
              dateTime: message.updatedAt,
              className: "flex-none py-0.5 text-xs leading-5 text-gray-500",
              children: timeAgo14(message.updatedAt)
            }
          )
        ] }),
        /* @__PURE__ */ jsx88("p", { className: "text-sm leading-6 text-gray-500", children: message.content })
      ] })
    ] }, message.id);
  });
  return /* @__PURE__ */ jsx88(Suspense63, { fallback: /* @__PURE__ */ jsx88(EdSkeleton44, {}), children: /* @__PURE__ */ jsxs79("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs79("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx88("div", { className: "text-primary-500 px-4 text-lg font-medium", children: name }),
      /* @__PURE__ */ jsxs79("div", { className: "text-primary-500 text-md px-4", children: [
        "Updated ",
        timeAgo14(conversation.updatedAt)
      ] })
    ] }),
    /* @__PURE__ */ jsx88("ul", { role: "list", className: "space-y-6", children: messageRows }),
    /* @__PURE__ */ jsx88("div", { className: "mt-2", children: /* @__PURE__ */ jsx88(
      CandidateSupportConversationForm,
      {
        conversationId: conversation.candidateSupportConversationId,
        onDone: () => {
        }
      }
    ) })
  ] }) });
};
var createRoute21 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-conversation`;
  return {
    id: routeId6,
    path: ":conversationCode",
    element: /* @__PURE__ */ jsx88(
      CandidateSupportConversationContainer,
      {
        routeId: routeId6,
        inList
      }
    ),
    loader: ({ params }) => {
      return loader33(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/CandidateSupport.tsx
import { OutletRoute as OutletRoute14 } from "app-core";
import { Fragment as Fragment37, jsx as jsx89, jsxs as jsxs80 } from "react/jsx-runtime";
var ConversationsList = ({ layoutRouteId }) => {
  const layoutData = useCandidateLayoutRouteData(layoutRouteId);
  const { candidate } = layoutData;
  if (!candidate) {
    return /* @__PURE__ */ jsx89(Fragment37, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx89(Suspense64, { fallback: /* @__PURE__ */ jsx89(EdSkeleton45, {}), children: /* @__PURE__ */ jsxs80("div", { className: "border bg-white p-2", children: [
    /* @__PURE__ */ jsx89(MynPageTitle40, { title: "Candidate Support" }),
    /* @__PURE__ */ jsx89(
      CandidateSupportConversationsListContainer,
      {
        candidateId: candidate.accountId
      }
    )
  ] }) });
};
var createRoute22 = (routePrefix, environment, context, inList = true, layoutRouteId) => {
  const routeId6 = `${routePrefix}-support`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "support",
    element: /* @__PURE__ */ jsx89(OutletRoute14, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx89(Link23, { to: "support", children: "Support" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx89(
          ConversationsList,
          {
            routeId: listRouteId,
            inList,
            layoutRouteId
          }
        ),
        children: [
          createRoute21(listRouteId, environment, context, inList)
        ]
      },
      createRoute21(routeId6, environment, context, inList),
      {
        path: "*",
        element: /* @__PURE__ */ jsx89(Navigate20, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/accounts/candidates/components/EmailNotifications.tsx
import { Suspense as Suspense67 } from "react";
import { Link as Link24, Navigate as Navigate21 } from "react-router-dom";
import { EdSkeleton as EdSkeleton48, MynPageTitle as MynPageTitle41 } from "shared-ui";
import { OutletRoute as OutletRoute15 } from "app-core";

// src/secure/accounts/candidates/components/__generated__/EmailNotificationContainerRouteQuery.graphql.ts
var node98 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "notificationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "notificationCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailNotificationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenant",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromEmail",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toEmail",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsEmailNotificationData",
    "kind": "LinkedField",
    "name": "emailNotificationData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dotnetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsReceiver",
    "kind": "LinkedField",
    "name": "receiver",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "receiverType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsNotificationAttribute",
    "kind": "LinkedField",
    "name": "attributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "providerType",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasSent",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasDelivered",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasOpened",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasClicked",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasHardBounced",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasSoftBounced",
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "wasMarkedAsSpam",
    "storageKey": null
  }, v23 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationContainerRouteQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                v14,
                v4,
                v5,
                v15,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationsEmailContainer_email"
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationContainerRouteQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                v14,
                v4,
                v5,
                v15,
                v16,
                v17,
                v18,
                v19,
                v20,
                v21,
                v22,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailEvent",
                  "kind": "LinkedField",
                  "name": "emailEvents",
                  "plural": true,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailEventId",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "occuredAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "517660e63134b346ffb23573aee19c8a",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationContainerRouteQuery",
      "operationKind": "query",
      "text": "query EmailNotificationContainerRouteQuery(\n  $notificationCode: Long!\n) {\n  notification: notificationsEmailNotificationByCode(code: $notificationCode) {\n    id\n    emailNotificationId\n    code\n    createdAt\n    tenant\n    fromEmail\n    fromName\n    toEmail\n    toName\n    emailNotificationData {\n      dotnetType\n      data\n    }\n    receiver {\n      id\n      receiverType\n    }\n    attributes {\n      type\n      value\n    }\n    emails {\n      id\n      emailId\n      code\n      createdAt\n      providerType\n      wasSent\n      wasDelivered\n      wasOpened\n      wasClicked\n      wasHardBounced\n      wasSoftBounced\n      wasMarkedAsSpam\n      ...NotificationsEmailContainer_email\n    }\n  }\n}\n\nfragment NotificationsEmailContainer_email on NotificationsEmail {\n  id\n  emailId\n  code\n  createdAt\n  providerType\n  wasSent\n  wasDelivered\n  wasOpened\n  wasClicked\n  wasHardBounced\n  wasSoftBounced\n  wasMarkedAsSpam\n  emailEvents {\n    id\n    emailEventId\n    createdAt\n    occuredAt\n    eventType\n  }\n}\n"
    }
  };
}();
node98.hash = "078baf3ed6f00c10d7d9cc337b7c1859";
var EmailNotificationContainerRouteQuery_graphql_default = node98;

// src/secure/accounts/candidates/components/EmailNotificationContainer.tsx
import { useCallback as useCallback38, useState as useState22 } from "react";
import { loadQuery as loadQuery34 } from "react-relay";
import { timeAgo as timeAgo16, useRouteData as useRouteData25 } from "shared-lib";
import {
  BooleanIcon as BooleanIcon2,
  Button as Button28,
  EdSkeleton as EdSkeleton46,
  LinkButton,
  Suspense as Suspense65
} from "shared-ui";

// src/secure/accounts/candidates/components/__generated__/NotificationsEmailContainer_email.graphql.ts
var node99 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsEmailContainer_email",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasDelivered",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasOpened",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasClicked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasHardBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSoftBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasMarkedAsSpam",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationsEmailEvent",
        "kind": "LinkedField",
        "name": "emailEvents",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailEventId",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occuredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "NotificationsEmail",
    "abstractKey": null
  };
}();
node99.hash = "1380d7124dcc6f1cb223ade1a3698d4e";
var NotificationsEmailContainer_email_graphql_default = node99;

// src/secure/accounts/candidates/components/NotificationsEmailContainer.tsx
import { useFragment as useFragment7 } from "react-relay";
import { classNames as classNames11 } from "shared-ui";
import { timeAgo as timeAgo15 } from "shared-lib";
import { jsx as jsx90, jsxs as jsxs81 } from "react/jsx-runtime";
var fragmentDef11 = NotificationsEmailContainer_email_graphql_default;
var NotificationsEmailContainer = ({ fragmentRef }) => {
  const data = useFragment7(fragmentDef11, fragmentRef);
  const eventRows = data.emailEvents.map((e) => {
    return /* @__PURE__ */ jsx90(
      "li",
      {
        className: classNames11(
          "focus-within:ring-info-600 relative cursor-pointer rounded-lg border px-6 py-5 focus-within:ring-2 focus-within:ring-inset hover:bg-gray-50"
        ),
        children: /* @__PURE__ */ jsxs81("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx90("div", { className: "text-md text-gray-500", children: timeAgo15(e.occuredAt) }),
          /* @__PURE__ */ jsx90("div", { className: "text-md text-gray-500", children: e.eventType })
        ] })
      },
      e.id
    );
  });
  return /* @__PURE__ */ jsxs81("div", { className: "flex flex-col gap-2 border p-4", children: [
    /* @__PURE__ */ jsxs81("div", { className: "flex items-center gap-2 border-b p-2", children: [
      /* @__PURE__ */ jsx90("div", { className: "text-primary-500 text-lg font-bold", children: "Email" }),
      /* @__PURE__ */ jsx90("div", { className: "text-md text-primary-500", children: timeAgo15(data.createdAt) })
    ] }),
    /* @__PURE__ */ jsx90("div", { className: "p-2", children: /* @__PURE__ */ jsx90("div", { className: "text-primary-700 text-sm font-bold", children: "Events" }) }),
    /* @__PURE__ */ jsx90("ul", { className: "mt-2 flex flex-col gap-2", children: eventRows })
  ] });
};

// src/secure/accounts/candidates/components/EmailNotificationContainer.tsx
import { Fragment as Fragment38, jsx as jsx91, jsxs as jsxs82 } from "react/jsx-runtime";
var queryDef42 = EmailNotificationContainerRouteQuery_graphql_default;
async function loader34(environment, params) {
  const code = params.notificationCode;
  const notificationCode = parseInt(code);
  try {
    return loadQuery34(
      environment,
      queryDef42,
      {
        notificationCode
      }
    );
  } catch (e) {
    console.error("EmailNotificationContainer Loader Failed.");
    console.error(e);
    throw e;
  }
}
var EmailNotificationContainer = ({ routeId: routeId6 }) => {
  const [selectedId, setSelectedId] = useState22(null);
  const clearSelected = useCallback38(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const data = useRouteData25(
    queryDef42,
    routeId6
  );
  if (!data) {
    return /* @__PURE__ */ jsx91(Fragment38, { children: "Loading..." });
  }
  const { notification } = data;
  if (!notification) {
    return /* @__PURE__ */ jsx91(Fragment38, { children: "Loading..." });
  }
  const emails = notification.emails || [];
  const emailRows = emails.map((item) => {
    return /* @__PURE__ */ jsxs82("tr", { children: [
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91("div", { className: "text-gray-900", children: timeAgo16(item.createdAt) }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91("div", { className: "text-gray-900", children: item.providerType }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasClicked }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasDelivered }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasHardBounced }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasMarkedAsSpam }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasOpened }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasSent }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap px-3 py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(BooleanIcon2, { value: item.wasSoftBounced }) }),
      /* @__PURE__ */ jsx91("td", { className: "whitespace-nowrap py-5 text-sm text-gray-500", children: /* @__PURE__ */ jsx91(
        LinkButton,
        {
          label: "Select",
          clicked: () => setSelectedId(item.emailId)
        }
      ) })
    ] }, item.id);
  });
  let displaySelected = null;
  if (selectedId) {
    const selected = emails.find((e) => e.emailId === selectedId);
    if (selected) {
      displaySelected = /* @__PURE__ */ jsx91(NotificationsEmailContainer, { fragmentRef: selected });
    }
  }
  return /* @__PURE__ */ jsx91(Suspense65, { fallback: /* @__PURE__ */ jsx91(EdSkeleton46, {}), children: /* @__PURE__ */ jsx91("div", { className: "flex", children: /* @__PURE__ */ jsxs82("div", { className: "flex flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs82("div", { className: "my-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx91("div", { className: "text-primary-700 px-1 text-xl font-bold", children: "Notification" }),
      /* @__PURE__ */ jsxs82("div", { className: "text-primary-700 px-1 text-sm", children: [
        "Created ",
        timeAgo16(notification.createdAt)
      ] })
    ] }),
    displaySelected && /* @__PURE__ */ jsxs82("div", { className: "flex flex-col gap-2", children: [
      displaySelected,
      /* @__PURE__ */ jsx91("div", { className: "border bg-gray-50 px-4 py-2", children: /* @__PURE__ */ jsx91(Button28, { clicked: clearSelected, children: "Close" }) })
    ] }),
    /* @__PURE__ */ jsx91("div", { className: "mt-8 flow-root", children: /* @__PURE__ */ jsx91("div", { className: "-mx-4 -my-2 sm:-mx-6 lg:-mx-8", children: /* @__PURE__ */ jsx91("div", { className: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8", children: /* @__PURE__ */ jsxs82("table", { className: "min-w-full divide-y divide-gray-300 border", children: [
      /* @__PURE__ */ jsx91("thead", { children: /* @__PURE__ */ jsxs82("tr", { children: [
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Created"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Provider"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Clicked"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Delivered"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Hard Bounced"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Marked As Spam"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Opened"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Sent"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Soft Bounced"
          }
        ),
        /* @__PURE__ */ jsx91(
          "th",
          {
            scope: "col",
            className: "bg-gray-100 px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
            children: "Select"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx91("tbody", { className: "divide-y divide-gray-200 bg-white", children: emailRows })
    ] }) }) }) }),
    /* @__PURE__ */ jsxs82("div", { className: "mt-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx91("div", { className: "text-primary-700 px-1 text-sm font-bold", children: "Data" }),
      /* @__PURE__ */ jsx91("div", { className: "break-all border bg-yellow-50 p-4", children: /* @__PURE__ */ jsx91("p", { children: JSON.stringify(notification.emailNotificationData, null, 2) }) })
    ] })
  ] }) }) });
};
var createRoute23 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-email-notification`;
  return {
    id: routeId6,
    path: ":notificationCode",
    element: /* @__PURE__ */ jsx91(EmailNotificationContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader34(environment, params);
    }
  };
};

// src/secure/accounts/candidates/components/__generated__/EmailNotificationListContainerQuery.graphql.ts
var node100 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailNotificationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "NotificationsEmailNotificationsConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotifications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailNotification",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsEmailNotificationData",
                      "kind": "LinkedField",
                      "name": "emailNotificationData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "data",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "dotnetType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsReceiver",
                      "kind": "LinkedField",
                      "name": "receiver",
                      "plural": false,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "receiverType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsNotificationAttribute",
                      "kind": "LinkedField",
                      "name": "attributes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailNotificationListContainer_list",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotifications"
        }
      ]
    },
    "params": {
      "cacheID": "22819e9b0957480f8a02c501d5be1147",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationListContainerQuery",
      "operationKind": "query",
      "text": "query EmailNotificationListContainerQuery(\n  $where: NotificationsEmailNotificationFilter!\n) {\n  ...EmailNotificationListContainer_list\n}\n\nfragment EmailNotificationListContainer_list on Query {\n  list: notificationsEmailNotifications(first: 25, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationId\n        code\n        createdAt\n        tenant\n        fromEmail\n        fromName\n        toEmail\n        toName\n        emailNotificationData {\n          data\n          dotnetType\n        }\n        receiver {\n          id\n          receiverType\n        }\n        attributes {\n          type\n          value\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node100.hash = "ce499da0571872b70b00430112bc69e5";
var EmailNotificationListContainerQuery_graphql_default = node100;

// src/secure/accounts/candidates/components/__generated__/EmailNotificationsListContainerPaginationQuery.graphql.ts
var node101 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EmailNotificationListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "NotificationsEmailNotificationsConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotifications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailNotification",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fromName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "toName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsEmailNotificationData",
                      "kind": "LinkedField",
                      "name": "emailNotificationData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "data",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "dotnetType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsReceiver",
                      "kind": "LinkedField",
                      "name": "receiver",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "receiverType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NotificationsNotificationAttribute",
                      "kind": "LinkedField",
                      "name": "attributes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailNotificationListContainer_list",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotifications"
        }
      ]
    },
    "params": {
      "cacheID": "3663cbf35c06ba331cac84ca323c1fcd",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query EmailNotificationsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: NotificationsEmailNotificationFilter\n) {\n  ...EmailNotificationListContainer_list_2HEEH6\n}\n\nfragment EmailNotificationListContainer_list_2HEEH6 on Query {\n  list: notificationsEmailNotifications(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationId\n        code\n        createdAt\n        tenant\n        fromEmail\n        fromName\n        toEmail\n        toName\n        emailNotificationData {\n          data\n          dotnetType\n        }\n        receiver {\n          id\n          receiverType\n        }\n        attributes {\n          type\n          value\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node101.hash = "df313a5c907500e87095f1a3b95ec60b";
var EmailNotificationsListContainerPaginationQuery_graphql_default = node101;

// src/secure/accounts/candidates/components/__generated__/EmailNotificationListContainer_list.graphql.ts
var node102 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmailNotificationsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "EmailNotificationListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "NotificationsEmailNotificationsConnection",
        "kind": "LinkedField",
        "name": "__EmailNotificationListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationsEmailNotificationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationsEmailNotification",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailNotificationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tenant",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "toEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "toName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsEmailNotificationData",
                    "kind": "LinkedField",
                    "name": "emailNotificationData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dotnetType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsReceiver",
                    "kind": "LinkedField",
                    "name": "receiver",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "receiverType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationsNotificationAttribute",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node102.hash = "df313a5c907500e87095f1a3b95ec60b";
var EmailNotificationListContainer_list_graphql_default = node102;

// src/secure/accounts/candidates/components/EmailNotificationListContainer.tsx
import { useCallback as useCallback39, useState as useState23 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery15, usePaginationFragment as usePaginationFragment10 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow5, parseISO as parseISO5 } from "date-fns";
import { Suspense as Suspense66 } from "shared-ui";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader6,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement8,
  EdSkeleton as EdSkeleton47,
  Input as Input8,
  ListLayout as ListLayout6
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined9, useDebounce as useDebounce7 } from "shared-lib";
import { jsx as jsx92, jsxs as jsxs83 } from "react/jsx-runtime";
var queryDef43 = EmailNotificationListContainerQuery_graphql_default;
var fragmentDef12 = EmailNotificationListContainer_list_graphql_default;
function createLinkTo6(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List7 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment10(fragmentDef12, fragmentRef);
  const onLoadNext = useCallback39(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined9).map((notification) => {
    const name = `${notification.toEmail}`;
    return {
      key: notification.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx92("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs83("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx92("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx92("div", { className: "text-md text-blue-700", children: notification.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs83("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow5(parseISO5(notification.createdAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: notification.code
      },
      element: /* @__PURE__ */ jsx92(DefaultListLayoutSectionElement8, { children: /* @__PURE__ */ jsx92("div", { className: "grid", children: /* @__PURE__ */ jsx92("div", { children: notification.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx92(Suspense66, { fallback: /* @__PURE__ */ jsx92(EdSkeleton47, {}), children: /* @__PURE__ */ jsx92(
    ListLayout6,
    {
      title: "Notifications",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx92(
        DefaultListLayoutItemHeader6,
        {
          title: "Notifications",
          to: createLinkTo6,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var EmailNotificationsListContainer = ({ candidateId }) => {
  const [filter, setFilter] = useState23(null);
  const searchTerm = useDebounce7(filter, 500);
  const where2 = {
    receiver: {
      id: { eq: candidateId }
    }
  };
  if (searchTerm) {
    where2.or = [{ toEmail: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery15(
    queryDef43,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs83("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx92("div", { className: "flex items-center justify-between space-x-4 border-b", children: /* @__PURE__ */ jsxs83("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx92("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx92("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx92(
        Input8,
        {
          placeholder: " Name ",
          name: "filter",
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx92("div", { className: "flex-1", children: /* @__PURE__ */ jsx92(List7, { fragmentRef: query }) })
  ] });
};

// src/secure/accounts/candidates/components/EmailNotifications.tsx
import { Fragment as Fragment39, jsx as jsx93, jsxs as jsxs84 } from "react/jsx-runtime";
var EmailNotificationsList = ({ layoutRouteId }) => {
  const layoutData = useCandidateLayoutRouteData(layoutRouteId);
  const { candidate } = layoutData;
  if (!candidate) {
    return /* @__PURE__ */ jsx93(Fragment39, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx93(Suspense67, { fallback: /* @__PURE__ */ jsx93(EdSkeleton48, {}), children: /* @__PURE__ */ jsxs84("div", { className: "border bg-white p-2", children: [
    /* @__PURE__ */ jsx93(MynPageTitle41, { title: "Candidate Notification" }),
    /* @__PURE__ */ jsx93(EmailNotificationsListContainer, { candidateId: candidate.accountId })
  ] }) });
};
var createRoute24 = (routePrefix, environment, context, inList = true, layoutRouteId) => {
  const routeId6 = `${routePrefix}-email-notifications`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "notifications",
    element: /* @__PURE__ */ jsx93(OutletRoute15, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx93(Link24, { to: "notifications", children: "Notifications" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx93(
          EmailNotificationsList,
          {
            routeId: listRouteId,
            inList,
            layoutRouteId
          }
        ),
        children: [
          createRoute23(listRouteId, environment, context, inList)
        ]
      },
      createRoute23(routeId6, environment, context, inList),
      {
        path: "*",
        element: /* @__PURE__ */ jsx93(Navigate21, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/accounts/candidates/components/CandidateRoute.tsx
import { jsx as jsx94 } from "react/jsx-runtime";
var createCandidateRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const layoutRouteId = `${routePrefix}-candidate-layout`;
  return [
    {
      path: "*",
      id: layoutRouteId,
      element: /* @__PURE__ */ jsx94(CandidateLayout, { inList, showHeader }),
      errorElement: /* @__PURE__ */ jsx94(ErrorContainer9, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx94(CandidateLink, { routeId: layoutRouteId })
      },
      loader: ({ params }) => {
        return loader29(environment, params);
      },
      children: [
        createRoute18(routePrefix, environment, context, inList),
        createRoute19(routePrefix, environment, context, inList),
        createRoute20(routePrefix, environment, context, inList),
        createRoute22(routePrefix, environment, context, inList, layoutRouteId),
        createRoute24(
          routePrefix,
          environment,
          context,
          inList,
          layoutRouteId
        ),
        createCandidateImpersonateRoute(routePrefix, environment, context),
        {
          path: "*",
          element: /* @__PURE__ */ jsx94(Navigate22, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/candidates/components/CandidatesRoute.tsx
import { jsx as jsx95, jsxs as jsxs85 } from "react/jsx-runtime";
var Layout8 = () => {
  return /* @__PURE__ */ jsx95(Suspense68, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx95(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsxs85("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx95("div", { className: "flex items-center justify-between border-b bg-white px-4 py-2", children: /* @__PURE__ */ jsxs85("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx95(EdLink4, { href: "../../", name: "List Candidates", children: /* @__PURE__ */ jsx95(Button29, { color: "primary", children: "Back" }) }),
      /* @__PURE__ */ jsx95(MynPageTitle42, { title: "Candidates" }),
      /* @__PURE__ */ jsx95(PageHeading3, { children: "Candidates" })
    ] }) }),
    /* @__PURE__ */ jsx95("div", { children: /* @__PURE__ */ jsx95(Outlet15, {}) })
  ] }) }) });
};
var ListRoute = () => {
  return /* @__PURE__ */ jsx95(Suspense68, { fallback: "Loading Candidates...", children: /* @__PURE__ */ jsx95(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsx95(CandidateAccountsListContainer, {}) }) });
};
var createCandidatesRoute = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-candidates`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx95(Layout8, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx95(ListRoute, {}),
          children: [
            {
              id: `${listRouteId}-candidate`,
              path: ":candidateCode/*",
              element: /* @__PURE__ */ jsx95(OutletRoute16, {}),
              children: createCandidateRoutes(
                `${listRouteId}-candidate`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routeId6}-candidate`,
          path: ":candidateCode/*",
          element: /* @__PURE__ */ jsx95(OutletRoute16, {}),
          children: createCandidateRoutes(
            `${routePrefix}-candidate`,
            environment,
            context,
            true,
            false
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx95(Navigate23, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/accounts/profiles/components/ProfileRoute.tsx
import { Navigate as Navigate24 } from "react-router-dom";

// src/secure/accounts/profiles/components/ProfilesLayout.tsx
import { Suspense as Suspense69 } from "react";
import { Outlet as Outlet16 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary8 } from "react-error-boundary";
import { Button as Button30, EdLink as EdLink5, PageHeading as PageHeading4 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback8 } from "app-core";
import { jsx as jsx96, jsxs as jsxs86 } from "react/jsx-runtime";
var ProfilesLayout = () => {
  return /* @__PURE__ */ jsx96(Suspense69, { fallback: "Loading Candidates...", children: /* @__PURE__ */ jsx96(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback8, children: /* @__PURE__ */ jsxs86("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx96("div", { className: "flex items-center justify-between border-b bg-white px-4 py-2", children: /* @__PURE__ */ jsxs86("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx96(EdLink5, { href: "../..", name: "List Candidates", children: /* @__PURE__ */ jsx96(Button30, { color: "primary", children: "Back" }) }),
      /* @__PURE__ */ jsx96(PageHeading4, { children: "Profiles" })
    ] }) }),
    /* @__PURE__ */ jsx96("div", { children: /* @__PURE__ */ jsx96(Outlet16, {}) })
  ] }) }) });
};

// src/secure/accounts/profiles/components/__generated__/ProfileListContainerQuery.graphql.ts
var node103 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileListContainerQuery",
      "selections": [
        {
          "args": v2,
          "kind": "FragmentSpread",
          "name": "ProfileList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ProfileListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfilesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    v4,
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationLatitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationLongitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationRadius",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v7,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "latitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "longitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "radius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "countryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "entireCountry",
                              "storageKey": null
                            },
                            v8
                          ],
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNote",
                      "kind": "LinkedField",
                      "name": "notes",
                      "plural": true,
                      "selections": [
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNoteTag",
                          "kind": "LinkedField",
                          "name": "tags",
                          "plural": true,
                          "selections": [
                            v7,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "value",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsUser",
                          "kind": "LinkedField",
                          "name": "createdByUser",
                          "plural": false,
                          "selections": [
                            v6,
                            v4,
                            v5
                          ],
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "account",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneVerificationStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneNumber",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneCountryPrefix",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v9,
                        v11,
                        v12,
                        v13,
                        v14,
                        v15,
                        v16,
                        v17,
                        v18,
                        v19,
                        v20,
                        v21,
                        v22,
                        v23,
                        v24,
                        v25,
                        v26,
                        v27
                      ],
                      "storageKey": null
                    },
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v12,
                        v13,
                        v14,
                        v15,
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        v8,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RightToWork",
                      "kind": "LinkedField",
                      "name": "rightToWork",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v9,
                            v11,
                            v12,
                            v22,
                            v21,
                            v13,
                            v23,
                            v14,
                            v15,
                            v25,
                            v16,
                            v17,
                            v18,
                            v19,
                            v20,
                            v24,
                            v26,
                            v27
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skillId",
                              "storageKey": null
                            },
                            v7,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v14,
                                v15
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v10,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "ProfileList_list",
          "kind": "LinkedHandle",
          "name": "recruitProfiles"
        }
      ]
    },
    "params": {
      "cacheID": "d46a5e1363375db0667c2ca4ea78121b",
      "id": null,
      "metadata": {},
      "name": "ProfileListContainerQuery",
      "operationKind": "query",
      "text": "query ProfileListContainerQuery(\n  $where: RecruitProfileFilter\n  $order: [RecruitProfileSort!]\n) {\n  ...ProfileList_list_71Jmb\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileList_list_71Jmb on Query {\n  list: recruitProfiles(first: 25, where: $where, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        ...Profile_profile\n        id\n        recruitProfileId\n        firstName\n        lastName\n        code\n        updatedAt\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  workLocations {\n    currentLocationName\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      name\n      latitude\n      longitude\n      radius\n      countryName\n      entireCountry\n      countryCode\n    }\n    id\n  }\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n  ...CandidateApplicationProfile_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  createdAt\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node103.hash = "5da4df41ef43b2e221d0b5c1a34f8e54";
var ProfileListContainerQuery_graphql_default = node103;

// src/secure/accounts/profiles/components/__generated__/RecruitProfilesPaginationQuery.graphql.ts
var node104 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedOn": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": {},
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RecruitProfilesPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "ProfileList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RecruitProfilesPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfilesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationLatitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationLongitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationRadius",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "latitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "longitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "radius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "countryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "entireCountry",
                              "storageKey": null
                            },
                            v7
                          ],
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNote",
                      "kind": "LinkedField",
                      "name": "notes",
                      "plural": true,
                      "selections": [
                        v2,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNoteTag",
                          "kind": "LinkedField",
                          "name": "tags",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "value",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v9,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsUser",
                          "kind": "LinkedField",
                          "name": "createdByUser",
                          "plural": false,
                          "selections": [
                            v5,
                            v3,
                            v4
                          ],
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "account",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneVerificationStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneNumber",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "phoneCountryPrefix",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v8,
                        v10,
                        v11,
                        v12,
                        v13,
                        v14,
                        v15,
                        v16,
                        v17,
                        v18,
                        v19,
                        v20,
                        v21,
                        v22,
                        v23,
                        v24,
                        v25,
                        v26
                      ],
                      "storageKey": null
                    },
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        v14,
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RightToWork",
                      "kind": "LinkedField",
                      "name": "rightToWork",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        },
                        v8
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v8,
                            v10,
                            v11,
                            v21,
                            v20,
                            v12,
                            v22,
                            v13,
                            v14,
                            v24,
                            v15,
                            v16,
                            v17,
                            v18,
                            v19,
                            v23,
                            v25,
                            v26
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skillId",
                              "storageKey": null
                            },
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v13,
                                v14
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "where",
            "order"
          ],
          "handle": "connection",
          "key": "ProfileList_list",
          "kind": "LinkedHandle",
          "name": "recruitProfiles"
        }
      ]
    },
    "params": {
      "cacheID": "06257c95be749ea5db5125d139778f2f",
      "id": null,
      "metadata": {},
      "name": "RecruitProfilesPaginationQuery",
      "operationKind": "query",
      "text": "query RecruitProfilesPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $order: [RecruitProfileSort!] = {updatedOn: DESC}\n  $where: RecruitProfileFilter = {}\n) {\n  ...ProfileList_list_cnSAE\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileList_list_cnSAE on Query {\n  list: recruitProfiles(first: $first, after: $after, where: $where, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        ...Profile_profile\n        id\n        recruitProfileId\n        firstName\n        lastName\n        code\n        updatedAt\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  workLocations {\n    currentLocationName\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      name\n      latitude\n      longitude\n      radius\n      countryName\n      entireCountry\n      countryCode\n    }\n    id\n  }\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n  ...CandidateApplicationProfile_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  createdAt\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node104.hash = "a82a4f3977c0da92cc043319f1c4586a";
var RecruitProfilesPaginationQuery_graphql_default = node104;

// src/secure/accounts/profiles/components/__generated__/ProfileList_list.graphql.ts
var node105 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedOn": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "defaultValue": {},
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RecruitProfilesPaginationQuery_graphql_default
      }
    },
    "name": "ProfileList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitProfilesConnection",
        "kind": "LinkedField",
        "name": "__ProfileList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfilesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfile",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Profile_profile"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitProfileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node105.hash = "a82a4f3977c0da92cc043319f1c4586a";
var ProfileList_list_graphql_default = node105;

// src/secure/accounts/profiles/components/ProfileList.tsx
import { useCallback as useCallback40, useState as useState24, useTransition } from "react";
import { useLazyLoadQuery as useLazyLoadQuery16, usePaginationFragment as usePaginationFragment11 } from "react-relay";
import {
  DebouncedInput as DebouncedInput3,
  Suspense as Suspense70,
  SortDir,
  Spinner as Spinner5,
  Tabs as Tabs3,
  ScrollArea as ScrollArea2,
  classNames as classNames12,
  MynPageTitle as MynPageTitle43
} from "shared-ui";
import { ProfileConnectionComponent, SortDirectionList } from "feature-recruit";
import { StyledTable as StyledTable2 } from "shared-ui";
import { jsx as jsx97, jsxs as jsxs87 } from "react/jsx-runtime";
var queryDef44 = ProfileListContainerQuery_graphql_default;
var fragmentDef13 = ProfileList_list_graphql_default;
var ProfileListContainer = () => {
  const query = useLazyLoadQuery16(queryDef44, {
    where: {},
    order: [{ updatedOn: "DESC" }]
  });
  if (!query)
    return null;
  return /* @__PURE__ */ jsx97(ProfileList, { fragmentRef: query });
};
var ProfileList = ({ fragmentRef }) => {
  const { data, loadNext, refetch, hasNext } = usePaginationFragment11(fragmentDef13, fragmentRef);
  const [loading, startTransition4] = useTransition();
  const onLoadNext = useCallback40(() => {
    loadNext(25);
  }, [loadNext]);
  const [filters, setFilters] = useState24({});
  const [prevQuery, setPrevQuery] = useState24("");
  const [sortState, setSortState] = useState24("DATE_UPDATED");
  const [sortOrder, setSortOrder] = useState24(SortDir.Desc);
  const [profileSortOrder, setProfileSortOrder] = useState24({
    updatedOn: "DESC"
  });
  const onSearch = useCallback40(
    (data2) => {
      startTransition4(() => {
        refetch(data2);
      });
    },
    [refetch, startTransition4]
  );
  const onSearchTerm = useCallback40(
    (query) => {
      if (!query && !prevQuery) {
        return;
      }
      setPrevQuery(query);
      const parts = query?.split(/\s+/);
      const firstPart = parts?.[0];
      const secondPart = parts?.slice(1)?.join(" ");
      const data2 = {
        where: {
          ...filters,
          or: [
            {
              firstName: { startsWith: firstPart },
              and: [{ lastName: { startsWith: secondPart } }]
            },
            {
              lastName: { startsWith: firstPart },
              and: [{ firstName: { startsWith: secondPart } }]
            },
            {
              firstName: { startsWith: query }
            },
            {
              lastName: { startsWith: query }
            },
            { emailAddress: { startsWith: query } }
          ]
        },
        order: [profileSortOrder]
      };
      setFilters(data2.where);
      onSearch(data2);
    },
    [onSearch, setFilters, filters, prevQuery, setPrevQuery, profileSortOrder]
  );
  const onSearchSource = useCallback40(
    (source) => {
      let profileType = null;
      if (source !== "") {
        profileType = {
          eq: source
        };
      }
      let data2 = {
        where: {
          ...filters,
          profileType
        },
        order: [profileSortOrder]
      };
      setFilters(data2.where);
      onSearch(data2);
    },
    [onSearch, setFilters, filters, profileSortOrder]
  );
  const sortStates = {
    DATE_UPDATED: "Date Updated",
    DATE_CREATED: "Date Created",
    EMAIL: "Email",
    NAME: "Name"
  };
  const sortBy = useCallback40(
    (state, dir) => {
      let order2 = {};
      switch (state) {
        case "DATE_UPDATED":
          order2 = { updatedOn: dir || sortOrder };
          break;
        case "DATE_CREATED":
          order2 = { createdOn: dir || sortOrder };
          break;
        case "EMAIL":
          order2 = { emailAddress: dir || sortOrder };
          break;
        case "NAME":
          order2 = { firstName: dir || sortOrder };
          break;
      }
      let data2 = {
        where: {
          ...filters
        },
        order: [order2]
      };
      startTransition4(() => {
        refetch(data2);
      });
      setProfileSortOrder(order2);
      setSortState(state);
      dir && setSortOrder(dir);
    },
    [refetch, filters, sortOrder, setSortState, setSortOrder, startTransition4]
  );
  const { list } = data;
  return /* @__PURE__ */ jsxs87(Suspense70, { children: [
    /* @__PURE__ */ jsx97(MynPageTitle43, { title: "Profiles" }),
    /* @__PURE__ */ jsx97("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs87("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx97("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsxs87("div", { className: " flex items-center gap-5", children: [
        /* @__PURE__ */ jsx97(
          DebouncedInput3,
          {
            placeholder: "Search by name, email",
            onValueChanged: (value) => onSearchTerm(value.trim()),
            value: void 0
          },
          "search"
        ),
        /* @__PURE__ */ jsx97("div", { className: "@container w-64", children: /* @__PURE__ */ jsx97(
          Tabs3,
          {
            tabs: [
              {
                name: "All",
                onClick: () => {
                  onSearchSource("");
                },
                to: ""
              },
              {
                name: "Vault",
                to: "",
                onClick: () => {
                  onSearchSource("VAULT");
                }
              },
              {
                name: "Talent Pool",
                to: "",
                onClick: () => {
                  onSearchSource("RECRUIT");
                }
              },
              {
                name: "Linked In",
                to: "",
                onClick: () => {
                  onSearchSource("LINKED_IN");
                }
              }
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs87("div", { className: "flex w-full max-w-sm items-center gap-2 py-2 lg:max-w-xs", children: [
          /* @__PURE__ */ jsx97(
            "select",
            {
              "aria-label": "Sort by",
              id: "profileSortFields",
              name: "profileSortFields",
              value: sortState,
              className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-lg border-gray-300 ",
              onChange: (e) => sortBy(e.target.value),
              children: Object.entries(sortStates).map(([key, value]) => /* @__PURE__ */ jsx97("option", { value: key, children: value }, key))
            }
          ),
          /* @__PURE__ */ jsx97("div", { className: "rounded border border-gray-300", children: /* @__PURE__ */ jsx97(
            SortDirectionList,
            {
              value: sortOrder,
              className: "rounded-sm",
              customSize: "px-2 py-2 text-md",
              onChanged: (value) => {
                sortBy(sortState, value);
              }
            }
          ) })
        ] }),
        loading && /* @__PURE__ */ jsx97(Spinner5, {})
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs87("div", { className: "flex flex-col gap-5 p-5", children: [
      list?.edges?.map((e) => /* @__PURE__ */ jsx97(ProfileConnectionComponent, { isInList: true, fragmentRef: e.node })),
      hasNext && /* @__PURE__ */ jsx97("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx97(
        "button",
        {
          className: "bg-primary-500 rounded-lg px-4 py-2 text-white",
          onClick: onLoadNext,
          children: "Load More"
        }
      ) })
    ] })
  ] });
};
var {
  Table: Table2,
  TableBody: TableBody2,
  TableCaption: TableCaption2,
  TableCell: TableCell2,
  TableHead: TableHead2,
  TableHeader: TableHeader2,
  TableRow: TableRow2
} = StyledTable2;

// src/secure/accounts/profiles/components/ProfileRoute.tsx
import { jsx as jsx98 } from "react/jsx-runtime";
var createProfileRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-admin-users`;
  const listRouteId = `${routeId6}-list`;
  const groupListRouteId = `${routeId6}-groups-list`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx98(ProfilesLayout, {}),
      children: [
        {
          id: listRouteId,
          path: "list",
          element: /* @__PURE__ */ jsx98(ProfileListContainer, {})
        },
        {
          id: listRouteId + "-redirect",
          path: "*",
          element: /* @__PURE__ */ jsx98(Navigate24, { to: "list" })
        }
      ]
    }
  ];
};

// src/secure/accounts/AccountsLayout.tsx
import { jsx as jsx99, jsxs as jsxs88 } from "react/jsx-runtime";
var tabs = [
  {
    label: "Employers",
    to: "../employers",
    description: "Administer Employer Accounts & Users"
  },
  {
    label: "Candidates",
    to: "../candidates",
    description: "Administer Candidate Accounts"
  },
  {
    label: "Profiles",
    to: "../profiles",
    description: "Administer Profiles"
  },
  {
    label: "Administrators",
    to: "../administrators",
    description: "Administer Internal Accounts"
  },
  {
    label: "Identity",
    to: "../identity",
    description: "Administer Identity Accounts"
  }
];
var AccountsHomeList = () => {
  const links = tabs.map((t) => {
    return /* @__PURE__ */ jsxs88(
      EdLink6,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx99("div", { className: "text-primary-700 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx99("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsx99(Suspense71, { fallback: "Loading...", children: /* @__PURE__ */ jsx99(ErrorBoundary9, { FallbackComponent: ErrorBoundaryFallback9, children: /* @__PURE__ */ jsxs88("div", { className: "flex sm:m-8", children: [
    /* @__PURE__ */ jsx99(MynPageTitle44, { title: "Accounts" }),
    /* @__PURE__ */ jsx99("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links })
  ] }) }) });
};
var createAppAdminAccountsRoutes = (environment, context) => {
  return [
    {
      path: "home/*",
      element: /* @__PURE__ */ jsx99(AccountsHomeList, {})
    },
    {
      path: "candidates/*",
      element: /* @__PURE__ */ jsx99(OutletRoute17, {}),
      children: createCandidatesRoute("admin-candidates", environment, context)
    },
    {
      path: "employers/*",
      element: /* @__PURE__ */ jsx99(OutletRoute17, {}),
      children: createEmployersRoutes("admin-employers", environment, context)
    },
    {
      path: "administrators/*",
      element: /* @__PURE__ */ jsx99(OutletRoute17, {}),
      children: createAdminRoutes("admin-administrators", environment, context)
    },
    {
      path: "profiles/*",
      element: /* @__PURE__ */ jsx99(OutletRoute17, {}),
      children: createProfileRoutes("admin-profiles", environment, context)
    },
    {
      path: "identity/*",
      element: /* @__PURE__ */ jsx99(OutletRoute17, {}),
      children: createIdentityRoutes("admin-identity", environment, context)
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx99(Navigate25, { to: "home", replace: true })
    }
  ];
};

// src/secure/index.ts
__reExport(secure_exports, accounts_exports);

// src/secure/integrations/custom-data/pages/__generated__/CustomDataFieldMappingDetailPageQuery.graphql.ts
var node106 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldMappingId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "fieldMappingId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fieldMappingConfigurationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v7 = [
    v5,
    v6
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationSystemsType",
    "kind": "LinkedField",
    "name": "sourceSystem",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationSystemsType",
    "kind": "LinkedField",
    "name": "targetSystem",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetType",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v14 = [
    v6,
    v12,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    v13
  ], v15 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationMappableAction",
    "kind": "LinkedField",
    "name": "mappings",
    "plural": true,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappable",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": v14,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappable",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": v14,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v16 = [
    v6,
    v12,
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationFieldTypes",
      "kind": "LinkedField",
      "name": "dataType",
      "plural": false,
      "selections": [
        v6,
        v5,
        v13
      ],
      "storageKey": null
    }
  ], v17 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationFieldDefinition",
    "kind": "LinkedField",
    "name": "sourceFieldNames",
    "plural": true,
    "selections": v16,
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationFieldDefinition",
    "kind": "LinkedField",
    "name": "targetFieldNames",
    "plural": true,
    "selections": v16,
    "storageKey": null
  }, v19 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CustomDataFieldMappingDetailPageQuery",
      "selections": [
        {
          "alias": "mapping",
          "args": v1,
          "concreteType": "IntegrationFieldMappingConfiguration",
          "kind": "LinkedField",
          "name": "integrationFieldMappingById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v8,
            v9,
            v10,
            v11,
            v15,
            v17,
            v18,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldMappingConfigurationDetail_fieldMappingConfiguration"
            },
            v19
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CustomDataFieldMappingDetailPageQuery",
      "selections": [
        {
          "alias": "mapping",
          "args": v1,
          "concreteType": "IntegrationFieldMappingConfiguration",
          "kind": "LinkedField",
          "name": "integrationFieldMappingById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v8,
            v9,
            v10,
            v11,
            v15,
            v17,
            v18,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            v19
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2d539f77c82027f9b6510684c25efd36",
      "id": null,
      "metadata": {},
      "name": "CustomDataFieldMappingDetailPageQuery",
      "operationKind": "query",
      "text": "query CustomDataFieldMappingDetailPageQuery(\n  $fieldMappingId: UUID!\n) {\n  mapping: integrationFieldMappingById(id: $fieldMappingId) {\n    id\n    fieldMappingConfigurationId\n    name\n    sourceSystem {\n      displayName\n      key\n    }\n    sourceType\n    targetSystem {\n      displayName\n      key\n    }\n    targetType\n    mappings {\n      id\n      source {\n        key\n        label\n        dataTypeKey\n        processorTypeKey\n        value\n      }\n      target {\n        key\n        label\n        dataTypeKey\n        processorTypeKey\n        value\n      }\n    }\n    sourceFieldNames {\n      key\n      label\n      dataType {\n        key\n        displayName\n        value\n      }\n    }\n    targetFieldNames {\n      key\n      label\n      dataType {\n        key\n        displayName\n        value\n      }\n    }\n    ...FieldMappingConfigurationDetail_fieldMappingConfiguration\n  }\n}\n\nfragment FieldMappingConfigurationDetail_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  createdAt\n  updatedAt\n  name\n  sourceSystem {\n    displayName\n    key\n  }\n  sourceType\n  targetSystem {\n    displayName\n    key\n  }\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node106.hash = "644a714cd6197b8cb617131c3943d929";
var CustomDataFieldMappingDetailPageQuery_graphql_default = node106;

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingDetailPage.tsx
import { useCallback as useCallback41 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery17 } from "react-relay";
import { useParams as useParams2 } from "react-router-dom";
import { createClientMutationId as createClientMutationId19 } from "shared-lib";
import { ButtonTabPills, LinkButton as LinkButton2, MynPageTitle as MynPageTitle45, useTabs } from "shared-ui";
import {
  FieldMappingConfigurationDetail,
  FieldMappingConfigurationFieldsForm,
  useSaveFieldMappingConfig
} from "feature-integrations";
import { jsx as jsx100, jsxs as jsxs89 } from "react/jsx-runtime";
var graphqlQuery2 = CustomDataFieldMappingDetailPageQuery_graphql_default;
var CustomDataFieldMappingDetailPage = ({
  onDone,
  onBack
}) => {
  const { fieldMappingId } = useParams2();
  if (fieldMappingId == null) {
    throw Error("fieldMappingId Required");
  }
  const [current, tabLinks, setTab] = useTabs([
    { name: "View" },
    { name: "Edit" }
  ]);
  const query = useLazyLoadQuery17(
    graphqlQuery2,
    { fieldMappingId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { mapping } = query;
  const [saveFieldMapping, isSaving] = useSaveFieldMappingConfig();
  const onSave = useCallback41(async (form) => {
    if (!mapping || !form.name || !form.actions) {
      return;
    }
    const clientMutationId = createClientMutationId19();
    const input = {
      id: mapping.id,
      name: form.name,
      actions: form.actions,
      clientMutationId
    };
    const response = await saveFieldMapping({
      connections: [],
      input: {
        input
      }
    });
    if (response.integrationsSaveFieldMapping?.payload?.node) {
      onDone({
        id: response.integrationsSaveFieldMapping.payload?.node.id
      });
    }
  }, []);
  if (!mapping) {
    return /* @__PURE__ */ jsx100("div", { children: "Not Found" });
  }
  const actions = [...mapping.mappings];
  const sourceFields = mapping.sourceFieldNames.map(
    (field) => field
  );
  const targetFields = mapping.targetFieldNames.map(
    (field) => field
  );
  let currentTab;
  switch (current.name) {
    case "View": {
      currentTab = /* @__PURE__ */ jsx100("div", { className: "mt-8", children: /* @__PURE__ */ jsx100(
        FieldMappingConfigurationDetail,
        {
          actions: /* @__PURE__ */ jsx100("div", {}),
          fieldMappingConfiguration: mapping
        }
      ) });
      break;
    }
    case "Edit": {
      currentTab = /* @__PURE__ */ jsx100("div", { className: "flex sm:w-1/2", children: /* @__PURE__ */ jsx100(
        FieldMappingConfigurationFieldsForm,
        {
          sourceFieldDefinitions: sourceFields,
          targetFieldDefinitions: targetFields,
          name: mapping.name,
          isBusy: isSaving,
          actions,
          onSave,
          onCancel: () => setTab({ name: "View" })
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs89("div", { children: [
    /* @__PURE__ */ jsx100(MynPageTitle45, { title: "Field Mapping Details" }),
    /* @__PURE__ */ jsxs89("div", { className: "flex items-center space-x-4 border-b px-2 py-4", children: [
      /* @__PURE__ */ jsx100(LinkButton2, { label: "Back", clicked: () => onBack() }),
      /* @__PURE__ */ jsx100(ButtonTabPills, { tabs: tabLinks })
    ] }),
    currentTab
  ] });
};

// src/secure/integrations/custom-data/pages/__generated__/CustomDataFieldMappingListPageQuery.graphql.ts
var node107 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "CustomDataFieldMappingListPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FieldMappingConfigurationList_fieldMappingConfigurations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "CustomDataFieldMappingListPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v0,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationMappableAction",
                      "kind": "LinkedField",
                      "name": "mappings",
                      "plural": true,
                      "selections": [
                        v1,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "source",
                          "plural": false,
                          "selections": v2,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "target",
                          "plural": false,
                          "selections": v2,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": 'integrationFieldMappings(first:10,order:[{"updatedAt":"DESC"}])'
        },
        {
          "alias": null,
          "args": v0,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingConfigurationList_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "9f08c2b39d649dd6c2fff6c3d0574a37",
      "id": null,
      "metadata": {},
      "name": "CustomDataFieldMappingListPageQuery",
      "operationKind": "query",
      "text": "query CustomDataFieldMappingListPageQuery {\n  ...FieldMappingConfigurationList_fieldMappingConfigurations\n}\n\nfragment FieldMappingConfigurationList_fieldMappingConfigurations on Query {\n  integrationFieldMappings(first: 10, order: [{updatedAt: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        ...FieldMappingConfigurationRow_fieldMappingConfiguration\n        __typename\n      }\n    }\n  }\n}\n\nfragment FieldMappingConfigurationRow_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  fieldMappingConfigurationId\n  createdAt\n  updatedAt\n  name\n  sourceType\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node107.hash = "8d01bc3c32e7686d6bfa28d37657b809";
var CustomDataFieldMappingListPageQuery_graphql_default = node107;

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingListPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery18 } from "react-relay";
import { PageHeading as PageHeading5 } from "shared-ui";
import { FieldMappingConfigurationList } from "feature-integrations";
import { jsx as jsx101, jsxs as jsxs90 } from "react/jsx-runtime";
var graphqlQuery3 = CustomDataFieldMappingListPageQuery_graphql_default;
var CustomDataFieldMappingListPage = ({
  onSelect
}) => {
  const query = useLazyLoadQuery18(
    graphqlQuery3,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs90("div", { className: "pt-4", children: [
    /* @__PURE__ */ jsx101(PageHeading5, { children: "Field Mappings" }),
    /* @__PURE__ */ jsx101(
      FieldMappingConfigurationList,
      {
        onSelect: (node151) => onSelect({ id: node151.fieldMappingConfigurationId }),
        fieldMappingConfigurationsKey: query
      }
    )
  ] });
};

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingNewPage.tsx
import { EmployerMappingNewForm } from "feature-integrations";
import { MynPageTitle as MynPageTitle46 } from "shared-ui";
import { jsx as jsx102, jsxs as jsxs91 } from "react/jsx-runtime";
var CustomDataFieldMappingNewPage = ({
  onDone,
  onCancel
}) => {
  return /* @__PURE__ */ jsxs91("div", { className: "w-1/3", children: [
    /* @__PURE__ */ jsx102(MynPageTitle46, { title: "Create New Field Mapping" }),
    /* @__PURE__ */ jsx102(EmployerMappingNewForm, { onDone, onCancel })
  ] });
};

// src/secure/integrations/custom-data/pages/CustomDataFieldMappingsLayoutPage.tsx
import { useCallback as useCallback42 } from "react";
import { Route, Routes, useNavigate as useNavigate17 } from "react-router-dom";
import { PlusIcon as PlusIcon2 } from "@heroicons/react/24/outline";
import { Breadcrumbs, EdButtonLink as EdButtonLink6, MynPageTitle as MynPageTitle47 } from "shared-ui";
import { jsx as jsx103, jsxs as jsxs92 } from "react/jsx-runtime";
var CustomDataFieldMappingsLayoutPage = ({
  integrationsUrl
}) => {
  const navigate = useNavigate17();
  const links = [
    { name: "Field Mappings", href: "" }
  ];
  const onGoToMapping = useCallback42(
    (id) => {
      navigate(`mapping/${id}`);
    },
    [navigate]
  );
  const onGoToList = useCallback42(() => {
    navigate(".");
  }, [navigate]);
  return /* @__PURE__ */ jsxs92("div", { children: [
    /* @__PURE__ */ jsx103("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx103("div", { className: "px-2", children: /* @__PURE__ */ jsx103(
      Breadcrumbs,
      {
        homeText: "Integrations",
        homeHref: integrationsUrl,
        links
      }
    ) }) }),
    /* @__PURE__ */ jsx103("div", { className: "px-4 pt-2 sm:px-8", children: /* @__PURE__ */ jsxs92(Routes, { children: [
      /* @__PURE__ */ jsx103(
        Route,
        {
          path: `new`,
          element: /* @__PURE__ */ jsx103(
            CustomDataFieldMappingNewPage,
            {
              onDone: onGoToMapping,
              onCancel: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx103(
        Route,
        {
          path: `mapping/:fieldMappingId`,
          element: /* @__PURE__ */ jsx103(
            CustomDataFieldMappingDetailPage,
            {
              onDone: onGoToList,
              onBack: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx103(
        Route,
        {
          path: "/",
          element: /* @__PURE__ */ jsxs92("div", { children: [
            /* @__PURE__ */ jsx103(MynPageTitle47, { title: "Custom Data Field Mappings" }),
            /* @__PURE__ */ jsx103("div", { className: "flex items-center justify-between border-b pb-2", children: /* @__PURE__ */ jsx103(EdButtonLink6, { to: "new", name: "new", icon: PlusIcon2 }) }),
            /* @__PURE__ */ jsx103(
              CustomDataFieldMappingListPage,
              {
                onSelect: (m) => onGoToMapping(m.id)
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingDetailPage.tsx
import { useParams as useParams3 } from "react-router-dom";
import { LinkButton as LinkButton3, MynPageTitle as MynPageTitle48 } from "shared-ui";
import { EmployerMappingEditForm } from "feature-integrations";
import { jsx as jsx104, jsxs as jsxs93 } from "react/jsx-runtime";
var IntegrationsConfigEmployerMappingDetailPage = ({ onDone, onBack }) => {
  const { employerMappingId } = useParams3();
  if (employerMappingId == null) {
    throw Error("employerMappingId Required");
  }
  return /* @__PURE__ */ jsxs93("div", { children: [
    /* @__PURE__ */ jsx104(MynPageTitle48, { title: "Employer Mapping Details" }),
    /* @__PURE__ */ jsx104("div", { className: "flex items-center space-x-4 border-b px-2 py-4", children: /* @__PURE__ */ jsx104(LinkButton3, { label: "Back", clicked: () => onBack() }) }),
    /* @__PURE__ */ jsx104("div", { children: /* @__PURE__ */ jsx104(
      EmployerMappingEditForm,
      {
        id: employerMappingId,
        onDone: () => onDone({ id: employerMappingId })
      }
    ) })
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingNewPage.tsx
import { EmployerMappingNewForm as EmployerMappingNewForm2 } from "feature-integrations";
import { MynPageTitle as MynPageTitle49 } from "shared-ui";
import { jsx as jsx105, jsxs as jsxs94 } from "react/jsx-runtime";
var IntegrationsConfigEmployerMappingNewPage = ({ onDone, onCancel }) => {
  return /* @__PURE__ */ jsxs94("div", { className: "p-8", children: [
    /* @__PURE__ */ jsx105(MynPageTitle49, { title: "Create New Employer Mapping" }),
    /* @__PURE__ */ jsx105("h1", { className: "text-info-500 text-xl font-medium", children: "Create a new Mapping" }),
    /* @__PURE__ */ jsx105(EmployerMappingNewForm2, { onDone, onCancel })
  ] });
};

// src/secure/integrations/config/pages/__generated__/IntegrationsConfigEmployerMappingListPageQuery.graphql.ts
var node108 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployerMappingList_employerMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationEmployerMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationEmployerMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEmployerMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationsEmployerMapping",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerMappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "integrationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elevateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "EmployerMappingList_integrationEmployerMappings",
          "kind": "LinkedHandle",
          "name": "integrationEmployerMappings"
        }
      ]
    },
    "params": {
      "cacheID": "08916a093023be094aa033e4f622f106",
      "id": null,
      "metadata": {},
      "name": "IntegrationsConfigEmployerMappingListPageQuery",
      "operationKind": "query",
      "text": "query IntegrationsConfigEmployerMappingListPageQuery(\n  $order: [IntegrationsEmployerMappingSort!]!\n  $where: IntegrationsEmployerMappingFilter!\n) {\n  ...EmployerMappingList_employerMappings\n}\n\nfragment EmployerMappingList_employerMappings on Query {\n  integrationEmployerMappings(first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerMappingId\n        createdAt\n        updatedAt\n        integrationType\n        elevateId\n        externalId\n        ...EmployerMappingRow_employerMapping\n        __typename\n      }\n    }\n  }\n}\n\nfragment EmployerMappingRow_employerMapping on IntegrationsEmployerMapping {\n  id\n  createdAt\n  updatedAt\n  integrationType\n  employerMappingId\n  elevateId\n  externalId\n}\n"
    }
  };
}();
node108.hash = "fdb9a4067a3b4bf1a69e6ef92d7ead24";
var IntegrationsConfigEmployerMappingListPageQuery_graphql_default = node108;

// src/secure/integrations/config/pages/IntegrationsConfigEmployerMappingListPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery19 } from "react-relay";
import { PageHeading as PageHeading6 } from "shared-ui";
import { EmployerMappingList } from "feature-integrations";
import { jsx as jsx106, jsxs as jsxs95 } from "react/jsx-runtime";
var graphqlQuery4 = IntegrationsConfigEmployerMappingListPageQuery_graphql_default;
var order = [{ updatedAt: "DESC" }];
var where = {
  isActive: { eq: true }
};
var IntegrationsConfigEmployerMappingListPage = ({ onSelect }) => {
  const query = useLazyLoadQuery19(
    graphqlQuery4,
    { where, order },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs95("div", { className: "pt-4", children: [
    /* @__PURE__ */ jsx106(PageHeading6, { children: "Employer Mappings" }),
    /* @__PURE__ */ jsx106(
      EmployerMappingList,
      {
        onSelect: (node151) => onSelect({ id: node151.id }),
        employerMappingsKey: query
      }
    )
  ] });
};

// src/secure/integrations/config/pages/IntegrationsConfigLayoutPage.tsx
import { useCallback as useCallback43 } from "react";
import { Route as Route2, Routes as Routes2, useNavigate as useNavigate18 } from "react-router-dom";
import { PlusIcon as PlusIcon3 } from "@heroicons/react/24/outline";
import { Breadcrumbs as Breadcrumbs2, EdButtonLink as EdButtonLink7, MynPageTitle as MynPageTitle50 } from "shared-ui";
import { jsx as jsx107, jsxs as jsxs96 } from "react/jsx-runtime";
var IntegrationsConfigLayoutPage = ({
  integrationsUrl
}) => {
  const navigate = useNavigate18();
  const links = [
    { name: "Elevate Configuration", href: "" }
  ];
  const onGoToMapping = useCallback43(
    (id) => {
      navigate(`mapping/${id}`);
    },
    [navigate]
  );
  const onGoToList = useCallback43(() => {
    navigate(".");
  }, [navigate]);
  return /* @__PURE__ */ jsxs96("div", { children: [
    /* @__PURE__ */ jsx107("div", { className: "flex border-b bg-white py-3", children: /* @__PURE__ */ jsx107("div", { className: "px-2", children: /* @__PURE__ */ jsx107(
      Breadcrumbs2,
      {
        homeText: "Integrations",
        homeHref: integrationsUrl,
        links
      }
    ) }) }),
    /* @__PURE__ */ jsx107("div", { className: "px-4 pt-2 sm:px-8", children: /* @__PURE__ */ jsxs96(Routes2, { children: [
      /* @__PURE__ */ jsx107(
        Route2,
        {
          path: `new`,
          element: /* @__PURE__ */ jsx107(
            IntegrationsConfigEmployerMappingNewPage,
            {
              onCancel: onGoToList,
              onDone: onGoToMapping
            }
          )
        }
      ),
      /* @__PURE__ */ jsx107(
        Route2,
        {
          path: `mapping/:employerMappingId`,
          element: /* @__PURE__ */ jsx107(
            IntegrationsConfigEmployerMappingDetailPage,
            {
              onDone: onGoToList,
              onBack: onGoToList
            }
          )
        }
      ),
      /* @__PURE__ */ jsx107(
        Route2,
        {
          path: "/",
          element: /* @__PURE__ */ jsxs96("div", { children: [
            /* @__PURE__ */ jsx107(MynPageTitle50, { title: "Integrations Config Employer Mappings" }),
            /* @__PURE__ */ jsx107("div", { className: "flex items-center justify-between border-b pb-2", children: /* @__PURE__ */ jsx107(EdButtonLink7, { to: "new", name: "name", icon: PlusIcon3 }) }),
            /* @__PURE__ */ jsx107(
              IntegrationsConfigEmployerMappingListPage,
              {
                onSelect: (m) => onGoToMapping(m.id)
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
};

// src/secure/integrations/IntegrationsLayout.tsx
import { Suspense as Suspense95 } from "react";
import { useNavigate as useNavigate19 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary14 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback15, OutletRoute as OutletRoute19 } from "app-core";
import { EdCard, EdGridLayout, MynPageTitle as MynPageTitle61, PageHeading as PageHeading9 } from "shared-ui";

// src/secure/integrations/csg/CsgRoute.tsx
import { Suspense as Suspense75 } from "react";
import { Outlet as Outlet17, Navigate as Navigate27 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary10 } from "react-error-boundary";
import { EdSkeleton as EdSkeleton52 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback10,
  useUserSessionContext
} from "app-core";

// src/secure/integrations/csg/__generated__/CsgOrganisationsContainerQuery.graphql.ts
var node109 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CsgOrganisationsContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "CsgOrganisationList_organisations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CsgOrganisationsContainerQuery",
      "selections": [
        {
          "alias": "organisations",
          "args": v2,
          "concreteType": "IntegrationCsgOrganisationsConnection",
          "kind": "LinkedField",
          "name": "integrationCsgOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationCsgOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CsgOrganisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "instanceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectorId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectors",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "organisations",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "CsgOrganisationList_organisations",
          "kind": "LinkedHandle",
          "name": "integrationCsgOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "c47540c292d76e9be5ba33bd05844c9b",
      "id": null,
      "metadata": {},
      "name": "CsgOrganisationsContainerQuery",
      "operationKind": "query",
      "text": "query CsgOrganisationsContainerQuery(\n  $where: CsgOrganisationFilter!\n) {\n  ...CsgOrganisationList_organisations_3FC4Qo\n}\n\nfragment CsgOrganisationList_organisations_3FC4Qo on Query {\n  organisations: integrationCsgOrganisations(where: $where, first: 25) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        mappingId\n        instanceId\n        isActive\n        name\n        description\n        sectorId\n        talentPoolId\n        sectors\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node109.hash = "68d1da3885d50e2f09a030f69fe93504";
var CsgOrganisationsContainerQuery_graphql_default = node109;

// src/secure/integrations/csg/CsgOrganisationsContainer.tsx
import { Suspense as Suspense74 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery20 } from "react-relay";
import { EdSkeleton as EdSkeleton51 } from "shared-ui";

// src/secure/integrations/csg/__generated__/CsgOrganisationListPaginationQuery.graphql.ts
var node110 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CsgOrganisationListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "CsgOrganisationList_organisations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CsgOrganisationListPaginationQuery",
      "selections": [
        {
          "alias": "organisations",
          "args": v1,
          "concreteType": "IntegrationCsgOrganisationsConnection",
          "kind": "LinkedField",
          "name": "integrationCsgOrganisations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationCsgOrganisationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CsgOrganisation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "instanceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectorId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectors",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "organisations",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "CsgOrganisationList_organisations",
          "kind": "LinkedHandle",
          "name": "integrationCsgOrganisations"
        }
      ]
    },
    "params": {
      "cacheID": "1cb324c8a35b31ed0ff8fd1f17c51429",
      "id": null,
      "metadata": {},
      "name": "CsgOrganisationListPaginationQuery",
      "operationKind": "query",
      "text": "query CsgOrganisationListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: CsgOrganisationFilter\n) {\n  ...CsgOrganisationList_organisations_3sueo6\n}\n\nfragment CsgOrganisationList_organisations_3sueo6 on Query {\n  organisations: integrationCsgOrganisations(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        mappingId\n        instanceId\n        isActive\n        name\n        description\n        sectorId\n        talentPoolId\n        sectors\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node110.hash = "b73c032c64bb36c136692cd7a87991e2";
var CsgOrganisationListPaginationQuery_graphql_default = node110;

// src/secure/integrations/csg/__generated__/CsgOrganisationList_organisations.graphql.ts
var node111 = /* @__PURE__ */ function() {
  var v0 = [
    "organisations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CsgOrganisationListPaginationQuery_graphql_default
      }
    },
    "name": "CsgOrganisationList_organisations",
    "selections": [
      {
        "alias": "organisations",
        "args": null,
        "concreteType": "IntegrationCsgOrganisationsConnection",
        "kind": "LinkedField",
        "name": "__CsgOrganisationList_organisations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationCsgOrganisationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CsgOrganisation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mappingId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instanceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sectorId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sectors",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node111.hash = "b73c032c64bb36c136692cd7a87991e2";
var CsgOrganisationList_organisations_graphql_default = node111;

// src/secure/integrations/csg/CsgOrganisationList.tsx
import {
  useCallback as useCallback45,
  useTransition as useTransition3
} from "react";
import { usePaginationFragment as usePaginationFragment12 } from "react-relay";
import { SectionedLayout, Tag } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined10 } from "shared-lib";

// src/secure/integrations/csg/CsgOrganisationContainer.tsx
import { useCallback as useCallback44, useTransition as useTransition2 } from "react";
import { usePreloadedQuery as usePreloadedQuery11 } from "react-relay";
import { MynPageTitle as MynPageTitle51, Suspense as Suspense73 } from "shared-ui";
import { EdSkeleton as EdSkeleton50, MobileHeader } from "shared-ui";

// src/secure/integrations/csg/__generated__/CsgOrganisationLayoutQuery.graphql.ts
var node112 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "alias": "csgOrganisation",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "code"
        }
      ],
      "concreteType": "CsgOrganisation",
      "kind": "LinkedField",
      "name": "integrationCsgOrganisationByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mappingId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instanceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectorId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "talentPoolId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectors",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CsgOrganisationLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CsgOrganisationLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0b5bbf887be75263c96f0c8502cece65",
      "id": null,
      "metadata": {},
      "name": "CsgOrganisationLayoutQuery",
      "operationKind": "query",
      "text": "query CsgOrganisationLayoutQuery(\n  $code: Int!\n) {\n  csgOrganisation: integrationCsgOrganisationByCode(code: $code) {\n    id\n    entityId\n    code\n    createdAt\n    updatedAt\n    version\n    mappingId\n    instanceId\n    isActive\n    name\n    description\n    sectorId\n    talentPoolId\n    sectors\n  }\n}\n"
    }
  };
}();
node112.hash = "66cbcb106ece0f5f85076bf6ee889b78";
var CsgOrganisationLayoutQuery_graphql_default = node112;

// src/secure/integrations/csg/CsgOrganisationLayout.tsx
import { Suspense as Suspense72 } from "react";
import { usePreloadedQuery as usePreloadedQuery10 } from "react-relay";
import { Navigate as Navigate26, Route as Route3, Routes as Routes3 } from "react-router-dom";
import { EdSkeleton as EdSkeleton49 } from "shared-ui";
import { jsx as jsx108, jsxs as jsxs97 } from "react/jsx-runtime";
var csgOrganisationLayoutQueryDef = CsgOrganisationLayoutQuery_graphql_default;
var CsgOrganisationLayout = ({ queryRef }) => {
  const { csgOrganisation } = usePreloadedQuery10(
    csgOrganisationLayoutQueryDef,
    queryRef
  );
  if (!csgOrganisation) {
    return /* @__PURE__ */ jsx108(EdSkeleton49, {});
  }
  return /* @__PURE__ */ jsx108(Suspense72, { fallback: /* @__PURE__ */ jsx108(EdSkeleton49, {}), children: /* @__PURE__ */ jsxs97(Routes3, { children: [
    /* @__PURE__ */ jsx108(Route3, { path: "info", element: /* @__PURE__ */ jsx108("div", { children: csgOrganisation.name }) }),
    /* @__PURE__ */ jsx108(Route3, { path: "*", element: /* @__PURE__ */ jsx108(Navigate26, { to: "info", replace: true }) })
  ] }) });
};

// src/secure/integrations/csg/CsgOrganisationContainer.tsx
import { useQueryPreloader } from "shared-lib";
import { Fragment as Fragment40, jsx as jsx109, jsxs as jsxs98 } from "react/jsx-runtime";
var CsgOrganisationContainer = ({
  csgOrganisationCode,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery43] = useQueryPreloader(
    csgOrganisationLayoutQueryDef,
    {
      code: csgOrganisationCode
    }
  );
  const [loading, startTransition4] = useTransition2();
  const onReload = useCallback44(() => {
    startTransition4(() => {
      loadQuery43({ code: csgOrganisationCode }, { fetchPolicy: "network-only" });
    });
  }, [loadQuery43]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx109("div", { className: "m-8", children: /* @__PURE__ */ jsx109(EdSkeleton50, {}) });
  }
  return /* @__PURE__ */ jsxs98(Suspense73, { fallback: /* @__PURE__ */ jsx109(EdSkeleton50, {}), children: [
    /* @__PURE__ */ jsx109(MynPageTitle51, { title: "CSG Organisation Details" }),
    /* @__PURE__ */ jsx109("div", { className: "flex flex-col lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx109(MobileHeaderNavigation, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx109(CsgOrganisationLayout, { queryRef: queryReference, onReload })
  ] });
};
var MobileHeaderNavigation = ({
  queryRef,
  showExpand = true
}) => {
  const data = usePreloadedQuery11(
    csgOrganisationLayoutQueryDef,
    queryRef
  );
  if (!queryRef) {
    return /* @__PURE__ */ jsx109(Fragment40, {});
  }
  return /* @__PURE__ */ jsx109("div", { className: "flex flex-col-reverse md:flex-col md:p-4", children: /* @__PURE__ */ jsx109(
    MobileHeader,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx109("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx109("div", { className: "text-2xl font-bold", children: data.csgOrganisation?.name || "" }) })
    }
  ) });
};

// src/secure/integrations/csg/CsgOrganisationList.tsx
import { Fragment as Fragment41, jsx as jsx110, jsxs as jsxs99 } from "react/jsx-runtime";
var fragmentDef14 = CsgOrganisationList_organisations_graphql_default;
function displayName(name) {
  return /* @__PURE__ */ jsx110("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
function csgOrganisationListHeader(organisation) {
  return /* @__PURE__ */ jsxs99("div", { className: "flex w-full items-center", children: [
    /* @__PURE__ */ jsx110("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsx110("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ jsx110("div", { className: "text-primary-900", children: displayName(organisation.name) }) }) }),
    /* @__PURE__ */ jsx110("div", { className: "flex flex-col gap-2 text-right", children: /* @__PURE__ */ jsx110(Tag, { children: organisation.isActive ? /* @__PURE__ */ jsx110("div", { children: "Active" }) : /* @__PURE__ */ jsx110("div", { children: "Inactive" }) }) })
  ] });
}
function itemHeader(organisation) {
  return /* @__PURE__ */ jsx110("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx110("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsxs99("div", { className: "flex w-full items-center text-xs lg:text-base", children: [
    /* @__PURE__ */ jsx110("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: /* @__PURE__ */ jsx110("span", { className: "font-bold", children: organisation.name }) }),
    /* @__PURE__ */ jsx110("div", { className: "ml-5 lg:text-sm", children: organisation.isActive ? /* @__PURE__ */ jsx110("div", { children: "Active" }) : /* @__PURE__ */ jsx110("div", { children: "Inactive" }) }),
    /* @__PURE__ */ jsx110("div", {})
  ] }) }) });
}
var CsgOrganisationList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment12(fragmentDef14, fragmentRef);
  const { organisations } = data;
  const sections = (organisations?.edges || []).filter(isNotNullOrUndefined10).map((organisation) => {
    return {
      key: organisation.node.code.toString(),
      listTitle: csgOrganisationListHeader(organisation.node),
      itemTitle: itemHeader(organisation.node),
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx110(
        CsgOrganisationContainer,
        {
          csgOrganisationCode: organisation.node.code
        }
      )
    };
  });
  const [loading, startTransition4] = useTransition3();
  const loadMore = useCallback45(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition4(() => {
      loadNext(5);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx110(Fragment41, { children: /* @__PURE__ */ jsx110(
    SectionedLayout,
    {
      expandLink: (id) => `../organisation/${id}/info`,
      title: "Organisations",
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext || loading,
      emptyState: /* @__PURE__ */ jsx110("div", { className: "m-8", children: /* @__PURE__ */ jsx110("h1", { className: "text-primary-500", children: "No Csg Organisations Currently" }) })
    }
  ) });
};

// src/secure/integrations/csg/CsgOrganisationsContainer.tsx
import { jsx as jsx111 } from "react/jsx-runtime";
var graphqlQuery5 = CsgOrganisationsContainerQuery_graphql_default;
var CsgOrganisationsContainer = ({ organisationId }) => {
  let where2 = {};
  if (organisationId) {
    where2 = {
      id: { eq: organisationId }
    };
  }
  const query = useLazyLoadQuery20(
    graphqlQuery5,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx111(Suspense74, { fallback: /* @__PURE__ */ jsx111(EdSkeleton51, {}), children: /* @__PURE__ */ jsx111(CsgOrganisationList, { fragmentRef: query }) });
};

// src/secure/integrations/csg/CsgRoute.tsx
import { jsx as jsx112 } from "react/jsx-runtime";
var CsgOrganisationsListRoute = () => {
  const session = useUserSessionContext();
  return /* @__PURE__ */ jsx112(Suspense75, { fallback: /* @__PURE__ */ jsx112(EdSkeleton52, {}), children: /* @__PURE__ */ jsx112(CsgOrganisationsContainer, {}) });
};
var createCsgRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx112(CsgOrganisationsListRoute, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx112(Navigate27, { to: "list", replace: true })
    }
  ];
};

// src/secure/integrations/csg/CsgLayout.tsx
import { Suspense as Suspense76 } from "react";
import { Outlet as Outlet18 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary11 } from "react-error-boundary";
import { Button as Button31, EdLink as EdLink7, MynPageTitle as MynPageTitle52, PageHeading as PageHeading7 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback11 } from "app-core";
import { jsx as jsx113, jsxs as jsxs100 } from "react/jsx-runtime";
var CsgLayout = () => {
  return /* @__PURE__ */ jsx113(Suspense76, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx113(ErrorBoundary11, { FallbackComponent: ErrorBoundaryFallback11, children: /* @__PURE__ */ jsxs100("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx113("div", { className: "flex items-center justify-between border-b bg-white px-4 py-2", children: /* @__PURE__ */ jsxs100("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx113(EdLink7, { href: "../", name: "Integrations", children: /* @__PURE__ */ jsx113(Button31, { color: "primary", children: "Back" }) }),
      /* @__PURE__ */ jsx113(MynPageTitle52, { title: "CSG Organisations" }),
      /* @__PURE__ */ jsx113(PageHeading7, { children: "CSG" })
    ] }) }),
    /* @__PURE__ */ jsx113("div", { children: /* @__PURE__ */ jsx113(Outlet18, {}) })
  ] }) }) });
};

// src/secure/integrations/access-group/AccessGroupRoute.tsx
import { Navigate as Navigate31, Outlet as Outlet22, useLocation as useLocation12 } from "react-router-dom";
import {
  CloudIcon,
  UserIcon as UserIcon2,
  DocumentIcon as DocumentIcon2,
  FolderIcon
} from "@heroicons/react/24/outline";
import { createLinkState as createLinkState11, ErrorContainer as ErrorContainer11, MynPageTitle as MynPageTitle60, TabPills as TabPills3 } from "shared-ui";
import { OutletRoute as OutletRoute18 } from "app-core";

// src/secure/integrations/access-group/instances/AccessGroupInstancesRoute.tsx
import { Suspense as Suspense80 } from "react";
import { Outlet as Outlet19, Navigate as Navigate28 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary12 } from "react-error-boundary";
import { EdSkeleton as EdSkeleton56, MynPageTitle as MynPageTitle54 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback12,
  useUserSessionContext as useUserSessionContext2
} from "app-core";

// src/secure/integrations/access-group/instances/__generated__/AccessGroupInstancesContainerQuery.graphql.ts
var node113 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupInstancesContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AccessGroupInstanceList_organisations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupInstancesContainerQuery",
      "selections": [
        {
          "alias": "organisations",
          "args": v2,
          "concreteType": "IntegrationAccessGroupInstancesConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupInstances",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupInstancesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupInstance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baseUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contractJobsWorkflowKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contractJobsLastPolledOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantsWorkflowKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantsLastPolledOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "organisations",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupInstanceList_organisations",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupInstances"
        }
      ]
    },
    "params": {
      "cacheID": "6fe1890511e5170a02fd41fe2ca1f43e",
      "id": null,
      "metadata": {},
      "name": "AccessGroupInstancesContainerQuery",
      "operationKind": "query",
      "text": "query AccessGroupInstancesContainerQuery(\n  $where: AccessGroupInstanceFilter!\n) {\n  ...AccessGroupInstanceList_organisations_3FC4Qo\n}\n\nfragment AccessGroupInstanceList_organisations_3FC4Qo on Query {\n  organisations: integrationAccessGroupInstances(where: $where, first: 25) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        isActive\n        baseUrl\n        contractJobsWorkflowKey\n        contractJobsLastPolledOn\n        applicantsWorkflowKey\n        applicantsLastPolledOn\n        sourceId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node113.hash = "1d8d1919da34af2ae4fa8c0ff9896426";
var AccessGroupInstancesContainerQuery_graphql_default = node113;

// src/secure/integrations/access-group/instances/AccessGroupInstancesContainer.tsx
import { Suspense as Suspense79 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery21 } from "react-relay";
import { EdSkeleton as EdSkeleton55 } from "shared-ui";

// src/secure/integrations/access-group/instances/__generated__/AccessGroupInstanceListPaginationQuery.graphql.ts
var node114 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupInstanceListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "AccessGroupInstanceList_organisations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupInstanceListPaginationQuery",
      "selections": [
        {
          "alias": "organisations",
          "args": v1,
          "concreteType": "IntegrationAccessGroupInstancesConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupInstances",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupInstancesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupInstance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "baseUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contractJobsWorkflowKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contractJobsLastPolledOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantsWorkflowKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantsLastPolledOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "organisations",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupInstanceList_organisations",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupInstances"
        }
      ]
    },
    "params": {
      "cacheID": "fd765640cf028b0d0a5bb92406506185",
      "id": null,
      "metadata": {},
      "name": "AccessGroupInstanceListPaginationQuery",
      "operationKind": "query",
      "text": "query AccessGroupInstanceListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: AccessGroupInstanceFilter\n) {\n  ...AccessGroupInstanceList_organisations_3sueo6\n}\n\nfragment AccessGroupInstanceList_organisations_3sueo6 on Query {\n  organisations: integrationAccessGroupInstances(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        isActive\n        baseUrl\n        contractJobsWorkflowKey\n        contractJobsLastPolledOn\n        applicantsWorkflowKey\n        applicantsLastPolledOn\n        sourceId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node114.hash = "facff603bc088a9916dbc51fd1bd7a69";
var AccessGroupInstanceListPaginationQuery_graphql_default = node114;

// src/secure/integrations/access-group/instances/__generated__/AccessGroupInstanceList_organisations.graphql.ts
var node115 = /* @__PURE__ */ function() {
  var v0 = [
    "organisations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AccessGroupInstanceListPaginationQuery_graphql_default
      }
    },
    "name": "AccessGroupInstanceList_organisations",
    "selections": [
      {
        "alias": "organisations",
        "args": null,
        "concreteType": "IntegrationAccessGroupInstancesConnection",
        "kind": "LinkedField",
        "name": "__AccessGroupInstanceList_organisations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationAccessGroupInstancesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccessGroupInstance",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baseUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contractJobsWorkflowKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contractJobsLastPolledOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantsWorkflowKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantsLastPolledOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node115.hash = "facff603bc088a9916dbc51fd1bd7a69";
var AccessGroupInstanceList_organisations_graphql_default = node115;

// src/secure/integrations/access-group/instances/AccessGroupInstanceList.tsx
import {
  useCallback as useCallback47,
  useTransition as useTransition4
} from "react";
import { usePaginationFragment as usePaginationFragment13 } from "react-relay";
import { SectionedLayout as SectionedLayout2, Tag as Tag2 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined11 } from "shared-lib";

// src/secure/integrations/access-group/instances/AccessGroupInstanceContainer.tsx
import { useCallback as useCallback46 } from "react";
import { usePreloadedQuery as usePreloadedQuery13 } from "react-relay";
import { MynPageTitle as MynPageTitle53, Suspense as Suspense78 } from "shared-ui";
import { EdSkeleton as EdSkeleton54, MobileHeader as MobileHeader2 } from "shared-ui";

// src/secure/integrations/access-group/instances/__generated__/AccessGroupInstanceLayoutQuery.graphql.ts
var node116 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "alias": "accessGroupInstance",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "code"
        }
      ],
      "concreteType": "AccessGroupInstance",
      "kind": "LinkedField",
      "name": "integrationAccessGroupInstanceByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contractJobsWorkflowKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contractJobsLastPolledOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicantsWorkflowKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicantsLastPolledOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupInstanceLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupInstanceLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "153e8f7a1a9b2bb3dc52e78bc147b03a",
      "id": null,
      "metadata": {},
      "name": "AccessGroupInstanceLayoutQuery",
      "operationKind": "query",
      "text": "query AccessGroupInstanceLayoutQuery(\n  $code: Int!\n) {\n  accessGroupInstance: integrationAccessGroupInstanceByCode(code: $code) {\n    id\n    entityId\n    code\n    createdAt\n    updatedAt\n    version\n    isActive\n    baseUrl\n    contractJobsWorkflowKey\n    contractJobsLastPolledOn\n    applicantsWorkflowKey\n    applicantsLastPolledOn\n    sourceId\n  }\n}\n"
    }
  };
}();
node116.hash = "d0d341a1b269f80fd41d5c2980f5b54a";
var AccessGroupInstanceLayoutQuery_graphql_default = node116;

// src/secure/integrations/access-group/instances/AccessGroupInstanceLayout.tsx
import { Suspense as Suspense77 } from "react";
import { usePreloadedQuery as usePreloadedQuery12 } from "react-relay";
import { EdSkeleton as EdSkeleton53 } from "shared-ui";
import { timeAgo as timeAgo17 } from "shared-lib";
import { jsx as jsx114, jsxs as jsxs101 } from "react/jsx-runtime";
var accessGroupInstanceLayoutQueryDef = AccessGroupInstanceLayoutQuery_graphql_default;
var AccessGroupInstanceLayout = ({ queryRef }) => {
  const { accessGroupInstance } = usePreloadedQuery12(
    accessGroupInstanceLayoutQueryDef,
    queryRef
  );
  if (!accessGroupInstance) {
    return /* @__PURE__ */ jsx114(EdSkeleton53, {});
  }
  return /* @__PURE__ */ jsx114(Suspense77, { fallback: /* @__PURE__ */ jsx114(EdSkeleton53, {}), children: /* @__PURE__ */ jsx114("div", { className: "p-8 bg-white w-full", children: /* @__PURE__ */ jsxs101("div", { className: "flex flex-col gap-2 divide-y divide-gray-100 p-8 bg-white w-full md:w-2/3 xl:w-1/3", children: [
    /* @__PURE__ */ jsx114("div", { className: "flex items-center justify-between gap-2", children: /* @__PURE__ */ jsx114("h1", { className: "text-primary-500", children: "Access Group Instance" }) }),
    /* @__PURE__ */ jsxs101("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx114("div", { children: "Base Url" }),
      /* @__PURE__ */ jsx114("div", { className: "font-medium text-primary-500", children: accessGroupInstance.baseUrl })
    ] }),
    /* @__PURE__ */ jsxs101("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx114("div", { children: "Applicants Last Polled" }),
      /* @__PURE__ */ jsx114("div", { className: "font-medium text-primary-500", children: timeAgo17(accessGroupInstance.applicantsLastPolledOn) })
    ] }),
    /* @__PURE__ */ jsxs101("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx114("div", { children: "Contract Jobs Last Polled" }),
      /* @__PURE__ */ jsx114("div", { className: "font-medium text-primary-500", children: timeAgo17(accessGroupInstance.contractJobsLastPolledOn) })
    ] })
  ] }) }) });
};

// src/secure/integrations/access-group/instances/AccessGroupInstanceContainer.tsx
import { useQueryPreloader as useQueryPreloader2 } from "shared-lib";
import { Fragment as Fragment42, jsx as jsx115, jsxs as jsxs102 } from "react/jsx-runtime";
var AccessGroupInstanceContainer = ({
  accessGroupInstanceCode,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery43] = useQueryPreloader2(
    accessGroupInstanceLayoutQueryDef,
    {
      code: accessGroupInstanceCode
    }
  );
  const onReload = useCallback46(() => {
    loadQuery43(
      { code: accessGroupInstanceCode },
      { fetchPolicy: "network-only" }
    );
  }, [loadQuery43]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx115("div", { className: "m-8", children: /* @__PURE__ */ jsx115(EdSkeleton54, {}) });
  }
  return /* @__PURE__ */ jsxs102(Suspense78, { fallback: /* @__PURE__ */ jsx115(EdSkeleton54, {}), children: [
    /* @__PURE__ */ jsx115(MynPageTitle53, { title: "Access Group Instance Details" }),
    /* @__PURE__ */ jsx115("div", { className: "flex flex-col bg-white lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx115(MobileHeaderNavigation2, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx115(
      AccessGroupInstanceLayout,
      {
        queryRef: queryReference,
        onReload
      }
    )
  ] });
};
var MobileHeaderNavigation2 = ({
  queryRef,
  showExpand = true
}) => {
  const data = usePreloadedQuery13(
    accessGroupInstanceLayoutQueryDef,
    queryRef
  );
  if (!queryRef) {
    return /* @__PURE__ */ jsx115(Fragment42, {});
  }
  return /* @__PURE__ */ jsx115("div", { className: "flex flex-col-reverse md:flex-col md:p-4", children: /* @__PURE__ */ jsx115(
    MobileHeader2,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx115("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx115("div", { className: "text-2xl font-bold", children: data.accessGroupInstance?.baseUrl || "" }) })
    }
  ) });
};

// src/secure/integrations/access-group/instances/AccessGroupInstanceList.tsx
import { Fragment as Fragment43, jsx as jsx116, jsxs as jsxs103 } from "react/jsx-runtime";
var fragmentDef15 = AccessGroupInstanceList_organisations_graphql_default;
function displayName2(name) {
  return /* @__PURE__ */ jsx116("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
function accessGroupInstanceListHeader(item) {
  return /* @__PURE__ */ jsxs103("div", { className: "flex w-full items-center", children: [
    /* @__PURE__ */ jsx116("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsx116("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ jsx116("div", { className: "text-primary-900", children: displayName2(item.baseUrl) }) }) }),
    /* @__PURE__ */ jsx116("div", { className: "flex flex-col gap-2 text-right", children: /* @__PURE__ */ jsx116(Tag2, { children: item.isActive ? /* @__PURE__ */ jsx116("div", { children: "Active" }) : /* @__PURE__ */ jsx116("div", { children: "Inactive" }) }) })
  ] });
}
function itemHeader2(item) {
  return /* @__PURE__ */ jsx116("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx116("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsxs103("div", { className: "flex w-full items-center text-xs lg:text-base", children: [
    /* @__PURE__ */ jsx116("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: /* @__PURE__ */ jsx116("span", { className: "font-bold", children: item.baseUrl }) }),
    /* @__PURE__ */ jsx116("div", { className: "ml-5 lg:text-sm", children: item.isActive ? /* @__PURE__ */ jsx116("div", { children: "Active" }) : /* @__PURE__ */ jsx116("div", { children: "Inactive" }) }),
    /* @__PURE__ */ jsx116("div", {})
  ] }) }) });
}
var AccessGroupInstanceList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment13(fragmentDef15, fragmentRef);
  const { organisations } = data;
  const sections = (organisations?.edges || []).filter(isNotNullOrUndefined11).map((item) => {
    return {
      key: item.node.code.toString(),
      listTitle: accessGroupInstanceListHeader(item.node),
      itemTitle: itemHeader2(item.node),
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx116(
        AccessGroupInstanceContainer,
        {
          accessGroupInstanceCode: item.node.code
        }
      )
    };
  });
  const [loading, startTransition4] = useTransition4();
  const loadMore = useCallback47(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition4(() => {
      loadNext(5);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx116(Fragment43, { children: /* @__PURE__ */ jsx116(
    SectionedLayout2,
    {
      expandLink: (code) => `../instance/${code}`,
      title: "Instances",
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext || loading,
      emptyState: /* @__PURE__ */ jsx116("div", { className: "m-8", children: /* @__PURE__ */ jsx116("h1", { className: "text-primary-500", children: "No Access Group Instances Found" }) })
    }
  ) });
};

// src/secure/integrations/access-group/instances/AccessGroupInstancesContainer.tsx
import { jsx as jsx117 } from "react/jsx-runtime";
var graphqlQuery6 = AccessGroupInstancesContainerQuery_graphql_default;
var AccessGroupInstancesContainer = ({ organisationId }) => {
  let where2 = {};
  if (organisationId) {
    where2 = {
      id: { eq: organisationId }
    };
  }
  const query = useLazyLoadQuery21(
    graphqlQuery6,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx117(Suspense79, { fallback: /* @__PURE__ */ jsx117(EdSkeleton55, {}), children: /* @__PURE__ */ jsx117(AccessGroupInstanceList, { fragmentRef: query }) });
};

// src/secure/integrations/access-group/instances/AccessGroupInstancesRoute.tsx
import { jsx as jsx118, jsxs as jsxs104 } from "react/jsx-runtime";
var AccessGroupInstancesListRoute = () => {
  const session = useUserSessionContext2();
  return /* @__PURE__ */ jsxs104(Suspense80, { fallback: /* @__PURE__ */ jsx118(EdSkeleton56, {}), children: [
    /* @__PURE__ */ jsx118(MynPageTitle54, { title: "Access Group Instances" }),
    /* @__PURE__ */ jsx118(AccessGroupInstancesContainer, {})
  ] });
};
var createAccessGroupInstancesRoutes = (environment, context, parentRouteId) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx118(AccessGroupInstancesListRoute, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx118(Navigate28, { to: "list", replace: true })
    }
  ];
};

// src/secure/integrations/access-group/AccessGroupLayout.tsx
import { Suspense as Suspense81 } from "react";
import { ErrorBoundary as ErrorBoundary13 } from "react-error-boundary";
import { Button as Button32, EdLink as EdLink8, PageHeading as PageHeading8 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback13 } from "app-core";
import { jsx as jsx119, jsxs as jsxs105 } from "react/jsx-runtime";
var AccessGroupLayout = () => {
  return /* @__PURE__ */ jsx119(Suspense81, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsx119(ErrorBoundary13, { FallbackComponent: ErrorBoundaryFallback13, children: /* @__PURE__ */ jsxs105("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx119("div", { className: "flex items-center justify-between border-b bg-white px-4 py-2", children: /* @__PURE__ */ jsxs105("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx119(EdLink8, { href: "../", name: "Integrations", children: /* @__PURE__ */ jsx119(Button32, { color: "primary", children: "Back" }) }),
      /* @__PURE__ */ jsx119(PageHeading8, { children: "Access Group" })
    ] }) }),
    /* @__PURE__ */ jsx119("div", { className: "m-8", children: /* @__PURE__ */ jsx119(EdLink8, { href: "instances", name: "Instances", children: /* @__PURE__ */ jsx119(Button32, { color: "primary", children: "Instances" }) }) })
  ] }) }) });
};

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobsRoute.tsx
import { Suspense as Suspense85 } from "react";
import { Navigate as Navigate29 } from "react-router-dom";
import { EdSkeleton as EdSkeleton60, MynPageTitle as MynPageTitle56 } from "shared-ui";
import {
  useUserSessionContext as useUserSessionContext3
} from "app-core";

// src/secure/integrations/access-group/contract-jobs/__generated__/AccessGroupContractJobsContainerQuery.graphql.ts
var node117 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupContractJobsContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AccessGroupContractJobList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupContractJobsContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "IntegrationAccessGroupContractJobsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupContractJobs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupContractJobsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupContractJob",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobRefNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupContractJobList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupContractJobs"
        }
      ]
    },
    "params": {
      "cacheID": "af88d9dee6481f5fbb981c85b74fb020",
      "id": null,
      "metadata": {},
      "name": "AccessGroupContractJobsContainerQuery",
      "operationKind": "query",
      "text": "query AccessGroupContractJobsContainerQuery(\n  $where: AccessGroupContractJobFilter!\n) {\n  ...AccessGroupContractJobList_list_3FC4Qo\n}\n\nfragment AccessGroupContractJobList_list_3FC4Qo on Query {\n  list: integrationAccessGroupContractJobs(where: $where, first: 25) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        jobId\n        jobRefNo\n        jobTemplateId\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node117.hash = "b88253d74c07d5802df7c0a584f5d54c";
var AccessGroupContractJobsContainerQuery_graphql_default = node117;

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobsContainer.tsx
import { Suspense as Suspense84, useCallback as useCallback51, useState as useState26 } from "react";
import { useLocalStorage } from "react-use";
import { useLazyLoadQuery as useLazyLoadQuery23 } from "react-relay";
import { EdSkeleton as EdSkeleton59 } from "shared-ui";
import { TextQueryFilter } from "feature-recruit";

// src/secure/integrations/access-group/contract-jobs/__generated__/AccessGroupContractJobListPaginationQuery.graphql.ts
var node118 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupContractJobListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "AccessGroupContractJobList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupContractJobListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "IntegrationAccessGroupContractJobsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupContractJobs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupContractJobsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupContractJob",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobRefNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupContractJobList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupContractJobs"
        }
      ]
    },
    "params": {
      "cacheID": "552931dcbc6c0ba7055568cd5431a013",
      "id": null,
      "metadata": {},
      "name": "AccessGroupContractJobListPaginationQuery",
      "operationKind": "query",
      "text": "query AccessGroupContractJobListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: AccessGroupContractJobFilter\n) {\n  ...AccessGroupContractJobList_list_3sueo6\n}\n\nfragment AccessGroupContractJobList_list_3sueo6 on Query {\n  list: integrationAccessGroupContractJobs(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        version\n        jobId\n        jobRefNo\n        jobTemplateId\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node118.hash = "5e9dfd020312e6dd4ed138d194d2fa35";
var AccessGroupContractJobListPaginationQuery_graphql_default = node118;

// src/secure/integrations/access-group/contract-jobs/__generated__/AccessGroupContractJobList_list.graphql.ts
var node119 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AccessGroupContractJobListPaginationQuery_graphql_default
      }
    },
    "name": "AccessGroupContractJobList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "IntegrationAccessGroupContractJobsConnection",
        "kind": "LinkedField",
        "name": "__AccessGroupContractJobList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationAccessGroupContractJobsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccessGroupContractJob",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobRefNo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTemplateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node119.hash = "5e9dfd020312e6dd4ed138d194d2fa35";
var AccessGroupContractJobList_list_graphql_default = node119;

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobList.tsx
import {
  useCallback as useCallback50,
  useTransition as useTransition5
} from "react";
import { usePaginationFragment as usePaginationFragment14 } from "react-relay";
import { SectionedLayout as SectionedLayout3 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined12 } from "shared-lib";

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobContainer.tsx
import { useCallback as useCallback49 } from "react";
import { usePreloadedQuery as usePreloadedQuery15 } from "react-relay";
import { MynPageTitle as MynPageTitle55, Suspense as Suspense83 } from "shared-ui";
import { EdSkeleton as EdSkeleton58, MobileHeader as MobileHeader3 } from "shared-ui";

// src/secure/integrations/access-group/contract-jobs/__generated__/AccessGroupContractJobLayoutQuery.graphql.ts
var node120 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timestamp",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v6 = [
    {
      "alias": "accessGroupContractJob",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "code"
        }
      ],
      "concreteType": "AccessGroupContractJob",
      "kind": "LinkedField",
      "name": "integrationAccessGroupContractJobByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessGroupInstanceId",
          "storageKey": null
        },
        v2,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobRefNo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedJobDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedJobDescriptionHtml",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectorId",
          "storageKey": null
        },
        v3,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noOfPlaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationsVacancy",
          "kind": "LinkedField",
          "name": "integrationVacancy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elevateEmployerId",
              "storageKey": null
            },
            v1,
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v1,
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccessGroupProgressMessage",
          "kind": "LinkedField",
          "name": "progressMessages",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            v4,
            v5
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccessGroupValidationError",
          "kind": "LinkedField",
          "name": "validationErrors",
          "plural": true,
          "selections": [
            v2,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "error",
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupContractJobLayoutQuery",
      "selections": v6,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupContractJobLayoutQuery",
      "selections": v6
    },
    "params": {
      "cacheID": "0d1d9aa5d7da6c98c47c5a7eda88f30b",
      "id": null,
      "metadata": {},
      "name": "AccessGroupContractJobLayoutQuery",
      "operationKind": "query",
      "text": "query AccessGroupContractJobLayoutQuery(\n  $code: Int!\n) {\n  accessGroupContractJob: integrationAccessGroupContractJobByCode(code: $code) {\n    id\n    entityId\n    accessGroupInstanceId\n    code\n    createdAt\n    updatedAt\n    version\n    jobId\n    jobRefNo\n    jobTemplateId\n    jobTitle\n    publishedJobDescription\n    publishedJobDescriptionHtml\n    sectorId\n    status\n    noOfPlaces\n    locationId\n    integrationVacancy {\n      elevateEmployerId\n      id\n      code\n      vacancyId\n      vacancy {\n        id\n        code\n        name\n        employerReference\n        employerName\n        status\n      }\n    }\n    progressMessages {\n      title\n      timestamp\n      message\n    }\n    validationErrors {\n      code\n      message\n      error\n      timestamp\n    }\n  }\n}\n"
    }
  };
}();
node120.hash = "aca9689f7337fa6ca05efdcb4b5607d5";
var AccessGroupContractJobLayoutQuery_graphql_default = node120;

// src/secure/integrations/access-group/contract-jobs/__generated__/AccessGroupContractJobLayoutIQuery.graphql.ts
var node121 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessGroupInstanceId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sectorId"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "accessGroupInstanceId",
      "variableName": "accessGroupInstanceId"
    },
    {
      "kind": "Variable",
      "name": "sectorId",
      "variableName": "sectorId"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupContractJobLayoutIQuery",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "CsgOrganisation",
          "kind": "LinkedField",
          "name": "integrationCsgOrganisationBySectorId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationsEmployerMapping",
              "kind": "LinkedField",
              "name": "employerMapping",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "employer",
                  "plural": false,
                  "selections": [
                    v3
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "AccessGroupContractJobLayoutIQuery",
      "selections": [
        {
          "alias": "data",
          "args": v2,
          "concreteType": "CsgOrganisation",
          "kind": "LinkedField",
          "name": "integrationCsgOrganisationBySectorId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationsEmployerMapping",
              "kind": "LinkedField",
              "name": "employerMapping",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "employer",
                  "plural": false,
                  "selections": [
                    v3,
                    v4
                  ],
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "92bd485758fdec08596d3d02e7a71e04",
      "id": null,
      "metadata": {},
      "name": "AccessGroupContractJobLayoutIQuery",
      "operationKind": "query",
      "text": "query AccessGroupContractJobLayoutIQuery(\n  $sectorId: Int!\n  $accessGroupInstanceId: UUID!\n) {\n  data: integrationCsgOrganisationBySectorId(sectorId: $sectorId, accessGroupInstanceId: $accessGroupInstanceId) {\n    employerMapping {\n      employer {\n        employerId\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
    }
  };
}();
node121.hash = "a1343a6f3b17841702f6c086bef463ed";
var AccessGroupContractJobLayoutIQuery_graphql_default = node121;

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobLayout.tsx
import { Suspense as Suspense82, useCallback as useCallback48, useState as useState25 } from "react";
import {
  useLazyLoadQuery as useLazyLoadQuery22,
  usePreloadedQuery as usePreloadedQuery14
} from "react-relay";
import { Button as Button33, EdSkeleton as EdSkeleton57, Loading as Loading2, Spinner as Spinner6 } from "shared-ui";
import { createClientMutationId as createClientMutationId20, timeAgo as timeAgo18, useToggle as useToggle10 } from "shared-lib";
import {
  VacancySearchAutoComplete
} from "feature-recruit";

// src/secure/integrations/access-group/mutations/__generated__/UsePullAccessGroupApplicantMutation.graphql.ts
var node122 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "boolean",
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UsePullAccessGroupApplicantMutation",
      "selections": [
        {
          "alias": "pull",
          "args": v1,
          "concreteType": "IntegrationAccessGroupApplicantPullPayload",
          "kind": "LinkedField",
          "name": "integrationAccessGroupApplicantPull",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UsePullAccessGroupApplicantMutation",
      "selections": [
        {
          "alias": "pull",
          "args": v1,
          "concreteType": "IntegrationAccessGroupApplicantPullPayload",
          "kind": "LinkedField",
          "name": "integrationAccessGroupApplicantPull",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "178b51d87bf112b30fb5315e6ef15053",
      "id": null,
      "metadata": {},
      "name": "UsePullAccessGroupApplicantMutation",
      "operationKind": "mutation",
      "text": "mutation UsePullAccessGroupApplicantMutation(\n  $input: IntegrationAccessGroupApplicantPullInput!\n) {\n  pull: integrationAccessGroupApplicantPull(input: $input) {\n    boolean\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node122.hash = "679d691dba7eb31232fb28799369a63b";
var UsePullAccessGroupApplicantMutation_graphql_default = node122;

// src/secure/integrations/access-group/mutations/UsePullAccessGroupApplicantMutation.ts
import { useAsyncMutation as useAsyncMutation24 } from "shared-lib";
var mutationDef24 = UsePullAccessGroupApplicantMutation_graphql_default;
function usePullAccessGroupApplicantMutation() {
  const [commit, isBusy] = useAsyncMutation24(mutationDef24);
  return [commit, isBusy];
}

// src/secure/integrations/access-group/mutations/__generated__/UseChangeAccessGroupJobMappingMutation.graphql.ts
var node123 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "IntegrationsAccessGroupContractJobChangeMappingPayload",
      "kind": "LinkedField",
      "name": "integrationsAccessGroupContractJobChangeMapping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfAccessGroupContractJob",
          "kind": "LinkedField",
          "name": "payload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AccessGroupContractJob",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseChangeAccessGroupJobMappingMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseChangeAccessGroupJobMappingMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "f936d139c9511ac64375dfc742c9eed5",
      "id": null,
      "metadata": {},
      "name": "UseChangeAccessGroupJobMappingMutation",
      "operationKind": "mutation",
      "text": "mutation UseChangeAccessGroupJobMappingMutation(\n  $input: IntegrationsAccessGroupContractJobChangeMappingInput!\n) {\n  integrationsAccessGroupContractJobChangeMapping(input: $input) {\n    payload {\n      node {\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node123.hash = "c66f51a1f3bc5575bf501acf77a0cc23";
var UseChangeAccessGroupJobMappingMutation_graphql_default = node123;

// src/secure/integrations/access-group/mutations/UseChangeAccessGroupJobMappingMutation.ts
import { useAsyncMutation as useAsyncMutation25 } from "shared-lib";
var mutationDef25 = UseChangeAccessGroupJobMappingMutation_graphql_default;
function useChangeAccessGroupJobMapping() {
  const [commit, isBusy] = useAsyncMutation25(mutationDef25);
  return [commit, isBusy];
}

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobLayout.tsx
import { Fragment as Fragment44, jsx as jsx120, jsxs as jsxs106 } from "react/jsx-runtime";
var accessGroupContractJobLayoutQueryDef = AccessGroupContractJobLayoutQuery_graphql_default;
var integrationCSGQuery = AccessGroupContractJobLayoutIQuery_graphql_default;
var AccessGroupContractJobLayout = ({ queryRef }) => {
  const { accessGroupContractJob } = usePreloadedQuery14(
    accessGroupContractJobLayoutQueryDef,
    queryRef
  );
  const [isChangingMapping, toggleIsChangingMapping] = useToggle10();
  const [saveJobMapping, isSavingJobMapping] = useChangeAccessGroupJobMapping();
  const [vacancy, setVacancy] = useState25(
    accessGroupContractJob?.integrationVacancy?.vacancy ? {
      id: accessGroupContractJob?.integrationVacancy?.id,
      vacancyId: accessGroupContractJob?.integrationVacancy?.vacancyId,
      code: accessGroupContractJob?.integrationVacancy?.code,
      name: accessGroupContractJob?.integrationVacancy?.vacancy?.name
    } : null
  );
  const handleChangeJobMapping = useCallback48(() => {
    if (!vacancy || !accessGroupContractJob) {
      return;
    }
    saveJobMapping({
      input: {
        contractJobId: accessGroupContractJob.entityId,
        vacancyId: vacancy.vacancyId,
        clientMutationId: createClientMutationId20()
      }
    });
  }, [saveJobMapping, vacancy, accessGroupContractJob]);
  if (!accessGroupContractJob) {
    return /* @__PURE__ */ jsx120(EdSkeleton57, {});
  }
  const logs = (accessGroupContractJob.progressMessages ?? []).map(
    (pm, index) => {
      return /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2", id: index.toString(), children: [
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center justify-between gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: pm.title }),
          /* @__PURE__ */ jsx120("div", { children: timeAgo18(pm.timestamp) })
        ] }),
        /* @__PURE__ */ jsx120("div", { className: "text-md text-gray-900", children: pm.message })
      ] });
    }
  );
  const errors = (accessGroupContractJob.validationErrors ?? []).map(
    (er, index) => {
      return /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2", id: index.toString(), children: [
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center justify-between gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: er.code }),
          /* @__PURE__ */ jsx120("div", { children: timeAgo18(er.timestamp) })
        ] }),
        /* @__PURE__ */ jsx120("div", { className: "text-md text-red-900", children: er.error }),
        /* @__PURE__ */ jsx120("div", { className: "text-md text-gray-900", children: er.message })
      ] });
    }
  );
  if (!accessGroupContractJob?.sectorId || !accessGroupContractJob?.accessGroupInstanceId) {
    return /* @__PURE__ */ jsx120(Fragment44, { children: /* @__PURE__ */ jsx120(Loading2, {}) });
  }
  return /* @__PURE__ */ jsx120(Suspense82, { fallback: /* @__PURE__ */ jsx120(EdSkeleton57, {}), children: /* @__PURE__ */ jsx120("div", { className: "w-full border-t bg-white p-8", children: /* @__PURE__ */ jsxs106("div", { className: "md:w-2/3", children: [
    /* @__PURE__ */ jsxs106("div", { className: "flex flex-wrap justify-between", children: [
      /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2 bg-white p-8", children: [
        /* @__PURE__ */ jsx120("div", { className: "flex items-center gap-2 border-b pb-2", children: /* @__PURE__ */ jsx120("h1", { className: "text-primary-500", children: "Details" }) }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Job Ref No" }),
          /* @__PURE__ */ jsx120("div", { className: "text-primary-500 font-medium", children: accessGroupContractJob.jobRefNo })
        ] }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Job Id" }),
          /* @__PURE__ */ jsx120("div", { className: "text-primary-500 font-medium", children: accessGroupContractJob.jobId })
        ] }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Job Title" }),
          /* @__PURE__ */ jsx120("div", { className: "text-primary-500 font-medium", children: accessGroupContractJob.jobTitle })
        ] }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Updated" }),
          /* @__PURE__ */ jsx120("div", { className: "text-primary-500 font-medium", children: timeAgo18(accessGroupContractJob.updatedAt) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2 bg-white p-8", children: [
        /* @__PURE__ */ jsx120("div", { className: "flex items-center gap-2 border-b pb-2", children: /* @__PURE__ */ jsx120("h1", { className: "text-primary-500", children: "Data" }) }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Has Job Description" }),
          /* @__PURE__ */ jsx120("div", { className: "font-medium", children: accessGroupContractJob.publishedJobDescription ? /* @__PURE__ */ jsx120("div", { className: "text-green-500", children: "Yes" }) : /* @__PURE__ */ jsx120("div", { className: "text-red-500", children: "No" }) })
        ] })
      ] })
    ] }),
    accessGroupContractJob.integrationVacancy?.vacancy ? /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2 bg-white p-8", children: [
      /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx120("div", { className: "flex items-center gap-2 border-b pb-2", children: /* @__PURE__ */ jsx120("h1", { className: "text-primary-500", children: "Linked To" }) }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Employer" }),
          /* @__PURE__ */ jsx120("div", { className: "text-primary-500 text-lg font-medium", children: accessGroupContractJob.integrationVacancy.vacancy.employerName })
        ] }),
        /* @__PURE__ */ jsxs106("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx120("div", { children: "Vacancy" }),
          /* @__PURE__ */ jsxs106("div", { className: "flex flex-wrap items-center gap-2", children: [
            /* @__PURE__ */ jsx120("div", { className: "text-primary-500 text-lg font-medium", children: accessGroupContractJob.integrationVacancy.vacancy.name }),
            /* @__PURE__ */ jsx120("div", { className: "text-primary-500 text-lg font-medium", children: accessGroupContractJob.integrationVacancy.vacancy.code }),
            /* @__PURE__ */ jsx120("div", { className: "text-primary-500 text-lg font-bold", children: accessGroupContractJob.integrationVacancy.vacancy.employerReference }),
            /* @__PURE__ */ jsx120("div", { className: "text-lg font-bold text-gray-900", children: accessGroupContractJob.integrationVacancy.vacancy.status })
          ] })
        ] }),
        /* @__PURE__ */ jsx120("div", { className: "my-4", children: accessGroupContractJob.integrationVacancy.vacancy.status === "OPEN" ? /* @__PURE__ */ jsx120("div", { className: "text-warning-500 text-lg font-bold", children: "Warning: Cannot Change Mapping for Open Vacancy" }) : /* @__PURE__ */ jsx120("div", { children: /* @__PURE__ */ jsx120(
          Button33,
          {
            color: "primary",
            disabled: isChangingMapping,
            onClick: toggleIsChangingMapping,
            children: "Change Mapping"
          }
        ) }) })
      ] }),
      isChangingMapping && /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx120(
          EmployerVacancySearch,
          {
            vacancy,
            setVacancy,
            isSavingJobMapping,
            handleChangeJobMapping,
            sectorId: accessGroupContractJob.sectorId,
            accessGroupInstanceId: accessGroupContractJob.accessGroupInstanceId
          }
        ),
        /* @__PURE__ */ jsx120("div", { children: /* @__PURE__ */ jsx120(
          Button33,
          {
            color: "primary",
            disabled: isChangingMapping,
            onClick: toggleIsChangingMapping,
            children: "Cancel"
          }
        ) })
      ] })
    ] }) : /* @__PURE__ */ jsxs106("div", { className: "flex flex-col gap-2 bg-white p-8", children: [
      /* @__PURE__ */ jsx120("div", { className: "text-red-500", children: "Not Mapped To Myn Vacancy" }),
      /* @__PURE__ */ jsx120(
        EmployerVacancySearch,
        {
          vacancy,
          setVacancy,
          isSavingJobMapping,
          handleChangeJobMapping,
          sectorId: accessGroupContractJob.sectorId,
          accessGroupInstanceId: accessGroupContractJob.accessGroupInstanceId
        }
      )
    ] }),
    logs.length > 0 && /* @__PURE__ */ jsxs106("div", { className: "flex w-full flex-col gap-2 bg-white p-8", children: [
      /* @__PURE__ */ jsx120("div", { className: "flex items-center justify-between gap-2 border-b pb-2", children: /* @__PURE__ */ jsx120("h1", { className: "text-primary-500", children: "Logs" }) }),
      /* @__PURE__ */ jsx120("div", { className: "flex-col gap-2", children: logs })
    ] }),
    errors.length > 0 && /* @__PURE__ */ jsxs106("div", { className: "flex w-full flex-col gap-2 bg-white p-8", children: [
      /* @__PURE__ */ jsx120("div", { className: "flex items-center justify-between gap-2 border-b pb-2", children: /* @__PURE__ */ jsx120("h1", { className: "text-primary-500", children: "Validation Errors" }) }),
      /* @__PURE__ */ jsx120("div", { className: "flex-col gap-2", children: errors })
    ] })
  ] }) }) });
};
var EmployerVacancySearch = ({
  vacancy,
  setVacancy,
  isSavingJobMapping,
  handleChangeJobMapping,
  sectorId,
  accessGroupInstanceId
}) => {
  const { data } = useLazyLoadQuery22(
    integrationCSGQuery,
    {
      sectorId,
      accessGroupInstanceId
    }
  );
  if (!data?.employerMapping?.employer?.employerId) {
    return /* @__PURE__ */ jsx120(Loading2, {});
  }
  return /* @__PURE__ */ jsxs106("div", { className: " flex flex-col gap-5 border p-5", children: [
    /* @__PURE__ */ jsx120("strong", { children: "Link Vacancy" }),
    /* @__PURE__ */ jsx120(
      VacancySearchAutoComplete,
      {
        defaultVacancySearchInput: {
          employerId: [data?.employerMapping?.employer?.employerId],
          pageNumber: 1,
          pageSize: 10
        },
        displayValue: (item) => {
          if (item) {
            return `${item.name}`;
          }
          return "";
        },
        onSelected: setVacancy,
        defaultValue: vacancy
      }
    ),
    /* @__PURE__ */ jsxs106(
      Button33,
      {
        "aria-label": "Link Now",
        onClick: handleChangeJobMapping,
        disabled: isSavingJobMapping,
        color: "primary",
        children: [
          "Link Now ",
          isSavingJobMapping && /* @__PURE__ */ jsx120(Spinner6, {})
        ]
      }
    )
  ] });
};

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobContainer.tsx
import { useQueryPreloader as useQueryPreloader3 } from "shared-lib";
import { Fragment as Fragment45, jsx as jsx121, jsxs as jsxs107 } from "react/jsx-runtime";
var AccessGroupContractJobContainer = ({
  accessGroupContractJobCode,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery43] = useQueryPreloader3(
    accessGroupContractJobLayoutQueryDef,
    { code: accessGroupContractJobCode }
  );
  const onReload = useCallback49(() => {
    loadQuery43(
      { code: accessGroupContractJobCode },
      { fetchPolicy: "network-only" }
    );
  }, [loadQuery43]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx121("div", { className: "m-8", children: /* @__PURE__ */ jsx121(EdSkeleton58, {}) });
  }
  return /* @__PURE__ */ jsxs107(Suspense83, { fallback: /* @__PURE__ */ jsx121(EdSkeleton58, {}), children: [
    /* @__PURE__ */ jsx121(MynPageTitle55, { title: "Access Group Contract Job Details" }),
    /* @__PURE__ */ jsx121("div", { className: "flex flex-col bg-white lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx121(MobileHeaderNavigation3, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx121(
      AccessGroupContractJobLayout,
      {
        queryRef: queryReference,
        onReload
      }
    )
  ] });
};
var MobileHeaderNavigation3 = ({
  queryRef,
  showExpand = true
}) => {
  const data = usePreloadedQuery15(
    accessGroupContractJobLayoutQueryDef,
    queryRef
  );
  if (!queryRef) {
    return /* @__PURE__ */ jsx121(Fragment45, {});
  }
  return /* @__PURE__ */ jsx121("div", { className: "flex flex-col-reverse md:flex-col md:p-4", children: /* @__PURE__ */ jsx121(
    MobileHeader3,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx121("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx121("div", { className: "text-2xl font-bold", children: data.accessGroupContractJob?.jobRefNo || "" }) })
    }
  ) });
};

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobList.tsx
import { Fragment as Fragment46, jsx as jsx122 } from "react/jsx-runtime";
var fragmentDef16 = AccessGroupContractJobList_list_graphql_default;
function displayName3(name) {
  if (!name) {
    return /* @__PURE__ */ jsx122("div", { className: "truncate whitespace-pre-line break-all", children: "Unknown" });
  }
  return /* @__PURE__ */ jsx122("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
function accessGroupContractJobListHeader(item) {
  return /* @__PURE__ */ jsx122("div", { className: "flex w-full items-center", children: /* @__PURE__ */ jsx122("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsx122("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ jsx122("div", { className: "text-primary-900", children: displayName3(item.jobRefNo?.toString()) }) }) }) });
}
function itemHeader3(item) {
  return /* @__PURE__ */ jsx122("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx122("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsx122("div", { className: "flex w-full items-center text-xs lg:text-base", children: /* @__PURE__ */ jsx122("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: /* @__PURE__ */ jsx122("span", { className: "font-bold", children: item.jobRefNo }) }) }) }) });
}
var AccessGroupContractJobList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment14(fragmentDef16, fragmentRef);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined12).map((item) => {
    return {
      key: item.node.code.toString(),
      listTitle: accessGroupContractJobListHeader(item.node),
      itemTitle: itemHeader3(item.node),
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx122(
        AccessGroupContractJobContainer,
        {
          accessGroupContractJobCode: item.node.code
        },
        item.node.code
      )
    };
  });
  const [loading, startTransition4] = useTransition5();
  const loadMore = useCallback50(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition4(() => {
      loadNext(5);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx122(Fragment46, { children: /* @__PURE__ */ jsx122(
    SectionedLayout3,
    {
      expandLink: (code) => `../contractJob/${code}`,
      title: "ContractJobs",
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext || loading,
      emptyState: /* @__PURE__ */ jsx122("div", { className: "m-8", children: /* @__PURE__ */ jsx122("h1", { className: "text-primary-500", children: "No Access Group ContractJobs Found" }) })
    }
  ) });
};

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobsContainer.tsx
import { jsx as jsx123, jsxs as jsxs108 } from "react/jsx-runtime";
var graphqlQuery7 = AccessGroupContractJobsContainerQuery_graphql_default;
var stateFilters = [
  { label: "(Choose)", key: "" },
  { label: "Closed", key: "CLOSED" },
  { label: "Failed", key: "FAILED" },
  { label: "Pending", key: "PENDING" },
  { label: "Resolved", key: "RESOLVED" },
  { label: "Synchronised", key: "SYNCHRONISED" },
  { label: "Validated", key: "VALIDATED" }
];
var AccessGroupContractJobsContainer = ({
  organisationId
}) => {
  const [stateFilter, setStateFilter] = useLocalStorage(
    "AccessGroupContractJobStateFilter",
    ""
  );
  const [searchTerm, setSearchTerm] = useState26(null);
  let where2 = {};
  if (stateFilter && stateFilter !== "") {
    const filter = stateFilter;
    if (filter) {
      where2 = {
        state: { eq: filter }
      };
    }
  }
  if (searchTerm && searchTerm !== "") {
    where2 = {
      jobRefNo: { startsWith: searchTerm }
    };
  }
  const onStateFilterChanged = useCallback51(
    (filter) => {
      setStateFilter(filter);
    },
    [setStateFilter]
  );
  const query = useLazyLoadQuery23(
    graphqlQuery7,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx123(Suspense84, { fallback: /* @__PURE__ */ jsx123(EdSkeleton59, {}), children: /* @__PURE__ */ jsxs108("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs108("div", { className: "flex items-center gap-2 border-b", children: [
      /* @__PURE__ */ jsxs108("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx123("div", { className: "p-2", children: "Status" }),
        /* @__PURE__ */ jsx123("div", { className: "p-2", children: /* @__PURE__ */ jsx123(
          "select",
          {
            id: "filterByFields",
            name: "filterByFields",
            "aria-label": "Filter By",
            value: stateFilter,
            className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-md border-gray-300",
            onChange: (e) => onStateFilterChanged(e.target.value),
            children: stateFilters.map((i) => /* @__PURE__ */ jsx123("option", { value: i.key, children: i.label }, i.key))
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs108("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx123("div", { className: "p-2", children: "Job Ref" }),
        /* @__PURE__ */ jsx123("div", { className: "p-2", children: /* @__PURE__ */ jsx123(TextQueryFilter, { placeholder: "Search", onChanged: setSearchTerm }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx123("div", { children: /* @__PURE__ */ jsx123(AccessGroupContractJobList, { fragmentRef: query }) })
  ] }) });
};

// src/secure/integrations/access-group/contract-jobs/AccessGroupContractJobsRoute.tsx
import { jsx as jsx124, jsxs as jsxs109 } from "react/jsx-runtime";
var AccessGroupContractJobsListRoute = () => {
  const session = useUserSessionContext3();
  return /* @__PURE__ */ jsxs109(Suspense85, { fallback: /* @__PURE__ */ jsx124(EdSkeleton60, {}), children: [
    /* @__PURE__ */ jsx124(MynPageTitle56, { title: "Access Group Contract Jobs" }),
    /* @__PURE__ */ jsx124(AccessGroupContractJobsContainer, {})
  ] });
};
var createAccessGroupContractJobsRoutes = (environment, context, parentRouteId) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx124(AccessGroupContractJobsListRoute, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx124(Navigate29, { to: "list", replace: true })
    }
  ];
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantsRoute.tsx
import { Suspense as Suspense94 } from "react";
import { Outlet as Outlet21, Navigate as Navigate30, useLocation as useLocation11 } from "react-router-dom";
import { UsersIcon as UsersIcon3, BoltIcon } from "@heroicons/react/24/outline";
import {
  createLinkState as createLinkState10,
  EdSkeleton as EdSkeleton69,
  ErrorContainer as ErrorContainer10,
  MynPageTitle as MynPageTitle59,
  TabUnderline as TabUnderline7
} from "shared-ui";

// src/secure/integrations/access-group/applicants/__generated__/AccessGroupApplicantsContainerQuery.graphql.ts
var node124 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v2 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v2,
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupApplicantsContainerQuery",
      "selections": [
        {
          "args": [
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "AccessGroupApplicantList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "AccessGroupApplicantsContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "IntegrationAccessGroupApplicantsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupApplicants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupApplicantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupApplicant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantSurname",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "primaryEmailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupApplicantList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupApplicants"
        }
      ]
    },
    "params": {
      "cacheID": "93556bdad1e1f31afd7a3282b40c0670",
      "id": null,
      "metadata": {},
      "name": "AccessGroupApplicantsContainerQuery",
      "operationKind": "query",
      "text": "query AccessGroupApplicantsContainerQuery(\n  $where: AccessGroupApplicantFilter!\n  $order: [AccessGroupApplicantSort!]\n) {\n  ...AccessGroupApplicantList_list_28pUDr\n}\n\nfragment AccessGroupApplicantList_list_28pUDr on Query {\n  list: integrationAccessGroupApplicants(where: $where, first: 25, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        applicantId\n        applicantName\n        applicantSurname\n        primaryEmailAddress\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node124.hash = "fbc445437665323a231ae9a8d15b9e92";
var AccessGroupApplicantsContainerQuery_graphql_default = node124;

// src/secure/integrations/access-group/applicants/AccessGroupApplicantsContainer.tsx
import { Suspense as Suspense91, useCallback as useCallback56, useState as useState27 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery25 } from "react-relay";
import {
  EdSkeleton as EdSkeleton66,
  SortDir as SortDir2,
  UncontrolledDateInput
} from "shared-ui";
import {
  SingleFilter,
  SortDirectionList as SortDirectionList2,
  TextQueryFilter as TextQueryFilter2
} from "feature-recruit";
import { InformationCircleIcon as InformationCircleIcon2 } from "@heroicons/react/24/outline";

// src/secure/integrations/access-group/applicants/__generated__/AccessGroupApplicantListPaginationQuery.graphql.ts
var node125 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        {
          "createdAt": "DESC"
        }
      ],
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupApplicantListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "AccessGroupApplicantList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupApplicantListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "IntegrationAccessGroupApplicantsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupApplicants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupApplicantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupApplicant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantSurname",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "primaryEmailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupApplicantList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupApplicants"
        }
      ]
    },
    "params": {
      "cacheID": "9900323fd5b05ae0c514f69aaba01874",
      "id": null,
      "metadata": {},
      "name": "AccessGroupApplicantListPaginationQuery",
      "operationKind": "query",
      "text": "query AccessGroupApplicantListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $order: [AccessGroupApplicantSort!] = [{createdAt: DESC}]\n  $where: AccessGroupApplicantFilter\n) {\n  ...AccessGroupApplicantList_list_cnSAE\n}\n\nfragment AccessGroupApplicantList_list_cnSAE on Query {\n  list: integrationAccessGroupApplicants(where: $where, first: $first, after: $after, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        applicantId\n        applicantName\n        applicantSurname\n        primaryEmailAddress\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node125.hash = "73c86ea0408118d9d5932dc0c32ff8c8";
var AccessGroupApplicantListPaginationQuery_graphql_default = node125;

// src/secure/integrations/access-group/applicants/__generated__/AccessGroupApplicantList_list.graphql.ts
var node126 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": [
          {
            "createdAt": "DESC"
          }
        ],
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AccessGroupApplicantListPaginationQuery_graphql_default
      }
    },
    "name": "AccessGroupApplicantList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "IntegrationAccessGroupApplicantsConnection",
        "kind": "LinkedField",
        "name": "__AccessGroupApplicantList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationAccessGroupApplicantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccessGroupApplicant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantSurname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryEmailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node126.hash = "73c86ea0408118d9d5932dc0c32ff8c8";
var AccessGroupApplicantList_list_graphql_default = node126;

// src/secure/integrations/access-group/applicants/AccessGroupApplicantList.tsx
import {
  useCallback as useCallback55,
  useTransition as useTransition8
} from "react";
import { usePaginationFragment as usePaginationFragment16 } from "react-relay";
import { SectionedLayout as SectionedLayout5 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined14 } from "shared-lib";

// src/secure/integrations/access-group/applicants/AccessGroupApplicantContainer.tsx
import { useCallback as useCallback54 } from "react";
import { usePreloadedQuery as usePreloadedQuery19 } from "react-relay";
import { useQueryPreloader as useQueryPreloader5 } from "shared-lib";
import { MynPageTitle as MynPageTitle57, Suspense as Suspense90 } from "shared-ui";
import { EdSkeleton as EdSkeleton65, MobileHeader as MobileHeader5 } from "shared-ui";

// src/secure/integrations/access-group/applicants/__generated__/AccessGroupApplicantLayoutQuery.graphql.ts
var node127 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "alias": "accessGroupApplicant",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "code"
        }
      ],
      "concreteType": "AccessGroupApplicant",
      "kind": "LinkedField",
      "name": "integrationAccessGroupApplicantByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessGroupInstanceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicantName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicantSurname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryEmailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryPhoneNo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectorIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupApplicantLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupApplicantLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "632e34186b188710b11710a29a755e40",
      "id": null,
      "metadata": {},
      "name": "AccessGroupApplicantLayoutQuery",
      "operationKind": "query",
      "text": "query AccessGroupApplicantLayoutQuery(\n  $code: Int!\n) {\n  accessGroupApplicant: integrationAccessGroupApplicantByCode(code: $code) {\n    id\n    entityId\n    code\n    accessGroupInstanceId\n    createdAt\n    updatedAt\n    applicantId\n    applicantName\n    applicantSurname\n    primaryEmailAddress\n    jobTitle\n    primaryPhoneNo\n    sectorIds\n    syncStatus\n  }\n}\n"
    }
  };
}();
node127.hash = "0c8624904f949bc6482269371504c65c";
var AccessGroupApplicantLayoutQuery_graphql_default = node127;

// src/secure/integrations/access-group/applicants/AccessGroupApplicantLayout.tsx
import { Suspense as Suspense89 } from "react";
import { usePreloadedQuery as usePreloadedQuery18 } from "react-relay";
import { timeAgo as timeAgo20, tryFormatDateHtml } from "shared-lib";
import { EdSkeleton as EdSkeleton64 } from "shared-ui";

// src/secure/integrations/access-group/review-list-applicants/__generated__/AccessGroupApplicantReviewListContainerQuery.graphql.ts
var node128 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupApplicantReviewListContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "AccessGroupReviewListApplicantList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupApplicantReviewListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "IntegrationAccessGroupReviewListApplicantsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupReviewListApplicants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupReviewListApplicantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupReviewListApplicant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reviewListApplicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccessGroupApplicant",
                      "kind": "LinkedField",
                      "name": "applicant",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicantName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicantSurname",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryEmailAddress",
                          "storageKey": null
                        },
                        v3
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobRefNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupReviewListApplicantList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupReviewListApplicants"
        }
      ]
    },
    "params": {
      "cacheID": "e7d1f68e5a6c6317c753e989cba2a3ec",
      "id": null,
      "metadata": {},
      "name": "AccessGroupApplicantReviewListContainerQuery",
      "operationKind": "query",
      "text": "query AccessGroupApplicantReviewListContainerQuery(\n  $where: AccessGroupReviewListApplicantFilter!\n) {\n  ...AccessGroupReviewListApplicantList_list_3FC4Qo\n}\n\nfragment AccessGroupReviewListApplicantList_list_3FC4Qo on Query {\n  list: integrationAccessGroupReviewListApplicants(where: $where, first: 25) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        reviewListApplicantId\n        applicantId\n        applicant {\n          applicantName\n          applicantSurname\n          primaryEmailAddress\n          id\n        }\n        jobId\n        jobRefNo\n        jobStatus\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node128.hash = "d6dbf03f7465770130c3825d67a55ed7";
var AccessGroupApplicantReviewListContainerQuery_graphql_default = node128;

// src/secure/integrations/access-group/review-list-applicants/AccessGroupApplicantReviewListContainer.tsx
import { Suspense as Suspense88 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery24 } from "react-relay";
import { EdSkeleton as EdSkeleton63 } from "shared-ui";

// src/secure/integrations/access-group/review-list-applicants/__generated__/AccessGroupReviewListApplicantListPaginationQuery.graphql.ts
var node129 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupReviewListApplicantListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "AccessGroupReviewListApplicantList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupReviewListApplicantListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "IntegrationAccessGroupReviewListApplicantsConnection",
          "kind": "LinkedField",
          "name": "integrationAccessGroupReviewListApplicants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationAccessGroupReviewListApplicantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupReviewListApplicant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reviewListApplicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccessGroupApplicant",
                      "kind": "LinkedField",
                      "name": "applicant",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicantName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicantSurname",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryEmailAddress",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobRefNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "AccessGroupReviewListApplicantList_list",
          "kind": "LinkedHandle",
          "name": "integrationAccessGroupReviewListApplicants"
        }
      ]
    },
    "params": {
      "cacheID": "0c3b23db402fd5643cb72e736372048d",
      "id": null,
      "metadata": {},
      "name": "AccessGroupReviewListApplicantListPaginationQuery",
      "operationKind": "query",
      "text": "query AccessGroupReviewListApplicantListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: AccessGroupReviewListApplicantFilter\n) {\n  ...AccessGroupReviewListApplicantList_list_3sueo6\n}\n\nfragment AccessGroupReviewListApplicantList_list_3sueo6 on Query {\n  list: integrationAccessGroupReviewListApplicants(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        reviewListApplicantId\n        applicantId\n        applicant {\n          applicantName\n          applicantSurname\n          primaryEmailAddress\n          id\n        }\n        jobId\n        jobRefNo\n        jobStatus\n        jobTitle\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node129.hash = "14382e8931cfd967df5f88dafd47e088";
var AccessGroupReviewListApplicantListPaginationQuery_graphql_default = node129;

// src/secure/integrations/access-group/review-list-applicants/__generated__/AccessGroupReviewListApplicantList_list.graphql.ts
var node130 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": AccessGroupReviewListApplicantListPaginationQuery_graphql_default
      }
    },
    "name": "AccessGroupReviewListApplicantList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "IntegrationAccessGroupReviewListApplicantsConnection",
        "kind": "LinkedField",
        "name": "__AccessGroupReviewListApplicantList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationAccessGroupReviewListApplicantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccessGroupReviewListApplicant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reviewListApplicantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessGroupApplicant",
                    "kind": "LinkedField",
                    "name": "applicant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applicantName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applicantSurname",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryEmailAddress",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobRefNo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node130.hash = "14382e8931cfd967df5f88dafd47e088";
var AccessGroupReviewListApplicantList_list_graphql_default = node130;

// src/secure/integrations/access-group/review-list-applicants/AccessGroupReviewListApplicantList.tsx
import {
  useCallback as useCallback53,
  useTransition as useTransition7
} from "react";
import { usePaginationFragment as usePaginationFragment15 } from "react-relay";
import { SectionedLayout as SectionedLayout4 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined13 } from "shared-lib";

// src/secure/integrations/access-group/review-list-applicants/AccessGroupReviewListApplicantContainer.tsx
import { useCallback as useCallback52, useTransition as useTransition6 } from "react";
import { usePreloadedQuery as usePreloadedQuery17 } from "react-relay";
import { Suspense as Suspense87 } from "shared-ui";
import { EdSkeleton as EdSkeleton62, MobileHeader as MobileHeader4 } from "shared-ui";

// src/secure/integrations/access-group/review-list-applicants/__generated__/AccessGroupReviewListApplicantLayoutQuery.graphql.ts
var node131 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reviewListApplicantId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicantId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicantName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicantSurname",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "primaryEmailAddress",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobRefNo",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobStatus",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobTitle",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupReviewListApplicantLayoutQuery",
      "selections": [
        {
          "alias": "accessGroupReviewListApplicant",
          "args": v1,
          "concreteType": "AccessGroupReviewListApplicant",
          "kind": "LinkedField",
          "name": "integrationAccessGroupReviewListApplicantByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccessGroupApplicant",
              "kind": "LinkedField",
              "name": "applicant",
              "plural": false,
              "selections": [
                v9,
                v10,
                v11
              ],
              "storageKey": null
            },
            v12,
            v13,
            v14,
            v15
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AccessGroupReviewListApplicantLayoutQuery",
      "selections": [
        {
          "alias": "accessGroupReviewListApplicant",
          "args": v1,
          "concreteType": "AccessGroupReviewListApplicant",
          "kind": "LinkedField",
          "name": "integrationAccessGroupReviewListApplicantByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccessGroupApplicant",
              "kind": "LinkedField",
              "name": "applicant",
              "plural": false,
              "selections": [
                v9,
                v10,
                v11,
                v2
              ],
              "storageKey": null
            },
            v12,
            v13,
            v14,
            v15
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8116ed791bcaa64417a9375bbed09189",
      "id": null,
      "metadata": {},
      "name": "AccessGroupReviewListApplicantLayoutQuery",
      "operationKind": "query",
      "text": "query AccessGroupReviewListApplicantLayoutQuery(\n  $code: Int!\n) {\n  accessGroupReviewListApplicant: integrationAccessGroupReviewListApplicantByCode(code: $code) {\n    id\n    entityId\n    code\n    createdAt\n    updatedAt\n    reviewListApplicantId\n    applicantId\n    applicant {\n      applicantName\n      applicantSurname\n      primaryEmailAddress\n      id\n    }\n    jobId\n    jobRefNo\n    jobStatus\n    jobTitle\n  }\n}\n"
    }
  };
}();
node131.hash = "bf143777e8baf7ba81512829ceb0993e";
var AccessGroupReviewListApplicantLayoutQuery_graphql_default = node131;

// src/secure/integrations/access-group/review-list-applicants/AccessGroupReviewListApplicantLayout.tsx
import { Suspense as Suspense86 } from "react";
import { usePreloadedQuery as usePreloadedQuery16 } from "react-relay";
import { EdSkeleton as EdSkeleton61 } from "shared-ui";
import { timeAgo as timeAgo19 } from "shared-lib";
import { jsx as jsx125, jsxs as jsxs110 } from "react/jsx-runtime";
var accessGroupReviewListApplicantLayoutQueryDef = AccessGroupReviewListApplicantLayoutQuery_graphql_default;
var AccessGroupReviewListReviewListApplicantLayout = ({ queryRef }) => {
  const { accessGroupReviewListApplicant } = usePreloadedQuery16(
    accessGroupReviewListApplicantLayoutQueryDef,
    queryRef
  );
  if (!accessGroupReviewListApplicant) {
    return /* @__PURE__ */ jsx125(EdSkeleton61, {});
  }
  return /* @__PURE__ */ jsx125(Suspense86, { fallback: /* @__PURE__ */ jsx125(EdSkeleton61, {}), children: /* @__PURE__ */ jsx125("div", { className: "w-full border-t bg-white p-8", children: /* @__PURE__ */ jsxs110("div", { className: "flex w-full flex-col gap-2 bg-white p-8 md:w-2/3 xl:w-1/3", children: [
    /* @__PURE__ */ jsx125("div", { className: "flex items-center justify-between gap-2 border-b pb-2", children: /* @__PURE__ */ jsx125("h1", { className: "text-primary-500", children: "Access Group ReviewListApplicant" }) }),
    /* @__PURE__ */ jsxs110("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx125("div", { children: "Primary Email Address" }),
      /* @__PURE__ */ jsx125("div", { className: "text-primary-500 font-medium", children: accessGroupReviewListApplicant?.applicant?.primaryEmailAddress })
    ] }),
    /* @__PURE__ */ jsxs110("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx125("div", { children: "Job Title" }),
      /* @__PURE__ */ jsx125("div", { className: "text-primary-500 font-medium", children: accessGroupReviewListApplicant.jobTitle })
    ] }),
    /* @__PURE__ */ jsxs110("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx125("div", { children: "Updated" }),
      /* @__PURE__ */ jsx125("div", { className: "text-primary-500 font-medium", children: timeAgo19(accessGroupReviewListApplicant.updatedAt) })
    ] })
  ] }) }) });
};

// src/secure/integrations/access-group/review-list-applicants/AccessGroupReviewListApplicantContainer.tsx
import { useQueryPreloader as useQueryPreloader4 } from "shared-lib";
import { Fragment as Fragment47, jsx as jsx126, jsxs as jsxs111 } from "react/jsx-runtime";
var AccessGroupReviewListApplicantContainer = ({
  accessGroupReviewListApplicantCode,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery43] = useQueryPreloader4(
    accessGroupReviewListApplicantLayoutQueryDef,
    {
      code: accessGroupReviewListApplicantCode
    }
  );
  const [loading, startTransition4] = useTransition6();
  const onReload = useCallback52(() => {
    startTransition4(() => {
      loadQuery43(
        { code: accessGroupReviewListApplicantCode },
        { fetchPolicy: "network-only" }
      );
    });
  }, [loadQuery43]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx126("div", { className: "m-8", children: /* @__PURE__ */ jsx126(EdSkeleton62, {}) });
  }
  return /* @__PURE__ */ jsxs111(Suspense87, { fallback: /* @__PURE__ */ jsx126(EdSkeleton62, {}), children: [
    /* @__PURE__ */ jsx126("div", { className: "flex flex-col bg-white lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx126(MobileHeaderNavigation4, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx126(
      AccessGroupReviewListReviewListApplicantLayout,
      {
        queryRef: queryReference,
        onReload
      }
    )
  ] });
};
var MobileHeaderNavigation4 = ({
  queryRef,
  showExpand = true
}) => {
  const data = usePreloadedQuery17(
    accessGroupReviewListApplicantLayoutQueryDef,
    queryRef
  );
  if (!queryRef) {
    return /* @__PURE__ */ jsx126(Fragment47, {});
  }
  return /* @__PURE__ */ jsx126("div", { className: "flex flex-col-reverse md:flex-col md:p-4", children: /* @__PURE__ */ jsx126(
    MobileHeader4,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx126("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx126("div", { className: "text-2xl font-bold", children: data.accessGroupReviewListApplicant?.applicant?.primaryEmailAddress || "" }) })
    }
  ) });
};

// src/secure/integrations/access-group/review-list-applicants/AccessGroupReviewListApplicantList.tsx
import { Fragment as Fragment48, jsx as jsx127 } from "react/jsx-runtime";
var fragmentDef17 = AccessGroupReviewListApplicantList_list_graphql_default;
function displayName4(name) {
  if (!name) {
    return /* @__PURE__ */ jsx127("div", { className: "truncate whitespace-pre-line break-all", children: "Unknown" });
  }
  return /* @__PURE__ */ jsx127("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
function accessGroupReviewListApplicantListHeader(item) {
  return /* @__PURE__ */ jsx127("div", { className: "flex w-full items-center", children: /* @__PURE__ */ jsx127("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsx127("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ jsx127("div", { className: "text-primary-900", children: displayName4(item?.applicant?.primaryEmailAddress) }) }) }) });
}
function itemHeader4(item) {
  return /* @__PURE__ */ jsx127("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx127("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsx127("div", { className: "flex w-full items-center text-xs lg:text-base", children: /* @__PURE__ */ jsx127("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: /* @__PURE__ */ jsx127("span", { className: "font-bold", children: item?.applicant?.primaryEmailAddress }) }) }) }) });
}
var AccessGroupReviewListReviewListApplicantList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment15(fragmentDef17, fragmentRef);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined13).map((item) => {
    return {
      key: item.node.code.toString(),
      listTitle: accessGroupReviewListApplicantListHeader(item.node),
      itemTitle: itemHeader4(item.node),
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx127(
        AccessGroupReviewListApplicantContainer,
        {
          accessGroupReviewListApplicantCode: item.node.code
        }
      )
    };
  });
  const [loading, startTransition4] = useTransition7();
  const loadMore = useCallback53(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition4(() => {
      loadNext(5);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx127(Fragment48, { children: /* @__PURE__ */ jsx127(
    SectionedLayout4,
    {
      expandLink: (code) => `../reviewListApplicant/${code}`,
      title: "ReviewListApplicants",
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext || loading,
      emptyState: /* @__PURE__ */ jsx127("div", { className: "m-8", children: /* @__PURE__ */ jsx127("h1", { className: "text-primary-500", children: "No Access Group ReviewListApplicants Found" }) })
    }
  ) });
};

// src/secure/integrations/access-group/review-list-applicants/AccessGroupApplicantReviewListContainer.tsx
import { jsx as jsx128 } from "react/jsx-runtime";
var graphqlQuery8 = AccessGroupApplicantReviewListContainerQuery_graphql_default;
var AccessGroupApplicantReviewListContainer = ({
  accessGroupApplicantId
}) => {
  const where2 = {
    accessGroupApplicantId: { eq: accessGroupApplicantId }
  };
  const query = useLazyLoadQuery24(
    graphqlQuery8,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx128(Suspense88, { fallback: /* @__PURE__ */ jsx128(EdSkeleton63, {}), children: /* @__PURE__ */ jsx128(AccessGroupReviewListReviewListApplicantList, { fragmentRef: query }) });
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantLayout.tsx
import { jsx as jsx129, jsxs as jsxs112 } from "react/jsx-runtime";
var accessGroupApplicantLayoutQueryDef = AccessGroupApplicantLayoutQuery_graphql_default;
var AccessGroupApplicantLayout = ({ queryRef }) => {
  const { accessGroupApplicant } = usePreloadedQuery18(
    accessGroupApplicantLayoutQueryDef,
    queryRef
  );
  if (!accessGroupApplicant) {
    return /* @__PURE__ */ jsx129(EdSkeleton64, {});
  }
  return /* @__PURE__ */ jsx129(Suspense89, { fallback: /* @__PURE__ */ jsx129(EdSkeleton64, {}), children: /* @__PURE__ */ jsxs112("div", { className: "w-full border-t bg-white p-8", children: [
    /* @__PURE__ */ jsx129("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsxs112("div", { className: "flex w-full flex-col gap-2 bg-white p-8", children: [
      /* @__PURE__ */ jsx129("div", { className: "flex items-center justify-between gap-2 border-b pb-2", children: /* @__PURE__ */ jsx129("h1", { className: "text-primary-500", children: "Access Group Applicant" }) }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "SectorId" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.sectorIds })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "ApplicantId" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.applicantId })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Sync Status" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.syncStatus })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Primary Phone Number" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.primaryPhoneNo })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Primary Email Address" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.primaryEmailAddress })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Job Title" }),
        /* @__PURE__ */ jsx129("div", { className: "text-primary-500 font-medium", children: accessGroupApplicant.jobTitle })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Created" }),
        /* @__PURE__ */ jsxs112("div", { className: "text-primary-500 font-medium", children: [
          timeAgo20(accessGroupApplicant.createdAt),
          " /",
          " ",
          tryFormatDateHtml(accessGroupApplicant.createdAt)
        ] })
      ] }),
      /* @__PURE__ */ jsxs112("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx129("div", { children: "Updated" }),
        /* @__PURE__ */ jsxs112("div", { className: "text-primary-500 font-medium", children: [
          timeAgo20(accessGroupApplicant.updatedAt),
          " /",
          " ",
          tryFormatDateHtml(accessGroupApplicant.updatedAt)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs112("div", { className: "flex flex-col md:p-4", children: [
      /* @__PURE__ */ jsx129("div", { className: "text-primary-500 text-md border-b p-4", children: "Review Lists" }),
      /* @__PURE__ */ jsx129("div", { className: "", children: /* @__PURE__ */ jsx129(
        AccessGroupApplicantReviewListContainer,
        {
          accessGroupApplicantId: accessGroupApplicant.entityId
        }
      ) })
    ] })
  ] }) });
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantContainer.tsx
import { Fragment as Fragment49, jsx as jsx130, jsxs as jsxs113 } from "react/jsx-runtime";
var AccessGroupApplicantContainer = ({
  accessGroupApplicantCode,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery43] = useQueryPreloader5(
    accessGroupApplicantLayoutQueryDef,
    { code: accessGroupApplicantCode }
  );
  const onReload = useCallback54(() => {
    loadQuery43(
      { code: accessGroupApplicantCode },
      { fetchPolicy: "network-only" }
    );
  }, [loadQuery43]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx130("div", { className: "m-8", children: /* @__PURE__ */ jsx130(EdSkeleton65, {}) });
  }
  return /* @__PURE__ */ jsxs113(Suspense90, { fallback: /* @__PURE__ */ jsx130(EdSkeleton65, {}), children: [
    /* @__PURE__ */ jsx130(MynPageTitle57, { title: "Access Group Applicant Details" }),
    /* @__PURE__ */ jsx130("div", { className: "flex flex-col bg-white lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx130(MobileHeaderNavigation5, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx130(
      AccessGroupApplicantLayout,
      {
        queryRef: queryReference,
        onReload
      }
    )
  ] });
};
var MobileHeaderNavigation5 = ({
  queryRef,
  showExpand = true
}) => {
  const data = usePreloadedQuery19(
    accessGroupApplicantLayoutQueryDef,
    queryRef
  );
  if (!queryRef) {
    return /* @__PURE__ */ jsx130(Fragment49, {});
  }
  const { accessGroupApplicant } = data;
  if (!accessGroupApplicant) {
    return /* @__PURE__ */ jsx130("div", { children: "Loading" });
  }
  return /* @__PURE__ */ jsx130("div", { className: "flex flex-col-reverse md:flex-col md:p-4", children: /* @__PURE__ */ jsx130(
    MobileHeader5,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx130("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx130("div", { className: "text-2xl font-bold", children: data.accessGroupApplicant?.primaryEmailAddress || "" }) })
    }
  ) });
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantList.tsx
import { Fragment as Fragment50, jsx as jsx131 } from "react/jsx-runtime";
var fragmentDef18 = AccessGroupApplicantList_list_graphql_default;
function displayName5(name) {
  if (!name) {
    return /* @__PURE__ */ jsx131("div", { className: "truncate whitespace-pre-line break-all", children: "Unknown" });
  }
  return /* @__PURE__ */ jsx131("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
function accessGroupApplicantListHeader(item) {
  return /* @__PURE__ */ jsx131("div", { className: "flex w-full items-center", children: /* @__PURE__ */ jsx131("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsx131("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ jsx131("div", { className: "text-primary-900", children: displayName5(item.primaryEmailAddress) }) }) }) });
}
function itemHeader5(item) {
  return /* @__PURE__ */ jsx131("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx131("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsx131("div", { className: "flex w-full items-center text-xs lg:text-base", children: /* @__PURE__ */ jsx131("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: /* @__PURE__ */ jsx131("span", { className: "font-bold", children: item.primaryEmailAddress }) }) }) }) });
}
var AccessGroupApplicantList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment16(fragmentDef18, fragmentRef);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined14).map((item) => {
    return {
      key: item.node.code.toString(),
      listTitle: accessGroupApplicantListHeader(item.node),
      itemTitle: itemHeader5(item.node),
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx131(
        AccessGroupApplicantContainer,
        {
          accessGroupApplicantCode: item.node.code
        },
        item.node.code
      )
    };
  });
  const [loading, startTransition4] = useTransition8();
  const loadMore = useCallback55(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition4(() => {
      loadNext(5);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx131(Fragment50, { children: /* @__PURE__ */ jsx131(
    SectionedLayout5,
    {
      expandLink: (code) => `../applicant/${code}`,
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext || loading,
      emptyState: /* @__PURE__ */ jsx131("div", { className: "m-8", children: /* @__PURE__ */ jsx131("h1", { className: "text-primary-500", children: "No Access Group Applicants Found" }) })
    }
  ) });
};

// src/lib/UseRouteRegistry.ts
import { useEffect as useEffect7 } from "react";
import { useLocation as useLocation10 } from "react-router-dom";
import { useSetLinkRegistry } from "app-core";
var adminLinkRegistry = class {
  constructor(location) {
    this.location = location;
  }
  applicationLink(code) {
    return `/admin/app/recruit/applications/application/${code}`;
  }
};
function useAdminRouteRegistry() {
  const location = useLocation10();
  const setRegistry = useSetLinkRegistry();
  useEffect7(() => {
    console.log("useAdminRouteRegistry");
    const registry = new adminLinkRegistry(location);
    setRegistry(registry);
  }, []);
}

// src/lib/UseUserManager.ts
import { ElevateAccountTypes, Tenant } from "app-core";

// src/config/config.ts
import { useContext, useMemo as useMemo8 } from "react";
import {
  loadEnvironmentConfig,
  GlobalSettingsContext,
  PortalApps
} from "shared-lib";

// src/config/oidc.config.ts
import { ElevateScopes } from "app-core";
var oidc_config_default = {
  responseType: "id_token token",
  acrValues: "tenant:admin",
  clientId: "admin.web",
  apiPath: `gateway`,
  automaticSilentRenew: true,
  scope: `openid profile email ${ElevateScopes.NotificationsScope} ${ElevateScopes.IdentityAdminApiScope} ${ElevateScopes.IntegrationsAdminApiScope} ${ElevateScopes.RecruitApiScope} ${ElevateScopes.EventTrackingApiScope} ${ElevateScopes.VaultScope} ${ElevateScopes.CompaniesScope}`
};

// src/config/config.ts
function useConfig() {
  const settings = useContext(GlobalSettingsContext);
  const environmentConfig = useMemo8(() => {
    return loadEnvironmentConfig(settings, PortalApps.Admin);
  }, [settings]);
  return {
    ...oidc_config_default,
    ...environmentConfig
  };
}

// src/lib/UseUserManager.ts
function useAuthConfig() {
  const config = useConfig();
  const signoutRedirectUri = `${window.location.protocol}//${window.location.host}/portal/admin/signout-oidc`;
  return {
    ...config,
    autoSignIn: false,
    accountType: ElevateAccountTypes.Internal,
    tenant: Tenant.Admin,
    signoutRedirectUri,
    onSetUserData: async () => {
      window.location.hash = "";
    }
  };
}

// src/lib/AccessGroupApplication.ts
var applicantSortName = {
  id: "applicantName",
  name: "Applicant Name"
};
var syncStatusOptions = /* @__PURE__ */ ((syncStatusOptions2) => {
  syncStatusOptions2["PENDING"] = "PENDING";
  syncStatusOptions2["SYNCHRONISED"] = "SYNCHRONISED";
  syncStatusOptions2["FAILED"] = "FAILED";
  return syncStatusOptions2;
})(syncStatusOptions || {});
var applicantSortValues = [
  applicantSortName,
  {
    id: "primaryEmailAddress",
    name: "Applicant Email"
  },
  {
    id: "applicantSurname",
    name: "Applicant Surname"
  },
  {
    id: "updatedAt",
    name: "Updated On"
  },
  {
    id: "createdAt",
    name: "Created On"
  }
];

// src/secure/integrations/access-group/applicants/AccessGroupApplicantsContainer.tsx
import { formatDateHtml } from "shared-lib";
import { jsx as jsx132, jsxs as jsxs114 } from "react/jsx-runtime";
var graphqlQuery9 = AccessGroupApplicantsContainerQuery_graphql_default;
var AccessGroupApplicantsContainer = ({
  organisationId
}) => {
  const [searchTerm, setSearchTerm] = useState27(null);
  const [createdOnDate, setCreatedOnDate] = useState27(null);
  const [updatedOnDate, setUpdatedOnDate] = useState27(null);
  const [sortField, setSortField] = useState27(null);
  const [options, setOptions] = useState27({
    sortField: "applicantName",
    sortDir: SortDir2.Asc
  });
  const [syncStatus, setSyncStatus] = useState27(null);
  let where2 = {};
  where2.or = where2.or ? [...where2.or] : [];
  where2.and = where2.and ? [...where2.and] : [];
  let order2 = [{}];
  if (searchTerm && searchTerm !== "") {
    const searchText = searchTerm.trim();
    where2.or = [
      ...where2.or,
      { applicantName: { contains: searchText } },
      { applicantSurname: { contains: searchText } },
      { primaryEmailAddress: { contains: searchText } },
      { primaryPhoneNo: { contains: searchText } }
    ];
    if (!isNaN(Number(searchText))) {
      where2.or = [
        { applicantId: { eq: Number(searchText) } },
        { sectorIds: { some: { eq: Number(searchText) } } }
      ];
    }
  }
  if (syncStatus) {
    where2.and = [...where2.and, { syncStatus: { eq: syncStatus } }];
  }
  if (createdOnDate) {
    where2.and = [
      ...where2.and,
      { accessCreatedOn: { gt: formatDateHtml(createdOnDate) } }
    ];
  }
  if (updatedOnDate) {
    where2.and = [
      ...where2.and,
      { accessUpdatedOn: { gt: formatDateHtml(updatedOnDate) } }
    ];
  }
  if (options.sortField && options.sortDir) {
    order2 = [{ [options.sortField]: options.sortDir }];
  }
  const onSortChange = useCallback56(
    (item) => {
      const sortField2 = item?.id || "";
      setSortField(sortField2);
      if (sortField2 !== "createdAt") {
        setCreatedOnDate(null);
      }
      if (sortField2 !== "updatedAt") {
        setUpdatedOnDate(null);
      }
      setOptions({
        ...options,
        sortField: sortField2
      });
    },
    [options, setOptions]
  );
  const onSortDirChange = useCallback56(
    (order3) => {
      const sortDir = order3;
      setOptions({
        ...options,
        sortDir
      });
    },
    [options, setOptions]
  );
  const query = useLazyLoadQuery25(
    graphqlQuery9,
    { where: where2, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx132(Suspense91, { fallback: /* @__PURE__ */ jsx132(EdSkeleton66, {}), children: /* @__PURE__ */ jsxs114("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs114("div", { className: "flex items-center gap-2 bg-white", children: [
      /* @__PURE__ */ jsxs114("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx132("div", { className: "p-2", children: "Search" }),
        /* @__PURE__ */ jsx132(
          InformationCircleIcon2,
          {
            className: "ml-2 h-5 w-5 flex-shrink-0",
            "aria-hidden": "true",
            title: `
Search Applicant By:
"ApplicantName"
"ApplicantSurname"
"PrimaryEmailAddress"
"PrimaryPhoneNo"
"ApplicantId"
"SectorId"
`
          }
        ),
        /* @__PURE__ */ jsx132("div", { className: "p-2", children: /* @__PURE__ */ jsx132(TextQueryFilter2, { placeholder: "Search", onChanged: setSearchTerm }) })
      ] }),
      /* @__PURE__ */ jsxs114("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx132("div", { className: "p-2", children: "Sync status" }),
        /* @__PURE__ */ jsx132("div", { className: "p-2", children: /* @__PURE__ */ jsxs114(
          "select",
          {
            id: "syncStatus",
            name: "syncStatus",
            "aria-label": "Filter By",
            value: syncStatus || "",
            className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-md border-gray-300",
            onChange: (e) => setSyncStatus(e.target.value),
            children: [
              syncStatus === null && /* @__PURE__ */ jsx132("option", { children: "(Choose)" }),
              Object.values(syncStatusOptions).map((i) => /* @__PURE__ */ jsx132("option", { value: i, children: i.toLowerCase() }, i))
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs114("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx132("div", { className: "p-2", children: "Order by" }),
        /* @__PURE__ */ jsxs114("div", { className: "flex grow items-center gap-2", children: [
          /* @__PURE__ */ jsx132(
            SingleFilter,
            {
              widthClass: "xl:min-w-[200px] md:w-48 grow",
              selected: options.sortField,
              values: applicantSortValues,
              defaultValue: applicantSortName,
              onChanged: onSortChange
            }
          ),
          /* @__PURE__ */ jsxs114("div", { className: "flex items-center gap-2", children: [
            sortField === "createdAt" && /* @__PURE__ */ jsx132("div", { className: "p-2", children: /* @__PURE__ */ jsx132(
              UncontrolledDateInput,
              {
                name: "createdAt",
                value: createdOnDate?.toISOString().split("T")[0],
                onChanged: (x) => setCreatedOnDate(new Date(x))
              }
            ) }),
            sortField === "updatedAt" && /* @__PURE__ */ jsx132("div", { className: "p-2", children: /* @__PURE__ */ jsx132(
              UncontrolledDateInput,
              {
                name: "updatedAt",
                value: updatedOnDate?.toISOString().split("T")[0],
                onChanged: (x) => setUpdatedOnDate(new Date(x))
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx132("div", { children: /* @__PURE__ */ jsx132(
            SortDirectionList2,
            {
              value: options.sortDir,
              onChanged: onSortDirChange
            }
          ) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx132("div", { className: "border", children: /* @__PURE__ */ jsx132(AccessGroupApplicantList, { fragmentRef: query }) })
  ] }) });
};

// src/secure/integrations/access-group/applicants/__generated__/AccessGroupApplicantPullLayoutQuery.graphql.ts
var node132 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "instances",
      "args": null,
      "concreteType": "IntegrationAccessGroupInstancesConnection",
      "kind": "LinkedField",
      "name": "integrationAccessGroupInstances",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationAccessGroupInstancesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AccessGroupInstance",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "baseUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AccessGroupApplicantPullLayoutQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AccessGroupApplicantPullLayoutQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "edea1c7fa9f3c3149ce63fdf802f7234",
      "id": null,
      "metadata": {},
      "name": "AccessGroupApplicantPullLayoutQuery",
      "operationKind": "query",
      "text": "query AccessGroupApplicantPullLayoutQuery {\n  instances: integrationAccessGroupInstances {\n    edges {\n      node {\n        id\n        entityId\n        code\n        createdAt\n        updatedAt\n        baseUrl\n      }\n    }\n  }\n}\n"
    }
  };
}();
node132.hash = "90bc605b7f118b668230d6a839b444ac";
var AccessGroupApplicantPullLayoutQuery_graphql_default = node132;

// src/secure/integrations/access-group/applicants/AccessGroupApplicantPullLayout.tsx
import { Suspense as Suspense93, useCallback as useCallback58, useState as useState29 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery26 } from "react-relay";
import { EdSkeleton as EdSkeleton68, MynPageTitle as MynPageTitle58, RadioList } from "shared-ui";

// src/secure/integrations/access-group/applicants/AccessGroupApplicantPullForm.tsx
import { Suspense as Suspense92, useCallback as useCallback57, useState as useState28 } from "react";
import { createClientMutationId as createClientMutationId21, useSetUserErrorCodes as useSetUserErrorCodes3 } from "shared-lib";
import { Button as Button34, EdSkeleton as EdSkeleton67 } from "shared-ui";
import { TextQueryFilter as TextQueryFilter3 } from "feature-recruit";
import { jsx as jsx133, jsxs as jsxs115 } from "react/jsx-runtime";
var AccessGroupApplicantPullForm = ({
  accessGroupInstanceId
}) => {
  const [applicantId, setApplicantId] = useState28(null);
  const [pullAccessGroupApplicant, isPullingAccessGroupApplicant] = usePullAccessGroupApplicantMutation();
  const setErrorCode = useSetUserErrorCodes3();
  const onPull = useCallback57(async () => {
    if (!applicantId) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId21(),
      applicantId: Number(applicantId),
      instanceId: accessGroupInstanceId
    };
    const response = await pullAccessGroupApplicant({ input });
    if (response.pull.userErrors && response.pull.userErrors.length > 0) {
      setErrorCode(response.pull.userErrors);
    }
  }, [pullAccessGroupApplicant]);
  return /* @__PURE__ */ jsx133(Suspense92, { fallback: /* @__PURE__ */ jsx133(EdSkeleton67, {}), children: /* @__PURE__ */ jsx133("div", { className: "flex flex-col bg-white lg:flex-col-reverse", children: /* @__PURE__ */ jsxs115("div", { className: "flex w-full flex-col gap-2 bg-white p-8", children: [
    /* @__PURE__ */ jsx133("div", { className: "flex items-center justify-between gap-2 border-b pb-2", children: /* @__PURE__ */ jsx133("h1", { className: "text-primary-500", children: "Actions" }) }),
    /* @__PURE__ */ jsxs115("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx133("div", { className: "p-2", children: "Access Applicant Id" }),
      /* @__PURE__ */ jsx133("div", { className: "p-2", children: /* @__PURE__ */ jsx133(
        TextQueryFilter3,
        {
          type: "number",
          placeholder: "applicantId",
          onChanged: (v) => setApplicantId(Number(v))
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx133("div", { className: "flex-1 justify-end", children: /* @__PURE__ */ jsx133(Button34, { color: "warning", clicked: onPull, children: "Pull From Access" }) })
  ] }) }) });
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantPullLayout.tsx
import { jsx as jsx134, jsxs as jsxs116 } from "react/jsx-runtime";
var queryDef45 = AccessGroupApplicantPullLayoutQuery_graphql_default;
var AccessGroupApplicantPullLayout = ({}) => {
  const [instanceId, setInstanceId] = useState29(null);
  const { instances } = useLazyLoadQuery26(
    queryDef45,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const onSelect = useCallback58(
    async (item) => {
      setInstanceId(item.id);
    },
    [setInstanceId]
  );
  if (!instances) {
    return /* @__PURE__ */ jsx134(EdSkeleton68, {});
  }
  const items = (instances.edges ?? []).map((i) => {
    return {
      id: i.node.entityId,
      label: i.node.baseUrl
    };
  });
  return /* @__PURE__ */ jsxs116(Suspense93, { fallback: /* @__PURE__ */ jsx134(EdSkeleton68, {}), children: [
    /* @__PURE__ */ jsx134(MynPageTitle58, { title: "Access Group Applicant Tasks" }),
    /* @__PURE__ */ jsx134("div", { className: "bg-white p-4", children: /* @__PURE__ */ jsxs116("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs116("div", { className: "flex items-center gap-2 border-b px-8 py-2", children: [
        /* @__PURE__ */ jsx134("div", { className: "text-primary-500 p-2", children: "Select Access Group Instance" }),
        /* @__PURE__ */ jsx134("div", { className: "p-2", children: /* @__PURE__ */ jsx134(RadioList, { list: items, value: instanceId, onChange: onSelect }) })
      ] }),
      instanceId && /* @__PURE__ */ jsx134("div", { className: "p-2", children: /* @__PURE__ */ jsx134(
        AccessGroupApplicantPullForm,
        {
          accessGroupInstanceId: instanceId
        }
      ) })
    ] }) })
  ] });
};

// src/secure/integrations/access-group/applicants/AccessGroupApplicantsRoute.tsx
import { jsx as jsx135, jsxs as jsxs117 } from "react/jsx-runtime";
var Layout9 = () => {
  const location = useLocation11();
  const tabs4 = [
    createLinkState10(location, "Applicants", `list`, UsersIcon3),
    createLinkState10(location, "Tasks", `tasks`, BoltIcon)
  ];
  return /* @__PURE__ */ jsxs117(Suspense94, { fallback: /* @__PURE__ */ jsx135(EdSkeleton69, {}), children: [
    /* @__PURE__ */ jsx135(MynPageTitle59, { title: "Access Group Applicants" }),
    /* @__PURE__ */ jsx135("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx135(TabUnderline7, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx135(Outlet21, {})
  ] });
};
var AccessGroupApplicantsListRoute = () => {
  return /* @__PURE__ */ jsx135(Suspense94, { fallback: /* @__PURE__ */ jsx135(EdSkeleton69, {}), children: /* @__PURE__ */ jsx135(AccessGroupApplicantsContainer, {}) });
};
var createAccessGroupApplicantsRoutes = (environment, context, parentRouteId) => {
  const routeId6 = `${parentRouteId}-layout`;
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx135(Layout9, {}),
      errorElement: /* @__PURE__ */ jsx135(ErrorContainer10, {}),
      children: [
        {
          path: "list/*",
          element: /* @__PURE__ */ jsx135(AccessGroupApplicantsListRoute, {})
        },
        {
          path: "tasks/*",
          element: /* @__PURE__ */ jsx135(AccessGroupApplicantPullLayout, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx135(Navigate30, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/integrations/access-group/AccessGroupRoute.tsx
import { jsx as jsx136, jsxs as jsxs118 } from "react/jsx-runtime";
var Layout10 = () => {
  const location = useLocation12();
  const tabs4 = [
    createLinkState11(location, "Home", `home`, FolderIcon),
    createLinkState11(location, "Instances", `instances`, CloudIcon),
    createLinkState11(location, "Contract Jobs", `contract-jobs`, DocumentIcon2),
    createLinkState11(location, "Applicants", `applicants`, UserIcon2)
  ];
  return /* @__PURE__ */ jsxs118("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx136(MynPageTitle60, { title: "Access Group" }),
    /* @__PURE__ */ jsx136("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx136(TabPills3, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx136(Outlet22, {})
  ] });
};
var createAccessGroupRoutes = (environment, context) => {
  const routeId6 = "access-group";
  return [
    {
      path: "*",
      id: routeId6,
      element: /* @__PURE__ */ jsx136(Layout10, {}),
      errorElement: /* @__PURE__ */ jsx136(ErrorContainer11, {}),
      children: [
        {
          id: `${routeId6}-home`,
          path: "home/*",
          element: /* @__PURE__ */ jsx136(AccessGroupLayout, {})
        },
        {
          id: `${routeId6}-instances`,
          path: "instances/*",
          element: /* @__PURE__ */ jsx136(OutletRoute18, {}),
          children: createAccessGroupInstancesRoutes(
            environment,
            context,
            `${routeId6}-instances`
          )
        },
        {
          id: `${routeId6}-contract-jobs`,
          path: "contract-jobs/*",
          element: /* @__PURE__ */ jsx136(OutletRoute18, {}),
          children: createAccessGroupContractJobsRoutes(
            environment,
            context,
            `${routeId6}-contract-jobs`
          )
        },
        {
          id: `${routeId6}-applicants`,
          path: "applicants/*",
          element: /* @__PURE__ */ jsx136(OutletRoute18, {}),
          children: createAccessGroupApplicantsRoutes(
            environment,
            context,
            `${routeId6}-applicants`
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx136(Navigate31, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/secure/integrations/IntegrationsLayout.tsx
import { jsx as jsx137, jsxs as jsxs119 } from "react/jsx-runtime";
var IntegrationsHome = () => {
  const navigate = useNavigate19();
  return /* @__PURE__ */ jsx137(Suspense95, { fallback: "Loading Integrations...", children: /* @__PURE__ */ jsxs119(ErrorBoundary14, { FallbackComponent: ErrorBoundaryFallback15, children: [
    /* @__PURE__ */ jsx137(MynPageTitle61, { title: "Integrations" }),
    /* @__PURE__ */ jsxs119("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx137(PageHeading9, { children: "Integrations" }),
      /* @__PURE__ */ jsxs119(EdGridLayout, { children: [
        /* @__PURE__ */ jsx137(
          EdCard,
          {
            title: "Commercial Services Group",
            description: /* @__PURE__ */ jsx137("div", { className: "prose-xl text-gray-900", children: "CSG" }),
            onSelected: () => {
              navigate(`csg`);
            }
          }
        ),
        /* @__PURE__ */ jsx137(
          EdCard,
          {
            title: "Access Group",
            description: /* @__PURE__ */ jsx137("div", { className: "prose-xl text-gray-900", children: "Access Group RCRM" }),
            onSelected: () => {
              navigate(`access-group`);
            }
          }
        ),
        /* @__PURE__ */ jsx137(
          EdCard,
          {
            title: "Elevate Configuration",
            description: /* @__PURE__ */ jsx137("div", { className: "prose-xl text-gray-900", children: "Elevate Configuration" }),
            onSelected: () => {
              navigate(`config`);
            }
          }
        ),
        /* @__PURE__ */ jsx137(
          EdCard,
          {
            title: "Custom Data",
            description: /* @__PURE__ */ jsx137("div", { className: "prose-xl text-gray-900", children: "Custom Data" }),
            onSelected: () => {
              navigate(`custom-data`);
            }
          }
        )
      ] })
    ] })
  ] }) });
};
var createIntegrationsRoutes = (environment, context) => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx137(IntegrationsHome, {})
    },
    {
      path: "config/*",
      element: /* @__PURE__ */ jsx137(IntegrationsConfigLayoutPage, { integrationsUrl: "../" })
    },
    {
      path: "custom-data/*",
      element: /* @__PURE__ */ jsx137(CustomDataFieldMappingsLayoutPage, { integrationsUrl: "../" })
    },
    {
      path: "csg/*",
      element: /* @__PURE__ */ jsx137(CsgLayout, {}),
      children: createCsgRoutes(environment, context)
    },
    {
      path: "access-group/*",
      element: /* @__PURE__ */ jsx137(OutletRoute19, {}),
      children: createAccessGroupRoutes(environment, context)
    }
  ];
};

// src/secure/notifications/AdminNotificationsLayout.tsx
import { Suspense as Suspense98 } from "react";
import { Navigate as Navigate32 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary15 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback16, OutletRoute as OutletRoute20 } from "app-core";
import {
  NotificationTypeLayout,
  NotificationCreateLayout
} from "feature-notifications";
import { EdLink as EdLink10, MynPageTitle as MynPageTitle64 } from "shared-ui";

// src/secure/notifications/pages/TemplatesRoute.tsx
import { Suspense as Suspense96 } from "react";
import { useNavigate as useNavigate20 } from "react-router-dom";
import { PlusIcon as PlusIcon4 } from "@heroicons/react/24/solid";
import { EmailTemplatesListContainer } from "feature-notifications";
import { Button as Button35, EdLink as EdLink9, Loading as Loading3, MynPageTitle as MynPageTitle62, PageHeading as PageHeading10 } from "shared-ui";
import { jsx as jsx138, jsxs as jsxs120 } from "react/jsx-runtime";
var TemplatesRoute = () => {
  const navigate = useNavigate20();
  return /* @__PURE__ */ jsx138(Suspense96, { fallback: /* @__PURE__ */ jsx138(Loading3, { label: "Loading Notifications..." }), children: /* @__PURE__ */ jsxs120("div", { className: "p-2", children: [
    /* @__PURE__ */ jsxs120("div", { className: "flex items-baseline border-b", children: [
      /* @__PURE__ */ jsx138(MynPageTitle62, { title: "Email Templates" }),
      /* @__PURE__ */ jsx138(PageHeading10, { children: "Templates" }),
      /* @__PURE__ */ jsx138("div", { children: /* @__PURE__ */ jsx138(EdLink9, { href: "../template-create", name: "Create template", children: /* @__PURE__ */ jsxs120(Button35, { "aria-label": "Create Template", color: "primary", children: [
        "Create Template\xA0",
        /* @__PURE__ */ jsx138(PlusIcon4, { className: "h-5 w-5" })
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx138(
      EmailTemplatesListContainer,
      {
        onSelect: ({ tenant, notificationType, templateType }) => {
          navigate(
            `../template/${tenant}/${notificationType}/${templateType}`
          );
        }
      }
    )
  ] }) });
};

// src/secure/notifications/pages/NotificationsRoute.tsx
import { Suspense as Suspense97 } from "react";
import { useNavigate as useNavigate21 } from "react-router-dom";
import { Loading as Loading4, MynPageTitle as MynPageTitle63, PageHeading as PageHeading11 } from "shared-ui";
import { EmailNotificationsListContainer as EmailNotificationsListContainer2 } from "feature-notifications";
import { jsx as jsx139, jsxs as jsxs121 } from "react/jsx-runtime";
var NotificationsRoute = () => {
  const navigate = useNavigate21();
  return /* @__PURE__ */ jsxs121(Suspense97, { fallback: /* @__PURE__ */ jsx139(Loading4, { label: "Loading Notifications..." }), children: [
    /* @__PURE__ */ jsx139(MynPageTitle63, { title: "Email Notifications" }),
    /* @__PURE__ */ jsx139("div", { className: "bg-white ", children: /* @__PURE__ */ jsx139("div", { className: "flex items-baseline border-b", children: /* @__PURE__ */ jsx139(PageHeading11, { children: "Notifications" }) }) }),
    /* @__PURE__ */ jsx139(
      EmailNotificationsListContainer2,
      {
        onSelectItem: ({ id }) => {
          navigate(`../notification/${id}`);
        }
      }
    )
  ] });
};

// src/secure/notifications/AdminNotificationsLayout.tsx
import { jsx as jsx140, jsxs as jsxs122 } from "react/jsx-runtime";
var tabs2 = [
  {
    label: "Email Templates",
    to: "../templates",
    description: "Email Templates"
  },
  {
    label: "Email Notifications",
    to: "../notifications",
    description: "Email Notifications"
  }
];
var AdminNotificationsLayout = () => {
  const links = tabs2.map((t) => {
    return /* @__PURE__ */ jsxs122(
      EdLink10,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx140("div", { className: "text-primary-700 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx140("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsxs122(Suspense98, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx140(MynPageTitle64, { title: "Notifications" }),
    /* @__PURE__ */ jsx140(ErrorBoundary15, { FallbackComponent: ErrorBoundaryFallback16, children: /* @__PURE__ */ jsx140("div", { className: "flex sm:m-8", children: /* @__PURE__ */ jsx140("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links }) }) })
  ] });
};
var createNotificationRoutes = (environment, context) => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx140(OutletRoute20, {}),
      children: [
        {
          path: "home/*",
          element: /* @__PURE__ */ jsx140(AdminNotificationsLayout, {})
        },
        {
          path: "templates/*",
          element: /* @__PURE__ */ jsx140(TemplatesRoute, {})
        },
        {
          path: "template-create/*",
          element: /* @__PURE__ */ jsx140(NotificationCreateLayout, {})
        },
        {
          path: "template/:tenant/:id/:type/*",
          element: /* @__PURE__ */ jsx140(NotificationTypeLayout, {})
        },
        {
          path: "notifications/*",
          element: /* @__PURE__ */ jsx140(NotificationsRoute, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx140(Navigate32, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/secure/workflows/pages/WorkflowDesignerPage.tsx
import { MynPageTitle as MynPageTitle65 } from "shared-ui";
import { jsx as jsx141, jsxs as jsxs123 } from "react/jsx-runtime";
var WorkflowDesignerPage = () => {
  return /* @__PURE__ */ jsxs123("div", { children: [
    /* @__PURE__ */ jsx141(MynPageTitle65, { title: "Workflow Designer" }),
    /* @__PURE__ */ jsx141("div", { className: "m-8", children: "Workflow Designer Is Hosted In A Specific Admin Portal" })
  ] });
};

// src/secure/workflows/pages/WorkflowHomePage.tsx
import { jsx as jsx142 } from "react/jsx-runtime";
var WorkflowHomePage = () => {
  return /* @__PURE__ */ jsx142("div", { children: "Workflows" });
};

// src/secure/workflows/WorkflowsLayout.tsx
import { Routes as Routes4, Route as Route4, useLocation as useLocation13 } from "react-router-dom";
import { PhotoIcon as PhotoIcon2, Squares2X2Icon as Squares2X2Icon2 } from "@heroicons/react/24/outline";
import { ErrorBoundary as ErrorBoundary16 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback17 } from "app-core";
import { createLinkState as createLinkState12, MynPageTitle as MynPageTitle66, TabPills as TabPills4 } from "shared-ui";
import { jsx as jsx143, jsxs as jsxs124 } from "react/jsx-runtime";
var WorkflowsLayout = () => {
  const location = useLocation13();
  const tabs4 = [
    createLinkState12(location, "Workflows", ``, Squares2X2Icon2),
    createLinkState12(location, "Designer", `designer`, PhotoIcon2)
  ];
  return /* @__PURE__ */ jsxs124(ErrorBoundary16, { FallbackComponent: ErrorBoundaryFallback17, children: [
    /* @__PURE__ */ jsx143(MynPageTitle66, { title: "Workflows" }),
    /* @__PURE__ */ jsx143("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx143(TabPills4, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsxs124(Routes4, { children: [
      /* @__PURE__ */ jsx143(Route4, { path: "/", element: /* @__PURE__ */ jsx143(WorkflowHomePage, {}) }),
      /* @__PURE__ */ jsx143(Route4, { path: "/designer", element: /* @__PURE__ */ jsx143(WorkflowDesignerPage, {}) })
    ] })
  ] });
};

// src/secure/system/SystemsLayout.tsx
import { Routes as Routes6, Route as Route6 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary17 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback18 } from "app-core";

// src/secure/system/components/SystemConfigurationLayout.tsx
import { Navigate as Navigate33, Route as Route5, Routes as Routes5, useLocation as useLocation14 } from "react-router-dom";
import { Squares2X2Icon as Squares2X2Icon3 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState13, TabPills as TabPills5 } from "shared-ui";

// src/secure/system/components/hosting/__generated__/HostingTenantsContainerQuery.graphql.ts
var node133 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "HostingTenantsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostingTenantsList_tenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "HostingTenantsContainerQuery",
      "selections": [
        {
          "alias": "tenants",
          "args": v1,
          "concreteType": "PlatformHostingTenantsConnection",
          "kind": "LinkedField",
          "name": "platformHostingTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PlatformHostingTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HostingTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HostStyleConfiguration",
                      "kind": "LinkedField",
                      "name": "styling",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "faviconUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryColor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "secondaryColor",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tenants",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "HostingTenantsList_tenants",
          "kind": "LinkedHandle",
          "name": "platformHostingTenants"
        }
      ]
    },
    "params": {
      "cacheID": "fe2642917c311ee5aac2891087999ca9",
      "id": null,
      "metadata": {},
      "name": "HostingTenantsContainerQuery",
      "operationKind": "query",
      "text": "query HostingTenantsContainerQuery(\n  $order: [HostingTenantSortInput!]!\n  $where: HostingTenantFilter!\n) {\n  ...HostingTenantsList_tenants\n}\n\nfragment HostingTenantRow_tenant on HostingTenant {\n  id\n  name\n  isDefault\n  version\n  styling {\n    faviconUrl\n    logoUrl\n    primaryColor\n    secondaryColor\n  }\n}\n\nfragment HostingTenantsList_tenants on Query {\n  tenants: platformHostingTenants(first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...HostingTenantRow_tenant\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node133.hash = "b47542d5a91ce3b2e00a0ac2190e9096";
var HostingTenantsContainerQuery_graphql_default = node133;

// src/secure/system/components/hosting/HostingTenantsContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery27 } from "react-relay/hooks";

// src/secure/system/components/hosting/__generated__/HostingTenantsListPaginationQuery.graphql.ts
var node134 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "HostingTenantsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "HostingTenantsList_tenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "HostingTenantsListPaginationQuery",
      "selections": [
        {
          "alias": "tenants",
          "args": v3,
          "concreteType": "PlatformHostingTenantsConnection",
          "kind": "LinkedField",
          "name": "platformHostingTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PlatformHostingTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HostingTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HostStyleConfiguration",
                      "kind": "LinkedField",
                      "name": "styling",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "faviconUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryColor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "secondaryColor",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tenants",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "HostingTenantsList_tenants",
          "kind": "LinkedHandle",
          "name": "platformHostingTenants"
        }
      ]
    },
    "params": {
      "cacheID": "dc95576d47292e878654c9aabc053687",
      "id": null,
      "metadata": {},
      "name": "HostingTenantsListPaginationQuery",
      "operationKind": "query",
      "text": "query HostingTenantsListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [HostingTenantSortInput!]\n  $where: HostingTenantFilter\n) {\n  ...HostingTenantsList_tenants_2HEEH6\n}\n\nfragment HostingTenantRow_tenant on HostingTenant {\n  id\n  name\n  isDefault\n  version\n  styling {\n    faviconUrl\n    logoUrl\n    primaryColor\n    secondaryColor\n  }\n}\n\nfragment HostingTenantsList_tenants_2HEEH6 on Query {\n  tenants: platformHostingTenants(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...HostingTenantRow_tenant\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node134.hash = "3142d2441a11a8a5873cc2fd8550137c";
var HostingTenantsListPaginationQuery_graphql_default = node134;

// src/secure/system/components/hosting/__generated__/HostingTenantsList_tenants.graphql.ts
var node135 = /* @__PURE__ */ function() {
  var v0 = [
    "tenants"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": HostingTenantsListPaginationQuery_graphql_default
      }
    },
    "name": "HostingTenantsList_tenants",
    "selections": [
      {
        "alias": "tenants",
        "args": null,
        "concreteType": "PlatformHostingTenantsConnection",
        "kind": "LinkedField",
        "name": "__HostingTenantsList_tenants_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlatformHostingTenantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HostingTenant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "HostingTenantRow_tenant"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node135.hash = "3142d2441a11a8a5873cc2fd8550137c";
var HostingTenantsList_tenants_graphql_default = node135;

// src/secure/system/components/hosting/HostingTenantsList.tsx
import { useCallback as useCallback60 } from "react";
import { usePaginationFragment as usePaginationFragment17 } from "react-relay/hooks";
import { isNotNull } from "shared-lib";
import { EdListHeader, EdTable } from "shared-ui";

// src/secure/system/components/hosting/__generated__/HostingTenantRow_tenant.graphql.ts
var node136 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HostingTenantRow_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HostStyleConfiguration",
      "kind": "LinkedField",
      "name": "styling",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "faviconUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HostingTenant",
  "abstractKey": null
};
node136.hash = "8b38852fb7ddc252577433e1277354d3";
var HostingTenantRow_tenant_graphql_default = node136;

// src/secure/system/components/hosting/HostingTenantRow.tsx
import { useCallback as useCallback59 } from "react";
import { useFragment as useFragment8 } from "react-relay";
import {
  EdActionCell,
  EdColumnCell,
  EdRow,
  LinkButton as LinkButton4
} from "shared-ui";
import { jsx as jsx144, jsxs as jsxs125 } from "react/jsx-runtime";
var fragmentDef19 = HostingTenantRow_tenant_graphql_default;
var HostingTenantTableColumns = [
  { id: "name", name: "Name" },
  { id: "isDefault", name: "Default" },
  { id: "version", name: "Version" },
  { id: "styling", name: "Styling" }
];
var HostingTenantRow = ({
  fragmentRef,
  selected
}) => {
  const data = useFragment8(fragmentDef19, fragmentRef);
  const select = useCallback59(() => {
    selected(data);
  }, [data, selected]);
  return /* @__PURE__ */ jsxs125(EdRow, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx144(EdColumnCell, { children: data.name }),
    /* @__PURE__ */ jsx144(EdColumnCell, { children: data.isDefault ? "Yes" : "No" }),
    /* @__PURE__ */ jsx144(EdColumnCell, { children: data.version }),
    /* @__PURE__ */ jsxs125(EdColumnCell, { children: [
      data.styling?.faviconUrl && /* @__PURE__ */ jsxs125("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx144("div", { className: "text-primary-700 w-16", children: "favicon" }),
        /* @__PURE__ */ jsx144("div", { children: data.styling?.faviconUrl })
      ] }),
      data.styling?.logoUrl && /* @__PURE__ */ jsxs125("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx144("div", { className: "text-primary-700 w-16", children: "logo" }),
        /* @__PURE__ */ jsx144("div", { children: data.styling?.logoUrl })
      ] })
    ] }),
    /* @__PURE__ */ jsx144(EdActionCell, { children: /* @__PURE__ */ jsx144(LinkButton4, { label: "Select", clicked: select }) })
  ] });
};

// src/secure/system/components/hosting/HostingTenantsList.tsx
import { jsx as jsx145, jsxs as jsxs126 } from "react/jsx-runtime";
var fragmentDef20 = HostingTenantsList_tenants_graphql_default;
var HostingTenantsList = ({
  fragmentRef
}) => {
  const paging = usePaginationFragment17(fragmentDef20, fragmentRef);
  const { data, refetch } = paging;
  const onSortChanged = useCallback60((columns) => {
    console.log(columns);
  }, []);
  const rows = data.tenants?.edges?.map((e) => e.node).filter(isNotNull).map((e) => {
    return /* @__PURE__ */ jsx145(
      HostingTenantRow,
      {
        fragmentRef: e,
        selected: () => {
          console.log(e);
        }
      },
      e.id
    );
  });
  return /* @__PURE__ */ jsxs126("div", { className: "flex flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsx145(EdListHeader, { total: data.tenants?.totalCount, paging }),
    /* @__PURE__ */ jsx145("div", { className: "flex ", children: /* @__PURE__ */ jsx145("div", { className: "w-full", children: /* @__PURE__ */ jsx145(
      EdTable,
      {
        defaultColumns: HostingTenantTableColumns,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/secure/system/components/hosting/HostingTenantsContainer.tsx
import { MynPageTitle as MynPageTitle67 } from "shared-ui";
import { jsx as jsx146, jsxs as jsxs127 } from "react/jsx-runtime";
var queryDef46 = HostingTenantsContainerQuery_graphql_default;
var HostingTenantsContainer = () => {
  const order2 = [{ updatedOn: "DESC" }];
  const where2 = {};
  const query = useLazyLoadQuery27(
    queryDef46,
    { order: order2, where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs127("div", { children: [
    /* @__PURE__ */ jsx146(MynPageTitle67, { title: "Hosting Tenants" }),
    /* @__PURE__ */ jsx146("div", { className: "mb-2 py-2", children: /* @__PURE__ */ jsx146("h1", { children: "Hosting Tenants" }) }),
    /* @__PURE__ */ jsx146(HostingTenantsList, { fragmentRef: query })
  ] });
};

// src/secure/system/components/SystemConfigurationLayout.tsx
import { jsx as jsx147, jsxs as jsxs128 } from "react/jsx-runtime";
var SystemConfigurationLayout = () => {
  const location = useLocation14();
  const tabs4 = [
    createLinkState13(location, "Hosting", `hosting`, Squares2X2Icon3)
  ];
  return /* @__PURE__ */ jsxs128("div", { className: "m-4 p-4", children: [
    /* @__PURE__ */ jsx147("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx147(TabPills5, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsxs128(Routes5, { children: [
      /* @__PURE__ */ jsx147(Route5, { path: "/", element: /* @__PURE__ */ jsx147(Navigate33, { to: "hosting" }) }),
      /* @__PURE__ */ jsx147(
        Route5,
        {
          path: "/hosting/*",
          element: /* @__PURE__ */ jsx147("div", { className: "p-2", children: /* @__PURE__ */ jsx147(HostingTenantsContainer, {}) })
        }
      )
    ] })
  ] });
};

// src/secure/system/SystemsLayout.tsx
import { jsx as jsx148 } from "react/jsx-runtime";
var SystemsLayout = () => {
  return /* @__PURE__ */ jsx148(ErrorBoundary17, { FallbackComponent: ErrorBoundaryFallback18, children: /* @__PURE__ */ jsx148(Routes6, { children: /* @__PURE__ */ jsx148(Route6, { path: "/*", element: /* @__PURE__ */ jsx148(SystemConfigurationLayout, {}) }) }) });
};

// src/secure/recruit/talent-pools/TalentPoolsLayout.tsx
import { useCallback as useCallback71 } from "react";
import {
  Navigate as Navigate37,
  Outlet as Outlet24,
  useLocation as useLocation16,
  useNavigate as useNavigate31
} from "react-router-dom";
import { UsersIcon as UsersIcon5 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState15, MynPageTitle as MynPageTitle77, TabPills as TabPills7 } from "shared-ui";
import { TalentPoolListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/TalentPoolCreateContainer.tsx
import { useCallback as useCallback61 } from "react";
import { useNavigate as useNavigate22 } from "react-router-dom";
import { MynPageTitle as MynPageTitle68, Suspense as Suspense99 } from "shared-ui";
import { EdSkeleton as EdSkeleton70 } from "shared-ui";
import { TalentPoolCreateEditor } from "feature-recruit";
import { jsx as jsx149, jsxs as jsxs129 } from "react/jsx-runtime";
var TalentPoolCreateContainer = () => {
  const navigate = useNavigate22();
  const onCreated = useCallback61(
    ({ code }) => {
      navigate(`../${code}`);
    },
    [navigate]
  );
  const onCancel = useCallback61(() => {
    navigate(`../list`);
  }, [navigate]);
  return /* @__PURE__ */ jsxs129(Suspense99, { fallback: /* @__PURE__ */ jsx149(EdSkeleton70, {}), children: [
    /* @__PURE__ */ jsx149(MynPageTitle68, { title: "Create Talent Pool" }),
    /* @__PURE__ */ jsx149(TalentPoolCreateEditor, { onDone: onCreated, onCancel })
  ] });
};

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolRouteQuery.graphql.ts
var node137 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "theme",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "customInviteLink",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "joinDeclinedLink",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitTalentPoolTheme",
    "kind": "LinkedField",
    "name": "customTheme",
    "plural": false,
    "selections": [
      v2,
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBgColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBorderColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroTextColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryButtonTextColor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolContainer_talentPool"
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3074a3f5590e063fa2a5d832b3eca568",
      "id": null,
      "metadata": {},
      "name": "TalentPoolRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolRouteQuery(\n  $talentPoolCode: Int!\n) {\n  talentPool: recruitTalentPoolByCode(code: $talentPoolCode) {\n    id\n    code\n    talentPoolId\n    name\n    description\n    theme\n    enabled\n    inviteOnly\n    slug\n    customInviteLink\n    joinDeclinedLink\n    customTheme {\n      id\n      name\n      primaryColor\n      logoUrl\n      heroBgColor\n      heroBorderColor\n      heroTextColor\n      primaryButtonTextColor\n    }\n    ...TalentPoolContainer_talentPool\n  }\n}\n\nfragment TalentPoolContainer_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n  ...TalentPoolUpdateEditor_talentPool\n}\n\nfragment TalentPoolUpdateEditor_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n}\n"
    }
  };
}();
node137.hash = "131cd053e77e2d58444a954747f8146c";
var TalentPoolRouteQuery_graphql_default = node137;

// src/secure/recruit/talent-pools/components/TalentPoolRoute.tsx
import { useCallback as useCallback70 } from "react";
import {
  Navigate as Navigate36,
  Outlet as Outlet23,
  useLocation as useLocation15,
  useNavigate as useNavigate30,
  useRouteLoaderData as useRouteLoaderData8
} from "react-router-dom";
import {
  loadQuery as loadQuery38,
  usePreloadedQuery as usePreloadedQuery20
} from "react-relay";
import { UserGroupIcon as UserGroupIcon3, UsersIcon as UsersIcon4 } from "@heroicons/react/24/outline";
import { MynPageTitle as MynPageTitle76, Suspense as Suspense108 } from "shared-ui";
import { useRouteData as useRouteData30 } from "shared-lib";
import { createLinkState as createLinkState14, EdSkeleton as EdSkeleton79, TabPills as TabPills6 } from "shared-ui";
import { OutletRoute as OutletRoute23 } from "app-core";
import { TalentPoolContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainerQuery.graphql.ts
var node138 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "seqId": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TalentPoolEmployerAccessListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canInviteMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canViewMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canAddAccess",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolEmployerAccessListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        }
      ]
    },
    "params": {
      "cacheID": "9f38fd9b18ad9d58084a6fe56edc941b",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessListContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessListContainerQuery(\n  $where: RecruitTalentPoolEmployerAccessFilter!\n) {\n  ...TalentPoolEmployerAccessListContainer_list\n}\n\nfragment TalentPoolEmployerAccessListContainer_list on Query {\n  list: recruitTalentPoolEmployerAccess(first: 25, order: [{seqId: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        version\n        talentPoolId\n        employerId\n        employerName\n        canUpdate\n        canInviteMembers\n        canViewMembers\n        canAddAccess\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node138.hash = "8063d0021be73912516c21661a67409d";
var TalentPoolEmployerAccessListContainerQuery_graphql_default = node138;

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainerPaginationQuery.graphql.ts
var node139 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "seqId": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "TalentPoolEmployerAccessListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canUpdate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canInviteMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canViewMembers",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canAddAccess",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolEmployerAccessListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        }
      ]
    },
    "params": {
      "cacheID": "6841bc76e243d84d7a6c09ca5a6aae4b",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: RecruitTalentPoolEmployerAccessFilter\n) {\n  ...TalentPoolEmployerAccessListContainer_list_2HEEH6\n}\n\nfragment TalentPoolEmployerAccessListContainer_list_2HEEH6 on Query {\n  list: recruitTalentPoolEmployerAccess(first: $first, after: $after, order: [{seqId: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        version\n        talentPoolId\n        employerId\n        employerName\n        canUpdate\n        canInviteMembers\n        canViewMembers\n        canAddAccess\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node139.hash = "ea8817bcc18caac160d2e8f6f91da65a";
var TalentPoolEmployerAccessListContainerPaginationQuery_graphql_default = node139;

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessListContainer_list.graphql.ts
var node140 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": TalentPoolEmployerAccessListContainerPaginationQuery_graphql_default
      }
    },
    "name": "TalentPoolEmployerAccessListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "seqId": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitTalentPoolEmployerAccessConnection",
        "kind": "LinkedField",
        "name": "__TalentPoolEmployerAccessListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolEmployerAccessEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPoolEmployerAccess",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolEmployerAccessId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canUpdate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canInviteMembers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canViewMembers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canAddAccess",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node140.hash = "ea8817bcc18caac160d2e8f6f91da65a";
var TalentPoolEmployerAccessListContainer_list_graphql_default = node140;

// src/secure/recruit/talent-pools/components/TalentPoolEmployerAccessListContainer.tsx
import { useCallback as useCallback62, useState as useState30 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery28, usePaginationFragment as usePaginationFragment18 } from "react-relay";
import { Suspense as Suspense100 } from "shared-ui";
import {
  Button as Button36,
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader7,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement9,
  EdSkeleton as EdSkeleton71,
  Input as Input9,
  ListLayout as ListLayout7
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined15, useDebounce as useDebounce8 } from "shared-lib";
import { jsx as jsx150, jsxs as jsxs130 } from "react/jsx-runtime";
var queryDef47 = TalentPoolEmployerAccessListContainerQuery_graphql_default;
var fragmentDef21 = TalentPoolEmployerAccessListContainer_list_graphql_default;
function createLinkTo7(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List8 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment18(fragmentDef21, fragmentRef);
  const onLoadNext = useCallback62(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined15).map((access) => {
    const name = `${access.employerName}`;
    return {
      key: access.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx150("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs130("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx150("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx150("div", { className: "text-md text-blue-700", children: access.code })
      ] }) }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: access.code
      },
      element: /* @__PURE__ */ jsx150(DefaultListLayoutSectionElement9, { children: /* @__PURE__ */ jsx150("div", { className: "grid", children: /* @__PURE__ */ jsx150("div", { children: access.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx150(Suspense100, { fallback: /* @__PURE__ */ jsx150(EdSkeleton71, {}), children: /* @__PURE__ */ jsx150(
    ListLayout7,
    {
      title: "Employer Access",
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx150(
        DefaultListLayoutItemHeader7,
        {
          title: "Employer Access",
          to: createLinkTo7,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var TalentPoolEmployerAccessListContainer = ({
  onCreate,
  talentPoolId
}) => {
  const [filter, setFilter] = useState30(null);
  const searchTerm = useDebounce8(filter, 500);
  let where2 = {};
  if (talentPoolId) {
    where2 = {
      ...where2,
      talentPoolId: { eq: talentPoolId }
    };
  }
  if (searchTerm) {
    where2.or = [{ employerName: { startsWith: filter } }];
  }
  const query = useLazyLoadQuery28(
    queryDef47,
    { where: where2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs130("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs130("div", { className: "flex items-center justify-between space-x-4 border-b", children: [
      /* @__PURE__ */ jsxs130("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx150("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx150("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx150(
          Input9,
          {
            placeholder: " Name ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsx150("div", { children: /* @__PURE__ */ jsx150(Button36, { clicked: onCreate, color: "primary", children: "Add Access" }) })
    ] }),
    /* @__PURE__ */ jsx150("div", { className: "flex-1", children: /* @__PURE__ */ jsx150(List8, { fragmentRef: query }) })
  ] });
};

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolEmployerAccessContainerQuery.graphql.ts
var node141 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolEmployerAccessCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolEmployerAccessCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolEmployerAccessId",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canUpdate",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canInviteMembers",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canViewMembers",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canAddAccess",
    "storageKey": null
  }, v12 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolEmployerAccessContainerQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolEmployerAccessForm_talentPoolAccess"
            },
            v12
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolEmployerAccessContainerQuery",
      "selections": [
        {
          "alias": "access",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c3ef1708a27c76eade5a07550d91d782",
      "id": null,
      "metadata": {},
      "name": "TalentPoolEmployerAccessContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolEmployerAccessContainerQuery(\n  $talentPoolEmployerAccessCode: Int!\n) {\n  access: recruitTalentPoolEmployerAccessByCode(code: $talentPoolEmployerAccessCode) {\n    talentPoolEmployerAccessId\n    code\n    version\n    talentPoolId\n    employerId\n    employerName\n    canUpdate\n    canInviteMembers\n    canViewMembers\n    canAddAccess\n    ...TalentPoolEmployerAccessForm_talentPoolAccess\n    id\n  }\n}\n\nfragment TalentPoolEmployerAccessForm_talentPoolAccess on RecruitTalentPoolEmployerAccess {\n  talentPoolEmployerAccessId\n  code\n  version\n  talentPoolId\n  employerId\n  employerName\n  canUpdate\n  canInviteMembers\n  canViewMembers\n  canAddAccess\n}\n"
    }
  };
}();
node141.hash = "ac52e61e9e07be826f2984b09dc498f1";
var TalentPoolEmployerAccessContainerQuery_graphql_default = node141;

// src/secure/recruit/talent-pools/components/TalentPoolEmployerAccessContainer.tsx
import { Fragment as Fragment51, useCallback as useCallback63 } from "react";
import { useNavigate as useNavigate23 } from "react-router-dom";
import { loadQuery as loadQuery35 } from "react-relay";
import { createClientMutationId as createClientMutationId22, useRouteData as useRouteData26, useToggle as useToggle11 } from "shared-lib";
import {
  BooleanIcon as BooleanIcon3,
  Button as Button37,
  DescriptionItem as DescriptionItem4,
  DescriptionList as DescriptionList4,
  EdSkeleton as EdSkeleton72,
  MynPageTitle as MynPageTitle69,
  Size as Size13,
  Suspense as Suspense101
} from "shared-ui";
import {
  TalentPoolEmployerAccessForm,
  useTalentPoolEmployerAccessRemove
} from "feature-recruit";
import { Fragment as Fragment52, jsx as jsx151, jsxs as jsxs131 } from "react/jsx-runtime";
var queryDef48 = TalentPoolEmployerAccessContainerQuery_graphql_default;
async function loader35(environment, params) {
  const code = params.talentPoolEmployerAccessCode;
  const talentPoolEmployerAccessCode = parseInt(code);
  return loadQuery35(
    environment,
    queryDef48,
    {
      talentPoolEmployerAccessCode
    }
  );
}
var TalentPoolEmployerAccessContainer = ({ routeId: routeId6 }) => {
  const navigate = useNavigate23();
  const [removeAccess, isRemovingAccess] = useTalentPoolEmployerAccessRemove();
  const [isEditing, toggleIsEditing] = useToggle11();
  const [isRemoving, toggleIsRemoving] = useToggle11();
  const data = useRouteData26(
    queryDef48,
    routeId6
  );
  const { access } = data;
  const onRemoveAccess = useCallback63(async () => {
    if (!access) {
      return;
    }
    const input = {
      talentPoolId: access.talentPoolId,
      employerId: access.employerId,
      clientMutationId: createClientMutationId22()
    };
    const response = await removeAccess({ input });
    if (response.data.payload) {
      navigate(`../`);
    }
  }, [removeAccess]);
  if (!data) {
    return /* @__PURE__ */ jsx151(Fragment52, { children: "Loading..." });
  }
  if (!access) {
    return /* @__PURE__ */ jsx151(EdSkeleton72, {});
  }
  return /* @__PURE__ */ jsxs131(Suspense101, { fallback: /* @__PURE__ */ jsx151(EdSkeleton72, {}), children: [
    /* @__PURE__ */ jsx151(MynPageTitle69, { title: "Talent PoolTalentPoolEmployerAccessContainer\nTalentPoolEmployerAccessContainer Employer Access Details" }),
    /* @__PURE__ */ jsx151("div", { className: "flex-1", children: /* @__PURE__ */ jsxs131("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs131("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
        /* @__PURE__ */ jsxs131("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
          /* @__PURE__ */ jsx151("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx151("div", { className: "text-primary-700 px-1 text-xl font-bold", children: access.employerName }) }),
          /* @__PURE__ */ jsx151("div", { className: "flex items-center gap-2 pt-2 text-sm", children: /* @__PURE__ */ jsx151("div", { className: "text-primary-700 text-sm font-bold", children: access.code }) })
        ] }),
        /* @__PURE__ */ jsxs131("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx151(Button37, { color: "warning", clicked: toggleIsRemoving, children: "Remove" }),
          isEditing ? /* @__PURE__ */ jsx151(Button37, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx151(Button37, { color: "primary", clicked: toggleIsEditing, children: "Edit" })
        ] })
      ] }),
      isRemoving && /* @__PURE__ */ jsx151("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ jsx151("div", { className: "sm:w-1/2", children: /* @__PURE__ */ jsx151(
        Button37,
        {
          color: "warning",
          size: Size13.xl,
          clicked: onRemoveAccess,
          disabled: isRemovingAccess,
          children: "Remove, Are you Sure ?"
        }
      ) }) }),
      isEditing ? /* @__PURE__ */ jsx151("div", { className: "m-4 border border-gray-100", children: /* @__PURE__ */ jsx151(
        TalentPoolEmployerAccessForm,
        {
          fragmentRef: access,
          onDone: toggleIsEditing,
          onCancel: toggleIsEditing
        }
      ) }) : /* @__PURE__ */ jsx151(
        DescriptionList4,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx151("div", { className: "flex items-center", children: "Access Controls" }),
          items: /* @__PURE__ */ jsxs131(Fragment51, { children: [
            /* @__PURE__ */ jsx151(DescriptionItem4, { label: "Can Update", children: /* @__PURE__ */ jsx151(BooleanIcon3, { value: access.canUpdate }) }),
            /* @__PURE__ */ jsx151(DescriptionItem4, { label: "Can Add Access", children: /* @__PURE__ */ jsx151(BooleanIcon3, { value: access.canAddAccess }) }),
            /* @__PURE__ */ jsx151(DescriptionItem4, { label: "Can Invite Members", children: /* @__PURE__ */ jsx151(BooleanIcon3, { value: access.canInviteMembers }) }),
            /* @__PURE__ */ jsx151(DescriptionItem4, { label: "Can View Members", children: /* @__PURE__ */ jsx151(BooleanIcon3, { value: access.canViewMembers }) })
          ] })
        }
      )
    ] }) })
  ] });
};
var createRoute25 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-employer-access`;
  return {
    id: routeId6,
    path: ":talentPoolEmployerAccessCode",
    element: /* @__PURE__ */ jsx151(TalentPoolEmployerAccessContainer, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader35(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolAddAccessRoute.tsx
import { useCallback as useCallback64 } from "react";
import { useNavigate as useNavigate24 } from "react-router-dom";
import { MynPageTitle as MynPageTitle70, Suspense as Suspense102 } from "shared-ui";
import { useRouteData as useRouteData27 } from "shared-lib";
import { EdSkeleton as EdSkeleton73 } from "shared-ui";
import { TalentPoolAddAccessContainer } from "feature-recruit";
import { Fragment as Fragment53, jsx as jsx152, jsxs as jsxs132 } from "react/jsx-runtime";
var TalentPoolAddAccessRoute = ({ routeId: routeId6 }) => {
  const data = useRouteData27(queryDef49, routeId6);
  const { talentPool } = data;
  const navigate = useNavigate24();
  const onCancel = useCallback64(() => {
    if (!talentPool) {
      return;
    }
    navigate(`../access`);
  }, [navigate]);
  const onDone = useCallback64(
    (code) => {
      navigate(`../${code}`);
    },
    [navigate]
  );
  if (!data) {
    return /* @__PURE__ */ jsx152(Fragment53, { children: "Loading..." });
  }
  if (!talentPool) {
    return /* @__PURE__ */ jsx152(EdSkeleton73, {});
  }
  return /* @__PURE__ */ jsxs132(Suspense102, { fallback: /* @__PURE__ */ jsx152(EdSkeleton73, {}), children: [
    /* @__PURE__ */ jsx152(MynPageTitle70, { title: "Add Talent Pool Employer Access" }),
    /* @__PURE__ */ jsx152(
      TalentPoolAddAccessContainer,
      {
        talentPool,
        onDone,
        onCancel
      }
    )
  ] });
};

// src/secure/recruit/talent-pools/components/TalentPoolInvitesRoute.tsx
import { useCallback as useCallback66 } from "react";
import { Link as Link25, Navigate as Navigate34, useNavigate as useNavigate26 } from "react-router-dom";
import { MynPageTitle as MynPageTitle72, Suspense as Suspense104 } from "shared-ui";
import { EdSkeleton as EdSkeleton75 } from "shared-ui";
import { OutletRoute as OutletRoute21 } from "app-core";
import { TalentPoolInvitesListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolInviteRouteQuery.graphql.ts
var node142 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolInviteCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolInviteCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolInviteId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateFirstName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateLastName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateEmail",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v17 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16,
                v2
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1ee923049f74fef822dc9a54cc1e24a1",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInviteRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolInviteRouteQuery(\n  $talentPoolInviteCode: Int!\n) {\n  invite: recruitTalentPoolInviteByCode(code: $talentPoolInviteCode) {\n    id\n    talentPoolInviteId\n    code\n    updatedAt\n    talentPoolId\n    candidateId\n    status\n    source\n    candidateFirstName\n    candidateLastName\n    candidateEmail\n    sourceId\n    candidate {\n      firstName\n      lastName\n      email\n      id\n    }\n  }\n}\n"
    }
  };
}();
node142.hash = "0f4427aa6285a7f249828cf08abc8d63";
var TalentPoolInviteRouteQuery_graphql_default = node142;

// src/secure/recruit/talent-pools/components/TalentPoolInviteRoute.tsx
import { Fragment as Fragment54, useCallback as useCallback65 } from "react";
import { useNavigate as useNavigate25 } from "react-router-dom";
import { loadQuery as loadQuery36 } from "react-relay";
import { createClientMutationId as createClientMutationId23, useRouteData as useRouteData28, useToggle as useToggle12 } from "shared-lib";
import {
  Button as Button38,
  DescriptionItem as DescriptionItem5,
  DescriptionList as DescriptionList5,
  EdSkeleton as EdSkeleton74,
  MynPageTitle as MynPageTitle71,
  Size as Size14,
  Suspense as Suspense103
} from "shared-ui";
import {
  useTalentPoolInviteExpire
} from "feature-recruit";
import { Fragment as Fragment55, jsx as jsx153, jsxs as jsxs133 } from "react/jsx-runtime";
var queryDef50 = TalentPoolInviteRouteQuery_graphql_default;
async function loader36(environment, params) {
  const code = params.talentPoolInviteCode;
  const talentPoolInviteCode = parseInt(code);
  return loadQuery36(environment, queryDef50, {
    talentPoolInviteCode
  });
}
var TalentPoolInviteRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate25();
  const [expireInvite, isExpiringInvite] = useTalentPoolInviteExpire();
  const [isEditing, toggleIsEditing] = useToggle12();
  const [isRemoving, toggleIsRemoving] = useToggle12();
  const data = useRouteData28(queryDef50, routeId6);
  const { invite } = data;
  const onExpireInvite = useCallback65(async () => {
    if (!invite) {
      return;
    }
    const input = {
      id: invite.talentPoolInviteId,
      clientMutationId: createClientMutationId23()
    };
    const response = await expireInvite({ input });
    if (response.data.payload) {
      navigate(`../`);
    }
  }, [expireInvite]);
  if (!data) {
    return /* @__PURE__ */ jsx153(Fragment55, { children: "Loading..." });
  }
  if (!invite) {
    return /* @__PURE__ */ jsx153(EdSkeleton74, {});
  }
  return /* @__PURE__ */ jsxs133(Suspense103, { fallback: /* @__PURE__ */ jsx153(EdSkeleton74, {}), children: [
    /* @__PURE__ */ jsx153(MynPageTitle71, { title: "Talent Pool Invite Details" }),
    /* @__PURE__ */ jsx153("div", { className: "flex-1", children: /* @__PURE__ */ jsxs133("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
      /* @__PURE__ */ jsxs133("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
        /* @__PURE__ */ jsxs133("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
          /* @__PURE__ */ jsxs133("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx153("div", { className: "text-primary-700 text-xl font-bold", children: invite.candidateFirstName }),
            /* @__PURE__ */ jsx153("div", { className: "text-primary-700 text-xl font-bold", children: invite.candidateLastName })
          ] }),
          /* @__PURE__ */ jsxs133("div", { className: "flex items-center gap-2 pt-1 text-sm", children: [
            /* @__PURE__ */ jsx153("div", { className: "text-primary-700 text-sm font-bold", children: invite.code }),
            /* @__PURE__ */ jsx153("div", { className: "text-md text-blue-700", children: invite.status })
          ] })
        ] }),
        /* @__PURE__ */ jsxs133("div", { className: "flex items-center gap-2", children: [
          invite.status !== "Withdrawn" && /* @__PURE__ */ jsx153(Button38, { color: "warning", clicked: toggleIsRemoving, children: "Expire" }),
          isEditing ? /* @__PURE__ */ jsx153(Button38, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx153(Button38, { color: "primary", clicked: toggleIsEditing, children: "Edit" })
        ] })
      ] }),
      isRemoving && /* @__PURE__ */ jsx153("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ jsx153("div", { className: "sm:w-1/2", children: /* @__PURE__ */ jsx153(
        Button38,
        {
          color: "warning",
          size: Size14.xl,
          clicked: onExpireInvite,
          disabled: isExpiringInvite,
          children: "Expire, Are you Sure ?"
        }
      ) }) }),
      isEditing ? /* @__PURE__ */ jsx153("div", { className: "m-4 border border-gray-100", children: "Editing" }) : /* @__PURE__ */ jsx153(
        DescriptionList5,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx153("div", { className: "flex items-center", children: "Invite" }),
          items: /* @__PURE__ */ jsxs133(Fragment54, { children: [
            /* @__PURE__ */ jsx153(DescriptionItem5, { label: "First Name", children: invite.candidateFirstName }),
            /* @__PURE__ */ jsx153(DescriptionItem5, { label: "Last Name", children: invite.candidateLastName }),
            /* @__PURE__ */ jsx153(DescriptionItem5, { label: "Email", children: invite.candidateEmail }),
            /* @__PURE__ */ jsx153(DescriptionItem5, { label: "source", children: invite.source })
          ] })
        }
      )
    ] }) })
  ] });
};
var createRoute26 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-invite`;
  return {
    id: routeId6,
    path: ":talentPoolInviteCode",
    element: /* @__PURE__ */ jsx153(TalentPoolInviteRoute, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader36(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolInvitesRoute.tsx
import { jsx as jsx154, jsxs as jsxs134 } from "react/jsx-runtime";
var TalentPoolInvitesRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate26();
  const data = useTalentPoolRouteData(routeId6);
  const { talentPool } = data;
  const onCreate = useCallback66(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx154(EdSkeleton75, {});
  }
  return /* @__PURE__ */ jsxs134(Suspense104, { fallback: /* @__PURE__ */ jsx154(EdSkeleton75, {}), children: [
    /* @__PURE__ */ jsx154(MynPageTitle72, { title: "Talent Pool Invites" }),
    /* @__PURE__ */ jsx154("div", { className: "border bg-white p-2", children: /* @__PURE__ */ jsx154(
      TalentPoolInvitesListContainer,
      {
        talentPoolId: talentPool.talentPoolId,
        onCreate
      }
    ) })
  ] });
};
var createRoute27 = (parentRouteId, environment, context) => {
  const routeId6 = `${parentRouteId}-invites`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx154(OutletRoute21, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx154(Link25, { to: "invites", children: "Invites" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx154(TalentPoolInvitesRoute, { routeId: parentRouteId }),
        children: [createRoute26(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx154(Navigate34, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolMembersRoute.tsx
import { useCallback as useCallback68 } from "react";
import { Link as Link26, Navigate as Navigate35, useNavigate as useNavigate28 } from "react-router-dom";
import { MynPageTitle as MynPageTitle74, Suspense as Suspense106 } from "shared-ui";
import { EdSkeleton as EdSkeleton77 } from "shared-ui";
import { OutletRoute as OutletRoute22 } from "app-core";
import { TalentPoolMemberListContainer } from "feature-recruit";

// src/secure/recruit/talent-pools/components/__generated__/TalentPoolMemberRouteQuery.graphql.ts
var node143 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolMemberCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolMemberCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolMemberContainer_member"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolMembershipId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "87be4cde47071d82e7087866587ad04b",
      "id": null,
      "metadata": {},
      "name": "TalentPoolMemberRouteQuery",
      "operationKind": "query",
      "text": "query TalentPoolMemberRouteQuery(\n  $talentPoolMemberCode: Long!\n) {\n  member: recruitTalentPoolMembershipByCode(code: $talentPoolMemberCode) {\n    id\n    code\n    ...TalentPoolMemberContainer_member\n  }\n}\n\nfragment TalentPoolMemberContainer_member on RecruitTalentPoolMembership {\n  id\n  talentPoolMembershipId\n  code\n  talentPoolId\n  status\n  updatedOn\n  profile {\n    recruitProfileId\n    firstName\n    lastName\n    emailAddress\n    id\n  }\n}\n"
    }
  };
}();
node143.hash = "c5a0a76db3c1985aa73259c6d94e6a30";
var TalentPoolMemberRouteQuery_graphql_default = node143;

// src/secure/recruit/talent-pools/components/TalentPoolMemberRoute.tsx
import { useCallback as useCallback67 } from "react";
import { useNavigate as useNavigate27 } from "react-router-dom";
import { loadQuery as loadQuery37 } from "react-relay";
import { MynPageTitle as MynPageTitle73, Suspense as Suspense105 } from "shared-ui";
import { useRouteData as useRouteData29 } from "shared-lib";
import { EdSkeleton as EdSkeleton76 } from "shared-ui";
import { TalentPoolMemberContainer } from "feature-recruit";
import { jsx as jsx155, jsxs as jsxs135 } from "react/jsx-runtime";
var queryDef51 = TalentPoolMemberRouteQuery_graphql_default;
async function loader37(environment, params) {
  const code = params.talentPoolMemberCode;
  const talentPoolMemberCode = parseInt(code);
  return loadQuery37(environment, queryDef51, {
    talentPoolMemberCode
  });
}
var TalentPoolMemberRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate27();
  const data = useRouteData29(queryDef51, routeId6);
  const onRevoked = useCallback67(() => {
    navigate("../");
  }, []);
  const { member } = data;
  if (!member) {
    return /* @__PURE__ */ jsx155(EdSkeleton76, {});
  }
  return /* @__PURE__ */ jsx155(Suspense105, { fallback: /* @__PURE__ */ jsx155(EdSkeleton76, {}), children: /* @__PURE__ */ jsxs135("div", { className: "flex-1", children: [
    /* @__PURE__ */ jsx155(MynPageTitle73, { title: "Talent Pool Member Details" }),
    /* @__PURE__ */ jsx155(TalentPoolMemberContainer, { onRevoked, fragmentRef: member })
  ] }) });
};
var createRoute28 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-member`;
  return {
    id: routeId6,
    path: ":talentPoolMemberCode",
    element: /* @__PURE__ */ jsx155(TalentPoolMemberRoute, { routeId: routeId6, inList }),
    loader: ({ params }) => {
      return loader37(environment, params);
    }
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolMembersRoute.tsx
import { jsx as jsx156, jsxs as jsxs136 } from "react/jsx-runtime";
var TalentPoolMembersRoute = ({ routeId: routeId6 }) => {
  const navigate = useNavigate28();
  const data = useTalentPoolRouteData(routeId6);
  const { talentPool } = data;
  const onCreate = useCallback68(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx156(EdSkeleton77, {});
  }
  return /* @__PURE__ */ jsx156(Suspense106, { fallback: /* @__PURE__ */ jsx156(EdSkeleton77, {}), children: /* @__PURE__ */ jsxs136("div", { className: "bg-white", children: [
    /* @__PURE__ */ jsx156(MynPageTitle74, { title: "Talent Pool Members" }),
    /* @__PURE__ */ jsx156(
      TalentPoolMemberListContainer,
      {
        talentPoolId: talentPool.talentPoolId,
        onCreate
      }
    )
  ] }) });
};
var createRoute29 = (parentRouteId, environment, context) => {
  const routeId6 = `${parentRouteId}-members`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: "*",
    element: /* @__PURE__ */ jsx156(OutletRoute22, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx156(Link26, { to: "members", children: "Members" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx156(TalentPoolMembersRoute, { routeId: parentRouteId }),
        children: [createRoute28(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx156(Navigate35, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolCreateInviteRoute.tsx
import { useCallback as useCallback69 } from "react";
import { useNavigate as useNavigate29 } from "react-router-dom";
import { MynPageTitle as MynPageTitle75, Suspense as Suspense107 } from "shared-ui";
import { EdSkeleton as EdSkeleton78 } from "shared-ui";
import { TalentPoolCreateInviteContainer } from "feature-recruit";
import { jsx as jsx157, jsxs as jsxs137 } from "react/jsx-runtime";
var TalentPoolCreateInviteRoute = ({ parentRouteId }) => {
  const data = useTalentPoolRouteData(parentRouteId);
  const navigate = useNavigate29();
  const onDone = useCallback69(
    (talentPoolInviteId) => {
      navigate(`../${talentPoolInviteId}`);
    },
    [navigate]
  );
  const onCancel = useCallback69(() => {
    navigate(`../`);
  }, [navigate]);
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx157(EdSkeleton78, {});
  }
  return /* @__PURE__ */ jsxs137(Suspense107, { fallback: /* @__PURE__ */ jsx157(EdSkeleton78, {}), children: [
    /* @__PURE__ */ jsx157(MynPageTitle75, { title: "Create Talent Pool Invites" }),
    /* @__PURE__ */ jsx157(
      TalentPoolCreateInviteContainer,
      {
        talentPool,
        onDone,
        onCancel
      }
    )
  ] });
};
var createRoute30 = (parentRouteId, environment, context, inList = true) => {
  const routeId6 = `${parentRouteId}-create-invite`;
  return {
    id: routeId6,
    path: "create-invite",
    element: /* @__PURE__ */ jsx157(
      TalentPoolCreateInviteRoute,
      {
        parentRouteId,
        routeId: routeId6,
        inList
      }
    )
  };
};

// src/secure/recruit/talent-pools/components/TalentPoolRoute.tsx
import { Fragment as Fragment56, jsx as jsx158, jsxs as jsxs138 } from "react/jsx-runtime";
var queryDef49 = TalentPoolRouteQuery_graphql_default;
async function loader38(environment, params) {
  const code = params.talentPoolCode;
  const talentPoolCode = parseInt(code);
  return loadQuery38(environment, queryDef49, {
    talentPoolCode
  });
}
function useTalentPoolRouteData(routeId6) {
  const queryRef = useRouteLoaderData8(
    routeId6
  );
  const data = usePreloadedQuery20(queryDef49, queryRef);
  return data;
}
var TalentPoolDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData30(queryDef49, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx158(Fragment56, { children: "Loading..." });
  }
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx158(EdSkeleton79, {});
  }
  return /* @__PURE__ */ jsxs138(Suspense108, { fallback: /* @__PURE__ */ jsx158(EdSkeleton79, {}), children: [
    /* @__PURE__ */ jsx158(MynPageTitle76, { title: "Talent Pool Details" }),
    /* @__PURE__ */ jsx158(TalentPoolContainer, { fragmentRef: talentPool })
  ] });
};
var TalentPoolEmployerAccess = ({ routeId: routeId6 }) => {
  const data = useRouteData30(queryDef49, routeId6);
  const navigate = useNavigate30();
  const onCreate = useCallback70(() => {
    navigate(`../add-access`);
  }, [navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx158(Fragment56, { children: "Loading..." });
  }
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx158(Fragment56, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs138(Suspense108, { fallback: /* @__PURE__ */ jsx158(EdSkeleton79, {}), children: [
    /* @__PURE__ */ jsx158(MynPageTitle76, { title: "Talent Pool Employer Access" }),
    /* @__PURE__ */ jsx158(
      TalentPoolEmployerAccessListContainer,
      {
        talentPoolId: talentPool.talentPoolId,
        onCreate
      }
    )
  ] });
};
var Layout11 = () => {
  const location = useLocation15();
  const tabs4 = [
    createLinkState14(location, "Details", `details`, UsersIcon4),
    createLinkState14(location, "Access", `access`, UserGroupIcon3),
    createLinkState14(location, "Invites", `invites`, UsersIcon4),
    createLinkState14(location, "Members", `members`, UsersIcon4)
  ];
  return /* @__PURE__ */ jsxs138("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx158(MynPageTitle76, { title: "Talent Pools Details" }),
    /* @__PURE__ */ jsx158("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx158(TabPills6, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx158(Outlet23, {})
  ] });
};
var createRoute31 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-job-board`;
  const listRouteId = `${routeId6}-list`;
  return {
    id: routeId6,
    path: ":talentPoolCode",
    element: /* @__PURE__ */ jsx158(Layout11, {}),
    loader: ({ params }) => {
      return loader38(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx158("div", { className: "flex-1", children: /* @__PURE__ */ jsx158(TalentPoolDetails, { routeId: routeId6, inList }) })
      },
      {
        id: listRouteId,
        path: "access/*",
        element: /* @__PURE__ */ jsx158("div", { className: "flex-1", children: /* @__PURE__ */ jsx158(TalentPoolEmployerAccess, { routeId: routeId6 }) }),
        children: [
          createRoute25(listRouteId, environment, context, true)
        ]
      },
      createRoute25(routeId6, environment, context, false),
      {
        path: "add-access",
        element: /* @__PURE__ */ jsx158(TalentPoolAddAccessRoute, { routeId: routeId6 })
      },
      {
        path: "invites/*",
        element: /* @__PURE__ */ jsx158(OutletRoute23, {}),
        children: [createRoute27(routeId6, environment, context)]
      },
      {
        path: "members/*",
        element: /* @__PURE__ */ jsx158(OutletRoute23, {}),
        children: [createRoute29(routeId6, environment, context)]
      },
      createRoute30(routeId6, environment, context, false),
      {
        path: "*",
        element: /* @__PURE__ */ jsx158(Navigate36, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/talent-pools/TalentPoolsLayout.tsx
import { jsx as jsx159, jsxs as jsxs139 } from "react/jsx-runtime";
var Layout12 = () => {
  const location = useLocation16();
  const tabs4 = [
    createLinkState15(location, "List", `list`, UsersIcon5),
    createLinkState15(location, "Create", `create`, UsersIcon5)
  ];
  return /* @__PURE__ */ jsxs139("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx159("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx159(TabPills7, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx159("div", { className: "p-2", children: /* @__PURE__ */ jsx159(Outlet24, {}) })
  ] });
};
var List9 = () => {
  const navigate = useNavigate31();
  const onCreate = useCallback71(() => {
    navigate(`../create`);
  }, [navigate]);
  return /* @__PURE__ */ jsxs139("div", { children: [
    /* @__PURE__ */ jsx159(MynPageTitle77, { title: "Talent Pools" }),
    /* @__PURE__ */ jsx159(TalentPoolListContainer, { onCreate }),
    ";"
  ] });
};
var createTalentPoolsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-talent-pools`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx159(Layout12, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx159(List9, {}),
          children: [
            createRoute31(listRouteId, environment, context, true)
          ]
        },
        createRoute31(routeId6, environment, context, false),
        {
          path: "create",
          element: /* @__PURE__ */ jsx159(TalentPoolCreateContainer, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx159(Navigate37, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/RecruitLayout.tsx
import { Suspense as Suspense120 } from "react";
import { Navigate as Navigate47 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary19 } from "react-error-boundary";
import { EdLink as EdLink11, MynPageTitle as MynPageTitle92 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback20, OutletRoute as OutletRoute30 } from "app-core";

// src/secure/recruit/config/components/__generated__/RecommendationConfigQuery.graphql.ts
var node144 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    {
      "alias": "config",
      "args": null,
      "concreteType": "RecruitCandidateRecommendationConfig",
      "kind": "LinkedField",
      "name": "recruitRecommendationCandidateConfig",
      "plural": false,
      "selections": [
        v0,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountId",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": [
            v0,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "experienceSimilarityThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "combinedScoreThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobMatchScoreThreshold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxVacancyOpenDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendEnabled",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationConfigQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "RecommendationConfigQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "1223de0b651c4355700b9ddc490a8afe",
      "id": null,
      "metadata": {},
      "name": "RecommendationConfigQuery",
      "operationKind": "query",
      "text": "query RecommendationConfigQuery {\n  config: recruitRecommendationCandidateConfig {\n    id\n    version\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    experienceSimilarityThreshold\n    combinedScoreThreshold\n    jobMatchScoreThreshold\n    maxVacancyOpenDays\n    recommendEnabled\n    sendEnabled\n  }\n}\n"
    }
  };
}();
node144.hash = "b0eb405e3623bf11c3b1a2198b8370a2";
var RecommendationConfigQuery_graphql_default = node144;

// src/secure/recruit/config/components/RecommendationConfig.tsx
import { Suspense as Suspense109 } from "react";
import { loadQuery as loadQuery39 } from "react-relay";
import { useRouteData as useRouteData31, useToggle as useToggle13 } from "shared-lib";
import {
  BooleanLabel,
  Button as Button39,
  ButtonList as ButtonList5,
  DescriptionItem as DescriptionItem6,
  DescriptionList as DescriptionList6,
  EdSkeleton as EdSkeleton80,
  MynPageTitle as MynPageTitle78
} from "shared-ui";

// src/secure/recruit/config/components/RecommendationConfigEditor.tsx
import { useCallback as useCallback72 } from "react";
import * as zod3 from "zod";
import { useForm as useForm7 } from "react-hook-form";
import { zodResolver as zodResolver7 } from "@hookform/resolvers/zod";
import {
  ActionContainer as ActionContainer4,
  ErrorField as ErrorField4,
  FormErrorCodes as FormErrorCodes3,
  FormInputRow as FormInputRow4,
  InputField as InputField4
} from "shared-ui";
import { createClientMutationId as createClientMutationId24 } from "shared-lib";

// src/secure/recruit/config/mutations/__generated__/UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation.graphql.ts
var node145 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitCandidateRecommendationConfig",
    "kind": "LinkedField",
    "name": "recommendation",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experienceSimilarityThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "combinedScoreThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobMatchScoreThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxVacancyOpenDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recommendEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sendEnabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateRecommendationConfigUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationConfigUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateRecommendationConfigUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationConfigUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d2cd189da409dfb3dc67c6858d64bc73",
      "id": null,
      "metadata": {},
      "name": "UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation(\n  $input: RecruitCandidateRecommendationConfigUpdateInput!\n) {\n  data: recruitCandidateRecommendationConfigUpdate(input: $input) {\n    recommendation {\n      id\n      version\n      createdOn\n      createdBy {\n        id\n        accountType\n      }\n      experienceSimilarityThreshold\n      combinedScoreThreshold\n      jobMatchScoreThreshold\n      maxVacancyOpenDays\n      recommendEnabled\n      sendEnabled\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node145.hash = "55b7ac008f40d0b91c6aef2559ffb2f2";
var UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation_graphql_default = node145;

// src/secure/recruit/config/mutations/UseJobBoardAdCreateCandidateRecommendationConfigUpdate.ts
import { useAsyncMutation as useAsyncMutation26 } from "shared-lib";
var mutationDef26 = UseJobBoardAdCreateCandidateRecommendationConfigUpdateMutation_graphql_default;
function useJobBoardAdCreateCandidateRecommendationConfigUpdate() {
  const [commit, isBusy] = useAsyncMutation26(
    mutationDef26
  );
  return [commit, isBusy];
}

// src/secure/recruit/config/components/RecommendationConfigEditor.tsx
import { jsx as jsx160, jsxs as jsxs140 } from "react/jsx-runtime";
var formSchema6 = zod3.object({
  recommendEnabled: zod3.boolean(),
  sendEnabled: zod3.boolean(),
  experienceSimilarityThreshold: zod3.coerce.number(),
  combinedScoreThreshold: zod3.coerce.number(),
  jobMatchScoreThreshold: zod3.coerce.number(),
  maxVacancyOpenDays: zod3.coerce.number()
});
var RecommendationConfigEditor = ({
  onDone,
  onCancel,
  recommendEnabled,
  sendEnabled,
  experienceSimilarityThreshold,
  combinedScoreThreshold,
  jobMatchScoreThreshold,
  maxVacancyOpenDays
}) => {
  const defaultValues = {
    recommendEnabled,
    sendEnabled,
    experienceSimilarityThreshold: Number(experienceSimilarityThreshold),
    combinedScoreThreshold: Number(combinedScoreThreshold),
    jobMatchScoreThreshold: Number(jobMatchScoreThreshold),
    maxVacancyOpenDays: Number(maxVacancyOpenDays)
  };
  const [update, isUpdating] = useJobBoardAdCreateCandidateRecommendationConfigUpdate();
  const { register, handleSubmit, watch, formState, control } = useForm7({
    resolver: zodResolver7(formSchema6),
    defaultValues,
    mode: "onChange"
  });
  const onUpdate = useCallback72(
    async (form) => {
      const input = {
        clientMutationId: createClientMutationId24(),
        recommendEnabled: form.recommendEnabled,
        sendEnabled: form.sendEnabled,
        combinedScoreThreshold: form.combinedScoreThreshold,
        experienceSimilarityThreshold: form.experienceSimilarityThreshold,
        jobMatchScoreThreshold: form.jobMatchScoreThreshold,
        maxVacancyOpenDays: form.maxVacancyOpenDays
      };
      return await update({ input });
    },
    [update]
  );
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    async (form) => {
      const response = await onUpdate(form);
      if (response.data.recommendation) {
        onDone();
      }
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  return /* @__PURE__ */ jsxs140("div", { className: "w-full p-4", children: [
    /* @__PURE__ */ jsx160(FormErrorCodes3, {}),
    /* @__PURE__ */ jsx160("form", { onSubmit, children: /* @__PURE__ */ jsxs140(
      ActionContainer4,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isUpdating,
        titleTop: `Update Recommendation Config`,
        children: [
          /* @__PURE__ */ jsxs140(FormInputRow4, { name: "recommendEnabled", title: "Enabled *", children: [
            /* @__PURE__ */ jsx160(
              InputField4,
              {
                register,
                type: "checkbox",
                name: "recommendEnabled",
                required: false
              }
            ),
            /* @__PURE__ */ jsx160(ErrorField4, { field: errors.recommendEnabled })
          ] }),
          /* @__PURE__ */ jsxs140(FormInputRow4, { name: "sendEnabled", title: "Send Enabled *", children: [
            /* @__PURE__ */ jsx160(
              InputField4,
              {
                register,
                name: "sendEnabled",
                type: "checkbox",
                required: true
              }
            ),
            /* @__PURE__ */ jsx160(ErrorField4, { field: errors.sendEnabled })
          ] }),
          /* @__PURE__ */ jsxs140(FormInputRow4, { name: "maxVacancyOpenDays", title: "Max Vacancy Open Days", children: [
            /* @__PURE__ */ jsx160(
              InputField4,
              {
                register,
                type: "number",
                name: "maxVacancyOpenDays",
                required: false
              }
            ),
            /* @__PURE__ */ jsx160(ErrorField4, { field: errors.maxVacancyOpenDays })
          ] }),
          /* @__PURE__ */ jsxs140(
            FormInputRow4,
            {
              name: "combinedScoreThreshold",
              title: "Combined Score Threshold",
              children: [
                /* @__PURE__ */ jsx160(
                  InputField4,
                  {
                    register,
                    type: "number",
                    name: "combinedScoreThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx160(ErrorField4, { field: errors.combinedScoreThreshold })
              ]
            }
          ),
          /* @__PURE__ */ jsxs140(
            FormInputRow4,
            {
              name: "experienceSimilarityThreshold",
              title: "Experience Similarity Threshold",
              children: [
                /* @__PURE__ */ jsx160(
                  InputField4,
                  {
                    register,
                    type: "number",
                    name: "experienceSimilarityThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx160(ErrorField4, { field: errors.experienceSimilarityThreshold })
              ]
            }
          ),
          /* @__PURE__ */ jsxs140(
            FormInputRow4,
            {
              name: "jobMatchScoreThreshold",
              title: "Job Match Score Threshold",
              children: [
                /* @__PURE__ */ jsx160(
                  InputField4,
                  {
                    register,
                    type: "number",
                    name: "jobMatchScoreThreshold",
                    required: false
                  }
                ),
                /* @__PURE__ */ jsx160(ErrorField4, { field: errors.jobMatchScoreThreshold })
              ]
            }
          )
        ]
      }
    ) })
  ] });
};

// src/secure/recruit/config/components/RecommendationConfig.tsx
import { Fragment as Fragment57, jsx as jsx161, jsxs as jsxs141 } from "react/jsx-runtime";
var queryDef52 = RecommendationConfigQuery_graphql_default;
async function loader39(environment, params) {
  return loadQuery39(environment, queryDef52, {});
}
var RecommendationConfig = ({ routeId: routeId6 }) => {
  const [isEditing, toggleIsEditing] = useToggle13();
  const data = useRouteData31(queryDef52, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx161(Fragment57, { children: "Loading..." });
  }
  const { config } = data;
  if (!config) {
    return /* @__PURE__ */ jsx161(EdSkeleton80, {});
  }
  return /* @__PURE__ */ jsxs141(Suspense109, { fallback: /* @__PURE__ */ jsx161(EdSkeleton80, {}), children: [
    /* @__PURE__ */ jsx161(MynPageTitle78, { title: "Recommend Config" }),
    /* @__PURE__ */ jsx161("div", { className: "bg-white", children: /* @__PURE__ */ jsx161("div", { className: "p-4 lg:p-8", children: /* @__PURE__ */ jsx161("div", { className: "lg:w-1/2", children: isEditing ? /* @__PURE__ */ jsx161("div", { className: "rounded-lg border bg-gray-100", children: /* @__PURE__ */ jsx161(
      RecommendationConfigEditor,
      {
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing,
        recommendEnabled: config.recommendEnabled,
        sendEnabled: config.sendEnabled,
        experienceSimilarityThreshold: config.experienceSimilarityThreshold,
        combinedScoreThreshold: config.combinedScoreThreshold,
        jobMatchScoreThreshold: config.jobMatchScoreThreshold,
        maxVacancyOpenDays: config.maxVacancyOpenDays
      }
    ) }) : /* @__PURE__ */ jsxs141("div", { className: "rounded-lg border bg-gray-100", children: [
      /* @__PURE__ */ jsx161(
        DescriptionList6,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx161("div", { className: "flex items-center", children: "Recommend Config" }),
          items: /* @__PURE__ */ jsxs141(Fragment57, { children: [
            /* @__PURE__ */ jsx161(DescriptionItem6, { label: "Enabled", children: /* @__PURE__ */ jsx161(BooleanLabel, { value: config.recommendEnabled }) }),
            /* @__PURE__ */ jsx161(DescriptionItem6, { label: "Send Enabled", children: /* @__PURE__ */ jsx161(BooleanLabel, { value: config.sendEnabled }) }),
            /* @__PURE__ */ jsx161(DescriptionItem6, { label: "Max Vacancy Open Days", children: config.maxVacancyOpenDays }),
            /* @__PURE__ */ jsx161(DescriptionItem6, { label: "Combined Score Threshold", children: config.combinedScoreThreshold }),
            /* @__PURE__ */ jsx161(
              DescriptionItem6,
              {
                label: "Experience Similarity Threshold",
                children: config.experienceSimilarityThreshold
              }
            ),
            /* @__PURE__ */ jsx161(DescriptionItem6, { label: "Job Match Score Threshold", children: config.jobMatchScoreThreshold })
          ] })
        }
      ),
      /* @__PURE__ */ jsx161("div", { className: "p-4 lg:p-8", children: /* @__PURE__ */ jsx161(ButtonList5, { children: /* @__PURE__ */ jsx161(Button39, { color: "primary", clicked: toggleIsEditing, children: "Edit" }) }) })
    ] }) }) }) })
  ] });
};

// src/secure/recruit/config/ConfigLayout.tsx
import { Navigate as Navigate38 } from "react-router-dom";
import { OutletRoute as OutletRoute24 } from "app-core";
import { jsx as jsx162 } from "react/jsx-runtime";
var createConfigRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-config`;
  const recommendationConfigRouteId = `${routeId6}-recommendation-config`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx162(OutletRoute24, {}),
      children: [
        {
          id: recommendationConfigRouteId,
          path: "recommendation-config/*",
          element: /* @__PURE__ */ jsx162(RecommendationConfig, { routeId: recommendationConfigRouteId }),
          loader: ({ params }) => {
            return loader39(environment, params);
          }
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx162(Navigate38, { to: "recommendation-config", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/AdminVacanciesRoutes.tsx
import { Outlet as Outlet25, useLocation as useLocation17 } from "react-router-dom";
import { UsersIcon as UsersIcon6 } from "@heroicons/react/24/outline";
import { createLinkState as createLinkState16, MynPageTitle as MynPageTitle81, TabPills as TabPills8 } from "shared-ui";

// src/secure/recruit/vacancies/vacancies/AdminVacanciesRoute.tsx
import { Navigate as Navigate40 } from "react-router-dom";
import { OutletRoute as OutletRoute26 } from "app-core";
import {
  VacancyLink,
  VacancySearchLoader,
  vacancyLoader as vacancyLoader2
} from "feature-recruit";

// src/secure/recruit/vacancies/vacancies/AdminVacancyRoute.tsx
import { Link as Link27, Navigate as Navigate39 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary18 } from "react-error-boundary";
import {
  BreadcrumbLink,
  ErrorContainer as ErrorContainer12,
  ListLayoutMobileList,
  Suspense as Suspense112
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback19, OutletRoute as OutletRoute25 } from "app-core";
import {
  VacancyRecommendationsRoute,
  VacancyConversations,
  VacancyApplicationsRoute,
  VacancyRoute,
  vacancyLoader,
  createVacancyEditRoutes,
  vacancyEditLoader,
  VacancyRoot,
  vacancyRootLoader,
  createCandidateApplicationRoutes,
  createVacancyRecommendationRoutes,
  VacancyMatchesLayout,
  createMatchRoutes
} from "feature-recruit";

// src/secure/recruit/vacancies/vacancies/AdminVacancyJobBoardAdsRoute.tsx
import { Suspense as Suspense110 } from "react";
import { ConnectionHandler as ConnectionHandler4 } from "react-relay";
import { Button as Button40, EdSkeleton as EdSkeleton81, MynPageTitle as MynPageTitle79 } from "shared-ui";
import { useToggle as useToggle14 } from "shared-lib";
import { useVacancyRouteData } from "feature-recruit";
import { jsx as jsx163, jsxs as jsxs142 } from "react/jsx-runtime";
var AdminVacancyJobBoardAdsRoute = ({ parentRouteId }) => {
  const [isCreating, toggleIsCreating] = useToggle14();
  const data = useVacancyRouteData(parentRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx163(EdSkeleton81, {});
  }
  const connectionId = ConnectionHandler4.getConnectionID(
    "root",
    "JobBoardAdList_list"
  );
  return /* @__PURE__ */ jsxs142(Suspense110, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx163(MynPageTitle79, { title: "Vacancy Job Ads" }),
    /* @__PURE__ */ jsxs142("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx163("div", { className: "m-8 sm:w-1/2", children: /* @__PURE__ */ jsx163(JobBoardAdsList, { vacancyId: vacancy.vacancyId }) }),
      /* @__PURE__ */ jsx163("div", { className: "mx-8 sm:w-1/2", children: isCreating ? /* @__PURE__ */ jsx163("div", { children: /* @__PURE__ */ jsx163(
        JobBoardAdReferenceEditor,
        {
          connectionId,
          vacancyId: vacancy.vacancyId,
          onDone: toggleIsCreating,
          onCancel: toggleIsCreating
        }
      ) }) : /* @__PURE__ */ jsx163("div", { children: /* @__PURE__ */ jsx163(Button40, { color: "primary", clicked: toggleIsCreating, children: "Create" }) }) })
    ] })
  ] });
};

// src/secure/recruit/vacancies/vacancies/__generated__/AdminVacancyJobPublishRouteQuery.graphql.ts
var node146 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyId",
          "variableName": "id"
        }
      ],
      "concreteType": "RecruitVacancyIdibuState",
      "kind": "LinkedField",
      "name": "recruitIdibuVacancyConfigByVacancyId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vacancyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actionUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasConfig",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitIdibuUppParameters",
          "kind": "LinkedField",
          "name": "params",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "partnerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "senderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobRef",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "location",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minSalary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxSalary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salaryDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobDesc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "term",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "per",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hideRef",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AdminVacancyJobPublishRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AdminVacancyJobPublishRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "bcb18b786a0c153530f232d6e8d04e83",
      "id": null,
      "metadata": {},
      "name": "AdminVacancyJobPublishRouteQuery",
      "operationKind": "query",
      "text": "query AdminVacancyJobPublishRouteQuery(\n  $id: UUID!\n) {\n  config: recruitIdibuVacancyConfigByVacancyId(vacancyId: $id) {\n    vacancyId\n    actionUrl\n    hasConfig\n    params {\n      partnerId\n      hash\n      senderId\n      jobTitle\n      jobRef\n      startDate\n      location\n      duration\n      minSalary\n      maxSalary\n      salaryDescription\n      appUrl\n      jobDesc\n      term\n      currency\n      per\n      hideRef\n    }\n  }\n}\n"
    }
  };
}();
node146.hash = "193c50bdd8cd3892a3cd2cd2ce5da3d4";
var AdminVacancyJobPublishRouteQuery_graphql_default = node146;

// src/secure/recruit/vacancies/vacancies/AdminVacancyJobPublishRoute.tsx
import { useEffect as useEffect8, useRef } from "react";
import { useLazyLoadQuery as useLazyLoadQuery29 } from "react-relay";
import Frame from "react-frame-component";
import { EdSkeleton as EdSkeleton82, MynPageTitle as MynPageTitle80, Suspense as Suspense111 } from "shared-ui";
import { useVacancyRouteData as useVacancyRouteData2 } from "feature-recruit";
import { jsx as jsx164, jsxs as jsxs143 } from "react/jsx-runtime";
var queryDef53 = AdminVacancyJobPublishRouteQuery_graphql_default;
var AdminVacancyJobPublishRoute = ({ parentRouteId }) => {
  const data = useVacancyRouteData2(parentRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx164(EdSkeleton82, {});
  }
  return /* @__PURE__ */ jsxs143(Suspense111, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx164(MynPageTitle80, { title: "Vacancy Job Publish" }),
    /* @__PURE__ */ jsx164(IdibuContainer, { vacancyId: vacancy.vacancyId })
  ] });
};
var styles = {
  border: 0,
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0
};
var IdibuContainer = ({ vacancyId }) => {
  const query = useLazyLoadQuery29(
    queryDef53,
    { id: vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { config } = query;
  if (!config) {
    return /* @__PURE__ */ jsx164(EdSkeleton82, {});
  }
  if (!config.actionUrl || !config.params) {
    return /* @__PURE__ */ jsx164("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsx164("div", { className: "text-primary-700 font-bold", children: "No Idibu Config" }) });
  }
  return /* @__PURE__ */ jsx164(Suspense111, { fallback: "Loading...", children: /* @__PURE__ */ jsx164("div", { className: "relative flex h-screen flex-col gap-5 overflow-hidden bg-white", children: /* @__PURE__ */ jsx164(Frame, { title: "idibu", style: styles, children: /* @__PURE__ */ jsx164(IdibuForm, { actionUrl: config.actionUrl, params: config.params }) }) }) });
};
var IdibuForm = ({ actionUrl, params }) => {
  const action = actionUrl + "?method=post";
  const formRef = useRef(null);
  useEffect8(() => {
    if (!formRef.current) {
      return;
    }
    formRef.current?.submit();
  }, [formRef]);
  const formattedHTMLText = params?.jobDesc?.replace(/(?:\r\n|\r|\n)/g, "<br>");
  return /* @__PURE__ */ jsxs143(
    "form",
    {
      id: "idibu-iframe-post-form",
      method: "post",
      action,
      ref: formRef,
      children: [
        params.appUrl && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "appUrl", value: params.appUrl }),
        params.currency && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "currency", value: params.currency }),
        params.duration && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "duration", value: params.duration }),
        params.hash && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "hash", value: params.hash }),
        params.hideRef && /* @__PURE__ */ jsx164(
          "input",
          {
            type: "hidden",
            name: "hideRef",
            value: params.hideRef ? "true" : "false"
          }
        ),
        params.jobDesc && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "jobDesc", value: formattedHTMLText }),
        params.jobRef && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "jobRef", value: params.jobRef }),
        params.jobTitle && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "jobTitle", value: params.jobTitle }),
        params.location && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "location", value: params.location }),
        params.maxSalary && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "maxSalary", value: params.maxSalary }),
        params.minSalary && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "minSalary", value: params.minSalary }),
        params.partnerId && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "partnerId", value: params.partnerId }),
        params.per && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "per", value: params.per }),
        params.salaryDescription && /* @__PURE__ */ jsx164(
          "input",
          {
            type: "hidden",
            name: "salaryDescription",
            value: params.salaryDescription
          }
        ),
        params.senderId && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "senderId", value: params.senderId }),
        params.startDate && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "startDate", value: params.startDate }),
        params.term && /* @__PURE__ */ jsx164("input", { type: "hidden", name: "term", value: params.term })
      ]
    }
  );
};

// src/secure/recruit/vacancies/vacancies/AdminVacancyRoute.tsx
import { jsx as jsx165 } from "react/jsx-runtime";
var vacancyTabs = [
  { name: "Dashboard", to: "dashboard" },
  { name: "Applications", to: "applications" },
  { name: "Matches", to: "matches" },
  { name: "Recommendations", to: "recommendations" },
  { name: "Edit", to: "edit" },
  { name: "Job Boards", to: "job-ads" },
  { name: "Job Publish", to: "job-publish" }
];
var createAdminVacancyRoute = (routePrefix, environment, context, options) => {
  return [
    {
      path: "*",
      id: `${routePrefix}-vacancy`,
      element: /* @__PURE__ */ jsx165(ErrorBoundary18, { FallbackComponent: ErrorBoundaryFallback19, children: /* @__PURE__ */ jsx165(VacancyRoute, { hideHeader: options?.hideHeader, tabs: vacancyTabs }) }),
      errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
      handle: {},
      loader: ({ params }) => {
        return vacancyLoader(environment, params);
      },
      children: [
        {
          path: "dashboard",
          id: `${routePrefix}-vacancy-root`,
          element: /* @__PURE__ */ jsx165(VacancyRoot, { id: `${routePrefix}-vacancy-root` }),
          handle: {},
          loader: ({ params }) => {
            return vacancyRootLoader(environment, params);
          }
        },
        {
          path: "job-ads",
          id: `${routePrefix}-vacancy-job-ads`,
          element: /* @__PURE__ */ jsx165(AdminVacancyJobBoardAdsRoute, { parentRouteId: routePrefix })
        },
        {
          path: "job-publish",
          id: `${routePrefix}-vacancy-job-publish`,
          element: /* @__PURE__ */ jsx165(AdminVacancyJobPublishRoute, { parentRouteId: routePrefix })
        },
        {
          id: `${routePrefix}-vacancy-conversations`,
          path: "inbox",
          element: /* @__PURE__ */ jsx165(VacancyConversations, { id: `${routePrefix}-vacancy-conversations` }),
          handle: {
            crumb: () => /* @__PURE__ */ jsx165(BreadcrumbLink, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return vacancyEditLoader(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-edit`,
          path: "edit",
          element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
          children: createVacancyEditRoutes(
            `${routePrefix}-vacancy-edit`,
            environment,
            context
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx165(BreadcrumbLink, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return vacancyEditLoader(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-recommendations`,
          path: "recommendations/*",
          element: /* @__PURE__ */ jsx165(
            VacancyRecommendationsRoute,
            {
              id: `${routePrefix}-vacancy-recommendations`
            }
          ),
          errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          handle: {
            crumb: () => /* @__PURE__ */ jsx165(Link27, { className: "text-md text-gray-500", to: "recommendations", children: "Recommendations" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx165(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {})
            },
            {
              id: `${routePrefix}-vacancy-recommendations-recommendation`,
              path: ":recommendationCode/*",
              element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
              errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
              children: createVacancyRecommendationRoutes(
                `${routePrefix}-vacancy-recommendations-recommendation`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-recommendations-recommendation-view`,
          path: "recommendation/:recommendationCode/*",
          element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
          errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
          children: createVacancyRecommendationRoutes(
            `${routePrefix}-vacancy-recommendations-recommendation-view`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-applications`,
          path: "applications/*",
          element: /* @__PURE__ */ jsx165(
            VacancyApplicationsRoute,
            {
              id: `${routePrefix}-vacancy-applications`
            }
          ),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx165(Link27, { className: "text-md text-gray-500", to: "applications", children: "Applications" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx165(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {})
            },
            {
              id: `${routePrefix}-vacancy-applications-application`,
              path: ":applicationCode/*",
              element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
              errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
              children: createCandidateApplicationRoutes(
                `${routePrefix}-vacancy-applications-application`,
                environment,
                context,
                false
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-matches`,
          path: "matches/*",
          element: /* @__PURE__ */ jsx165(Suspense112, { fallback: "Loading...", children: /* @__PURE__ */ jsx165(OutletRoute25, {}) }),
          errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx165(Link27, { className: "text-md text-gray-500", to: "matches", children: "Matches" })
          },
          children: [
            {
              path: "*",
              element: /* @__PURE__ */ jsx165(
                VacancyMatchesLayout,
                {
                  vacancyRouteId: routePrefix,
                  environment
                }
              )
            },
            {
              id: `${routePrefix}-vacancy-matches-match`,
              path: ":matchCode/*",
              element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
              errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
              children: createMatchRoutes(
                `${routePrefix}-vacancy-matches-match`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-application`,
          path: ":applicationCode/*",
          element: /* @__PURE__ */ jsx165(OutletRoute25, {}),
          errorElement: /* @__PURE__ */ jsx165(ErrorContainer12, {}),
          children: createCandidateApplicationRoutes(
            `${routePrefix}-vacancy-application-application`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-dashboard`,
          path: "*",
          element: /* @__PURE__ */ jsx165(Navigate39, { to: "dashboard", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/vacancies/AdminVacanciesRoute.tsx
import { jsx as jsx166 } from "react/jsx-runtime";
var AdminVacanciesRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-vacancies`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx166(OutletRoute26, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx166(VacancySearchLoader, { showAddVacancy: false }),
          children: [
            {
              id: `${listRouteId}-vacancy`,
              path: ":vacancyCode/*",
              element: /* @__PURE__ */ jsx166(OutletRoute26, {}),
              children: createAdminVacancyRoute(
                `${listRouteId}-vacancy`,
                environment,
                context
              ),
              handle: {
                crumb: () => /* @__PURE__ */ jsx166(VacancyLink, { id: `${listRouteId}-vacancy` })
              },
              loader: ({ params }) => {
                return vacancyLoader2(environment, params);
              }
            }
          ]
        },
        {
          id: `${routeId6}-vacancy`,
          path: "view/:vacancyCode/*",
          element: /* @__PURE__ */ jsx166(OutletRoute26, {}),
          children: createAdminVacancyRoute(
            `${routeId6}-vacancy`,
            environment,
            context,
            { hideHeader: true }
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx166(VacancyLink, { id: `${routeId6}-vacancy` })
          },
          loader: ({ params }) => {
            return vacancyLoader2(environment, params);
          }
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx166(Navigate40, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/vacancies/AdminVacanciesRoutes.tsx
import { jsx as jsx167, jsxs as jsxs144 } from "react/jsx-runtime";
var Layout13 = () => {
  const location = useLocation17();
  const tabs4 = [createLinkState16(location, "List", `list`, UsersIcon6)];
  return /* @__PURE__ */ jsxs144("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs144("div", { className: "border-b bg-white p-2", children: [
      /* @__PURE__ */ jsx167(MynPageTitle81, { title: "Vacancies" }),
      /* @__PURE__ */ jsx167(TabPills8, { tabs: tabs4 })
    ] }),
    /* @__PURE__ */ jsx167(Outlet25, {})
  ] });
};
var createVacanciesAdministrationRoutes = (environment, context) => {
  const routeId6 = "admin-vacancies";
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx167(Layout13, {}),
      children: AdminVacanciesRoutes(routeId6, environment, context)
    }
  ];
};

// src/secure/recruit/vacancies/vacancy-qa/components/VacancyQualityAssuranceDashboardRoute.tsx
import { Suspense as Suspense113 } from "react";
import { Navigate as Navigate41 } from "react-router-dom";
import { OutletRoute as OutletRoute27 } from "app-core";
import {
  VacancyQualityAssurancesListContainer,
  createVacancyQualityAssuranceRoute
} from "feature-recruit";
import { MynPageTitle as MynPageTitle82 } from "shared-ui";
import { jsx as jsx168, jsxs as jsxs145 } from "react/jsx-runtime";
var List10 = () => {
  return /* @__PURE__ */ jsxs145(Suspense113, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx168(MynPageTitle82, { title: "Vacancy Quality Assurance List" }),
    /* @__PURE__ */ jsx168(VacancyQualityAssurancesListContainer, {})
  ] });
};
var createVacancyQualityAssuranceDashboardRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-vacancy-quality-assurance`;
  const listRouteId = `${routeId6}-list`;
  const listQARouteId = `${listRouteId}-qa`;
  const qaRouteId = `${routeId6}-qa`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx168(OutletRoute27, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx168(List10, {}),
          children: [
            createVacancyQualityAssuranceRoute(
              listQARouteId,
              environment,
              context
            )
          ]
        },
        createVacancyQualityAssuranceRoute(qaRouteId, environment, context),
        {
          path: "*",
          element: /* @__PURE__ */ jsx168(Navigate41, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/job-board-search/pages/__generated__/JobBoardSearchPageQuery.graphql.ts
var node147 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v7 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchRunStats",
    "kind": "LinkedField",
    "name": "searchRunStats",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchResultStats",
    "kind": "LinkedField",
    "name": "searchResultStats",
    "plural": false,
    "selections": v7,
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchPageQuery",
      "selections": [
        {
          "alias": "search",
          "args": v1,
          "concreteType": "JobBoardSearchSearch",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "JobBoardSearchContainer_search"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchPageQuery",
      "selections": [
        {
          "alias": "search",
          "args": v1,
          "concreteType": "JobBoardSearchSearch",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "organisationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "query",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resumeDaysOld",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "radius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "locationsPattern",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scheduleStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchTriggerSpec",
              "kind": "LinkedField",
              "name": "searchTrigger",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startsOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endsOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cronExpression",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchJobBoard",
              "kind": "LinkedField",
              "name": "jobBoards",
              "plural": true,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchParameter",
                  "kind": "LinkedField",
                  "name": "parameters",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "autoDownload",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchJobBoard",
              "kind": "LinkedField",
              "name": "jobBoardDefinitions",
              "plural": true,
              "selections": [
                v2,
                v11,
                v5,
                v3
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b8a9b184d692797ab109c1326605e5b7",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchPageQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchPageQuery(\n  $code: Long!\n) {\n  search: jobBoardSearchSearchByCode(code: $code) {\n    id\n    code\n    searchId\n    name\n    description\n    searchRunStats {\n      count\n    }\n    searchResultStats {\n      count\n    }\n    ...JobBoardSearchContainer_search\n  }\n}\n\nfragment JobBoardSearchActivateButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchCloseButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchContainer_search on JobBoardSearchSearch {\n  id\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n  searchTrigger {\n    startsOn\n    endsOn\n    cronExpression\n  }\n  searchRunStats {\n    count\n  }\n  searchResultStats {\n    count\n  }\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n  ...JobBoardSearchDetailForm_search\n  ...JobBoardSearchDetailView_search\n  ...JobBoardSearchCreateRunButton_search\n  ...JobBoardSearchActivateButton_search\n  ...JobBoardSearchCloseButton_search\n}\n\nfragment JobBoardSearchCreateRunButton_search on JobBoardSearchSearch {\n  id\n  searchId\n}\n\nfragment JobBoardSearchDetailForm_search on JobBoardSearchSearch {\n  id\n  searchId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  description\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n  ...JobBoardSearchJobBoardEditor_search\n}\n\nfragment JobBoardSearchDetailView_search on JobBoardSearchSearch {\n  id\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n  jobBoards {\n    jobBoardId\n    autoDownload\n    parameters {\n      formId\n      value\n    }\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n}\n\nfragment JobBoardSearchJobBoardEditor_search on JobBoardSearchSearch {\n  id\n  searchId\n  jobBoards {\n    jobBoardId\n    parameters {\n      value\n      formId\n    }\n    autoDownload\n  }\n  jobBoardDefinitions {\n    id\n    jobBoardId\n    name\n    code\n  }\n}\n"
    }
  };
}();
node147.hash = "b47c7724cae0ad73fcaa02012c2b59ef";
var JobBoardSearchPageQuery_graphql_default = node147;

// src/secure/recruit/job-board-search/pages/JobBoardSearchPage.tsx
import { loadQuery as loadQuery41, usePreloadedQuery as usePreloadedQuery22 } from "react-relay";
import { useRouteLoaderData as useRouteLoaderData10 } from "react-router-dom";
import { useRefresh } from "shared-lib";
import { ButtonTabUnderline, MynPageTitle as MynPageTitle84, useTabs as useTabs2 } from "shared-ui";
import {
  JobBoardSearchContainer,
  JobBoardSearchRunsContainer,
  JobBoardSearchResultsContainer
} from "feature-recruit";

// src/secure/recruit/job-board-search/pages/__generated__/EmployerJobBoardSearchLayoutQuery.graphql.ts
var node148 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        v2,
        v3,
        v4,
        v5
      ],
      "storageKey": null
    },
    {
      "alias": "module",
      "args": [
        {
          "kind": "Variable",
          "name": "employerCode",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "JobBoardSearchModule",
      "kind": "LinkedField",
      "name": "jobBoardSearchJobBoardSearchModuleByEmployerCode",
      "plural": false,
      "selections": [
        v1,
        v2,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        v4,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        v3,
        v5
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerJobBoardSearchLayoutQuery",
      "selections": v6,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerJobBoardSearchLayoutQuery",
      "selections": v6
    },
    "params": {
      "cacheID": "8b425c1825bbf961d41d8d2eaea5ac35",
      "id": null,
      "metadata": {},
      "name": "EmployerJobBoardSearchLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerJobBoardSearchLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n    code\n    updatedAt\n    name\n  }\n  module: jobBoardSearchJobBoardSearchModuleByEmployerCode(employerCode: $employerCode) {\n    id\n    code\n    status\n    name\n    isTest\n    createdAt\n    updatedAt\n  }\n}\n"
    }
  };
}();
node148.hash = "66b7fb317668400ee7c673e2dbef9179";
var EmployerJobBoardSearchLayoutQuery_graphql_default = node148;

// src/secure/recruit/job-board-search/pages/EmployerJobBoardSearchLayout.tsx
import { useMemo as useMemo9 } from "react";
import {
  Link as Link28,
  Outlet as Outlet26,
  useLoaderData as useLoaderData9,
  useLocation as useLocation18,
  useRouteLoaderData as useRouteLoaderData9
} from "react-router-dom";
import {
  loadQuery as loadQuery40,
  usePreloadedQuery as usePreloadedQuery21
} from "react-relay";
import { ArrowsPointingOutIcon as ArrowsPointingOutIcon6 } from "@heroicons/react/24/outline";
import { MynPageTitle as MynPageTitle83, Suspense as Suspense114 } from "shared-ui";
import {
  createLinkState as createLinkState17,
  EdButtonLink as EdButtonLink8,
  IconJustify as IconJustify6,
  TabUnderline as TabUnderline8
} from "shared-ui";
import { Fragment as Fragment58, jsx as jsx169, jsxs as jsxs146 } from "react/jsx-runtime";
var layoutQueryDef2 = EmployerJobBoardSearchLayoutQuery_graphql_default;
function useEmployerJobBoardSearchLayoutRouteData(routeId6) {
  const queryRef = useRouteLoaderData9(
    routeId6
  );
  const data = usePreloadedQuery21(
    layoutQueryDef2,
    queryRef
  );
  return data;
}
var EmployerJobBoardSearchLayout = ({
  showHeader,
  inList
}) => {
  const location = useLocation18();
  const preloadedQuery = useLoaderData9();
  const data = usePreloadedQuery21(layoutQueryDef2, preloadedQuery);
  const tabs4 = useMemo9(() => {
    return [
      createLinkState17(location, "Dashboard", `dashboard`),
      createLinkState17(location, "Searches", `searches`),
      createLinkState17(location, "New Search", `new-search`)
    ];
  }, [location]);
  const { employer, module } = data;
  if (employer === null || employer === void 0) {
    return /* @__PURE__ */ jsx169("div", { children: "Not Found" });
  }
  const name = `${employer.name}`;
  return /* @__PURE__ */ jsxs146(Suspense114, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx169(MynPageTitle83, { title: "Employer Job Board Search Employer" }),
    /* @__PURE__ */ jsxs146("div", { className: "flex flex-1 flex-col", children: [
      showHeader && /* @__PURE__ */ jsxs146("div", { className: "flex flex-wrap items-center gap-2 border-b py-4", children: [
        /* @__PURE__ */ jsx169("div", { className: "text-primary-700 px-2 font-medium uppercase sm:px-8", children: name }),
        module ? /* @__PURE__ */ jsx169("div", { className: "text-success-700 px-2 font-medium", children: "Enabled" }) : /* @__PURE__ */ jsx169("div", { className: "text-danger-700 px-2 font-medium", children: "Disabled" })
      ] }),
      /* @__PURE__ */ jsxs146("div", { className: "flex flex-wrap items-center justify-between border-b bg-white py-3", children: [
        /* @__PURE__ */ jsx169("div", { className: "px-4", children: /* @__PURE__ */ jsx169(TabUnderline8, { tabs: tabs4 }) }),
        inList && /* @__PURE__ */ jsx169("div", { children: /* @__PURE__ */ jsx169(
          EdButtonLink8,
          {
            to: `../../../../${employer.code}`,
            name: "View",
            icon: ArrowsPointingOutIcon6,
            iconJustify: IconJustify6.Right
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx169(Outlet26, {})
    ] })
  ] });
};
async function loader40(environment, params) {
  const code = params.employerCode;
  const employerCode = parseInt(code);
  return loadQuery40(
    environment,
    layoutQueryDef2,
    {
      employerCode
    }
  );
}

// src/secure/recruit/job-board-search/pages/JobBoardSearchPage.tsx
import { jsx as jsx170, jsxs as jsxs147 } from "react/jsx-runtime";
var queryDef54 = JobBoardSearchPageQuery_graphql_default;
function useJobBoardSearchPageRouteData(routeId6) {
  const queryRef = useRouteLoaderData10(
    routeId6
  );
  const data = usePreloadedQuery22(queryDef54, queryRef);
  return data;
}
async function loader41(environment, params) {
  return loadQuery41(environment, queryDef54, {
    code: Number(params.searchCode)
  });
}
var JobBoardSearchPage = ({
  routeId: routeId6,
  employerRouteId
}) => {
  const [options, refresh] = useRefresh();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const { search } = useJobBoardSearchPageRouteData(routeId6);
  const [current, tabLinks] = useTabs2([
    { name: "Details", label: "Details" },
    {
      name: "Runs",
      label: search?.searchRunStats ? `Runs (${search.searchRunStats.count})` : "Runs"
    },
    {
      name: "Results",
      label: search?.searchResultStats ? `Results (${search.searchResultStats.count})` : "Results"
    }
  ]);
  if (!search || !employer) {
    return /* @__PURE__ */ jsx170("div", { children: "Loading...." });
  }
  let currentTab;
  switch (current.name) {
    case "Details": {
      currentTab = /* @__PURE__ */ jsx170("div", { className: "m-2 flex-1", children: /* @__PURE__ */ jsx170(JobBoardSearchContainer, { search, onUpdate: refresh }) });
      break;
    }
    case "Runs": {
      currentTab = /* @__PURE__ */ jsx170("div", { className: "mx-1 flex-1", children: /* @__PURE__ */ jsx170(
        JobBoardSearchRunsContainer,
        {
          organisationId: employer.employerId,
          searchId: search.searchId
        }
      ) });
      break;
    }
    case "Results": {
      currentTab = /* @__PURE__ */ jsx170("div", { className: "m-1 flex-1", children: /* @__PURE__ */ jsx170(
        JobBoardSearchResultsContainer,
        {
          organisationId: employer.employerId,
          searchId: search.searchId
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs147("div", { className: "rounded-lg border border-gray-200 bg-white p-3", children: [
    /* @__PURE__ */ jsx170(MynPageTitle84, { title: "Job Board Search" }),
    /* @__PURE__ */ jsx170("div", { className: "mb-2 font-medium text-gray-500", children: /* @__PURE__ */ jsx170("div", { children: search.name }) }),
    /* @__PURE__ */ jsx170("div", { className: "mb-2 pb-4", children: /* @__PURE__ */ jsx170(ButtonTabUnderline, { tabs: tabLinks }) }),
    /* @__PURE__ */ jsx170("div", { className: "flex", children: currentTab })
  ] });
};
var createRoute32 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-search`;
  return {
    id: routeId6,
    path: "search/:searchCode",
    element: /* @__PURE__ */ jsx170(JobBoardSearchPage, { routeId: routeId6, employerRouteId }),
    loader: ({ params }) => {
      return loader41(environment, params);
    }
  };
};

// src/secure/recruit/job-board-search/pages/JobBoardSearchesPage.tsx
import { useCallback as useCallback74 } from "react";
import { Link as Link29, useNavigate as useNavigate32 } from "react-router-dom";
import { MynPageTitle as MynPageTitle85, Suspense as Suspense116 } from "shared-ui";
import { EdSkeleton as EdSkeleton84 } from "shared-ui";

// src/secure/recruit/job-board-search/pages/__generated__/JobBoardSearchesContainerQuery.graphql.ts
var node149 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v3 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "organisationId",
      "variableName": "organisationId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchesContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchList_searches"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v2
      ],
      "kind": "Operation",
      "name": "JobBoardSearchesContainerQuery",
      "selections": [
        {
          "alias": "searches",
          "args": v3,
          "concreteType": "JobBoardSearchSearchesConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearch",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "query",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeDaysOld",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "locationsPattern",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scheduleStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "searches",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchList_searches",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchSearches"
        }
      ]
    },
    "params": {
      "cacheID": "197429b2a60422ce3089f03c0591ef3f",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchesContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchesContainerQuery(\n  $organisationId: UUID!\n  $order: [JobBoardSearchSearchSort!]!\n  $where: JobBoardSearchSearchFilter!\n) {\n  ...JobBoardSearchList_searches\n}\n\nfragment JobBoardSearchList_searches on Query {\n  searches: jobBoardSearchSearches(organisationId: $organisationId, first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        searchId\n        ...JobBoardSearchRow_search\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchRow_search on JobBoardSearchSearch {\n  id\n  code\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n}\n"
    }
  };
}();
node149.hash = "9210fb1990fbf78b769fde8df1438b9f";
var JobBoardSearchesContainerQuery_graphql_default = node149;

// src/secure/recruit/job-board-search/pages/JobBoardSearchesContainer.tsx
import { useCallback as useCallback73, useState as useState31 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery30 } from "react-relay/hooks";
import { Suspense as Suspense115 } from "shared-ui";
import { useDebounce as useDebounce9 } from "shared-lib";
import { Button as Button41, EdSkeleton as EdSkeleton83, Input as Input10, RadioList as RadioList2 } from "shared-ui";
import { JobBoardSearchList, JobBoardSearchStatus } from "feature-recruit";
import { jsx as jsx171, jsxs as jsxs148 } from "react/jsx-runtime";
var statusList = [
  {
    id: "All",
    label: "All"
  },
  {
    id: JobBoardSearchStatus.Active.toString(),
    label: "Active"
  },
  {
    id: JobBoardSearchStatus.Draft.toString(),
    label: "Draft"
  },
  {
    id: JobBoardSearchStatus.Closed.toString(),
    label: "Closed"
  }
];
var graphqlQuery10 = JobBoardSearchesContainerQuery_graphql_default;
var JobBoardSearchesContainer = ({
  employer,
  onSelect
}) => {
  const onNewSearch = useCallback73(() => {
  }, []);
  const [filter, setFilter] = useState31(null);
  const searchTerm = useDebounce9(filter, 500);
  const [searchStatus, setSearchStatus] = useState31(statusList[0]);
  const onSetVacancySyncStatus = useCallback73(
    (ms) => {
      setSearchStatus(ms);
    },
    [searchStatus]
  );
  const order2 = [{ updatedAt: "DESC" }];
  const where2 = {
    organisationId: { eq: employer.employerId }
  };
  const query = useLazyLoadQuery30(
    graphqlQuery10,
    { organisationId: employer.employerId, where: where2, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!employer) {
    return /* @__PURE__ */ jsx171(EdSkeleton83, {});
  }
  return /* @__PURE__ */ jsx171(Suspense115, { fallback: /* @__PURE__ */ jsx171(EdSkeleton83, {}), children: /* @__PURE__ */ jsxs148("div", { children: [
    /* @__PURE__ */ jsxs148("div", { className: "flex items-center justify-between space-x-4", children: [
      /* @__PURE__ */ jsxs148("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsxs148("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx171("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx171("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx171(
            Input10,
            {
              placeholder: " Title or Bullhorn Code ",
              name: "filter",
              onValueChange: (filter2) => setFilter(filter2)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs148("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx171("label", { className: "text-gray-700", htmlFor: "filter", children: "Sync Status" }),
          /* @__PURE__ */ jsx171("div", { children: /* @__PURE__ */ jsx171(
            RadioList2,
            {
              list: statusList,
              value: searchStatus,
              onChange: (status) => onSetVacancySyncStatus(status)
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx171("div", { className: "flex items-center space-x-4 p-2", children: /* @__PURE__ */ jsx171(Button41, { className: "p-2", color: "primary", clicked: onNewSearch, children: "New Search" }) })
    ] }),
    /* @__PURE__ */ jsx171(JobBoardSearchList, { onSelect, searchesKey: query })
  ] }) });
};

// src/secure/recruit/job-board-search/pages/JobBoardSearchesPage.tsx
import { jsx as jsx172, jsxs as jsxs149 } from "react/jsx-runtime";
var JobBoardSearchesPage = ({ employerRouteId }) => {
  const navigate = useNavigate32();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const onSelect = useCallback74(
    ({ code }) => {
      navigate(`../search/${code}`);
    },
    [navigate]
  );
  if (!employer) {
    return /* @__PURE__ */ jsx172(EdSkeleton84, {});
  }
  return /* @__PURE__ */ jsxs149(Suspense116, { fallback: /* @__PURE__ */ jsx172(EdSkeleton84, {}), children: [
    /* @__PURE__ */ jsx172(MynPageTitle85, { title: "Job Board Searches" }),
    /* @__PURE__ */ jsx172("div", { children: /* @__PURE__ */ jsx172(JobBoardSearchesContainer, { employer, onSelect }) })
  ] });
};
var createRoute33 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-searches`;
  return {
    id: routeId6,
    path: "searches",
    element: /* @__PURE__ */ jsx172(JobBoardSearchesPage, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx172(Link29, { to: "searches", children: "Searches" })
    }
  };
};

// src/secure/recruit/job-board-search/pages/EmployerJobBoardDashboard.tsx
import { useCallback as useCallback75 } from "react";
import { Link as Link30 } from "react-router-dom";
import { Button as Button42, EdSkeleton as EdSkeleton85, MynPageTitle as MynPageTitle86 } from "shared-ui";
import {
  useEnableJobBoardSearchModule
} from "feature-recruit";
import { jsx as jsx173, jsxs as jsxs150 } from "react/jsx-runtime";
var Page = ({ employerRouteId }) => {
  const { employer, module } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const [enable, isEnabling] = useEnableJobBoardSearchModule();
  const onEnable = useCallback75(async () => {
    if (!employer) {
      return;
    }
    const input = {
      organisationId: employer.employerId
    };
    const result = await enable({ connections: [], input });
    if (result.result) {
    }
  }, [enable]);
  const onNew = useCallback75(() => {
  }, []);
  const onCancel = useCallback75(() => {
  }, []);
  if (!employer) {
    return /* @__PURE__ */ jsx173(EdSkeleton85, {});
  }
  return /* @__PURE__ */ jsxs150("div", { className: "m-8 rounded-lg border border-gray-200 bg-white p-3 md:w-1/3", children: [
    /* @__PURE__ */ jsx173(MynPageTitle86, { title: "Employer Job Board Dashboard" }),
    module ? /* @__PURE__ */ jsx173("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx173("div", { className: "text-success-700 px-2 font-medium", children: "Enabled" }) }) : /* @__PURE__ */ jsxs150("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx173("div", { className: "border-b p-2", children: /* @__PURE__ */ jsx173("div", { className: "text-danger-700 px-2 font-medium", children: "Disabled" }) }),
      /* @__PURE__ */ jsx173("div", { className: "p-2", children: /* @__PURE__ */ jsx173(Button42, { color: "primary", clicked: onEnable, disabled: isEnabling, children: "Enable" }) })
    ] })
  ] });
};
var createRoute34 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-dashboard`;
  return {
    id: routeId6,
    path: "dashboard",
    element: /* @__PURE__ */ jsx173(Page, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx173(Link30, { to: "dashboard", children: "Dashboard" })
    }
  };
};

// src/secure/recruit/job-board-search/pages/JobBoardNewSearchPage.tsx
import { useCallback as useCallback76 } from "react";
import { Link as Link31, useNavigate as useNavigate33 } from "react-router-dom";
import { JobBoardSearchNewForm } from "feature-recruit";
import { EdSkeleton as EdSkeleton86, MynPageTitle as MynPageTitle87 } from "shared-ui";
import { jsx as jsx174, jsxs as jsxs151 } from "react/jsx-runtime";
var JobBoardNewSearchPage = ({ employerRouteId }) => {
  const navigate = useNavigate33();
  const { employer } = useEmployerJobBoardSearchLayoutRouteData(employerRouteId);
  const onNew = useCallback76(
    (code) => {
      navigate(`../search/${code}`);
    },
    [navigate]
  );
  const onCancel = useCallback76(() => {
    navigate(`../searches`);
  }, [navigate]);
  if (!employer) {
    return /* @__PURE__ */ jsx174(EdSkeleton86, {});
  }
  return /* @__PURE__ */ jsxs151("div", { className: "m-8 rounded-lg border border-gray-200 bg-white p-3 md:w-1/3", children: [
    /* @__PURE__ */ jsx174(MynPageTitle87, { title: "Job Board New Search" }),
    /* @__PURE__ */ jsx174("div", { className: "mb-2 font-medium text-gray-500", children: /* @__PURE__ */ jsx174("div", { children: "Create A Search" }) }),
    /* @__PURE__ */ jsx174("div", { className: "mb-2 pb-4", children: /* @__PURE__ */ jsx174(
      JobBoardSearchNewForm,
      {
        organisationId: employer.employerId,
        onDone: onNew,
        onCancel
      }
    ) })
  ] });
};
var createRoute35 = (routePrefix, environment, context, employerRouteId) => {
  const routeId6 = `${routePrefix}-new-search`;
  return {
    id: routeId6,
    path: "new-search",
    element: /* @__PURE__ */ jsx174(JobBoardNewSearchPage, { employerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx174(Link31, { to: "new-search", children: "New Search" })
    }
  };
};

// src/secure/recruit/job-board-search/JobBoardSearchLayout.tsx
import { Navigate as Navigate42 } from "react-router-dom";
import { OutletRoute as OutletRoute28 } from "app-core";

// src/secure/recruit/employers/EmployersList.tsx
import { useCallback as useCallback77 } from "react";
import { useNavigate as useNavigate34 } from "react-router-dom";
import {
  EmployerSearchContainer as EmployerSearchContainer2
} from "feature-employer-accounts";
import { MynPageTitle as MynPageTitle88 } from "shared-ui";
import { jsx as jsx175, jsxs as jsxs152 } from "react/jsx-runtime";
var EmployersList = ({ navigateTo: navigateTo2 }) => {
  const navigate = useNavigate34();
  const onSelect = useCallback77(
    (result) => {
      navigate(navigateTo2(result));
    },
    [navigate]
  );
  return /* @__PURE__ */ jsxs152("div", { className: "container m-auto flex flex-col gap-2 border bg-white p-8", children: [
    /* @__PURE__ */ jsx175(MynPageTitle88, { title: "Job Board Employer Search" }),
    /* @__PURE__ */ jsx175("div", { className: "text-primary-700 border-b p-2 text-lg", children: "Search for Employer" }),
    /* @__PURE__ */ jsx175("div", { className: "p-2", children: /* @__PURE__ */ jsx175(EmployerSearchContainer2, { onSearchCompleted: onSelect }) })
  ] });
};

// src/secure/recruit/job-board-search/JobBoardSearchLayout.tsx
import { jsx as jsx176 } from "react/jsx-runtime";
function navigateTo(result) {
  return `../employer/${result.code}`;
}
var createJobBoardSearchRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-job-board-search`;
  const employerRouteId = `${routeId6}-employer`;
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx176(OutletRoute28, {}),
      children: [
        {
          path: "list/*",
          element: /* @__PURE__ */ jsx176(EmployersList, { navigateTo })
        },
        {
          id: employerRouteId,
          path: "employer/:employerCode/*",
          element: /* @__PURE__ */ jsx176(EmployerJobBoardSearchLayout, { inList: false, showHeader: true }),
          loader: ({ params }) => {
            return loader40(environment, params);
          },
          children: [
            createRoute34(routeId6, environment, context, employerRouteId),
            createRoute35(routeId6, environment, context, employerRouteId),
            createRoute33(routeId6, environment, context, employerRouteId),
            createRoute32(routeId6, environment, context, employerRouteId),
            {
              path: "*",
              element: /* @__PURE__ */ jsx176(Navigate42, { to: "dashboard", replace: true })
            }
          ]
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx176(Navigate42, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/email-applications/EmailApplicationsLayout.tsx
import { Navigate as Navigate44 } from "react-router-dom";
import { OutletRoute as OutletRoute29 } from "app-core";
import { EmailApplicationList } from "feature-recruit";

// src/secure/recruit/email-applications/components/__generated__/EmailApplicationRouteQuery.graphql.ts
var node150 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emailApplicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "emailApplicationCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailApplicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailApplicationRouteQuery",
      "selections": [
        {
          "alias": "emailApplication",
          "args": v1,
          "concreteType": "RecruitEmailApplication",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmailApplicationContainer_emailApplication"
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailApplicationRouteQuery",
      "selections": [
        {
          "alias": "emailApplication",
          "args": v1,
          "concreteType": "RecruitEmailApplication",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobBoardName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyUnknown",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyClosed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "receivedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawContents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                v3,
                v2
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmailApplicationEvent",
              "kind": "LinkedField",
              "name": "events",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "details",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventTiming",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isFailure",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v2,
                v5,
                v6,
                v3
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bbdb8fa183d3c916b3374d19bca6d905",
      "id": null,
      "metadata": {},
      "name": "EmailApplicationRouteQuery",
      "operationKind": "query",
      "text": "query EmailApplicationRouteQuery(\n  $emailApplicationCode: Int!\n) {\n  emailApplication: recruitEmailApplicationByCode(code: $emailApplicationCode) {\n    id\n    code\n    emailApplicationId\n    firstName\n    lastName\n    emailAddress\n    ...EmailApplicationContainer_emailApplication\n  }\n}\n\nfragment EmailApplicationContainer_emailApplication on RecruitEmailApplication {\n  id\n  code\n  emailApplicationId\n  firstName\n  lastName\n  emailAddress\n  jobReference\n  jobBoardName\n  vacancyUnknown\n  vacancyClosed\n  receivedDate\n  emailSubject\n  rawContents\n  vacancy {\n    name\n    code\n    id\n  }\n  events {\n    date\n    details\n    eventTiming\n    isFailure\n  }\n  candidate {\n    id\n    firstName\n    lastName\n    code\n  }\n}\n"
    }
  };
}();
node150.hash = "aefbfc892165a0dfc28babcadf3c0fdd";
var EmailApplicationRouteQuery_graphql_default = node150;

// src/secure/recruit/email-applications/components/EmailApplicationRoute.tsx
import { Suspense as Suspense117 } from "react";
import {
  Navigate as Navigate43,
  Outlet as Outlet27,
  useLocation as useLocation19,
  useRouteLoaderData as useRouteLoaderData11
} from "react-router-dom";
import {
  loadQuery as loadQuery42,
  usePreloadedQuery as usePreloadedQuery23
} from "react-relay";
import { UsersIcon as UsersIcon7 } from "@heroicons/react/24/outline";
import { useRouteData as useRouteData32 } from "shared-lib";
import { createLinkState as createLinkState18, EdSkeleton as EdSkeleton87, MynPageTitle as MynPageTitle89, TabPills as TabPills9 } from "shared-ui";
import { EmailApplicationContainer } from "feature-recruit";
import { Fragment as Fragment59, jsx as jsx177, jsxs as jsxs153 } from "react/jsx-runtime";
var queryDef55 = EmailApplicationRouteQuery_graphql_default;
async function loader42(environment, params) {
  const code = params.emailApplicationCode;
  const emailApplicationCode = parseInt(code);
  return loadQuery42(environment, queryDef55, {
    emailApplicationCode
  });
}
var EmailApplicationDetails = ({ routeId: routeId6 }) => {
  const data = useRouteData32(queryDef55, routeId6);
  if (!data) {
    return /* @__PURE__ */ jsx177(Fragment59, { children: "Loading..." });
  }
  const { emailApplication } = data;
  if (!emailApplication) {
    return /* @__PURE__ */ jsx177(EdSkeleton87, {});
  }
  return /* @__PURE__ */ jsxs153(Suspense117, { fallback: /* @__PURE__ */ jsx177(EdSkeleton87, {}), children: [
    /* @__PURE__ */ jsx177(MynPageTitle89, { title: "Email Application Details" }),
    /* @__PURE__ */ jsx177("div", { className: "p-4", children: /* @__PURE__ */ jsx177(EmailApplicationContainer, { fragmentRef: emailApplication }) })
  ] });
};
var Layout14 = () => {
  const location = useLocation19();
  const tabs4 = [createLinkState18(location, "Details", `details`, UsersIcon7)];
  return /* @__PURE__ */ jsxs153("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx177("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx177(TabPills9, { tabs: tabs4 }) }),
    /* @__PURE__ */ jsx177(Outlet27, {})
  ] });
};
var createRoute36 = (routePrefix, environment, context, inList = true) => {
  const routeId6 = `${routePrefix}-email-application`;
  return {
    id: routeId6,
    path: ":emailApplicationCode",
    element: /* @__PURE__ */ jsx177(Layout14, {}),
    loader: ({ params }) => {
      return loader42(environment, params);
    },
    children: [
      {
        id: `${routeId6}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx177("div", { className: "flex-1", children: /* @__PURE__ */ jsx177(EmailApplicationDetails, { routeId: routeId6, inList }) })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx177(Navigate43, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/recruit/email-applications/EmailApplicationsLayout.tsx
import { MynPageTitle as MynPageTitle90 } from "shared-ui";
import { jsx as jsx178, jsxs as jsxs154 } from "react/jsx-runtime";
var List11 = () => {
  return /* @__PURE__ */ jsxs154("div", { children: [
    /* @__PURE__ */ jsx178(MynPageTitle90, { title: "Email Applications" }),
    /* @__PURE__ */ jsx178(EmailApplicationList, {})
  ] });
};
var createEmailApplicationsRoutes = (routePrefix, environment, context) => {
  const routeId6 = `${routePrefix}-email-applications`;
  const listRouteId = `${routeId6}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx178(OutletRoute29, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx178(List11, {}),
          children: [
            createRoute36(
              listRouteId,
              environment,
              context,
              true
            )
          ]
        },
        createRoute36(routeId6, environment, context, false),
        {
          path: "*",
          element: /* @__PURE__ */ jsx178(Navigate44, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recruit/applications/AdminApplicationsRoutes.tsx
import { Suspense as Suspense118 } from "react";
import { Navigate as Navigate45, Outlet as Outlet28, Link as Link32 } from "react-router-dom";
import { useUserSessionContext as useUserSessionContext4 } from "app-core";
import {
  createCandidateApplicationRoutes as createCandidateApplicationRoutes2,
  CandidateApplicationSearchList,
  ShowExpandApplicationProfile
} from "feature-recruit";
import { MynPageTitle as MynPageTitle91 } from "shared-ui";
import { jsx as jsx179, jsxs as jsxs155 } from "react/jsx-runtime";
var ApplicationsListRoute = () => {
  const session = useUserSessionContext4();
  return /* @__PURE__ */ jsxs155("div", { children: [
    /* @__PURE__ */ jsx179(MynPageTitle91, { title: "Applications" }),
    /* @__PURE__ */ jsx179(CandidateApplicationSearchList, { employerId: session.employerId }),
    ";"
  ] });
};
var ApplicationRoute = () => {
  return /* @__PURE__ */ jsxs155(Suspense118, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx179(MynPageTitle91, { title: "Application Details" }),
    /* @__PURE__ */ jsx179(Outlet28, {})
  ] });
};
var createApplicationsAdministrationRoutes = (environment, context) => {
  return [
    {
      id: "admin-application-dashboard",
      path: "list/*",
      element: /* @__PURE__ */ jsx179(Suspense118, { children: /* @__PURE__ */ jsx179(ApplicationsListRoute, {}) }),
      children: [
        {
          id: "admin-application-code",
          path: ":applicationCode/*",
          element: /* @__PURE__ */ jsx179(ApplicationRoute, {}),
          children: createCandidateApplicationRoutes2(
            "admin-application-dashboard-application",
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx179("div", {})
        }
      ]
    },
    {
      path: "application/:applicationCode/*",
      element: /* @__PURE__ */ jsx179(ShowExpandApplicationProfile.Provider, { value: false, children: /* @__PURE__ */ jsx179(ApplicationRoute, {}) }),
      children: createCandidateApplicationRoutes2(
        "admin-application-application-code",
        environment,
        context
      ),
      handle: {
        crumb: () => /* @__PURE__ */ jsx179(Link32, { to: "../../list", children: "Application" })
      }
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx179(Navigate45, { to: "list", replace: true })
    }
  ];
};

// src/secure/recruit/profiles/AdminProfileRoutes.tsx
import { Suspense as Suspense119 } from "react";
import { Navigate as Navigate46 } from "react-router-dom";
import {
  Profile,
  ProfileDetails,
  ProfileNotes,
  ProfileSearchContainer,
  ProfileWorkHistory,
  ProfileWorkTimeline
} from "feature-recruit";
import { jsx as jsx180 } from "react/jsx-runtime";
var createProfileSearchAdministrationRoutes = (environment, context) => {
  const routeId6 = "admin-recruit-profile";
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx180(ProfileSearchContainer, {}),
      children: [
        {
          id: `${routeId6}-profileId`,
          path: ":profileId/*",
          element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(Profile, { isInList: true }) }),
          children: [
            {
              path: "*",
              element: /* @__PURE__ */ jsx180(Navigate46, { to: `top-skills`, replace: true })
            },
            {
              id: `${routeId6}-top-skills`,
              path: "top-skills",
              element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(ProfileWorkTimeline, {}) })
            },
            {
              id: `${routeId6}-work-history`,
              path: "work-history",
              element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(ProfileWorkHistory, {}) })
            },
            {
              id: `${routeId6}-details`,
              path: "details",
              element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(ProfileDetails, {}) })
            },
            {
              id: `${routeId6}-notes`,
              path: "notes",
              element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(ProfileNotes, {}) })
            }
          ]
        }
      ]
    },
    {
      path: "profile/:profileId",
      element: /* @__PURE__ */ jsx180(Suspense119, { fallback: "Loading...", children: /* @__PURE__ */ jsx180(Profile, { isInList: false }) })
    }
  ];
};

// src/secure/recruit/RecruitLayout.tsx
import { jsx as jsx181, jsxs as jsxs156 } from "react/jsx-runtime";
var tabs3 = [
  {
    label: "Vacancies",
    to: "../vacancies",
    description: "Administer Vacancies"
  },
  {
    label: "Applications",
    to: "../applications",
    description: "Administer Applications"
  },
  {
    label: "Profile",
    to: "../profile",
    description: "Administer Profiles"
  },
  {
    label: "Talent Pools",
    to: "../talent-pools",
    description: "Administer Talent Pools"
  },
  { label: "Job Boards", to: "../job-boards", description: "Job Boards" },
  {
    label: "Job Board Search",
    to: "../job-board-search",
    description: "Job Board Search"
  },
  {
    label: "Email Applications",
    to: "../email-applications",
    description: "Email Applications"
  },
  {
    label: "Config",
    to: "../config",
    description: "Config"
  },
  {
    label: "Vacancy QA",
    to: "../vacancy-qa",
    description: "Vacancy Quality Assurance"
  }
];
var AccountsHome = () => {
  const links = tabs3.map((t) => {
    return /* @__PURE__ */ jsxs156(
      EdLink11,
      {
        name: t.label,
        href: t.to,
        className: "border bg-white p-8",
        children: [
          /* @__PURE__ */ jsx181("div", { className: "text-primary-700 py-2 text-xl", children: t.label }),
          /* @__PURE__ */ jsx181("p", { className: "mt-2 py-2  text-sm text-gray-500", children: t.description })
        ]
      },
      t.to
    );
  });
  return /* @__PURE__ */ jsxs156(Suspense120, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsx181(MynPageTitle92, { title: "Recruit" }),
    /* @__PURE__ */ jsx181(ErrorBoundary19, { FallbackComponent: ErrorBoundaryFallback20, children: /* @__PURE__ */ jsx181("div", { className: "flex sm:m-8", children: /* @__PURE__ */ jsx181("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: links }) }) })
  ] });
};
var createAppAdminRecruitRoutes = (environment, context) => {
  const routeId6 = "admin-recruit";
  return [
    {
      id: routeId6,
      path: "*",
      element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
      children: [
        {
          path: "home/*",
          element: /* @__PURE__ */ jsx181(AccountsHome, {})
        },
        {
          path: "vacancies/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createVacanciesAdministrationRoutes(environment, context)
        },
        {
          path: "applications/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createApplicationsAdministrationRoutes(
            environment,
            context
          )
        },
        {
          path: "profile/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createProfileSearchAdministrationRoutes(
            environment,
            context
          )
        },
        {
          path: "talent-pools/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createTalentPoolsRoutes(
            "admin-job-talent-pools",
            environment,
            context
          )
        },
        {
          path: "job-board-search/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createJobBoardSearchRoutes(routeId6, environment, context)
        },
        {
          path: "job-boards/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createJobBoardsRoutes(routeId6, environment, context)
        },
        {
          path: "config/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createConfigRoutes(routeId6, environment, context)
        },
        {
          path: "email-applications/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createEmailApplicationsRoutes(
            routeId6,
            environment,
            context
          )
        },
        {
          path: "vacancy-qa/*",
          element: /* @__PURE__ */ jsx181(OutletRoute30, {}),
          children: createVacancyQualityAssuranceDashboardRoutes(
            routeId6,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx181(Navigate47, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/AppAdminRoutes.tsx
import { jsx as jsx182 } from "react/jsx-runtime";
var AppAdminRoutes = (environment, context) => {
  return [
    {
      path: "signin-oidc/*",
      element: /* @__PURE__ */ jsx182(SignInLoader, {}),
      errorElement: /* @__PURE__ */ jsx182(ErrorContainer13, {})
    },
    {
      path: "signout-oidc",
      element: /* @__PURE__ */ jsx182(Navigate48, { replace: true, to: "/employers" }),
      errorElement: /* @__PURE__ */ jsx182(ErrorContainer13, {})
    },
    {
      path: "app/*",
      element: /* @__PURE__ */ jsx182(AppAdminSecureLayout, {}),
      errorElement: /* @__PURE__ */ jsx182(ErrorContainer13, {}),
      loader: () => {
        return loader3(environment);
      },
      children: AppAdminSecureRoutes(environment, context)
    },
    {
      path: "debugger/*",
      element: /* @__PURE__ */ jsx182(DebuggerConfig, { onDone: () => console.log(``) }),
      errorElement: /* @__PURE__ */ jsx182(ErrorContainer13, {})
    },
    {
      index: true,
      element: /* @__PURE__ */ jsx182(HomePage, {}),
      errorElement: /* @__PURE__ */ jsx182(ErrorContainer13, {})
    }
  ];
};

// src/AppAdmin.tsx
import { useEffect as useEffect9 } from "react";
import { Outlet as Outlet29 } from "react-router-dom";
import {
  AuthProvider,
  getAppContext,
  setAppContext,
  Tenant as Tenant2,
  useOIDC as useOIDC2
} from "app-core";
import { Suspense as Suspense121 } from "shared-ui";
import { jsx as jsx183 } from "react/jsx-runtime";
var app = {
  tenant: Tenant2.Admin
};
var AppAdmin = () => {
  const oidc = useOIDC2();
  const authConfig = useAuthConfig();
  useAdminRouteRegistry();
  useEffect9(() => {
    let isMounted = true;
    const currentContext = getAppContext();
    if (currentContext && currentContext.tenant != app.tenant) {
      setAppContext(app);
      window.location.reload();
      return;
    }
    setAppContext(app);
    async function checkSessionAsync() {
      oidc.setTenant(Tenant2.Admin);
      await oidc.checkSession();
    }
    checkSessionAsync();
    return () => {
      isMounted = false;
    };
  }, [oidc]);
  return /* @__PURE__ */ jsx183(AuthProvider, { ...authConfig, children: /* @__PURE__ */ jsx183(Suspense121, { fallback: "Loading Admin...", children: /* @__PURE__ */ jsx183(Outlet29, {}) }) });
};
export {
  AppAdmin,
  AppAdminRoutes
};
/*! Bundled license information:

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.mjs.map